(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire847f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire847f"] = parcelRequire;
}
parcelRequire.register("6kBsm", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $49c1aa6c5541520f$export$bdfd709ae4826697; }, function (v) { return $49c1aa6c5541520f$export$bdfd709ae4826697 = v; });
var $49c1aa6c5541520f$export$bdfd709ae4826697;
var $49c1aa6c5541520f$export$c9e73fbda7da57b6;
var $49c1aa6c5541520f$export$5a759dc7a1cfb72a;
"use strict";
var $49c1aa6c5541520f$var$bundleURL = {};
function $49c1aa6c5541520f$var$getBundleURLCached(id) {
    var value = $49c1aa6c5541520f$var$bundleURL[id];
    if (!value) {
        value = $49c1aa6c5541520f$var$getBundleURL();
        $49c1aa6c5541520f$var$bundleURL[id] = value;
    }
    return value;
}
function $49c1aa6c5541520f$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $49c1aa6c5541520f$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $49c1aa6c5541520f$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $49c1aa6c5541520f$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$49c1aa6c5541520f$export$bdfd709ae4826697 = $49c1aa6c5541520f$var$getBundleURLCached;
$49c1aa6c5541520f$export$c9e73fbda7da57b6 = $49c1aa6c5541520f$var$getBaseURL;
$49c1aa6c5541520f$export$5a759dc7a1cfb72a = $49c1aa6c5541520f$var$getOrigin;

});

var $551174e99d8c5924$var$n, $551174e99d8c5924$export$41c562ebe57d11e2, $551174e99d8c5924$var$u, $551174e99d8c5924$export$a8257692ac88316c, $551174e99d8c5924$var$t, $551174e99d8c5924$var$o, $551174e99d8c5924$var$r, $551174e99d8c5924$var$f, $551174e99d8c5924$var$e, $551174e99d8c5924$var$c = {}, $551174e99d8c5924$var$s = [], $551174e99d8c5924$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $551174e99d8c5924$var$v = Array.isArray;
function $551174e99d8c5924$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $551174e99d8c5924$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $551174e99d8c5924$export$c8a8987d4410bf2d(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $551174e99d8c5924$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $551174e99d8c5924$var$d(l, f, t, o, null);
}
function $551174e99d8c5924$var$d(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$551174e99d8c5924$var$u : r
    };
    return null == r && null != $551174e99d8c5924$export$41c562ebe57d11e2.vnode && $551174e99d8c5924$export$41c562ebe57d11e2.vnode(f), f;
}
function $551174e99d8c5924$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $551174e99d8c5924$export$ffb0004e005737fa(n) {
    return n.children;
}
function $551174e99d8c5924$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $551174e99d8c5924$var$g(n, l) {
    if (null == l) return n.__ ? $551174e99d8c5924$var$g(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $551174e99d8c5924$var$g(n) : null;
}
function $551174e99d8c5924$var$m(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $551174e99d8c5924$var$m(n);
    }
}
function $551174e99d8c5924$var$w(n) {
    (!n.__d && (n.__d = !0) && $551174e99d8c5924$var$t.push(n) && !$551174e99d8c5924$var$x.__r++ || $551174e99d8c5924$var$o !== $551174e99d8c5924$export$41c562ebe57d11e2.debounceRendering) && (($551174e99d8c5924$var$o = $551174e99d8c5924$export$41c562ebe57d11e2.debounceRendering) || $551174e99d8c5924$var$r)($551174e99d8c5924$var$x);
}
function $551174e99d8c5924$var$x() {
    var n, l, u, i, o, r, e, c;
    for($551174e99d8c5924$var$t.sort($551174e99d8c5924$var$f); n = $551174e99d8c5924$var$t.shift();)n.__d && (l = $551174e99d8c5924$var$t.length, i = void 0, o = void 0, e = (r = (u = n).__v).__e, (c = u.__P) && (i = [], (o = $551174e99d8c5924$var$h({}, r)).__v = r.__v + 1, $551174e99d8c5924$var$L(c, r, o, u.__n, void 0 !== c.ownerSVGElement, null != r.__h ? [
        e
    ] : null, i, null == e ? $551174e99d8c5924$var$g(r) : e, r.__h), $551174e99d8c5924$var$M(i, r), r.__e != e && $551174e99d8c5924$var$m(r)), $551174e99d8c5924$var$t.length > l && $551174e99d8c5924$var$t.sort($551174e99d8c5924$var$f));
    $551174e99d8c5924$var$x.__r = 0;
}
function $551174e99d8c5924$var$P(n, l, u, i, t, o, r, f, e, a) {
    var h, p, y, _, b, m, w, x = i && i.__k || $551174e99d8c5924$var$s, P = x.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (_ = u.__k[h] = null == (_ = l[h]) || "boolean" == typeof _ || "function" == typeof _ ? null : "string" == typeof _ || "number" == typeof _ || "bigint" == typeof _ ? $551174e99d8c5924$var$d(null, _, null, null, _) : $551174e99d8c5924$var$v(_) ? $551174e99d8c5924$var$d($551174e99d8c5924$export$ffb0004e005737fa, {
        children: _
    }, null, null, null) : _.__b > 0 ? $551174e99d8c5924$var$d(_.type, _.props, _.key, _.ref ? _.ref : null, _.__v) : _)) {
        if (_.__ = u, _.__b = u.__b + 1, null === (y = x[h]) || y && _.key == y.key && _.type === y.type) x[h] = void 0;
        else for(p = 0; p < P; p++){
            if ((y = x[p]) && _.key == y.key && _.type === y.type) {
                x[p] = void 0;
                break;
            }
            y = null;
        }
        $551174e99d8c5924$var$L(n, _, y = y || $551174e99d8c5924$var$c, t, o, r, f, e, a), b = _.__e, (p = _.ref) && y.ref != p && (w || (w = []), y.ref && w.push(y.ref, null, _), w.push(p, _.__c || b, _)), null != b ? (null == m && (m = b), "function" == typeof _.type && _.__k === y.__k ? _.__d = e = $551174e99d8c5924$var$C(_, e, n) : e = $551174e99d8c5924$var$$(n, _, y, x, b, e), "function" == typeof u.type && (u.__d = e)) : e && y.__e == e && e.parentNode != n && (e = $551174e99d8c5924$var$g(y));
    }
    for(u.__e = m, h = P; h--;)null != x[h] && ("function" == typeof u.type && null != x[h].__e && x[h].__e == u.__d && (u.__d = $551174e99d8c5924$var$A(i).nextSibling), $551174e99d8c5924$var$q(x[h], x[h]));
    if (w) for(h = 0; h < w.length; h++)$551174e99d8c5924$var$O(w[h], w[++h], w[++h]);
}
function $551174e99d8c5924$var$C(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $551174e99d8c5924$var$C(i, l, u) : $551174e99d8c5924$var$$(u, i, i, t, i.__e, l));
    return l;
}
function $551174e99d8c5924$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($551174e99d8c5924$var$v(n) ? n.some(function(n) {
        $551174e99d8c5924$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $551174e99d8c5924$var$$(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 1)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $551174e99d8c5924$var$A(n) {
    var l, u, i;
    if (null == n.type || "string" == typeof n.type) return n.__e;
    if (n.__k) {
        for(l = n.__k.length - 1; l >= 0; l--)if ((u = n.__k[l]) && (i = $551174e99d8c5924$var$A(u))) return i;
    }
    return null;
}
function $551174e99d8c5924$var$H(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $551174e99d8c5924$var$T(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $551174e99d8c5924$var$T(n, o, l[o], u[o], i);
}
function $551174e99d8c5924$var$I(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $551174e99d8c5924$var$a.test(l) ? u : u + "px";
}
function $551174e99d8c5924$var$T(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $551174e99d8c5924$var$I(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $551174e99d8c5924$var$I(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $551174e99d8c5924$var$z : $551174e99d8c5924$var$j, o) : n.removeEventListener(l, o ? $551174e99d8c5924$var$z : $551174e99d8c5924$var$j, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $551174e99d8c5924$var$j(n) {
    return this.l[n.type + !1]($551174e99d8c5924$export$41c562ebe57d11e2.event ? $551174e99d8c5924$export$41c562ebe57d11e2.event(n) : n);
}
function $551174e99d8c5924$var$z(n) {
    return this.l[n.type + !0]($551174e99d8c5924$export$41c562ebe57d11e2.event ? $551174e99d8c5924$export$41c562ebe57d11e2.event(n) : n);
}
function $551174e99d8c5924$var$L(n, u, i, t, o, r, f, e, c) {
    var s, a, p, y, d, _, g, m, w, x, C, S, $, A, H, I = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (s = $551174e99d8c5924$export$41c562ebe57d11e2.__b) && s(u);
    try {
        n: if ("function" == typeof I) {
            if (m = u.props, w = (s = I.contextType) && t[s.__c], x = s ? w ? w.props.value : s.__ : t, i.__c ? g = (a = u.__c = i.__c).__ = a.__E : ("prototype" in I && I.prototype.render ? u.__c = a = new I(m, x) : (u.__c = a = new $551174e99d8c5924$export$16fa2f45be04daa8(m, x), a.constructor = I, a.render = $551174e99d8c5924$var$B), w && w.sub(a), a.props = m, a.state || (a.state = {}), a.context = x, a.__n = t, p = a.__d = !0, a.__h = [], a._sb = []), null == a.__s && (a.__s = a.state), null != I.getDerivedStateFromProps && (a.__s == a.state && (a.__s = $551174e99d8c5924$var$h({}, a.__s)), $551174e99d8c5924$var$h(a.__s, I.getDerivedStateFromProps(m, a.__s))), y = a.props, d = a.state, a.__v = u, p) null == I.getDerivedStateFromProps && null != a.componentWillMount && a.componentWillMount(), null != a.componentDidMount && a.__h.push(a.componentDidMount);
            else {
                if (null == I.getDerivedStateFromProps && m !== y && null != a.componentWillReceiveProps && a.componentWillReceiveProps(m, x), !a.__e && null != a.shouldComponentUpdate && !1 === a.shouldComponentUpdate(m, a.__s, x) || u.__v === i.__v) {
                    for(u.__v !== i.__v && (a.props = m, a.state = a.__s, a.__d = !1), a.__e = !1, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), C = 0; C < a._sb.length; C++)a.__h.push(a._sb[C]);
                    a._sb = [], a.__h.length && f.push(a);
                    break n;
                }
                null != a.componentWillUpdate && a.componentWillUpdate(m, a.__s, x), null != a.componentDidUpdate && a.__h.push(function() {
                    a.componentDidUpdate(y, d, _);
                });
            }
            if (a.context = x, a.props = m, a.__P = n, S = $551174e99d8c5924$export$41c562ebe57d11e2.__r, $ = 0, "prototype" in I && I.prototype.render) {
                for(a.state = a.__s, a.__d = !1, S && S(u), s = a.render(a.props, a.state, a.context), A = 0; A < a._sb.length; A++)a.__h.push(a._sb[A]);
                a._sb = [];
            } else do a.__d = !1, S && S(u), s = a.render(a.props, a.state, a.context), a.state = a.__s;
            while (a.__d && ++$ < 25);
            a.state = a.__s, null != a.getChildContext && (t = $551174e99d8c5924$var$h($551174e99d8c5924$var$h({}, t), a.getChildContext())), p || null == a.getSnapshotBeforeUpdate || (_ = a.getSnapshotBeforeUpdate(y, d)), $551174e99d8c5924$var$P(n, $551174e99d8c5924$var$v(H = null != s && s.type === $551174e99d8c5924$export$ffb0004e005737fa && null == s.key ? s.props.children : s) ? H : [
                H
            ], u, i, t, o, r, f, e, c), a.base = u.__e, u.__h = null, a.__h.length && f.push(a), g && (a.__E = a.__ = null), a.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $551174e99d8c5924$var$N(i.__e, u, i, t, o, r, f, c);
        (s = $551174e99d8c5924$export$41c562ebe57d11e2.diffed) && s(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $551174e99d8c5924$export$41c562ebe57d11e2.__e(n, u, i);
    }
}
function $551174e99d8c5924$var$M(n, u) {
    $551174e99d8c5924$export$41c562ebe57d11e2.__c && $551174e99d8c5924$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $551174e99d8c5924$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $551174e99d8c5924$var$N(l, u, i, t, o, r, f, e) {
    var s, a, h, y = i.props, d = u.props, _ = u.type, k = 0;
    if ("svg" === _ && (o = !0), null != r) {
        for(; k < r.length; k++)if ((s = r[k]) && "setAttribute" in s == !!_ && (_ ? s.localName === _ : 3 === s.nodeType)) {
            l = s, r[k] = null;
            break;
        }
    }
    if (null == l) {
        if (null === _) return document.createTextNode(d);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", _) : document.createElement(_, d.is && d), r = null, e = !1;
    }
    if (null === _) y === d || e && l.data === d || (l.data = d);
    else {
        if (r = r && $551174e99d8c5924$var$n.call(l.childNodes), a = (y = i.props || $551174e99d8c5924$var$c).dangerouslySetInnerHTML, h = d.dangerouslySetInnerHTML, !e) {
            if (null != r) for(y = {}, k = 0; k < l.attributes.length; k++)y[l.attributes[k].name] = l.attributes[k].value;
            (h || a) && (h && (a && h.__html == a.__html || h.__html === l.innerHTML) || (l.innerHTML = h && h.__html || ""));
        }
        if ($551174e99d8c5924$var$H(l, d, y, o, e), h) u.__k = [];
        else if ($551174e99d8c5924$var$P(l, $551174e99d8c5924$var$v(k = u.props.children) ? k : [
            k
        ], u, i, t, o && "foreignObject" !== _, r, f, r ? r[0] : i.__k && $551174e99d8c5924$var$g(i, 0), e), null != r) for(k = r.length; k--;)null != r[k] && $551174e99d8c5924$var$p(r[k]);
        e || ("value" in d && void 0 !== (k = d.value) && (k !== l.value || "progress" === _ && !k || "option" === _ && k !== y.value) && $551174e99d8c5924$var$T(l, "value", k, y.value, !1), "checked" in d && void 0 !== (k = d.checked) && k !== l.checked && $551174e99d8c5924$var$T(l, "checked", k, y.checked, !1));
    }
    return l;
}
function $551174e99d8c5924$var$O(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $551174e99d8c5924$export$41c562ebe57d11e2.__e(n, i);
    }
}
function $551174e99d8c5924$var$q(n, u, i) {
    var t, o;
    if ($551174e99d8c5924$export$41c562ebe57d11e2.unmount && $551174e99d8c5924$export$41c562ebe57d11e2.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $551174e99d8c5924$var$O(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $551174e99d8c5924$export$41c562ebe57d11e2.__e(n, u);
        }
        t.base = t.__P = null, n.__c = void 0;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $551174e99d8c5924$var$q(t[o], u, i || "function" != typeof n.type);
    i || null == n.__e || $551174e99d8c5924$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $551174e99d8c5924$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $551174e99d8c5924$export$b3890eb0ae9dca99(u, i, t) {
    var o, r, f;
    $551174e99d8c5924$export$41c562ebe57d11e2.__ && $551174e99d8c5924$export$41c562ebe57d11e2.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, f = [], $551174e99d8c5924$var$L(i, u = (!o && t || i).__k = $551174e99d8c5924$export$c8a8987d4410bf2d($551174e99d8c5924$export$ffb0004e005737fa, null, [
        u
    ]), r || $551174e99d8c5924$var$c, $551174e99d8c5924$var$c, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $551174e99d8c5924$var$n.call(i.childNodes) : null, f, !o && t ? t : r ? r.__e : i.firstChild, o), $551174e99d8c5924$var$M(f, u);
}
function $551174e99d8c5924$export$fa8d919ba61d84db(n, l) {
    $551174e99d8c5924$export$b3890eb0ae9dca99(n, l, $551174e99d8c5924$export$fa8d919ba61d84db);
}
function $551174e99d8c5924$export$e530037191fcd5d7(l, u, i) {
    var t, o, r, f, e = $551174e99d8c5924$var$h({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $551174e99d8c5924$var$n.call(arguments, 2) : i), $551174e99d8c5924$var$d(l.type, e, t || l.key, o || l.ref, null);
}
function $551174e99d8c5924$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $551174e99d8c5924$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, i;
            return this.getChildContext || (u = [], (i = {})[l] = this, this.getChildContext = function() {
                return i;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $551174e99d8c5924$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$551174e99d8c5924$var$n = $551174e99d8c5924$var$s.slice, $551174e99d8c5924$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $551174e99d8c5924$var$u = 0, $551174e99d8c5924$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $551174e99d8c5924$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $551174e99d8c5924$var$h({}, this.state), "function" == typeof n && (n = n($551174e99d8c5924$var$h({}, u), this.props)), n && $551174e99d8c5924$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $551174e99d8c5924$var$w(this));
}, $551174e99d8c5924$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $551174e99d8c5924$var$w(this));
}, $551174e99d8c5924$export$16fa2f45be04daa8.prototype.render = $551174e99d8c5924$export$ffb0004e005737fa, $551174e99d8c5924$var$t = [], $551174e99d8c5924$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $551174e99d8c5924$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $551174e99d8c5924$var$x.__r = 0, $551174e99d8c5924$var$e = 0;


var $8161a3c5d316e860$var$_ = 0;
function $8161a3c5d316e860$export$34b9dba7ce09269b(o, e, n, t, f, l) {
    var s, u, a = {};
    for(u in e)"ref" == u ? s = e[u] : a[u] = e[u];
    var i = {
        type: o,
        props: a,
        key: n,
        ref: s,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$8161a3c5d316e860$var$_,
        __source: f,
        __self: l
    };
    if ("function" == typeof o && (s = o.defaultProps)) for(u in s)void 0 === a[u] && (a[u] = s[u]);
    return (0, $551174e99d8c5924$export$41c562ebe57d11e2).vnode && (0, $551174e99d8c5924$export$41c562ebe57d11e2).vnode(i), i;
}








var $5c5fa90583e4b8e8$var$t, $5c5fa90583e4b8e8$var$r, $5c5fa90583e4b8e8$var$u, $5c5fa90583e4b8e8$var$i, $5c5fa90583e4b8e8$var$o = 0, $5c5fa90583e4b8e8$var$f = [], $5c5fa90583e4b8e8$var$c = [], $5c5fa90583e4b8e8$var$e = (0, $551174e99d8c5924$export$41c562ebe57d11e2).__b, $5c5fa90583e4b8e8$var$a = (0, $551174e99d8c5924$export$41c562ebe57d11e2).__r, $5c5fa90583e4b8e8$var$v = (0, $551174e99d8c5924$export$41c562ebe57d11e2).diffed, $5c5fa90583e4b8e8$var$l = (0, $551174e99d8c5924$export$41c562ebe57d11e2).__c, $5c5fa90583e4b8e8$var$m = (0, $551174e99d8c5924$export$41c562ebe57d11e2).unmount;
function $5c5fa90583e4b8e8$var$d(t, u) {
    (0, $551174e99d8c5924$export$41c562ebe57d11e2).__h && (0, $551174e99d8c5924$export$41c562ebe57d11e2).__h($5c5fa90583e4b8e8$var$r, t, $5c5fa90583e4b8e8$var$o || u), $5c5fa90583e4b8e8$var$o = 0;
    var i = $5c5fa90583e4b8e8$var$r.__H || ($5c5fa90583e4b8e8$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $5c5fa90583e4b8e8$var$c
    }), i.__[t];
}
function $5c5fa90583e4b8e8$export$60241385465d0a34(n) {
    return $5c5fa90583e4b8e8$var$o = 1, $5c5fa90583e4b8e8$export$13e3392192263954($5c5fa90583e4b8e8$var$B, n);
}
function $5c5fa90583e4b8e8$export$13e3392192263954(n, u, i) {
    var o = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $5c5fa90583e4b8e8$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $5c5fa90583e4b8e8$var$r, !$5c5fa90583e4b8e8$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $5c5fa90583e4b8e8$var$r.u = !0;
        var c = $5c5fa90583e4b8e8$var$r.shouldComponentUpdate, e = $5c5fa90583e4b8e8$var$r.componentWillUpdate;
        $5c5fa90583e4b8e8$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $5c5fa90583e4b8e8$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $5c5fa90583e4b8e8$export$6d9c69b0de29b591(u, i) {
    var o = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 3);
    !(0, $551174e99d8c5924$export$41c562ebe57d11e2).__s && $5c5fa90583e4b8e8$var$z(o.__H, i) && (o.__ = u, o.i = i, $5c5fa90583e4b8e8$var$r.__H.__h.push(o));
}
function $5c5fa90583e4b8e8$export$e5c5a5f917a5871c(u, i) {
    var o = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 4);
    !(0, $551174e99d8c5924$export$41c562ebe57d11e2).__s && $5c5fa90583e4b8e8$var$z(o.__H, i) && (o.__ = u, o.i = i, $5c5fa90583e4b8e8$var$r.__h.push(o));
}
function $5c5fa90583e4b8e8$export$b8f5890fc79d6aca(n) {
    return $5c5fa90583e4b8e8$var$o = 5, $5c5fa90583e4b8e8$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $5c5fa90583e4b8e8$export$d5a552a76deda3c2(n, t, r) {
    $5c5fa90583e4b8e8$var$o = 6, $5c5fa90583e4b8e8$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $5c5fa90583e4b8e8$export$1538c33de8887b59(n, r) {
    var u = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 7);
    return $5c5fa90583e4b8e8$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $5c5fa90583e4b8e8$export$35808ee640e87ca7(n, t) {
    return $5c5fa90583e4b8e8$var$o = 8, $5c5fa90583e4b8e8$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $5c5fa90583e4b8e8$export$fae74005e78b1a27(n) {
    var u = $5c5fa90583e4b8e8$var$r.context[n.__c], i = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($5c5fa90583e4b8e8$var$r)), u.props.value) : n.__;
}
function $5c5fa90583e4b8e8$export$dc8fbce3eb94dc1e(t, r) {
    (0, $551174e99d8c5924$export$41c562ebe57d11e2).useDebugValue && (0, $551174e99d8c5924$export$41c562ebe57d11e2).useDebugValue(r ? r(t) : t);
}
function $5c5fa90583e4b8e8$export$c052f6604b7d51fe(n) {
    var u = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 10), i = $5c5fa90583e4b8e8$export$60241385465d0a34();
    return u.__ = n, $5c5fa90583e4b8e8$var$r.componentDidCatch || ($5c5fa90583e4b8e8$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $5c5fa90583e4b8e8$export$f680877a34711e37() {
    var n = $5c5fa90583e4b8e8$var$d($5c5fa90583e4b8e8$var$t++, 11);
    if (!n.__) {
        for(var u = $5c5fa90583e4b8e8$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $5c5fa90583e4b8e8$var$b() {
    for(var t; t = $5c5fa90583e4b8e8$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($5c5fa90583e4b8e8$var$k), t.__H.__h.forEach($5c5fa90583e4b8e8$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $551174e99d8c5924$export$41c562ebe57d11e2).__e(r, t.__v);
    }
}
(0, $551174e99d8c5924$export$41c562ebe57d11e2).__b = function(n) {
    $5c5fa90583e4b8e8$var$r = null, $5c5fa90583e4b8e8$var$e && $5c5fa90583e4b8e8$var$e(n);
}, (0, $551174e99d8c5924$export$41c562ebe57d11e2).__r = function(n) {
    $5c5fa90583e4b8e8$var$a && $5c5fa90583e4b8e8$var$a(n), $5c5fa90583e4b8e8$var$t = 0;
    var i = ($5c5fa90583e4b8e8$var$r = n.__c).__H;
    i && ($5c5fa90583e4b8e8$var$u === $5c5fa90583e4b8e8$var$r ? (i.__h = [], $5c5fa90583e4b8e8$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $5c5fa90583e4b8e8$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($5c5fa90583e4b8e8$var$k), i.__h.forEach($5c5fa90583e4b8e8$var$w), i.__h = [], $5c5fa90583e4b8e8$var$t = 0)), $5c5fa90583e4b8e8$var$u = $5c5fa90583e4b8e8$var$r;
}, (0, $551174e99d8c5924$export$41c562ebe57d11e2).diffed = function(t) {
    $5c5fa90583e4b8e8$var$v && $5c5fa90583e4b8e8$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $5c5fa90583e4b8e8$var$f.push(o) && $5c5fa90583e4b8e8$var$i === (0, $551174e99d8c5924$export$41c562ebe57d11e2).requestAnimationFrame || (($5c5fa90583e4b8e8$var$i = (0, $551174e99d8c5924$export$41c562ebe57d11e2).requestAnimationFrame) || $5c5fa90583e4b8e8$var$j)($5c5fa90583e4b8e8$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $5c5fa90583e4b8e8$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $5c5fa90583e4b8e8$var$c;
    })), $5c5fa90583e4b8e8$var$u = $5c5fa90583e4b8e8$var$r = null;
}, (0, $551174e99d8c5924$export$41c562ebe57d11e2).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($5c5fa90583e4b8e8$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $5c5fa90583e4b8e8$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $551174e99d8c5924$export$41c562ebe57d11e2).__e(u, t.__v);
        }
    }), $5c5fa90583e4b8e8$var$l && $5c5fa90583e4b8e8$var$l(t, r);
}, (0, $551174e99d8c5924$export$41c562ebe57d11e2).unmount = function(t) {
    $5c5fa90583e4b8e8$var$m && $5c5fa90583e4b8e8$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $5c5fa90583e4b8e8$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $551174e99d8c5924$export$41c562ebe57d11e2).__e(r, u.__v));
};
var $5c5fa90583e4b8e8$var$g = "function" == typeof requestAnimationFrame;
function $5c5fa90583e4b8e8$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $5c5fa90583e4b8e8$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $5c5fa90583e4b8e8$var$g && (t = requestAnimationFrame(r));
}
function $5c5fa90583e4b8e8$var$k(n) {
    var t = $5c5fa90583e4b8e8$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $5c5fa90583e4b8e8$var$r = t;
}
function $5c5fa90583e4b8e8$var$w(n) {
    var t = $5c5fa90583e4b8e8$var$r;
    n.__c = n.__(), $5c5fa90583e4b8e8$var$r = t;
}
function $5c5fa90583e4b8e8$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $5c5fa90583e4b8e8$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}



// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $fe1664b9958a6563$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
// TODO: switch to `export { useSyncExternalStore } from "preact/compat"` once we update Preact to >= 10.11.3
function $fe1664b9958a6563$var$is(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
}
function $fe1664b9958a6563$export$306c0aa65ff9ec16(subscribe, getSnapshot, getSSRSnapshot) {
    if (getSSRSnapshot && !$fe1664b9958a6563$var$canUseDOM) getSnapshot = getSSRSnapshot;
    const value = getSnapshot();
    const [{ _instance: _instance }, forceUpdate] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)({
        _instance: {
            _value: value,
            _getSnapshot: getSnapshot
        }
    });
    (0, $5c5fa90583e4b8e8$export$e5c5a5f917a5871c)(()=>{
        _instance._value = value;
        _instance._getSnapshot = getSnapshot;
        if (!$fe1664b9958a6563$var$is(_instance._value, getSnapshot())) forceUpdate({
            _instance: _instance
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        if (!$fe1664b9958a6563$var$is(_instance._value, _instance._getSnapshot())) forceUpdate({
            _instance: _instance
        });
        return subscribe(()=>{
            if (!$fe1664b9958a6563$var$is(_instance._value, _instance._getSnapshot())) forceUpdate({
                _instance: _instance
            });
        });
    }, [
        subscribe
    ]);
    return value;
}
function $fe1664b9958a6563$export$257a8862b851cb5b(component) {
    return component;
}
const $fe1664b9958a6563$export$90fc3a17d93f704c = (fn)=>{
    const ref = (0, $5c5fa90583e4b8e8$export$b8f5890fc79d6aca)([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    (0, $5c5fa90583e4b8e8$export$e5c5a5f917a5871c)(()=>{
        ref[0] = fn;
    });
    return ref[1];
};


/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $e85d6386137e524a$var$relativePath = (base = "", path = location.pathname)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
const $e85d6386137e524a$var$absolutePath = (to, base = "")=>to[0] === "~" ? to.slice(1) : base + to;
/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $e85d6386137e524a$var$eventPopstate = "popstate";
const $e85d6386137e524a$var$eventPushState = "pushState";
const $e85d6386137e524a$var$eventReplaceState = "replaceState";
const $e85d6386137e524a$var$eventHashchange = "hashchange";
const $e85d6386137e524a$export$4bf9923669ad6c63 = [
    $e85d6386137e524a$var$eventPopstate,
    $e85d6386137e524a$var$eventPushState,
    $e85d6386137e524a$var$eventReplaceState,
    $e85d6386137e524a$var$eventHashchange
];
const $e85d6386137e524a$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $e85d6386137e524a$export$4bf9923669ad6c63)addEventListener(event, callback);
    return ()=>{
        for (const event of $e85d6386137e524a$export$4bf9923669ad6c63)removeEventListener(event, callback);
    };
};
const $e85d6386137e524a$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $fe1664b9958a6563$export$306c0aa65ff9ec16)($e85d6386137e524a$var$subscribeToLocationUpdates, fn, ssrFn);
const $e85d6386137e524a$var$currentSearch = ()=>location.search;
const $e85d6386137e524a$export$bd221a7c56b93941 = ()=>$e85d6386137e524a$export$3a1ff78c39f8a86($e85d6386137e524a$var$currentSearch);
const $e85d6386137e524a$var$currentPathname = ()=>location.pathname;
const $e85d6386137e524a$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath } = {})=>$e85d6386137e524a$export$3a1ff78c39f8a86($e85d6386137e524a$var$currentPathname, ssrPath ? ()=>ssrPath : $e85d6386137e524a$var$currentPathname);
const $e85d6386137e524a$export$ff7962acd6052c28 = (to, { replace: replace = false } = {})=>history[replace ? $e85d6386137e524a$var$eventReplaceState : $e85d6386137e524a$var$eventPushState](null, "", to);
// the 2nd argument of the `useLocation` return value is a function
// that allows to perform a navigation.
//
// the function reference should stay the same between re-renders, so that
// it can be passed down as an element prop without any performance concerns.
// (This is achieved via `useEvent`.)
const $e85d6386137e524a$var$useLocation = (opts = {})=>[
        $e85d6386137e524a$var$relativePath(opts.base, $e85d6386137e524a$export$2a28ef6a9fe822a4(opts)),
        (0, $fe1664b9958a6563$export$90fc3a17d93f704c)((to, navOpts)=>$e85d6386137e524a$export$ff7962acd6052c28($e85d6386137e524a$var$absolutePath(to, opts.base), navOpts))
    ];
var $e85d6386137e524a$export$2e2bcd8739ae039 = $e85d6386137e524a$var$useLocation;
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined") for (const type of [
    $e85d6386137e524a$var$eventPushState,
    $e85d6386137e524a$var$eventReplaceState
]){
    const original = history[type];
    // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
    // however that will require an additional peer dependency on react-dom.
    // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
    history[type] = function() {
        const result = original.apply(this, arguments);
        const event = new Event(type);
        event.arguments = arguments;
        dispatchEvent(event);
        return result;
    };
}


// creates a matcher function
function $d7bafb128031febe$export$2e2bcd8739ae039(makeRegexpFn = $d7bafb128031febe$var$pathToRegexp) {
    let cache = {};
    // obtains a cached regexp version of the pattern
    const getRegexp = (pattern)=>cache[pattern] || (cache[pattern] = makeRegexpFn(pattern));
    return (pattern, path)=>{
        const { regexp: regexp, keys: keys } = getRegexp(pattern || "");
        const out = regexp.exec(path);
        if (!out) return [
            false,
            null
        ];
        // formats an object with matched params
        const params = keys.reduce((params, key, i)=>{
            params[key.name] = out[i + 1];
            return params;
        }, {});
        return [
            true,
            params
        ];
    };
}
// escapes a regexp string (borrowed from path-to-regexp sources)
// https://github.com/pillarjs/path-to-regexp/blob/v3.0.0/index.js#L202
const $d7bafb128031febe$var$escapeRx = (str)=>str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
// returns a segment representation in RegExp based on flags
// adapted and simplified version from path-to-regexp sources
const $d7bafb128031febe$var$rxForSegment = (repeat, optional, prefix)=>{
    let capture = repeat ? "((?:[^\\/]+?)(?:\\/(?:[^\\/]+?))*)" : "([^\\/]+?)";
    if (optional && prefix) capture = "(?:\\/" + capture + ")";
    return capture + (optional ? "?" : "");
};
const $d7bafb128031febe$var$pathToRegexp = (pattern)=>{
    const groupRx = /:([A-Za-z0-9_]+)([?+*]?)/g;
    let match = null, lastIndex = 0, keys = [], result = "";
    while((match = groupRx.exec(pattern)) !== null){
        const [_, segment, mod] = match;
        // :foo  [1]      (  )
        // :foo? [0 - 1]  ( o)
        // :foo+ [1 - ∞]  (r )
        // :foo* [0 - ∞]  (ro)
        const repeat = mod === "+" || mod === "*";
        const optional = mod === "?" || mod === "*";
        const prefix = optional && pattern[match.index - 1] === "/" ? 1 : 0;
        const prev = pattern.substring(lastIndex, match.index - prefix);
        keys.push({
            name: segment
        });
        lastIndex = groupRx.lastIndex;
        result += $d7bafb128031febe$var$escapeRx(prev) + $d7bafb128031febe$var$rxForSegment(repeat, optional, prefix);
    }
    result += $d7bafb128031febe$var$escapeRx(pattern.substring(lastIndex));
    return {
        keys: keys,
        regexp: new RegExp("^" + result + "(?:\\/)?$", "i")
    };
};



/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $bf49b3b08868bbb1$var$defaultRouter = {
    hook: (0, $e85d6386137e524a$export$2e2bcd8739ae039),
    matcher: (0, $d7bafb128031febe$export$2e2bcd8739ae039)(),
    base: ""
};
const $bf49b3b08868bbb1$var$RouterCtx = (0, $551174e99d8c5924$export$fd42f52fd3ae1109)($bf49b3b08868bbb1$var$defaultRouter);
const $bf49b3b08868bbb1$export$9a302a45f65d0572 = ()=>(0, $5c5fa90583e4b8e8$export$fae74005e78b1a27)($bf49b3b08868bbb1$var$RouterCtx);
/*
 * Part 1, Hooks API: useRoute and useLocation
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $bf49b3b08868bbb1$var$useLocationFromRouter = (router)=>router.hook(router);
const $bf49b3b08868bbb1$export$45d76561a5302f2b = ()=>$bf49b3b08868bbb1$var$useLocationFromRouter($bf49b3b08868bbb1$export$9a302a45f65d0572());
const $bf49b3b08868bbb1$export$3f79f0b98112cf57 = (pattern)=>{
    const router = $bf49b3b08868bbb1$export$9a302a45f65d0572();
    const [path] = $bf49b3b08868bbb1$var$useLocationFromRouter(router);
    return router.matcher(pattern, path);
};
const $bf49b3b08868bbb1$export$55185c17a0fcbe46 = ({ hook: hook, matcher: matcher, ssrPath: ssrPath, base: base = "", parent: parent, children: children })=>{
    // updates the current router with the props passed down to the component
    const updateRouter = (router, proto = parent || $bf49b3b08868bbb1$var$defaultRouter)=>{
        router.hook = hook || proto.hook;
        router.matcher = matcher || proto.matcher;
        router.ssrPath = ssrPath || proto.ssrPath;
        router.ownBase = base;
        // store reference to parent router
        router.parent = parent;
        return router;
    };
    // we use `useState` here, but it only catches the first render and never changes.
    // https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
    const [value] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(()=>updateRouter({
            // We must store base as a property accessor because effects
            // somewhat counter-intuitively run in child components *first*!
            // This means that by the time a parent's base is updated in the
            // parent effect, the child effect has already run, and saw
            // the parent's *previous* base during its own execution.
            get base () {
                return (value.parent || $bf49b3b08868bbb1$var$defaultRouter).base + value.ownBase;
            }
        })); // create the object once...
    (0, $5c5fa90583e4b8e8$export$e5c5a5f917a5871c)(()=>{
        updateRouter(value);
    }); // ...then update it on each render
    return (0, $551174e99d8c5924$export$c8a8987d4410bf2d)($bf49b3b08868bbb1$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
const $bf49b3b08868bbb1$export$e7b0ac011bb776c6 = ({ path: path, match: match, component: component, children: children })=>{
    const useRouteMatch = $bf49b3b08868bbb1$export$3f79f0b98112cf57(path);
    // `props.match` is present - Route is controlled by the Switch
    const [matches, params] = match || useRouteMatch;
    if (!matches) return null;
    // React-Router style `component` prop
    if (component) return (0, $551174e99d8c5924$export$c8a8987d4410bf2d)(component, {
        params: params
    });
    // support render prop or plain children
    return typeof children === "function" ? children(params) : children;
};
const $bf49b3b08868bbb1$export$a6c7ac8248d6e38a = (0, $fe1664b9958a6563$export$257a8862b851cb5b)((props, ref)=>{
    const router = $bf49b3b08868bbb1$export$9a302a45f65d0572();
    const [, navigate] = $bf49b3b08868bbb1$var$useLocationFromRouter(router);
    const { to: to, href: href = to, children: children, onClick: onClick } = props;
    const handleClick = (0, $fe1664b9958a6563$export$90fc3a17d93f704c)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        onClick && onClick(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(to || href, props);
        }
    });
    // wraps children in `a` if needed
    const extraProps = {
        // handle nested routers and absolute paths
        href: href[0] === "~" ? href.slice(1) : router.base + href,
        onClick: handleClick,
        to: null,
        ref: ref
    };
    const jsx = (0, $551174e99d8c5924$export$a8257692ac88316c)(children) ? children : (0, $551174e99d8c5924$export$c8a8987d4410bf2d)("a", props);
    return (0, $551174e99d8c5924$export$e530037191fcd5d7)(jsx, extraProps);
});
const $bf49b3b08868bbb1$var$flattenChildren = (children)=>{
    return Array.isArray(children) ? [].concat(...children.map((c)=>c && c.type === (0, $551174e99d8c5924$export$ffb0004e005737fa) ? $bf49b3b08868bbb1$var$flattenChildren(c.props.children) : $bf49b3b08868bbb1$var$flattenChildren(c))) : [
        children
    ];
};
const $bf49b3b08868bbb1$export$b5d5cf8927ab7262 = ({ children: children, location: location })=>{
    const router = $bf49b3b08868bbb1$export$9a302a45f65d0572();
    const matcher = router.matcher;
    const [originalLocation] = $bf49b3b08868bbb1$var$useLocationFromRouter(router);
    for (const element of $bf49b3b08868bbb1$var$flattenChildren(children)){
        let match = 0;
        if ((0, $551174e99d8c5924$export$a8257692ac88316c)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = element.props.path ? matcher(element.props.path, location || originalLocation) : [
            true,
            {}
        ])[0]) return (0, $551174e99d8c5924$export$e530037191fcd5d7)(element, {
            match: match
        });
    }
    return null;
};
const $bf49b3b08868bbb1$export$2d8d895a0a0f636e = (props)=>{
    const { to: to, href: href = to } = props;
    const [, navigate] = $bf49b3b08868bbb1$export$45d76561a5302f2b();
    const redirect = (0, $fe1664b9958a6563$export$90fc3a17d93f704c)(()=>navigate(to || href, props));
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $5c5fa90583e4b8e8$export$e5c5a5f917a5871c)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return null;
};
var $bf49b3b08868bbb1$export$2e2bcd8739ae039 = $bf49b3b08868bbb1$export$3f79f0b98112cf57;



const $66f2da609d6d9bfe$var$windowLocation = ()=>window.location.hash.replace("#", "") || "/";
const $66f2da609d6d9bfe$export$8eb08f90c24d5079 = ({ url: url })=>`/#/play/${encodeURIComponent(url)}`;
const $66f2da609d6d9bfe$export$4fac2eeccfa4a8ca = (location)=>{
    if (location === "/") return "home";
    const currentView = location.split("/").filter(Boolean)[0];
    return currentView || "";
};
const $66f2da609d6d9bfe$export$b37f3f4c9f6562f7 = ()=>{
    const [currentLocation, setCurrentLocation] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)($66f2da609d6d9bfe$var$windowLocation());
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        const onHashChange = ()=>{
            let newLocation = $66f2da609d6d9bfe$var$windowLocation();
            if (newLocation !== currentLocation) {
                setCurrentLocation(newLocation);
                window.scrollTo(0, 0);
            }
        };
        onHashChange();
        window.addEventListener("hashchange", onHashChange);
        return ()=>window.removeEventListener("hashchange", onHashChange);
    }, [
        currentLocation,
        setCurrentLocation
    ]);
    const navigate = (0, $5c5fa90583e4b8e8$export$35808ee640e87ca7)((to)=>{
        window.location.hash = to.replace("#/", "");
    }, []);
    return [
        currentLocation,
        navigate
    ];
};



const $1a1447a1dbeb7cc3$export$d9a33280f07116d9 = [
    "light",
    "dim",
    "dark",
    /* Solarized */ "solarized-light",
    "solarized-dark",
    /* Original */ "emo",
    "redrum",
    "toxin",
    "valve",
    "wasp",
    /* Monkeytype */ /* @see https://github.com/monkeytypegame/monkeytype/blob/master/frontend/static/themes/_list.json */ "a8008",
    "a80s_after_dark",
    "a9009",
    "aether",
    "alduin",
    "alpine",
    "arch",
    "aurora",
    "beach",
    "bento",
    "bingsu",
    "bliss",
    "blue_dolphin",
    "blueberry_dark",
    "blueberry_light",
    "botanical",
    "bouquet",
    "breeze",
    "bushido",
    "cafe",
    "camping",
    "carbon",
    "catppuccin",
    "chaos_theory",
    "cheesecake",
    "cherry_blossom",
    "comfy",
    "copper",
    "creamsicle",
    "cyberspace",
    "dark_magic_girl",
    "dark_note",
    "darling",
    "deku",
    "desert_oasis",
    "dev",
    "diner",
    "dino",
    "dmg",
    "dollar",
    "dots",
    "dracula",
    "drowning",
    "dualshot",
    "earthsong",
    "everblush",
    "evil_eye",
    "ez_mode",
    "fire",
    "fledgling",
    "fleuriste",
    "froyo",
    "frozen_llama",
    "fruit_chew",
    "fundamentals",
    "future_funk",
    "godspeed",
    "graen",
    "grand_prix",
    "gruvbox_dark",
    "gruvbox_light",
    "hammerhead",
    "hanok",
    "hedge",
    "honey",
    "horizon",
    "husqy",
    "iceberg_dark",
    "iceberg_light",
    "ishtar",
    "iv_clover",
    "iv_spade",
    "joker",
    "laser",
    "lavender",
    "leather",
    "lil_dragon",
    "lime",
    "luna",
    "magic_girl",
    "mashu",
    "matcha_moccha",
    "material",
    "matrix",
    "menthol",
    "metaverse",
    "metropolis",
    "mexican",
    "miami",
    "miami_nights",
    "midnight",
    "milkshake",
    "mint",
    "mizu",
    "modern_dolch",
    "modern_dolch_light",
    "modern_ink",
    "monokai",
    "moonlight",
    "mountain",
    "mr_sleeves",
    "ms_cupcakes",
    "muted",
    "nautilus",
    "nebula",
    "night_runner",
    "nord",
    "nord_light",
    "norse",
    "oblivion",
    "olive",
    "olivia",
    "onedark",
    "our_theme",
    "paper",
    "passion_fruit",
    "pastel",
    "peach_blossom",
    "peaches",
    "pink_lemonade",
    "pulse",
    "purpurite",
    "red_dragon",
    "red_samurai",
    "repose_dark",
    "repose_light",
    "retro",
    "retrocast",
    "rose_pine",
    "rose_pine_dawn",
    "rose_pine_moon",
    "rudy",
    "ryujinscales",
    "serika",
    "serika_dark",
    "sewing_tin",
    "sewing_tin_light",
    "shadow",
    "shoko",
    "slambook",
    "snes",
    "soaring_skies",
    "sonokai",
    "stealth",
    "strawberry",
    "striker",
    "superuser",
    "sweden",
    "taro",
    "terminal",
    "terra",
    "terror_below",
    "tiramisu",
    "trackday",
    "trance",
    "tron_orange",
    "vaporwave",
    "viridescent",
    "voc",
    "vscode",
    "watermelon",
    "wavez",
    "witch_girl"
];



const $1e789317f11755fe$var$LS_THEME_KEY = "elseifplayer/theme";
const $1e789317f11755fe$var$DEFAULT_THEME = (0, $1a1447a1dbeb7cc3$export$d9a33280f07116d9)[0];
const $1e789317f11755fe$var$getSavedTheme = ()=>{
    const savedTheme = localStorage.getItem($1e789317f11755fe$var$LS_THEME_KEY);
    return savedTheme || $1e789317f11755fe$var$DEFAULT_THEME;
};
const $1e789317f11755fe$var$assertTheme = (theme)=>(0, $1a1447a1dbeb7cc3$export$d9a33280f07116d9).includes(theme) ? theme : $1e789317f11755fe$var$getSavedTheme();
const $1e789317f11755fe$export$818080cba8053148 = (initialTheme = $1e789317f11755fe$var$getSavedTheme())=>{
    const [currentTheme, setCurrentTheme] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(initialTheme);
    const setTheme = (theme)=>{
        const newTheme = $1e789317f11755fe$var$assertTheme(theme);
        setCurrentTheme(newTheme);
        localStorage.setItem($1e789317f11755fe$var$LS_THEME_KEY, newTheme);
    };
    const setRandomTheme = ()=>{
        const randomTheme = (0, $1a1447a1dbeb7cc3$export$d9a33280f07116d9)[Math.floor(Math.random() * (0, $1a1447a1dbeb7cc3$export$d9a33280f07116d9).length)];
        setTheme(randomTheme);
    };
    return {
        currentTheme: currentTheme,
        setTheme: setTheme,
        setRandomTheme: setRandomTheme,
        themes: $1a1447a1dbeb7cc3$export$d9a33280f07116d9
    };
};






function $1708390c5041b6e2$export$2e2bcd8739ae039({ theme: theme, setLocation: setLocation, buildLink: buildLink }) {
    const fileInputHandler = ({ target: target })=>{
        const file = target.files[0];
        const url = `${URL.createObjectURL(file)}#${file.name}`;
        setLocation(buildLink({
            url: url,
            theme: theme
        }));
    };
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("input", {
        type: "file",
        onChange: fileInputHandler
    });
}



function $bc4fc25313d9323c$export$2e2bcd8739ae039({ theme: theme, setLocation: setLocation, buildLink: buildLink }) {
    const urlRE = /^(http|https):\/\/[^ "]+$/;
    const onKeyPress = ({ keyCode: keyCode, target: target })=>{
        if (keyCode !== 13) return;
        const url = encodeURI(target.value);
        if (urlRE.test(url)) setLocation(buildLink({
            url: url,
            theme: theme
        }));
    };
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("input", {
        type: "text",
        placeholder: "https://...",
        onKeyPress: onKeyPress
    });
}



function $7c39639b64b564e0$export$2e2bcd8739ae039({ themeEngine: themeEngine }) {
    const options = themeEngine.themes.map((theme)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("option", {
            value: theme,
            children: theme
        }, theme));
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("select", {
        value: themeEngine.currentTheme,
        onChange: ({ target: target })=>themeEngine.setTheme(target.value),
        children: options
    });
}


function $85078130a8d7a0de$export$2e2bcd8739ae039({ themeEngine: themeEngine }) {
    const setLocation = (0, $66f2da609d6d9bfe$export$b37f3f4c9f6562f7)()[1];
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("main", {
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h1", {
                children: "ElseIFPlayer"
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                    children: [
                        "Interactive Fiction interpreter that runs right in your browser.",
                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {}),
                        "Source code can be found in this ",
                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            href: "https://github.com/He4eT/elseifplayer",
                            children: "repository"
                        }),
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("hr", {}),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                        children: "Interface Theme"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $7c39639b64b564e0$export$2e2bcd8739ae039), {
                        themeEngine: themeEngine
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: [
                            "Preview and choose from available themes on the ",
                            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                                href: "/#/themes/",
                                children: "themes page"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("small", {
                            children: "Double-click the input field during the game to enter full-screen mode."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("hr", {}),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                        children: "Play a Game from the List"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                            href: "/#/games/",
                            children: "IFDB games"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("hr", {}),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                        children: "Play the Game from a File"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("details", {
                            children: [
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("summary", {
                                    children: "Supported formats"
                                }),
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                                    children: "Text-only games are supported:"
                                }),
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                                            children: "ADRIFT 4 (.taf)"
                                        }),
                                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                                            children: "Glulx (.gblorb, .ulx)"
                                        }),
                                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                                            children: "Hugo (.hex)"
                                        }),
                                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                                            children: "TADS 2/3 (.gam, .t3)"
                                        }),
                                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                                            children: "Z-code (.z3, .z4, .z5, .z8, .blorb)"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("label", {
                            children: [
                                "Local file: ",
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {}),
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $1708390c5041b6e2$export$2e2bcd8739ae039), {
                                    setLocation: setLocation,
                                    buildLink: (0, $66f2da609d6d9bfe$export$8eb08f90c24d5079),
                                    theme: themeEngine.currentTheme
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("label", {
                            children: [
                                "Direct link: ",
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {}),
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bc4fc25313d9323c$export$2e2bcd8739ae039), {
                                    setLocation: setLocation,
                                    buildLink: (0, $66f2da609d6d9bfe$export$8eb08f90c24d5079),
                                    theme: themeEngine.currentTheme
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}







function $c416337fc7df6b27$export$2e2bcd8739ae039({ name: name, ifdb: ifdb, url: url }) {
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h4", {
                children: name
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                href: ifdb,
                children: "IFDB page"
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("span", {
                children: " | "
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                href: (0, $66f2da609d6d9bfe$export$8eb08f90c24d5079)({
                    url: url
                }),
                children: "Play"
            })
        ]
    });
}


var $8072c402bd1a5d6e$export$2e2bcd8739ae039 = [
    [
        "Lost Pig",
        "https://ifdb.org/viewgame?id=mohwfk47yjzii14w",
        "https://mirror.ifarchive.org/if-archive/games/zcode/LostPig.z8"
    ],
    [
        /* Check with cheap-glk */ "Counterfeit Monkey",
        "https://ifdb.org/viewgame?id=aearuuxv83plclpl",
        "https://mirror.ifarchive.org/if-archive/games/glulx/CounterfeitMonkey.gblorb"
    ],
    [
        /* Works. Check inputs */ "Anchorhead",
        "https://ifdb.org/viewgame?id=op0uw1gn1tjqmjt7",
        "https://ifarchive.org/if-archive/games/zcode/anchor.z8"
    ],
    /* [
    '80 DAYS',
    'https://ifdb.org/viewgame?id=du51t0qrhjqlnbij',
    'INKLEWRITER'
  ], */ [
        "Galatea",
        "https://ifdb.org/viewgame?id=urxrv27t7qtu52lb",
        "https://mirror.ifarchive.org/if-archive/games/zcode/Galatea.zblorb"
    ],
    [
        /* Works. Check inputs */ "Photopia",
        "https://ifdb.org/viewgame?id=ju778uv5xaswnlpl",
        "https://mirror.ifarchive.org/if-archive/games/zcode/photopia.z5"
    ],
    [
        "Spider and Web",
        "https://ifdb.org/viewgame?id=2xyccw3pe0uovfad",
        "https://mirror.ifarchive.org/if-archive/games/zcode/Tangle.z5"
    ],
    /* [
    'Trinity',
    'https://ifdb.org/viewgame?id=j18kjz80hxjtyayw',
    'ZIP'
  ], */ /* [
    'Hadean Lands',
    'https://ifdb.org/viewgame?id=u58d0mlbfwcorfi',
    'COMMERCIAL'
  ], */ /* [
    'Superluminal Vagrant Twin',
    'https://ifdb.org/viewgame?id=5xzoz5wimz4xxha',
    'CORS https://v6p9d9t4.ssl.hwcdn.net/html/177384/Superluminal%20Vagrant%20Twin%20Webpage/files/Superluminal%20Vagrant%20Twin.gblorb'
  ], */ /* [
    'Birdland',
    'https://ifdb.org/viewgame?id=ap1651hvjldbuugj',
    'TWINE'
  ], */ [
        "Slouching Towards Bedlam",
        "https://ifdb.org/viewgame?id=032krqe6bjn5au78",
        "https://mirror.ifarchive.org/if-archive/games/competition2003/zcode/slouch/slouch.z5"
    ],
    [
        "Curses!",
        "https://ifdb.org/viewgame?id=plvzam05bmz3enh8",
        "https://mirror.ifarchive.org/if-archive/games/zcode/curses.z5"
    ],
    /* [
    'howling dogs',
    'https://ifdb.org/viewgame?id=mxj7xp4nffia9rbj',
    'TWINE'
  ], */ [
        "Violet",
        "https://ifdb.org/viewgame?id=4glrrfh7wrp9zz7b",
        "https://mirror.ifarchive.org/if-archive/games/zcode/Violet.zblorb"
    ],
    [
        "The Wizard Sniffer",
        "https://ifdb.org/viewgame?id=uq18rw9gt8j58da",
        "https://ifarchive.org/if-archive/games/competition2017/The%20Wizard%20Sniffer/The_Wizard_Sniffer.gblorb"
    ],
    /* [
    'Eat Me',
    'https://ifdb.org/viewgame?id=yutkd9u0oeog4br1',
    'ZIP https://ifarchive.org/if-archive/games/competition2017/Eat%20Me/Eat%20Me/Gblorb.zip'
  ], */ /* [
    'Horse Master',
    'https://ifdb.org/viewgame?id=ogkcvv9l1q0aatpd',
    'TWINE'
  ], */ /* [
    'Mentula Macanus: Apocolocyntosis',
    'https://ifdb.org/viewgame?id=etul31tqgl3n22nl'
    'ZIP'
  ], */ [
        "Shade",
        "https://ifdb.org/viewgame?id=hsfc7fnl40k4a30q",
        "https://mirror.ifarchive.org/if-archive/games/zcode/shade.z5"
    ],
    [
        "Vespers",
        "https://ifdb.org/viewgame?id=6dj2vguyiagrhvc2",
        "https://mirror.ifarchive.org/if-archive/games/zcode/vespers.z8"
    ],
    /* [
    'Will Not Let Me Go',
    'https://ifdb.org/viewgame?id=67r2qc21m5nzexv1',
    'TWINE'
  ], */ /* [
    'Bee',
    'https://ifdb.org/viewgame?id=8pe83e92v4nvabic',
    'VARYTALE'
  ], */ /* [
    'Creatures Such As We',
    'https://ifdb.org/viewgame?id=8l9cdcd1tbt77hfl',
    'TWINE'
  ], */ /* [
    'Kerkerkruip',
    'https://ifdb.org/viewgame?id=f7zdhxmiraht53d1',
    'CORS https://downloads.kerkerkruip.org/Kerkerkruip-latest.gblorb'
  ], */ /* [
    'Midnight. Swordfight.',
    'https://ifdb.org/viewgame?id=2cuwjlvpybg8oaf0',
    'CORS https://www.castleprincessdragon.com/InteractiveFiction/MS/MidnightSwordfight.gblorb'
  ], */ [
        "Savoir-Faire",
        "https://ifdb.org/viewgame?id=p0cizeb3kiwzlm2p",
        "https://mirror.ifarchive.org/if-archive/games/zcode/Savoir-Faire.zblorb"
    ],
    /* [
    'With Those We Love Alive',
    'https://ifdb.org/viewgame?id=445d989vuwlh4cvz',
    'TWINE'
  ], */ [
        "Aisle",
        "https://ifdb.org/viewgame?id=j49crlvd62mhwuzu",
        "https://mirror.ifarchive.org/if-archive/games/zcode/Aisle.z5"
    ],
    /* [
    'Blue Lacuna',
    'https://ifdb.org/viewgame?id=ez2mcyx4zi98qlkh',
    'ZIP'
  ], */ [
        "Gun Mute",
        "https://ifdb.org/viewgame?id=xwedbibfksczn7eq",
        "https://mirror.ifarchive.org/if-archive/games/tads/GunMute.t3"
    ],
    /* [
    'The King of Shreds and Patches',
    'https://ifdb.org/viewgame?id=9ntef9expou18abv',
    'ZIP'
  ], */ /* [
    'A Mind Forever Voyaging',
    'https://ifdb.org/viewgame?id=4h62dvooeg9ajtfa',
    'CORS'
  ], */ /* [
    'SPY INTRIGUE',
    'https://ifdb.org/viewgame?id=zz6i7irfr70nvp7a',
    'TWINE'
  ], */ /* [
    'Wishbringer',
    'https://ifdb.org/viewgame?id=z02joykzh66wfhcl',
    'CORS'
  ], */ [
        "A Beauty Cold and Austere",
        "https://ifdb.org/viewgame?id=y9y7jozi0l76bb82",
        "https://ifarchive.org/if-archive/games/competition2017/A%20Beauty%20Cold%20and%20Austere/A_Beauty_Cold_and_Austere.gblorb"
    ],
    /* [
    'Cactus Blue Motel',
    'https://ifdb.org/viewgame?id=7e699ifb6u3767yr',
    'TWINE'
  ], */ [
        "Coloratura",
        "https://ifdb.org/viewgame?id=g0fl99ovcrq2sqzk",
        "https://mirror.ifarchive.org/if-archive/games/competition2013/glulx/coloratura/Coloratura.gblorb"
    ],
    /* [
    'Harmonia',
    'https://ifdb.org/viewgame?id=bkyia4k48od1ila',
    'TWINE'
  ], */ [
        "Lime Ergot",
        "https://ifdb.org/viewgame?id=b8mb4fcwmf1hrxl",
        "https://mirror.ifarchive.org/if-archive/games/glulx/Lime_Ergot.gblorb"
    ],
    [
        "Rameses",
        "https://ifdb.org/viewgame?id=0stz0hr7a98bp9mp",
        "https://mirror.ifarchive.org/if-archive/games/zcode/rameses.zblorb"
    ],
    /* [
    'Spellbreaker',
    'https://ifdb.org/viewgame?id=wqsmrahzozosu3r',
    'CORS'
  ], */ /* [
    'Suspended',
    'https://ifdb.org/viewgame?id=t47hei9uq10xoar8',
    'CORS'
  ], */ [
        "The Wand",
        "https://ifdb.org/viewgame?id=2jil5vbxmbv8riv1",
        "https://ifarchive.org/if-archive/games/glulx/Wand.ulx"
    ],
    /* [
    'Zork I',
    'https://ifdb.org/viewgame?id=0dbnusxunq7fw5ro',
    'ZIP'
  ], */ [
        "1893: A World's Fair Mystery",
        "https://ifdb.org/viewgame?id=00e0t7swrris5pg6",
        "https://mirror.ifarchive.org/if-archive/games/tads/1893.gam"
    ],
    [
        "Adventure",
        "https://ifdb.org/viewgame?id=fft6pu91j85y4acv",
        "https://mirror.ifarchive.org/if-archive/games/zcode/Advent.z5"
    ],
    [
        "Alias 'The Magpie'",
        "https://ifdb.org/viewgame?id=yspn49v69hzc8rtb",
        "https://ifarchive.org/if-archive/games/competition2018/Alias%20The%20Magpie/Alias%20%27The%20Magpie%27.gblorb"
    ],
    /* [
    'De Baron',
    'https://ifdb.org/viewgame?id=weac28l51hiqfzxz',
    'ZIP'
  ], */ /* [
    'Bogeyman',
    'https://ifdb.org/viewgame?id=ltwvgb2lubkx82yi',
    'TWINE'
  ], */ [
        "Cragne Manor",
        "https://ifdb.org/viewgame?id=4x7nltu8p851tn4x",
        "https://mirror.ifarchive.org/if-archive/games/glulx/cragne.gblorb"
    ],
    [
        "The Edifice",
        "https://ifdb.org/viewgame?id=4tb9soabrb4apqzd",
        "https://mirror.ifarchive.org/if-archive/games/zcode/edifice.z5"
    ],
    [
        "Endless, Nameless",
        "https://ifdb.org/viewgame?id=7vtm1rq16hh3xch",
        "https://ifarchive.org/if-archive/games/zcode/nameless.z8"
    ],
    [
        "Everybody Dies",
        "https://ifdb.org/viewgame?id=lyblvftb8xtlo0a1",
        "https://mirror.ifarchive.org/if-archive/games/competition2008/glulx/everybodydies/EverybodyDies.gblorb"
    ],
    /* [
    'Fallen London',
    'https://ifdb.org/viewgame?id=y9m60ythcj2xn9r',
    'STORYNEXUS'
  ], */ [
        "Foo Foo",
        "https://ifdb.org/viewgame?id=ec6x9y8qcmsrxob9",
        "https://ifarchive.org/if-archive/games/springthing/2016/FooFoo.gblorb"
    ],
    [
        "The Gostak",
        "https://ifdb.org/viewgame?id=w5s3sv43s3p98v45",
        "https://mirror.ifarchive.org/if-archive/games/zcode/gostak.z5"
    ],
    /* [
    'The Hitchhiker\'s Guide to the Galaxy',
    'https://ifdb.org/viewgame?id=ouv80gvsl32xlion',
    'CORS https://www.douglasadams.com/creations/hhgg.z3'
  ], */ /* [
    'Hoist Sail for the Heliopause and Home',
    'https://ifdb.org/viewgame?id=ykccumi5xc5rltev',
    'CORS https://eblong.com/zarf/ftp/Heliopause.zblorb'
  ], */ /* [
    'Human Errors',
    'https://ifdb.org/viewgame?id=14oexa2wyym73glu',
    'TWINE'
  ], */ [
        "Inside the Facility",
        "https://ifdb.org/viewgame?id=stsdri5zh7a4i5my",
        "https://ifarchive.org/if-archive/games/competition2016/Inside%20the%20Facility/Facility.z8"
    ],
    /* [
    'Junior Arithmancer',
    'https://ifdb.org/viewgame?id=pw1rbjt1t4n4n87s',
    'https://ifarchive.org/if-archive/games/competition2018/Junior%20Arithmancer/Junior_Arithmancer.gblorb',
  ], */ [
        "Make It Good",
        "https://ifdb.org/viewgame?id=jdrbw1htq4ah8q57",
        "https://mirror.ifarchive.org/if-archive/games/zcode/MakeItGood.z8"
    ],
    [
        "Sub Rosa",
        "https://ifdb.org/viewgame?id=73nvz9yui87ub3sd",
        "https://mirror.ifarchive.org/if-archive/games/glulx/Sub_Rosa.gblorb"
    ],
    [
        "Suveh Nux",
        "https://ifdb.org/viewgame?id=xkai23ry99qdxce3",
        "https://mirror.ifarchive.org/if-archive/games/zcode/suvehnux.z5"
    ],
    /* [
    'their angelical understanding',
    'https://ifdb.org/viewgame?id=zpmfvbgolvfwbid',
    'TWINE'
  ], */ /* [
    'Toby\'s Nose',
    'https://ifdb.org/viewgame?id=xf5y04yekcrqtnc',
    'CORS https://www.castleprincessdragon.com/InteractiveFiction/TobysNose/Toby\'s%20Nose.gblorb'
  ], */ [
        "Varicella",
        "https://ifdb.org/viewgame?id=ywwlr3tpxnktjasd",
        "https://mirror.ifarchive.org/if-archive/games/zcode/vgame.z8"
    ]
].map(([name, ifdb, url])=>({
        name: name,
        ifdb: ifdb,
        url: url
    }));


var $760411a9160bcc21$export$79863f625c4e57;
var $760411a9160bcc21$export$ccc8042d79dd0831;
$760411a9160bcc21$export$79863f625c4e57 = `-soi4G_games`;
$760411a9160bcc21$export$ccc8042d79dd0831 = `-soi4G_tutorial`;


const $a9795ef4044b2e22$var$tutorialGame = {
    name: "The Dreamhold",
    ifdb: "https://ifdb.org/viewgame?id=3myqnrs64nbtwdaz",
    url: "https://mirror.ifarchive.org/if-archive/games/zcode/dreamhold.z8"
};
function $a9795ef4044b2e22$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("main", {
        className: $760411a9160bcc21$export$79863f625c4e57,
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h1", {
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: "https://ifdb.org/",
                        title: "The Interactive Fiction Database",
                        children: "IFDB"
                    }),
                    " Games"
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                children: [
                    "Choose one or ",
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                        href: "/",
                        children: "go back"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                className: $760411a9160bcc21$export$ccc8042d79dd0831,
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                        children: "Tutorial"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                        children: "If you are not familiar with Interactive Fiction, you should start with this tutorial game by\xa0Andrew\xa0Plotkin:"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("ul", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                            children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $c416337fc7df6b27$export$2e2bcd8739ae039), {
                                ...$a9795ef4044b2e22$var$tutorialGame
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                children: "Interactive Fiction Top 50 of All Time"
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: "https://ifdb.org/search?comp&sortby=awn&searchfor=series%3AInteractive+Fiction+Top+50+of+All+Time",
                        children: "Every four years "
                    }),
                    ", Victor Gijsbers puts together a list of the top 50 IF games of all time. Here is an almost complete and slightly rearranged version of the ",
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: "https://ifdb.org/viewcomp?id=1lv599reviaxvwo7",
                        children: "list from 2019"
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("ol", {
                children: (0, $8072c402bd1a5d6e$export$2e2bcd8739ae039).map((game)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("li", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $c416337fc7df6b27$export$2e2bcd8739ae039), {
                            ...game
                        })
                    }, game.name))
            })
        ]
    });
}




var $6b876c53408b349f$export$97aac956da55dae9;
var $6b876c53408b349f$export$b7e3ae3d7c15e42e;
var $6b876c53408b349f$export$a8ecead220dd38a6;
var $6b876c53408b349f$export$c789db2c85949867;
var $6b876c53408b349f$export$d61e5f8e032e1547;
var $6b876c53408b349f$export$77694752ff0b3730;
var $6b876c53408b349f$export$d9a33280f07116d9;
$6b876c53408b349f$export$97aac956da55dae9 = `qdlvgW_current`;
$6b876c53408b349f$export$b7e3ae3d7c15e42e = `qdlvgW_input`;
$6b876c53408b349f$export$a8ecead220dd38a6 = `qdlvgW_message`;
$6b876c53408b349f$export$c789db2c85949867 = `qdlvgW_output`;
$6b876c53408b349f$export$d61e5f8e032e1547 = `qdlvgW_subheader`;
$6b876c53408b349f$export$77694752ff0b3730 = `qdlvgW_themePreview`;
$6b876c53408b349f$export$d9a33280f07116d9 = `qdlvgW_themes`;


const $d21b3c63351f5932$var$Preview = (themeEngine, theme)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
        className: [
            $6b876c53408b349f$export$77694752ff0b3730,
            theme
        ].join(" "),
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                className: $6b876c53408b349f$export$c789db2c85949867,
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                        className: [
                            $6b876c53408b349f$export$a8ecead220dd38a6,
                            $6b876c53408b349f$export$b7e3ae3d7c15e42e
                        ].join(" "),
                        children: "> look"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {})
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                        className: [
                            $6b876c53408b349f$export$a8ecead220dd38a6,
                            $6b876c53408b349f$export$d61e5f8e032e1547
                        ].join(" "),
                        children: theme
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                        children: "Observe a vibrant demonstration of colors at work, showcasing their versatile usage right before your eyes."
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("button", {
                onClick: ()=>themeEngine.setTheme(theme),
                children: "Apply this colors"
            })
        ]
    }, theme);
function $d21b3c63351f5932$export$2e2bcd8739ae039({ themeEngine: themeEngine }) {
    const themes = themeEngine.themes.map((theme)=>$d21b3c63351f5932$var$Preview(themeEngine, theme));
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("main", {
        className: $6b876c53408b349f$export$d9a33280f07116d9,
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h1", {
                children: "Themes Page"
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                children: [
                    "Choose one or ",
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                        href: "/",
                        children: "go back"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                className: [
                    $6b876c53408b349f$export$77694752ff0b3730,
                    $6b876c53408b349f$export$97aac956da55dae9
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                        children: "Current Theme"
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                        className: $6b876c53408b349f$export$c789db2c85949867,
                        children: [
                            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                                className: [
                                    $6b876c53408b349f$export$a8ecead220dd38a6,
                                    $6b876c53408b349f$export$b7e3ae3d7c15e42e
                                ].join(" "),
                                children: "> look"
                            }),
                            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                                children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {})
                            }),
                            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                                className: [
                                    $6b876c53408b349f$export$a8ecead220dd38a6,
                                    $6b876c53408b349f$export$d61e5f8e032e1547
                                ].join(" "),
                                children: [
                                    "Selected: ",
                                    themeEngine.currentTheme
                                ]
                            }),
                            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                                children: "You can set random one with the button below or choose any theme from the list."
                            }),
                            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                                children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("button", {
                        onClick: ()=>themeEngine.setRandomTheme(),
                        children: "Set a random theme"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h2", {
                children: "Theme List"
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                children: themes
            })
        ]
    });
}






/*

Emglken port of Bocfel
======================

Copyright (c) 2021 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ /*

Emglken VM
==========

Copyright (c) 2022 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ /*

Emglken File System
===================

Copyright (c) 2020 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ const $02f1d47ba060901a$var$DIR_MODE = 16895 // 040777
;
const $02f1d47ba060901a$var$FILE_MODE = 33206 // 100666
;
const $02f1d47ba060901a$var$SEEK_SET = 0;
const $02f1d47ba060901a$var$SEEK_CUR = 1;
const $02f1d47ba060901a$var$SEEK_END = 2;
// WASI error codes
// See https://github.com/WebAssembly/wasi-libc/blob/master/libc-bottom-half/headers/public/wasi/api.h
const $02f1d47ba060901a$var$EINVAL = 28;
const $02f1d47ba060901a$var$ENOENT = 44;
// Convert Linux flags to Glk flags
const $02f1d47ba060901a$var$filemode_Write = 1;
const $02f1d47ba060901a$var$filemode_Read = 2;
const $02f1d47ba060901a$var$filemode_ReadWrite = 3;
const $02f1d47ba060901a$var$filemode_WriteAppend = 5;
function $02f1d47ba060901a$var$convert_flags(flags) {
    // O_APPEND => filemode_WriteAppend
    if (flags & 0x400) return $02f1d47ba060901a$var$filemode_WriteAppend;
    // O_WRONLY => filemode_Write
    if (flags & 1) return $02f1d47ba060901a$var$filemode_Write;
    // O_RDWR => filemode_ReadWrite
    if (flags & 2) return $02f1d47ba060901a$var$filemode_ReadWrite;
    // O_RDONLY => filemode_Read
    return $02f1d47ba060901a$var$filemode_Read;
}
class $02f1d47ba060901a$export$2e2bcd8739ae039 {
    constructor(VM){
        this.dialog = VM.options.Dialog;
        this.streaming = this.dialog.streaming;
        this.FS = VM.Module.FS;
        this.VM = VM;
        this.filename_map = {};
        this.filename_counter = 0;
    }
    close(stream) {
        if (stream.name === "storyfile") ;
        else {
            if (this.streaming) stream.fstream.fclose();
            else if (stream.fmode !== $02f1d47ba060901a$var$filemode_Read) this.dialog.file_write(stream.fref, stream.data);
        }
    }
    createNode(parent, name, mode /*, dev*/ ) {
        const FS = this.FS;
        if (!FS.isDir(mode) && !FS.isFile(mode)) throw new FS.ErrnoError($02f1d47ba060901a$var$EINVAL);
        const node = FS.createNode(parent, name, mode);
        node.node_ops = this;
        node.stream_ops = this;
        node.timestamp = Date.now();
        return node;
    }
    getattr(node) {
        // At present only the size of the storyfile will be returned, as needed by Bocfel
        const size = node.name === "storyfile" ? this.VM.data.length : 0;
        // Not sure what to return here, so only return stuff some of it
        return {
            atime: new Date(node.timestamp),
            ctime: new Date(node.timestamp),
            dev: 1,
            gid: 0,
            ino: node.id,
            mode: node.mode,
            mtime: new Date(node.timestamp),
            nlink: 1,
            rdev: node.rdev,
            size: size,
            uid: 0
        };
    }
    // Get a Dialog ref for non-streaming Dialogs
    get_dialog_ref(filename) {
        let [name, usage] = filename.split(".");
        // RemGlk sends usages starting with 'glk', but Dialog wants them without
        usage = usage.replace("glk", "");
        // Retrieve the game ID if opening a savefile
        let gameid = "";
        if (usage === "save") gameid = this.VM.Module.AsciiToString(this.VM.Module._gidispatch_get_game_id());
        return this.dialog.file_construct_ref(name, usage, gameid);
    }
    llseek(stream, offset, whence) {
        let position = offset;
        if (whence === $02f1d47ba060901a$var$SEEK_CUR) position += stream.position;
        else if (whence === $02f1d47ba060901a$var$SEEK_END) {
            if (stream.name === "storyfile") position += stream.data.length;
            else if (this.streaming) {
                const curpos = stream.fstream.ftell();
                stream.fstream.fseek(0, $02f1d47ba060901a$var$SEEK_END);
                position += stream.fstream.ftell();
                stream.fstream.fseek(curpos, $02f1d47ba060901a$var$SEEK_SET);
            } else position += stream.data.length;
        }
        if (position < 0) throw new this.FS.ErrnoError($02f1d47ba060901a$var$EINVAL);
        return position;
    }
    lookup(parent, name) {
        if (name !== "storyfile") {
            const realname = this.filename_map[name] || name;
            if (!this.dialog.file_ref_exists(this.streaming ? {
                filename: realname
            } : this.get_dialog_ref(realname))) throw new this.FS.ErrnoError($02f1d47ba060901a$var$ENOENT);
        }
        return this.createNode(parent, name, $02f1d47ba060901a$var$FILE_MODE);
    }
    mknod(parent, name, mode /*, dev*/ ) {
        return this.createNode(parent, name, mode);
    }
    mmap() {
        throw new Error("EmglkenFS.mmap");
    }
    mount() {
        return this.createNode(null, "/", $02f1d47ba060901a$var$DIR_MODE, 0);
    }
    msync() {
        throw new Error("EmglkenFS.msync");
    }
    open(stream) {
        stream.name = stream.node.name;
        if (stream.name === "storyfile") stream.data = this.VM.data;
        else {
            const fmode = $02f1d47ba060901a$var$convert_flags(stream.flags);
            const realname = this.filename_map[stream.name] || stream.name;
            if (this.streaming) stream.fstream = this.dialog.file_fopen(fmode, {
                filename: realname
            });
            else {
                stream.fref = this.get_dialog_ref(realname);
                stream.fmode = fmode;
                // Read the content if not overwriting
                stream.data = null;
                if (fmode !== $02f1d47ba060901a$var$filemode_Write) stream.data = this.dialog.file_read(stream.fref);
                // If no file and not reading, create a blank file
                if (stream.data == null) {
                    stream.data = new Uint8Array(0);
                    if (fmode !== $02f1d47ba060901a$var$filemode_Read) this.dialog.file_write(stream.fref, "", true);
                }
            //stream.position = fmode === filemode_WriteAppend ? data.length : 0
            }
        }
    }
    read(stream, buffer, offset, length, position) {
        if (length === 0) return 0;
        if (stream.name === "storyfile") {
            const size = Math.min(stream.data.length - position, length);
            buffer.set(stream.data.subarray(position, position + size), offset);
            return size;
        } else if (this.streaming) {
            stream.fstream.fseek(position, $02f1d47ba060901a$var$SEEK_SET);
            const buf = stream.fstream.BufferClass.from(buffer.buffer, offset, length);
            return stream.fstream.fread(buf, length);
        } else {
            const size = Math.min(stream.data.length - position, length);
            buffer.set(stream.data.subarray(position, position + size), offset);
            return size;
        }
    }
    readdir() {
        throw new Error("EmglkenFS.readdir");
    }
    readlink() {
        throw new this.FS.ErrnoError($02f1d47ba060901a$var$EINVAL);
    }
    // electrofs.js will give a full system path, which we can't handle. So store the full path and return a fake file name
    register_filename(filename, usage) {
        const suffix = usage === "save" ? ".glksave" : usage === "data" ? ".glkdata" : ".txt";
        if (!/\.(glkdata|glksave|txt)$/.test(filename)) filename = filename + suffix;
        if (this.filename_map[filename]) return this.filename_map[filename];
        const fakename = "emglken_fake_file_" + this.filename_counter++;
        this.filename_map[filename] = fakename;
        this.filename_map[fakename + suffix] = filename;
        return fakename;
    }
    rename() {
        throw new Error("EmglkenFS.rename");
    }
    rmdir() {
        throw new Error("EmglkenFS.rmdir");
    }
    setattr() {
    // I don't think we need to do anything here?
    // Maybe truncate a file?
    }
    symlink() {
        throw new Error("EmglkenFS.symlink");
    }
    unlink(parent, name) {
        const realname = this.filename_map[name] || name;
        this.dialog.file_remove_ref(this.get_dialog_ref(realname));
    }
    write(stream, buffer, offset, length, position) {
        if (stream.name === "storyfile") throw new Error("EmglkenFS.write: cannot write to storyfile");
        if (this.streaming) {
            stream.fstream.fseek(position, $02f1d47ba060901a$var$SEEK_SET);
            const buf = stream.fstream.BufferClass.from(buffer).subarray(offset, offset + length);
            return stream.fstream.fwrite(buf, length);
        } else {
            position = position || stream.position;
            const end_of_write = length + position;
            if (end_of_write > stream.data.length) {
                const old_data = stream.data;
                stream.data = new Uint8Array(end_of_write);
                stream.data.set(old_data);
            }
            stream.data.set(buffer.subarray(offset, offset + length), position);
            return length;
        }
    }
}


const $7c4ebf67e8338ec8$var$base_options = {
    arguments: [
        "storyfile"
    ]
};
class $7c4ebf67e8338ec8$export$2e2bcd8739ae039 {
    // Store the data and options
    init(data, options) {
        this.data = data;
        this.options = Object.assign({}, $7c4ebf67e8338ec8$var$base_options, this.default_options(), options);
    }
    // Start GlkOte and the vmcore
    async start() {
        const encoder = new TextEncoder();
        let buffer = "";
        const Module = {
            arguments: this.options.show_help ? [
                "-help"
            ] : this.options.arguments,
            emglken_stdin_buffers: [],
            emglken_stdin_ready () {},
            // Fake locateFile so that Lectrote doesn't get tripped up on import.meta.url not being handled in CJS properly
            locateFile () {},
            print: (data)=>{
                if (buffer === "" && data !== "" && !data.startsWith("{")) console.log(data);
                else {
                    buffer += data;
                    if (data.endsWith("}")) {
                        let obj;
                        try {
                            obj = JSON.parse(buffer);
                        } catch (e) {}
                        if (obj) {
                            buffer = "";
                            // Store the usage of a fileref prompt request
                            if (obj.specialinput && obj.specialinput.type === "fileref_prompt") this.last_fr_usage = obj.specialinput.filetype;
                            this.options.GlkOte.update(obj);
                        }
                    }
                }
            },
            preRun: ()=>{
                const FS = Module.FS;
                this.EFS = new (0, $02f1d47ba060901a$export$2e2bcd8739ae039)(this);
                FS.mkdir("/emglken");
                FS.mount(this.EFS, {}, "/emglken");
                FS.chdir("/emglken");
            },
            wasmBinary: this.options.wasmBinary
        };
        this.Module = Module;
        this.options.accept = (data)=>{
            if (data.type === "specialresponse" && data.response === "fileref_prompt" && data.value) {
                // electrofs.js returns a full path, so register it with EmglkenFS, and return a fake filename
                if (this.EFS.streaming) data.value = this.EFS.register_filename(data.value.filename, this.last_fr_usage);
                else data.value = data.value.filename;
            }
            const json_data = JSON.stringify(data);
            const buffer = encoder.encode(json_data);
            Module.emglken_stdin_buffers.push(buffer);
            Module.emglken_stdin_ready();
        };
        await this.options.vmcore(Module);
        this.options.GlkOte.init(this.options);
    }
}


var $15b39ab17ec5a236$exports = {};


$15b39ab17ec5a236$exports = (parcelRequire("6kBsm")).getBundleURL("ejVIo") + (parcelRequire("n9Yfb")).resolve("5EF4K");


var $1c3c240882313db4$var$Module = (()=>{
    var _scriptDir = "file:///node_modules/emglken/build/bocfel-core.js";
    return function(Module = {}) {
        var Module = typeof Module != "undefined" ? Module : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || false;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
            if (!condition) abort(text);
        }
        var UTF8Decoder = new TextDecoder("utf8");
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            return UTF8Decoder.decode(heapOrArray.buffer ? heapOrArray.subarray(idx, endPtr) : new Uint8Array(heapOrArray.slice(idx, endPtr)));
        }
        function UTF8ToString(ptr, maxBytesToRead) {
            if (!ptr) return "";
            var maxPtr = ptr + maxBytesToRead;
            for(var end = ptr; !(end >= maxPtr) && HEAPU8[end];)++end;
            return UTF8Decoder.decode(HEAPU8.subarray(ptr, end));
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATMAIN__ = [];
        var __ATEXIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeExited = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() {
            return noExitRuntime || runtimeKeepaliveCounter > 0;
        }
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
            FS.ignorePermissions = false;
            TTY.init();
            callRuntimeCallbacks(__ATINIT__);
        }
        function preMain() {
            callRuntimeCallbacks(__ATMAIN__);
        }
        function exitRuntime() {
            ___funcs_on_exit();
            callRuntimeCallbacks(__ATEXIT__);
            FS.quit();
            TTY.shutdown();
            runtimeExited = true;
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
            return id;
        }
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        if (Module["locateFile"]) {
            wasmBinaryFile = "bocfel-core.wasm";
            if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        } else wasmBinaryFile = new URL($15b39ab17ec5a236$exports).href;
        function getBinary(file) {
            try {
                if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                if (readBinary) return readBinary(file);
                throw "both async and sync fetching of the wasm failed";
            } catch (err) {
                abort(err);
            }
        }
        function getBinaryPromise(binaryFile) {
            if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                if (typeof fetch == "function") return fetch(binaryFile, {
                    credentials: "same-origin"
                }).then(function(response) {
                    if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                    return response["arrayBuffer"]();
                }).catch(function() {
                    return getBinary(binaryFile);
                });
            }
            return Promise.resolve().then(function() {
                return getBinary(binaryFile);
            });
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
            return getBinaryPromise(binaryFile).then(function(binary) {
                return WebAssembly.instantiate(binary, imports);
            }).then(function(instance) {
                return instance;
            }).then(receiver, function(reason) {
                err("failed to asynchronously prepare wasm: " + reason);
                abort(reason);
            });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
            if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                credentials: "same-origin"
            }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, imports);
                return result.then(callback, function(reason) {
                    err("wasm streaming compile failed: " + reason);
                    err("falling back to ArrayBuffer instantiation");
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                });
            });
            else return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                exports = Asyncify.instrumentWasmExports(exports);
                Module["asm"] = exports;
                wasmMemory = Module["asm"]["da"];
                updateMemoryViews();
                wasmTable = Module["asm"]["na"];
                addOnInit(Module["asm"]["ea"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            function receiveInstantiationResult(result) {
                receiveInstance(result["instance"]);
            }
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
            return {};
        }
        var tempDouble;
        var tempI64;
        function __asyncjs__emglken_fill_stdin_buffer(buffer, maxlen) {
            return Asyncify.handleAsync(async ()=>{
                if (!Module.emglken_stdin_buffers.length) await new Promise((resolve)=>{
                    Module.emglken_stdin_ready = resolve;
                });
                const input = Module.emglken_stdin_buffers.shift();
                const len = Math.min(input.length, maxlen);
                if (len == input.length) HEAPU8.set(input, buffer);
                else {
                    HEAPU8.set(input.subarray(0, len), buffer);
                    Module.emglken_stdin_buffers.unshift(input.subarray(len));
                }
                return len;
            });
        }
        function ExitStatus(status) {
            this.name = "ExitStatus";
            this.message = "Program terminated with exit(" + status + ")";
            this.status = status;
        }
        function callRuntimeCallbacks(callbacks) {
            while(callbacks.length > 0)callbacks.shift()(Module);
        }
        var exceptionCaught = [];
        function exception_addRef(info) {
            info.add_ref();
        }
        var uncaughtExceptionCount = 0;
        function ___cxa_begin_catch(ptr) {
            var info = new ExceptionInfo(ptr);
            if (!info.get_caught()) {
                info.set_caught(true);
                uncaughtExceptionCount--;
            }
            info.set_rethrown(false);
            exceptionCaught.push(info);
            exception_addRef(info);
            return info.get_exception_ptr();
        }
        var exceptionLast = 0;
        function exception_decRef(info) {
            if (info.release_ref() && !info.get_rethrown()) {
                var destructor = info.get_destructor();
                if (destructor) ((a1)=>dynCall_ii.apply(null, [
                        destructor,
                        a1
                    ]))(info.excPtr);
                ___cxa_free_exception(info.excPtr);
            }
        }
        function ___cxa_end_catch() {
            _setThrew(0);
            var info = exceptionCaught.pop();
            exception_decRef(info);
            exceptionLast = 0;
        }
        function ExceptionInfo(excPtr) {
            this.excPtr = excPtr;
            this.ptr = excPtr - 24;
            this.set_type = function(type) {
                HEAPU32[this.ptr + 4 >> 2] = type;
            };
            this.get_type = function() {
                return HEAPU32[this.ptr + 4 >> 2];
            };
            this.set_destructor = function(destructor) {
                HEAPU32[this.ptr + 8 >> 2] = destructor;
            };
            this.get_destructor = function() {
                return HEAPU32[this.ptr + 8 >> 2];
            };
            this.set_refcount = function(refcount) {
                HEAP32[this.ptr >> 2] = refcount;
            };
            this.set_caught = function(caught) {
                caught = caught ? 1 : 0;
                HEAP8[this.ptr + 12 >> 0] = caught;
            };
            this.get_caught = function() {
                return HEAP8[this.ptr + 12 >> 0] != 0;
            };
            this.set_rethrown = function(rethrown) {
                rethrown = rethrown ? 1 : 0;
                HEAP8[this.ptr + 13 >> 0] = rethrown;
            };
            this.get_rethrown = function() {
                return HEAP8[this.ptr + 13 >> 0] != 0;
            };
            this.init = function(type, destructor) {
                this.set_adjusted_ptr(0);
                this.set_type(type);
                this.set_destructor(destructor);
                this.set_refcount(0);
                this.set_caught(false);
                this.set_rethrown(false);
            };
            this.add_ref = function() {
                var value = HEAP32[this.ptr >> 2];
                HEAP32[this.ptr >> 2] = value + 1;
            };
            this.release_ref = function() {
                var prev = HEAP32[this.ptr >> 2];
                HEAP32[this.ptr >> 2] = prev - 1;
                return prev === 1;
            };
            this.set_adjusted_ptr = function(adjustedPtr) {
                HEAPU32[this.ptr + 16 >> 2] = adjustedPtr;
            };
            this.get_adjusted_ptr = function() {
                return HEAPU32[this.ptr + 16 >> 2];
            };
            this.get_exception_ptr = function() {
                var isPointer = ___cxa_is_pointer_type(this.get_type());
                if (isPointer) return HEAPU32[this.excPtr >> 2];
                var adjusted = this.get_adjusted_ptr();
                if (adjusted !== 0) return adjusted;
                return this.excPtr;
            };
        }
        function ___resumeException(ptr) {
            if (!exceptionLast) exceptionLast = ptr;
            throw ptr;
        }
        function ___cxa_find_matching_catch() {
            var thrown = exceptionLast;
            if (!thrown) {
                setTempRet0(0);
                return 0;
            }
            var info = new ExceptionInfo(thrown);
            info.set_adjusted_ptr(thrown);
            var thrownType = info.get_type();
            if (!thrownType) {
                setTempRet0(0);
                return thrown;
            }
            for(var i = 0; i < arguments.length; i++){
                var caughtType = arguments[i];
                if (caughtType === 0 || caughtType === thrownType) break;
                var adjusted_ptr_addr = info.ptr + 16;
                if (___cxa_can_catch(caughtType, thrownType, adjusted_ptr_addr)) {
                    setTempRet0(caughtType);
                    return thrown;
                }
            }
            setTempRet0(thrownType);
            return thrown;
        }
        var ___cxa_find_matching_catch_2 = ___cxa_find_matching_catch;
        var ___cxa_find_matching_catch_3 = ___cxa_find_matching_catch;
        var ___cxa_find_matching_catch_4 = ___cxa_find_matching_catch;
        var ___cxa_find_matching_catch_5 = ___cxa_find_matching_catch;
        var ___cxa_find_matching_catch_6 = ___cxa_find_matching_catch;
        var ___cxa_find_matching_catch_7 = ___cxa_find_matching_catch;
        function ___cxa_rethrow() {
            var info = exceptionCaught.pop();
            if (!info) abort("no exception to throw");
            var ptr = info.excPtr;
            if (!info.get_rethrown()) {
                exceptionCaught.push(info);
                info.set_rethrown(true);
                info.set_caught(false);
                uncaughtExceptionCount++;
            }
            exceptionLast = ptr;
            throw ptr;
        }
        function ___cxa_throw(ptr, type, destructor) {
            var info = new ExceptionInfo(ptr);
            info.init(type, destructor);
            exceptionLast = ptr;
            uncaughtExceptionCount++;
            throw ptr;
        }
        function ___cxa_uncaught_exceptions() {
            return uncaughtExceptionCount;
        }
        var PATH = {
            isAbs: (path)=>path.charAt(0) === "/",
            splitPath: (filename)=>{
                var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return splitPathRe.exec(filename).slice(1);
            },
            normalizeArray: (parts, allowAboveRoot)=>{
                var up = 0;
                for(var i = parts.length - 1; i >= 0; i--){
                    var last = parts[i];
                    if (last === ".") parts.splice(i, 1);
                    else if (last === "..") {
                        parts.splice(i, 1);
                        up++;
                    } else if (up) {
                        parts.splice(i, 1);
                        up--;
                    }
                }
                if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                return parts;
            },
            normalize: (path)=>{
                var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                if (!path && !isAbsolute) path = ".";
                if (path && trailingSlash) path += "/";
                return (isAbsolute ? "/" : "") + path;
            },
            dirname: (path)=>{
                var result = PATH.splitPath(path), root = result[0], dir = result[1];
                if (!root && !dir) return ".";
                if (dir) dir = dir.substr(0, dir.length - 1);
                return root + dir;
            },
            basename: (path)=>{
                if (path === "/") return "/";
                path = PATH.normalize(path);
                path = path.replace(/\/$/, "");
                var lastSlash = path.lastIndexOf("/");
                if (lastSlash === -1) return path;
                return path.substr(lastSlash + 1);
            },
            join: function() {
                var paths = Array.prototype.slice.call(arguments);
                return PATH.normalize(paths.join("/"));
            },
            join2: (l, r)=>{
                return PATH.normalize(l + "/" + r);
            }
        };
        function getRandomDevice() {
            if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                var randomBuffer = new Uint8Array(1);
                return ()=>{
                    crypto.getRandomValues(randomBuffer);
                    return randomBuffer[0];
                };
            } else return ()=>abort("randomDevice");
        }
        var PATH_FS = {
            resolve: function() {
                var resolvedPath = "", resolvedAbsolute = false;
                for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                    var path = i >= 0 ? arguments[i] : FS.cwd();
                    if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                    else if (!path) return "";
                    resolvedPath = path + "/" + resolvedPath;
                    resolvedAbsolute = PATH.isAbs(path);
                }
                resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
            },
            relative: (from, to)=>{
                from = PATH_FS.resolve(from).substr(1);
                to = PATH_FS.resolve(to).substr(1);
                function trim(arr) {
                    var start = 0;
                    for(; start < arr.length; start++){
                        if (arr[start] !== "") break;
                    }
                    var end = arr.length - 1;
                    for(; end >= 0; end--){
                        if (arr[end] !== "") break;
                    }
                    if (start > end) return [];
                    return arr.slice(start, end - start + 1);
                }
                var fromParts = trim(from.split("/"));
                var toParts = trim(to.split("/"));
                var length = Math.min(fromParts.length, toParts.length);
                var samePartsLength = length;
                for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i;
                    break;
                }
                var outputParts = [];
                for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                outputParts = outputParts.concat(toParts.slice(samePartsLength));
                return outputParts.join("/");
            }
        };
        function intArrayFromString(stringy, dontAddNull, length) {
            var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull) u8array.length = numBytesWritten;
            return u8array;
        }
        var TTY = {
            ttys: [],
            init: function() {},
            shutdown: function() {},
            register: function(dev, ops) {
                TTY.ttys[dev] = {
                    input: [],
                    output: [],
                    ops: ops
                };
                FS.registerDevice(dev, TTY.stream_ops);
            },
            stream_ops: {
                open: function(stream) {
                    var tty = TTY.ttys[stream.node.rdev];
                    if (!tty) throw new FS.ErrnoError(43);
                    stream.tty = tty;
                    stream.seekable = false;
                },
                close: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                fsync: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                read: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                    var bytesRead = 0;
                    for(var i = 0; i < length; i++){
                        var result;
                        try {
                            result = stream.tty.ops.get_char(stream.tty);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                        if (result === null || result === undefined) break;
                        bytesRead++;
                        buffer[offset + i] = result;
                    }
                    if (bytesRead) stream.node.timestamp = Date.now();
                    return bytesRead;
                },
                write: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                    try {
                        for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                    } catch (e) {
                        throw new FS.ErrnoError(29);
                    }
                    if (length) stream.node.timestamp = Date.now();
                    return i;
                }
            },
            default_tty_ops: {
                get_char: function(tty) {
                    if (!tty.input.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        tty.input = intArrayFromString(result, true);
                    }
                    return tty.input.shift();
                },
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            },
            default_tty1_ops: {
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            }
        };
        function mmapAlloc(size) {
            abort();
        }
        var MEMFS = {
            ops_table: null,
            mount: function(mount) {
                return MEMFS.createNode(null, "/", 16895, 0);
            },
            createNode: function(parent, name, mode, dev) {
                if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                if (!MEMFS.ops_table) MEMFS.ops_table = {
                    dir: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            lookup: MEMFS.node_ops.lookup,
                            mknod: MEMFS.node_ops.mknod,
                            rename: MEMFS.node_ops.rename,
                            unlink: MEMFS.node_ops.unlink,
                            rmdir: MEMFS.node_ops.rmdir,
                            readdir: MEMFS.node_ops.readdir,
                            symlink: MEMFS.node_ops.symlink
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek,
                            read: MEMFS.stream_ops.read,
                            write: MEMFS.stream_ops.write,
                            allocate: MEMFS.stream_ops.allocate,
                            mmap: MEMFS.stream_ops.mmap,
                            msync: MEMFS.stream_ops.msync
                        }
                    },
                    link: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            readlink: MEMFS.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: FS.chrdev_stream_ops
                    }
                };
                var node = FS.createNode(parent, name, mode, dev);
                if (FS.isDir(node.mode)) {
                    node.node_ops = MEMFS.ops_table.dir.node;
                    node.stream_ops = MEMFS.ops_table.dir.stream;
                    node.contents = {};
                } else if (FS.isFile(node.mode)) {
                    node.node_ops = MEMFS.ops_table.file.node;
                    node.stream_ops = MEMFS.ops_table.file.stream;
                    node.usedBytes = 0;
                    node.contents = null;
                } else if (FS.isLink(node.mode)) {
                    node.node_ops = MEMFS.ops_table.link.node;
                    node.stream_ops = MEMFS.ops_table.link.stream;
                } else if (FS.isChrdev(node.mode)) {
                    node.node_ops = MEMFS.ops_table.chrdev.node;
                    node.stream_ops = MEMFS.ops_table.chrdev.stream;
                }
                node.timestamp = Date.now();
                if (parent) {
                    parent.contents[name] = node;
                    parent.timestamp = node.timestamp;
                }
                return node;
            },
            getFileDataAsTypedArray: function(node) {
                if (!node.contents) return new Uint8Array(0);
                if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                return new Uint8Array(node.contents);
            },
            expandFileStorage: function(node, newCapacity) {
                var prevCapacity = node.contents ? node.contents.length : 0;
                if (prevCapacity >= newCapacity) return;
                var CAPACITY_DOUBLING_MAX = 1048576;
                newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                var oldContents = node.contents;
                node.contents = new Uint8Array(newCapacity);
                if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
            },
            resizeFileStorage: function(node, newSize) {
                if (node.usedBytes == newSize) return;
                if (newSize == 0) {
                    node.contents = null;
                    node.usedBytes = 0;
                } else {
                    var oldContents = node.contents;
                    node.contents = new Uint8Array(newSize);
                    if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                    node.usedBytes = newSize;
                }
            },
            node_ops: {
                getattr: function(node) {
                    var attr = {};
                    attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                    attr.ino = node.id;
                    attr.mode = node.mode;
                    attr.nlink = 1;
                    attr.uid = 0;
                    attr.gid = 0;
                    attr.rdev = node.rdev;
                    if (FS.isDir(node.mode)) attr.size = 4096;
                    else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                    else if (FS.isLink(node.mode)) attr.size = node.link.length;
                    else attr.size = 0;
                    attr.atime = new Date(node.timestamp);
                    attr.mtime = new Date(node.timestamp);
                    attr.ctime = new Date(node.timestamp);
                    attr.blksize = 4096;
                    attr.blocks = Math.ceil(attr.size / attr.blksize);
                    return attr;
                },
                setattr: function(node, attr) {
                    if (attr.mode !== undefined) node.mode = attr.mode;
                    if (attr.timestamp !== undefined) node.timestamp = attr.timestamp;
                    if (attr.size !== undefined) MEMFS.resizeFileStorage(node, attr.size);
                },
                lookup: function(parent, name) {
                    throw FS.genericErrors[44];
                },
                mknod: function(parent, name, mode, dev) {
                    return MEMFS.createNode(parent, name, mode, dev);
                },
                rename: function(old_node, new_dir, new_name) {
                    if (FS.isDir(old_node.mode)) {
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (new_node) {
                            for(var i in new_node.contents)throw new FS.ErrnoError(55);
                        }
                    }
                    delete old_node.parent.contents[old_node.name];
                    old_node.parent.timestamp = Date.now();
                    old_node.name = new_name;
                    new_dir.contents[new_name] = old_node;
                    new_dir.timestamp = old_node.parent.timestamp;
                    old_node.parent = new_dir;
                },
                unlink: function(parent, name) {
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                rmdir: function(parent, name) {
                    var node = FS.lookupNode(parent, name);
                    for(var i in node.contents)throw new FS.ErrnoError(55);
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                readdir: function(node) {
                    var entries = [
                        ".",
                        ".."
                    ];
                    for(var key in node.contents){
                        if (!node.contents.hasOwnProperty(key)) continue;
                        entries.push(key);
                    }
                    return entries;
                },
                symlink: function(parent, newname, oldpath) {
                    var node = MEMFS.createNode(parent, newname, 41471, 0);
                    node.link = oldpath;
                    return node;
                },
                readlink: function(node) {
                    if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                    return node.link;
                }
            },
            stream_ops: {
                read: function(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= stream.node.usedBytes) return 0;
                    var size = Math.min(stream.node.usedBytes - position, length);
                    if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    return size;
                },
                write: function(stream, buffer, offset, length, position, canOwn) {
                    if (buffer.buffer === HEAP8.buffer) canOwn = false;
                    if (!length) return 0;
                    var node = stream.node;
                    node.timestamp = Date.now();
                    if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                        if (canOwn) {
                            node.contents = buffer.subarray(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (node.usedBytes === 0 && position === 0) {
                            node.contents = buffer.slice(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (position + length <= node.usedBytes) {
                            node.contents.set(buffer.subarray(offset, offset + length), position);
                            return length;
                        }
                    }
                    MEMFS.expandFileStorage(node, position + length);
                    if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                    else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                    node.usedBytes = Math.max(node.usedBytes, position + length);
                    return length;
                },
                llseek: function(stream, offset, whence) {
                    var position = offset;
                    if (whence === 1) position += stream.position;
                    else if (whence === 2) {
                        if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                    }
                    if (position < 0) throw new FS.ErrnoError(28);
                    return position;
                },
                allocate: function(stream, offset, length) {
                    MEMFS.expandFileStorage(stream.node, offset + length);
                    stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                },
                mmap: function(stream, length, position, prot, flags) {
                    if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                    var ptr;
                    var allocated;
                    var contents = stream.node.contents;
                    if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                        allocated = false;
                        ptr = contents.byteOffset;
                    } else {
                        if (position > 0 || position + length < contents.length) {
                            if (contents.subarray) contents = contents.subarray(position, position + length);
                            else contents = Array.prototype.slice.call(contents, position, position + length);
                        }
                        allocated = true;
                        ptr = mmapAlloc(length);
                        if (!ptr) throw new FS.ErrnoError(48);
                        HEAP8.set(contents, ptr);
                    }
                    return {
                        ptr: ptr,
                        allocated: allocated
                    };
                },
                msync: function(stream, buffer, offset, length, mmapFlags) {
                    MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                    return 0;
                }
            }
        };
        function asyncLoad(url, onload, onerror, noRunDep) {
            var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
            readAsync(url, (arrayBuffer)=>{
                assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
                onload(new Uint8Array(arrayBuffer));
                if (dep) removeRunDependency(dep);
            }, (event)=>{
                if (onerror) onerror();
                else throw 'Loading data file "' + url + '" failed.';
            });
            if (dep) addRunDependency(dep);
        }
        var FS = {
            root: null,
            mounts: [],
            devices: {},
            streams: [],
            nextInode: 1,
            nameTable: null,
            currentPath: "/",
            initialized: false,
            ignorePermissions: true,
            ErrnoError: null,
            genericErrors: {},
            filesystems: null,
            syncFSRequests: 0,
            lookupPath: (path, opts = {})=>{
                path = PATH_FS.resolve(path);
                if (!path) return {
                    path: "",
                    node: null
                };
                var defaults = {
                    follow_mount: true,
                    recurse_count: 0
                };
                opts = Object.assign(defaults, opts);
                if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                var parts = path.split("/").filter((p)=>!!p);
                var current = FS.root;
                var current_path = "/";
                for(var i = 0; i < parts.length; i++){
                    var islast = i === parts.length - 1;
                    if (islast && opts.parent) break;
                    current = FS.lookupNode(current, parts[i]);
                    current_path = PATH.join2(current_path, parts[i]);
                    if (FS.isMountpoint(current)) {
                        if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                    }
                    if (!islast || opts.follow) {
                        var count = 0;
                        while(FS.isLink(current.mode)){
                            var link = FS.readlink(current_path);
                            current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                            var lookup = FS.lookupPath(current_path, {
                                recurse_count: opts.recurse_count + 1
                            });
                            current = lookup.node;
                            if (count++ > 40) throw new FS.ErrnoError(32);
                        }
                    }
                }
                return {
                    path: current_path,
                    node: current
                };
            },
            getPath: (node)=>{
                var path;
                while(true){
                    if (FS.isRoot(node)) {
                        var mount = node.mount.mountpoint;
                        if (!path) return mount;
                        return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
                    }
                    path = path ? node.name + "/" + path : node.name;
                    node = node.parent;
                }
            },
            hashName: (parentid, name)=>{
                var hash = 0;
                for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                return (parentid + hash >>> 0) % FS.nameTable.length;
            },
            hashAddNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                node.name_next = FS.nameTable[hash];
                FS.nameTable[hash] = node;
            },
            hashRemoveNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                else {
                    var current = FS.nameTable[hash];
                    while(current){
                        if (current.name_next === node) {
                            current.name_next = node.name_next;
                            break;
                        }
                        current = current.name_next;
                    }
                }
            },
            lookupNode: (parent, name)=>{
                var errCode = FS.mayLookup(parent);
                if (errCode) throw new FS.ErrnoError(errCode, parent);
                var hash = FS.hashName(parent.id, name);
                for(var node = FS.nameTable[hash]; node; node = node.name_next){
                    var nodeName = node.name;
                    if (node.parent.id === parent.id && nodeName === name) return node;
                }
                return FS.lookup(parent, name);
            },
            createNode: (parent, name, mode, rdev)=>{
                var node = new FS.FSNode(parent, name, mode, rdev);
                FS.hashAddNode(node);
                return node;
            },
            destroyNode: (node)=>{
                FS.hashRemoveNode(node);
            },
            isRoot: (node)=>{
                return node === node.parent;
            },
            isMountpoint: (node)=>{
                return !!node.mounted;
            },
            isFile: (mode)=>{
                return (mode & 61440) === 32768;
            },
            isDir: (mode)=>{
                return (mode & 61440) === 16384;
            },
            isLink: (mode)=>{
                return (mode & 61440) === 40960;
            },
            isChrdev: (mode)=>{
                return (mode & 61440) === 8192;
            },
            isBlkdev: (mode)=>{
                return (mode & 61440) === 24576;
            },
            isFIFO: (mode)=>{
                return (mode & 61440) === 4096;
            },
            isSocket: (mode)=>{
                return (mode & 49152) === 49152;
            },
            flagModes: {
                "r": 0,
                "r+": 2,
                "w": 577,
                "w+": 578,
                "a": 1089,
                "a+": 1090
            },
            modeStringToFlags: (str)=>{
                var flags = FS.flagModes[str];
                if (typeof flags == "undefined") throw new Error("Unknown file open mode: " + str);
                return flags;
            },
            flagsToPermissionString: (flag)=>{
                var perms = [
                    "r",
                    "w",
                    "rw"
                ][flag & 3];
                if (flag & 512) perms += "w";
                return perms;
            },
            nodePermissions: (node, perms)=>{
                if (FS.ignorePermissions) return 0;
                if (perms.includes("r") && !(node.mode & 292)) return 2;
                else if (perms.includes("w") && !(node.mode & 146)) return 2;
                else if (perms.includes("x") && !(node.mode & 73)) return 2;
                return 0;
            },
            mayLookup: (dir)=>{
                var errCode = FS.nodePermissions(dir, "x");
                if (errCode) return errCode;
                if (!dir.node_ops.lookup) return 2;
                return 0;
            },
            mayCreate: (dir, name)=>{
                try {
                    var node = FS.lookupNode(dir, name);
                    return 20;
                } catch (e) {}
                return FS.nodePermissions(dir, "wx");
            },
            mayDelete: (dir, name, isdir)=>{
                var node;
                try {
                    node = FS.lookupNode(dir, name);
                } catch (e) {
                    return e.errno;
                }
                var errCode = FS.nodePermissions(dir, "wx");
                if (errCode) return errCode;
                if (isdir) {
                    if (!FS.isDir(node.mode)) return 54;
                    if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                } else {
                    if (FS.isDir(node.mode)) return 31;
                }
                return 0;
            },
            mayOpen: (node, flags)=>{
                if (!node) return 44;
                if (FS.isLink(node.mode)) return 32;
                else if (FS.isDir(node.mode)) {
                    if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                }
                return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
            },
            MAX_OPEN_FDS: 4096,
            nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS)=>{
                for(var fd = fd_start; fd <= fd_end; fd++){
                    if (!FS.streams[fd]) return fd;
                }
                throw new FS.ErrnoError(33);
            },
            getStream: (fd)=>FS.streams[fd],
            createStream: (stream, fd_start, fd_end)=>{
                if (!FS.FSStream) {
                    FS.FSStream = function() {
                        this.shared = {};
                    };
                    FS.FSStream.prototype = {};
                    Object.defineProperties(FS.FSStream.prototype, {
                        object: {
                            get: function() {
                                return this.node;
                            },
                            set: function(val) {
                                this.node = val;
                            }
                        },
                        isRead: {
                            get: function() {
                                return (this.flags & 2097155) !== 1;
                            }
                        },
                        isWrite: {
                            get: function() {
                                return (this.flags & 2097155) !== 0;
                            }
                        },
                        isAppend: {
                            get: function() {
                                return this.flags & 1024;
                            }
                        },
                        flags: {
                            get: function() {
                                return this.shared.flags;
                            },
                            set: function(val) {
                                this.shared.flags = val;
                            }
                        },
                        position: {
                            get: function() {
                                return this.shared.position;
                            },
                            set: function(val) {
                                this.shared.position = val;
                            }
                        }
                    });
                }
                stream = Object.assign(new FS.FSStream(), stream);
                var fd = FS.nextfd(fd_start, fd_end);
                stream.fd = fd;
                FS.streams[fd] = stream;
                return stream;
            },
            closeStream: (fd)=>{
                FS.streams[fd] = null;
            },
            chrdev_stream_ops: {
                open: (stream)=>{
                    var device = FS.getDevice(stream.node.rdev);
                    stream.stream_ops = device.stream_ops;
                    if (stream.stream_ops.open) stream.stream_ops.open(stream);
                },
                llseek: ()=>{
                    throw new FS.ErrnoError(70);
                }
            },
            major: (dev)=>dev >> 8,
            minor: (dev)=>dev & 255,
            makedev: (ma, mi)=>ma << 8 | mi,
            registerDevice: (dev, ops)=>{
                FS.devices[dev] = {
                    stream_ops: ops
                };
            },
            getDevice: (dev)=>FS.devices[dev],
            getMounts: (mount)=>{
                var mounts = [];
                var check = [
                    mount
                ];
                while(check.length){
                    var m = check.pop();
                    mounts.push(m);
                    check.push.apply(check, m.mounts);
                }
                return mounts;
            },
            syncfs: (populate, callback)=>{
                if (typeof populate == "function") {
                    callback = populate;
                    populate = false;
                }
                FS.syncFSRequests++;
                if (FS.syncFSRequests > 1) err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
                var mounts = FS.getMounts(FS.root.mount);
                var completed = 0;
                function doCallback(errCode) {
                    FS.syncFSRequests--;
                    return callback(errCode);
                }
                function done(errCode) {
                    if (errCode) {
                        if (!done.errored) {
                            done.errored = true;
                            return doCallback(errCode);
                        }
                        return;
                    }
                    if (++completed >= mounts.length) doCallback(null);
                }
                mounts.forEach((mount)=>{
                    if (!mount.type.syncfs) return done(null);
                    mount.type.syncfs(mount, populate, done);
                });
            },
            mount: (type, opts, mountpoint)=>{
                var root = mountpoint === "/";
                var pseudo = !mountpoint;
                var node;
                if (root && FS.root) throw new FS.ErrnoError(10);
                else if (!root && !pseudo) {
                    var lookup = FS.lookupPath(mountpoint, {
                        follow_mount: false
                    });
                    mountpoint = lookup.path;
                    node = lookup.node;
                    if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                    if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                }
                var mount = {
                    type: type,
                    opts: opts,
                    mountpoint: mountpoint,
                    mounts: []
                };
                var mountRoot = type.mount(mount);
                mountRoot.mount = mount;
                mount.root = mountRoot;
                if (root) FS.root = mountRoot;
                else if (node) {
                    node.mounted = mount;
                    if (node.mount) node.mount.mounts.push(mount);
                }
                return mountRoot;
            },
            unmount: (mountpoint)=>{
                var lookup = FS.lookupPath(mountpoint, {
                    follow_mount: false
                });
                if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                var node = lookup.node;
                var mount = node.mounted;
                var mounts = FS.getMounts(mount);
                Object.keys(FS.nameTable).forEach((hash)=>{
                    var current = FS.nameTable[hash];
                    while(current){
                        var next = current.name_next;
                        if (mounts.includes(current.mount)) FS.destroyNode(current);
                        current = next;
                    }
                });
                node.mounted = null;
                var idx = node.mount.mounts.indexOf(mount);
                node.mount.mounts.splice(idx, 1);
            },
            lookup: (parent, name)=>{
                return parent.node_ops.lookup(parent, name);
            },
            mknod: (path, mode, dev)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                var errCode = FS.mayCreate(parent, name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                return parent.node_ops.mknod(parent, name, mode, dev);
            },
            create: (path, mode)=>{
                mode = mode !== undefined ? mode : 438;
                mode &= 4095;
                mode |= 32768;
                return FS.mknod(path, mode, 0);
            },
            mkdir: (path, mode)=>{
                mode = mode !== undefined ? mode : 511;
                mode &= 1023;
                mode |= 16384;
                return FS.mknod(path, mode, 0);
            },
            mkdirTree: (path, mode)=>{
                var dirs = path.split("/");
                var d = "";
                for(var i = 0; i < dirs.length; ++i){
                    if (!dirs[i]) continue;
                    d += "/" + dirs[i];
                    try {
                        FS.mkdir(d, mode);
                    } catch (e) {
                        if (e.errno != 20) throw e;
                    }
                }
            },
            mkdev: (path, mode, dev)=>{
                if (typeof dev == "undefined") {
                    dev = mode;
                    mode = 438;
                }
                mode |= 8192;
                return FS.mknod(path, mode, dev);
            },
            symlink: (oldpath, newpath)=>{
                if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                var lookup = FS.lookupPath(newpath, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var newname = PATH.basename(newpath);
                var errCode = FS.mayCreate(parent, newname);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                return parent.node_ops.symlink(parent, newname, oldpath);
            },
            rename: (old_path, new_path)=>{
                var old_dirname = PATH.dirname(old_path);
                var new_dirname = PATH.dirname(new_path);
                var old_name = PATH.basename(old_path);
                var new_name = PATH.basename(new_path);
                var lookup, old_dir, new_dir;
                lookup = FS.lookupPath(old_path, {
                    parent: true
                });
                old_dir = lookup.node;
                lookup = FS.lookupPath(new_path, {
                    parent: true
                });
                new_dir = lookup.node;
                if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                var old_node = FS.lookupNode(old_dir, old_name);
                var relative = PATH_FS.relative(old_path, new_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                relative = PATH_FS.relative(new_path, old_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                var new_node;
                try {
                    new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}
                if (old_node === new_node) return;
                var isdir = FS.isDir(old_node.mode);
                var errCode = FS.mayDelete(old_dir, old_name, isdir);
                if (errCode) throw new FS.ErrnoError(errCode);
                errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                if (new_dir !== old_dir) {
                    errCode = FS.nodePermissions(old_dir, "w");
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                FS.hashRemoveNode(old_node);
                try {
                    old_dir.node_ops.rename(old_node, new_dir, new_name);
                } catch (e) {
                    throw e;
                } finally{
                    FS.hashAddNode(old_node);
                }
            },
            rmdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, true);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.rmdir(parent, name);
                FS.destroyNode(node);
            },
            readdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                return node.node_ops.readdir(node);
            },
            unlink: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, false);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.unlink(parent, name);
                FS.destroyNode(node);
            },
            readlink: (path)=>{
                var lookup = FS.lookupPath(path);
                var link = lookup.node;
                if (!link) throw new FS.ErrnoError(44);
                if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
            },
            stat: (path, dontFollow)=>{
                var lookup = FS.lookupPath(path, {
                    follow: !dontFollow
                });
                var node = lookup.node;
                if (!node) throw new FS.ErrnoError(44);
                if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                return node.node_ops.getattr(node);
            },
            lstat: (path)=>{
                return FS.stat(path, true);
            },
            chmod: (path, mode, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    mode: mode & 4095 | node.mode & -4096,
                    timestamp: Date.now()
                });
            },
            lchmod: (path, mode)=>{
                FS.chmod(path, mode, true);
            },
            fchmod: (fd, mode)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chmod(stream.node, mode);
            },
            chown: (path, uid, gid, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    timestamp: Date.now()
                });
            },
            lchown: (path, uid, gid)=>{
                FS.chown(path, uid, gid, true);
            },
            fchown: (fd, uid, gid)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chown(stream.node, uid, gid);
            },
            truncate: (path, len)=>{
                if (len < 0) throw new FS.ErrnoError(28);
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                var errCode = FS.nodePermissions(node, "w");
                if (errCode) throw new FS.ErrnoError(errCode);
                node.node_ops.setattr(node, {
                    size: len,
                    timestamp: Date.now()
                });
            },
            ftruncate: (fd, len)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                FS.truncate(stream.node, len);
            },
            utime: (path, atime, mtime)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                node.node_ops.setattr(node, {
                    timestamp: Math.max(atime, mtime)
                });
            },
            open: (path, flags, mode)=>{
                if (path === "") throw new FS.ErrnoError(44);
                flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
                mode = typeof mode == "undefined" ? 438 : mode;
                if (flags & 64) mode = mode & 4095 | 32768;
                else mode = 0;
                var node;
                if (typeof path == "object") node = path;
                else {
                    path = PATH.normalize(path);
                    try {
                        var lookup = FS.lookupPath(path, {
                            follow: !(flags & 131072)
                        });
                        node = lookup.node;
                    } catch (e) {}
                }
                var created = false;
                if (flags & 64) {
                    if (node) {
                        if (flags & 128) throw new FS.ErrnoError(20);
                    } else {
                        node = FS.mknod(path, mode, 0);
                        created = true;
                    }
                }
                if (!node) throw new FS.ErrnoError(44);
                if (FS.isChrdev(node.mode)) flags &= -513;
                if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                if (!created) {
                    var errCode = FS.mayOpen(node, flags);
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                if (flags & 512 && !created) FS.truncate(node, 0);
                flags &= -131713;
                var stream = FS.createStream({
                    node: node,
                    path: FS.getPath(node),
                    flags: flags,
                    seekable: true,
                    position: 0,
                    stream_ops: node.stream_ops,
                    ungotten: [],
                    error: false
                });
                if (stream.stream_ops.open) stream.stream_ops.open(stream);
                if (Module["logReadFiles"] && !(flags & 1)) {
                    if (!FS.readFiles) FS.readFiles = {};
                    if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                }
                return stream;
            },
            close: (stream)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (stream.getdents) stream.getdents = null;
                try {
                    if (stream.stream_ops.close) stream.stream_ops.close(stream);
                } catch (e) {
                    throw e;
                } finally{
                    FS.closeStream(stream.fd);
                }
                stream.fd = null;
            },
            isClosed: (stream)=>{
                return stream.fd === null;
            },
            llseek: (stream, offset, whence)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                stream.position = stream.stream_ops.llseek(stream, offset, whence);
                stream.ungotten = [];
                return stream.position;
            },
            read: (stream, buffer, offset, length, position)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                if (!seeking) stream.position += bytesRead;
                return bytesRead;
            },
            write: (stream, buffer, offset, length, position, canOwn)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                if (!seeking) stream.position += bytesWritten;
                return bytesWritten;
            },
            allocate: (stream, offset, length)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                stream.stream_ops.allocate(stream, offset, length);
            },
            mmap: (stream, length, position, prot, flags)=>{
                if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                return stream.stream_ops.mmap(stream, length, position, prot, flags);
            },
            msync: (stream, buffer, offset, length, mmapFlags)=>{
                if (!stream.stream_ops.msync) return 0;
                return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
            },
            munmap: (stream)=>0,
            ioctl: (stream, cmd, arg)=>{
                if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                return stream.stream_ops.ioctl(stream, cmd, arg);
            },
            readFile: (path, opts = {})=>{
                opts.flags = opts.flags || 0;
                opts.encoding = opts.encoding || "binary";
                if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error('Invalid encoding type "' + opts.encoding + '"');
                var ret;
                var stream = FS.open(path, opts.flags);
                var stat = FS.stat(path);
                var length = stat.size;
                var buf = new Uint8Array(length);
                FS.read(stream, buf, 0, length, 0);
                if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                else if (opts.encoding === "binary") ret = buf;
                FS.close(stream);
                return ret;
            },
            writeFile: (path, data, opts = {})=>{
                opts.flags = opts.flags || 577;
                var stream = FS.open(path, opts.flags, opts.mode);
                if (typeof data == "string") {
                    var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                    var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                    FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn);
                } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn);
                else throw new Error("Unsupported data type");
                FS.close(stream);
            },
            cwd: ()=>FS.currentPath,
            chdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                if (lookup.node === null) throw new FS.ErrnoError(44);
                if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                var errCode = FS.nodePermissions(lookup.node, "x");
                if (errCode) throw new FS.ErrnoError(errCode);
                FS.currentPath = lookup.path;
            },
            createDefaultDirectories: ()=>{
                FS.mkdir("/tmp");
                FS.mkdir("/home");
                FS.mkdir("/home/web_user");
            },
            createDefaultDevices: ()=>{
                FS.mkdir("/dev");
                FS.registerDevice(FS.makedev(1, 3), {
                    read: ()=>0,
                    write: (stream, buffer, offset, length, pos)=>length
                });
                FS.mkdev("/dev/null", FS.makedev(1, 3));
                TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                FS.mkdev("/dev/tty", FS.makedev(5, 0));
                FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                var random_device = getRandomDevice();
                FS.createDevice("/dev", "random", random_device);
                FS.createDevice("/dev", "urandom", random_device);
                FS.mkdir("/dev/shm");
                FS.mkdir("/dev/shm/tmp");
            },
            createSpecialDirectories: ()=>{
                FS.mkdir("/proc");
                var proc_self = FS.mkdir("/proc/self");
                FS.mkdir("/proc/self/fd");
                FS.mount({
                    mount: ()=>{
                        var node = FS.createNode(proc_self, "fd", 16895, 73);
                        node.node_ops = {
                            lookup: (parent, name)=>{
                                var fd = +name;
                                var stream = FS.getStream(fd);
                                if (!stream) throw new FS.ErrnoError(8);
                                var ret = {
                                    parent: null,
                                    mount: {
                                        mountpoint: "fake"
                                    },
                                    node_ops: {
                                        readlink: ()=>stream.path
                                    }
                                };
                                ret.parent = ret;
                                return ret;
                            }
                        };
                        return node;
                    }
                }, {}, "/proc/self/fd");
            },
            createStandardStreams: ()=>{
                if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                else FS.symlink("/dev/tty", "/dev/stdin");
                if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                else FS.symlink("/dev/tty", "/dev/stdout");
                if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                else FS.symlink("/dev/tty1", "/dev/stderr");
                var stdin = FS.open("/dev/stdin", 0);
                var stdout = FS.open("/dev/stdout", 1);
                var stderr = FS.open("/dev/stderr", 1);
            },
            ensureErrnoError: ()=>{
                if (FS.ErrnoError) return;
                FS.ErrnoError = function ErrnoError(errno, node) {
                    this.name = "ErrnoError";
                    this.node = node;
                    this.setErrno = function(errno) {
                        this.errno = errno;
                    };
                    this.setErrno(errno);
                    this.message = "FS error";
                };
                FS.ErrnoError.prototype = new Error();
                FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                [
                    44
                ].forEach((code)=>{
                    FS.genericErrors[code] = new FS.ErrnoError(code);
                    FS.genericErrors[code].stack = "<generic error, no stack>";
                });
            },
            staticInit: ()=>{
                FS.ensureErrnoError();
                FS.nameTable = new Array(4096);
                FS.mount(MEMFS, {}, "/");
                FS.createDefaultDirectories();
                FS.createDefaultDevices();
                FS.createSpecialDirectories();
                FS.filesystems = {
                    "MEMFS": MEMFS
                };
            },
            init: (input, output, error)=>{
                FS.init.initialized = true;
                FS.ensureErrnoError();
                Module["stdin"] = input || Module["stdin"];
                Module["stdout"] = output || Module["stdout"];
                Module["stderr"] = error || Module["stderr"];
                FS.createStandardStreams();
            },
            quit: ()=>{
                FS.init.initialized = false;
                _fflush(0);
                for(var i = 0; i < FS.streams.length; i++){
                    var stream = FS.streams[i];
                    if (!stream) continue;
                    FS.close(stream);
                }
            },
            getMode: (canRead, canWrite)=>{
                var mode = 0;
                if (canRead) mode |= 365;
                if (canWrite) mode |= 146;
                return mode;
            },
            findObject: (path, dontResolveLastLink)=>{
                var ret = FS.analyzePath(path, dontResolveLastLink);
                if (!ret.exists) return null;
                return ret.object;
            },
            analyzePath: (path, dontResolveLastLink)=>{
                try {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    path = lookup.path;
                } catch (e) {}
                var ret = {
                    isRoot: false,
                    exists: false,
                    error: 0,
                    name: null,
                    path: null,
                    object: null,
                    parentExists: false,
                    parentPath: null,
                    parentObject: null
                };
                try {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    ret.parentExists = true;
                    ret.parentPath = lookup.path;
                    ret.parentObject = lookup.node;
                    ret.name = PATH.basename(path);
                    lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    ret.exists = true;
                    ret.path = lookup.path;
                    ret.object = lookup.node;
                    ret.name = lookup.node.name;
                    ret.isRoot = lookup.path === "/";
                } catch (e) {
                    ret.error = e.errno;
                }
                return ret;
            },
            createPath: (parent, path, canRead, canWrite)=>{
                parent = typeof parent == "string" ? parent : FS.getPath(parent);
                var parts = path.split("/").reverse();
                while(parts.length){
                    var part = parts.pop();
                    if (!part) continue;
                    var current = PATH.join2(parent, part);
                    try {
                        FS.mkdir(current);
                    } catch (e) {}
                    parent = current;
                }
                return current;
            },
            createFile: (parent, name, properties, canRead, canWrite)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(canRead, canWrite);
                return FS.create(path, mode);
            },
            createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                var path = name;
                if (parent) {
                    parent = typeof parent == "string" ? parent : FS.getPath(parent);
                    path = name ? PATH.join2(parent, name) : parent;
                }
                var mode = FS.getMode(canRead, canWrite);
                var node = FS.create(path, mode);
                if (data) {
                    if (typeof data == "string") {
                        var arr = new Array(data.length);
                        for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                        data = arr;
                    }
                    FS.chmod(node, mode | 146);
                    var stream = FS.open(node, 577);
                    FS.write(stream, data, 0, data.length, 0, canOwn);
                    FS.close(stream);
                    FS.chmod(node, mode);
                }
                return node;
            },
            createDevice: (parent, name, input, output)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(!!input, !!output);
                if (!FS.createDevice.major) FS.createDevice.major = 64;
                var dev = FS.makedev(FS.createDevice.major++, 0);
                FS.registerDevice(dev, {
                    open: (stream)=>{
                        stream.seekable = false;
                    },
                    close: (stream)=>{
                        if (output && output.buffer && output.buffer.length) output(10);
                    },
                    read: (stream, buffer, offset, length, pos)=>{
                        var bytesRead = 0;
                        for(var i = 0; i < length; i++){
                            var result;
                            try {
                                result = input();
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                            if (result === null || result === undefined) break;
                            bytesRead++;
                            buffer[offset + i] = result;
                        }
                        if (bytesRead) stream.node.timestamp = Date.now();
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, pos)=>{
                        for(var i = 0; i < length; i++)try {
                            output(buffer[offset + i]);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (length) stream.node.timestamp = Date.now();
                        return i;
                    }
                });
                return FS.mkdev(path, mode, dev);
            },
            forceLoadFile: (obj)=>{
                if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                else if (read_) try {
                    obj.contents = intArrayFromString(read_(obj.url), true);
                    obj.usedBytes = obj.contents.length;
                } catch (e) {
                    throw new FS.ErrnoError(29);
                }
                else throw new Error("Cannot load without read() or XMLHttpRequest.");
            },
            createLazyFile: (parent, name, url, canRead, canWrite)=>{
                function LazyUint8Array() {
                    this.lengthKnown = false;
                    this.chunks = [];
                }
                LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                    if (idx > this.length - 1 || idx < 0) return undefined;
                    var chunkOffset = idx % this.chunkSize;
                    var chunkNum = idx / this.chunkSize | 0;
                    return this.getter(chunkNum)[chunkOffset];
                };
                LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                    this.getter = getter;
                };
                LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                    var xhr = new XMLHttpRequest();
                    xhr.open("HEAD", url, false);
                    xhr.send(null);
                    if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                    var datalength = Number(xhr.getResponseHeader("Content-length"));
                    var header;
                    var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                    var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                    var chunkSize = 1048576;
                    if (!hasByteServing) chunkSize = datalength;
                    var doXHR = (from, to)=>{
                        if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                        if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
                        xhr.responseType = "arraybuffer";
                        if (xhr.overrideMimeType) xhr.overrideMimeType("text/plain; charset=x-user-defined");
                        xhr.send(null);
                        if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                        if (xhr.response !== undefined) return new Uint8Array(xhr.response || []);
                        return intArrayFromString(xhr.responseText || "", true);
                    };
                    var lazyArray = this;
                    lazyArray.setDataGetter((chunkNum)=>{
                        var start = chunkNum * chunkSize;
                        var end = (chunkNum + 1) * chunkSize - 1;
                        end = Math.min(end, datalength - 1);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") lazyArray.chunks[chunkNum] = doXHR(start, end);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                        return lazyArray.chunks[chunkNum];
                    });
                    if (usesGzip || !datalength) {
                        chunkSize = datalength = 1;
                        datalength = this.getter(0).length;
                        chunkSize = datalength;
                        out("LazyFiles on gzip forces download of the whole file when length is accessed");
                    }
                    this._length = datalength;
                    this._chunkSize = chunkSize;
                    this.lengthKnown = true;
                };
                if (typeof XMLHttpRequest != "undefined") {
                    if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                    var lazyArray = new LazyUint8Array();
                    Object.defineProperties(lazyArray, {
                        length: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._length;
                            }
                        },
                        chunkSize: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._chunkSize;
                            }
                        }
                    });
                    var properties = {
                        isDevice: false,
                        contents: lazyArray
                    };
                } else var properties = {
                    isDevice: false,
                    url: url
                };
                var node = FS.createFile(parent, name, properties, canRead, canWrite);
                if (properties.contents) node.contents = properties.contents;
                else if (properties.url) {
                    node.contents = null;
                    node.url = properties.url;
                }
                Object.defineProperties(node, {
                    usedBytes: {
                        get: function() {
                            return this.contents.length;
                        }
                    }
                });
                var stream_ops = {};
                var keys = Object.keys(node.stream_ops);
                keys.forEach((key)=>{
                    var fn = node.stream_ops[key];
                    stream_ops[key] = function forceLoadLazyFile() {
                        FS.forceLoadFile(node);
                        return fn.apply(null, arguments);
                    };
                });
                function writeChunks(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= contents.length) return 0;
                    var size = Math.min(contents.length - position, length);
                    if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                    return size;
                }
                stream_ops.read = (stream, buffer, offset, length, position)=>{
                    FS.forceLoadFile(node);
                    return writeChunks(stream, buffer, offset, length, position);
                };
                stream_ops.mmap = (stream, length, position, prot, flags)=>{
                    FS.forceLoadFile(node);
                    var ptr = mmapAlloc(length);
                    if (!ptr) throw new FS.ErrnoError(48);
                    writeChunks(stream, HEAP8, ptr, length, position);
                    return {
                        ptr: ptr,
                        allocated: true
                    };
                };
                node.stream_ops = stream_ops;
                return node;
            },
            createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish)=>{
                var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                var dep = getUniqueRunDependency("cp " + fullname);
                function processData(byteArray) {
                    function finish(byteArray) {
                        if (preFinish) preFinish();
                        if (!dontCreateFile) FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                        if (onload) onload();
                        removeRunDependency(dep);
                    }
                    if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                        if (onerror) onerror();
                        removeRunDependency(dep);
                    })) return;
                    finish(byteArray);
                }
                addRunDependency(dep);
                if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                else processData(url);
            },
            indexedDB: ()=>{
                return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
            },
            DB_NAME: ()=>{
                return "EM_FS_" + window.location.pathname;
            },
            DB_VERSION: 20,
            DB_STORE_NAME: "FILE_DATA",
            saveFilesToDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = ()=>{
                    out("creating db");
                    var db = openRequest.result;
                    db.createObjectStore(FS.DB_STORE_NAME);
                };
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    var transaction = db.transaction([
                        FS.DB_STORE_NAME
                    ], "readwrite");
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var putRequest = files.put(FS.analyzePath(path).object.contents, path);
                        putRequest.onsuccess = ()=>{
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        putRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            },
            loadFilesFromDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = onerror;
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    try {
                        var transaction = db.transaction([
                            FS.DB_STORE_NAME
                        ], "readonly");
                    } catch (e) {
                        onerror(e);
                        return;
                    }
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var getRequest = files.get(path);
                        getRequest.onsuccess = ()=>{
                            if (FS.analyzePath(path).exists) FS.unlink(path);
                            FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        getRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            }
        };
        var SYSCALLS = {
            DEFAULT_POLLMASK: 5,
            calculateAt: function(dirfd, path, allowEmpty) {
                if (PATH.isAbs(path)) return path;
                var dir;
                if (dirfd === -100) dir = FS.cwd();
                else {
                    var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                    dir = dirstream.path;
                }
                if (path.length == 0) {
                    if (!allowEmpty) throw new FS.ErrnoError(44);
                    return dir;
                }
                return PATH.join2(dir, path);
            },
            doStat: function(func, path, buf) {
                try {
                    var stat = func(path);
                } catch (e) {
                    if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                    throw e;
                }
                HEAP32[buf >> 2] = stat.dev;
                HEAP32[buf + 8 >> 2] = stat.ino;
                HEAP32[buf + 12 >> 2] = stat.mode;
                HEAPU32[buf + 16 >> 2] = stat.nlink;
                HEAP32[buf + 20 >> 2] = stat.uid;
                HEAP32[buf + 24 >> 2] = stat.gid;
                HEAP32[buf + 28 >> 2] = stat.rdev;
                tempI64 = [
                    stat.size >>> 0,
                    (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 40 >> 2] = tempI64[0], HEAP32[buf + 44 >> 2] = tempI64[1];
                HEAP32[buf + 48 >> 2] = 4096;
                HEAP32[buf + 52 >> 2] = stat.blocks;
                var atime = stat.atime.getTime();
                var mtime = stat.mtime.getTime();
                var ctime = stat.ctime.getTime();
                tempI64 = [
                    Math.floor(atime / 1e3) >>> 0,
                    (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 56 >> 2] = tempI64[0], HEAP32[buf + 60 >> 2] = tempI64[1];
                HEAPU32[buf + 64 >> 2] = atime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(mtime / 1e3) >>> 0,
                    (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 72 >> 2] = tempI64[0], HEAP32[buf + 76 >> 2] = tempI64[1];
                HEAPU32[buf + 80 >> 2] = mtime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(ctime / 1e3) >>> 0,
                    (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 88 >> 2] = tempI64[0], HEAP32[buf + 92 >> 2] = tempI64[1];
                HEAPU32[buf + 96 >> 2] = ctime % 1e3 * 1e3;
                tempI64 = [
                    stat.ino >>> 0,
                    (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 104 >> 2] = tempI64[0], HEAP32[buf + 108 >> 2] = tempI64[1];
                return 0;
            },
            doMsync: function(addr, stream, len, flags, offset) {
                if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                if (flags & 2) return 0;
                var buffer = HEAPU8.slice(addr, addr + len);
                FS.msync(stream, buffer, offset, len, flags);
            },
            varargs: undefined,
            get: function() {
                SYSCALLS.varargs += 4;
                var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
                return ret;
            },
            getStr: function(ptr) {
                var ret = UTF8ToString(ptr);
                return ret;
            },
            getStreamFromFD: function(fd) {
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                return stream;
            }
        };
        function ___syscall_faccessat(dirfd, path, amode, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (amode & -8) return -28;
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node) return -44;
                var perms = "";
                if (amode & 4) perms += "r";
                if (amode & 2) perms += "w";
                if (amode & 1) perms += "x";
                if (perms && FS.nodePermissions(node, perms)) return -2;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function setErrNo(value) {
            HEAP32[___errno_location() >> 2] = value;
            return value;
        }
        function ___syscall_fcntl64(fd, cmd, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(cmd){
                    case 0:
                        var arg = SYSCALLS.get();
                        if (arg < 0) return -28;
                        var newStream;
                        newStream = FS.createStream(stream, arg);
                        return newStream.fd;
                    case 1:
                    case 2:
                        return 0;
                    case 3:
                        return stream.flags;
                    case 4:
                        var arg = SYSCALLS.get();
                        stream.flags |= arg;
                        return 0;
                    case 5:
                        var arg = SYSCALLS.get();
                        var offset = 0;
                        HEAP16[arg + offset >> 1] = 2;
                        return 0;
                    case 6:
                    case 7:
                        return 0;
                    case 16:
                    case 8:
                        return -28;
                    case 9:
                        setErrNo(28);
                        return -1;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_getcwd(buf, size) {
            try {
                if (size === 0) return -28;
                var cwd = FS.cwd();
                var cwdLengthInBytes = lengthBytesUTF8(cwd) + 1;
                if (size < cwdLengthInBytes) return -68;
                stringToUTF8(cwd, buf, size);
                return cwdLengthInBytes;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_ioctl(fd, op, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(op){
                    case 21509:
                    case 21505:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21510:
                    case 21511:
                    case 21512:
                    case 21506:
                    case 21507:
                    case 21508:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21519:
                        if (!stream.tty) return -59;
                        var argp = SYSCALLS.get();
                        HEAP32[argp >> 2] = 0;
                        return 0;
                    case 21520:
                        if (!stream.tty) return -59;
                        return -28;
                    case 21531:
                        var argp = SYSCALLS.get();
                        return FS.ioctl(stream, op, argp);
                    case 21523:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21524:
                        if (!stream.tty) return -59;
                        return 0;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                var mode = varargs ? SYSCALLS.get() : 0;
                return FS.open(path, flags, mode).fd;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        var nowIsMonotonic = true;
        function __emscripten_get_now_is_monotonic() {
            return nowIsMonotonic;
        }
        function readI53FromI64(ptr) {
            return HEAPU32[ptr >> 2] + HEAP32[ptr + 4 >> 2] * 4294967296;
        }
        function __isLeapYear(year) {
            return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }
        var __MONTH_DAYS_LEAP_CUMULATIVE = [
            0,
            31,
            60,
            91,
            121,
            152,
            182,
            213,
            244,
            274,
            305,
            335
        ];
        var __MONTH_DAYS_REGULAR_CUMULATIVE = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
        function __yday_from_date(date) {
            var isLeapYear = __isLeapYear(date.getFullYear());
            var monthDaysCumulative = isLeapYear ? __MONTH_DAYS_LEAP_CUMULATIVE : __MONTH_DAYS_REGULAR_CUMULATIVE;
            var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
            return yday;
        }
        function __localtime_js(time, tmPtr) {
            var date = new Date(readI53FromI64(time) * 1e3);
            HEAP32[tmPtr >> 2] = date.getSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getHours();
            HEAP32[tmPtr + 12 >> 2] = date.getDate();
            HEAP32[tmPtr + 16 >> 2] = date.getMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getDay();
            var yday = __yday_from_date(date) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            HEAP32[tmPtr + 36 >> 2] = -(date.getTimezoneOffset() * 60);
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
            HEAP32[tmPtr + 32 >> 2] = dst;
        }
        function allocateUTF8(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = _malloc(size);
            if (ret) stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function __tzset_js(timezone, daylight, tzname) {
            var currentYear = new Date().getFullYear();
            var winter = new Date(currentYear, 0, 1);
            var summer = new Date(currentYear, 6, 1);
            var winterOffset = winter.getTimezoneOffset();
            var summerOffset = summer.getTimezoneOffset();
            var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
            HEAPU32[timezone >> 2] = stdTimezoneOffset * 60;
            HEAP32[daylight >> 2] = Number(winterOffset != summerOffset);
            function extractZone(date) {
                var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                return match ? match[1] : "GMT";
            }
            var winterName = extractZone(winter);
            var summerName = extractZone(summer);
            var winterNamePtr = allocateUTF8(winterName);
            var summerNamePtr = allocateUTF8(summerName);
            if (summerOffset < winterOffset) {
                HEAPU32[tzname >> 2] = winterNamePtr;
                HEAPU32[tzname + 4 >> 2] = summerNamePtr;
            } else {
                HEAPU32[tzname >> 2] = summerNamePtr;
                HEAPU32[tzname + 4 >> 2] = winterNamePtr;
            }
        }
        function _abort() {
            abort("");
        }
        function _emscripten_date_now() {
            return Date.now();
        }
        var _emscripten_get_now;
        _emscripten_get_now = ()=>performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
            HEAPU8.copyWithin(dest, src, src + num);
        }
        function getHeapMax() {
            return 2147483648;
        }
        function emscripten_realloc_buffer(size) {
            var b = wasmMemory.buffer;
            try {
                wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
                updateMemoryViews();
                return 1;
            } catch (e) {}
        }
        function _emscripten_resize_heap(requestedSize) {
            var oldSize = HEAPU8.length;
            requestedSize = requestedSize >>> 0;
            var maxHeapSize = getHeapMax();
            if (requestedSize > maxHeapSize) return false;
            let alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
            for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                var replacement = emscripten_realloc_buffer(newSize);
                if (replacement) return true;
            }
            return false;
        }
        var ENV = {};
        function getExecutableName() {
            return thisProgram || "./this.program";
        }
        function getEnvStrings() {
            if (!getEnvStrings.strings) {
                var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                var env = {
                    "USER": "web_user",
                    "LOGNAME": "web_user",
                    "PATH": "/",
                    "PWD": "/",
                    "HOME": "/home/web_user",
                    "LANG": lang,
                    "_": getExecutableName()
                };
                for(var x in ENV)if (ENV[x] === undefined) delete env[x];
                else env[x] = ENV[x];
                var strings = [];
                for(var x in env)strings.push(x + "=" + env[x]);
                getEnvStrings.strings = strings;
            }
            return getEnvStrings.strings;
        }
        function writeAsciiToMemory(str, buffer, dontAddNull) {
            for(var i = 0; i < str.length; ++i)HEAP8[buffer++ >> 0] = str.charCodeAt(i);
            if (!dontAddNull) HEAP8[buffer >> 0] = 0;
        }
        function _environ_get(__environ, environ_buf) {
            var bufSize = 0;
            getEnvStrings().forEach(function(string, i) {
                var ptr = environ_buf + bufSize;
                HEAPU32[__environ + i * 4 >> 2] = ptr;
                writeAsciiToMemory(string, ptr);
                bufSize += string.length + 1;
            });
            return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
            var strings = getEnvStrings();
            HEAPU32[penviron_count >> 2] = strings.length;
            var bufSize = 0;
            strings.forEach(function(string) {
                bufSize += string.length + 1;
            });
            HEAPU32[penviron_buf_size >> 2] = bufSize;
            return 0;
        }
        function _proc_exit(code) {
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
                if (Module["onExit"]) Module["onExit"](code);
                ABORT = true;
            }
            quit_(code, new ExitStatus(code));
        }
        function exitJS(status, implicit) {
            EXITSTATUS = status;
            if (!keepRuntimeAlive()) exitRuntime();
            _proc_exit(status);
        }
        var _exit = exitJS;
        function _fd_close(fd) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.close(stream);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doReadv(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.read(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (curr < len) break;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doReadv(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function convertI32PairToI53Checked(lo, hi) {
            return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
            try {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                if (isNaN(offset)) return 61;
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.llseek(stream, offset, whence);
                tempI64 = [
                    stream.position >>> 0,
                    (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[newOffset >> 2] = tempI64[0], HEAP32[newOffset + 4 >> 2] = tempI64[1];
                if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doWritev(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.write(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doWritev(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function _llvm_eh_typeid_for(type) {
            return type;
        }
        function __arraySum(array, index) {
            var sum = 0;
            for(var i = 0; i <= index; sum += array[i++]);
            return sum;
        }
        var __MONTH_DAYS_LEAP = [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        var __MONTH_DAYS_REGULAR = [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        function __addDays(date, days) {
            var newDate = new Date(date.getTime());
            while(days > 0){
                var leap = __isLeapYear(newDate.getFullYear());
                var currentMonth = newDate.getMonth();
                var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];
                if (days > daysInCurrentMonth - newDate.getDate()) {
                    days -= daysInCurrentMonth - newDate.getDate() + 1;
                    newDate.setDate(1);
                    if (currentMonth < 11) newDate.setMonth(currentMonth + 1);
                    else {
                        newDate.setMonth(0);
                        newDate.setFullYear(newDate.getFullYear() + 1);
                    }
                } else {
                    newDate.setDate(newDate.getDate() + days);
                    return newDate;
                }
            }
            return newDate;
        }
        function writeArrayToMemory(array, buffer) {
            HEAP8.set(array, buffer);
        }
        function _strftime(s, maxsize, format, tm) {
            var tm_zone = HEAP32[tm + 40 >> 2];
            var date = {
                tm_sec: HEAP32[tm >> 2],
                tm_min: HEAP32[tm + 4 >> 2],
                tm_hour: HEAP32[tm + 8 >> 2],
                tm_mday: HEAP32[tm + 12 >> 2],
                tm_mon: HEAP32[tm + 16 >> 2],
                tm_year: HEAP32[tm + 20 >> 2],
                tm_wday: HEAP32[tm + 24 >> 2],
                tm_yday: HEAP32[tm + 28 >> 2],
                tm_isdst: HEAP32[tm + 32 >> 2],
                tm_gmtoff: HEAP32[tm + 36 >> 2],
                tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
            };
            var pattern = UTF8ToString(format);
            var EXPANSION_RULES_1 = {
                "%c": "%a %b %d %H:%M:%S %Y",
                "%D": "%m/%d/%y",
                "%F": "%Y-%m-%d",
                "%h": "%b",
                "%r": "%I:%M:%S %p",
                "%R": "%H:%M",
                "%T": "%H:%M:%S",
                "%x": "%m/%d/%y",
                "%X": "%H:%M:%S",
                "%Ec": "%c",
                "%EC": "%C",
                "%Ex": "%m/%d/%y",
                "%EX": "%H:%M:%S",
                "%Ey": "%y",
                "%EY": "%Y",
                "%Od": "%d",
                "%Oe": "%e",
                "%OH": "%H",
                "%OI": "%I",
                "%Om": "%m",
                "%OM": "%M",
                "%OS": "%S",
                "%Ou": "%u",
                "%OU": "%U",
                "%OV": "%V",
                "%Ow": "%w",
                "%OW": "%W",
                "%Oy": "%y"
            };
            for(var rule in EXPANSION_RULES_1)pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
            var WEEKDAYS = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ];
            var MONTHS = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
            function leadingSomething(value, digits, character) {
                var str = typeof value == "number" ? value.toString() : value || "";
                while(str.length < digits)str = character[0] + str;
                return str;
            }
            function leadingNulls(value, digits) {
                return leadingSomething(value, digits, "0");
            }
            function compareByDay(date1, date2) {
                function sgn(value) {
                    return value < 0 ? -1 : value > 0 ? 1 : 0;
                }
                var compare;
                if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                    if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) compare = sgn(date1.getDate() - date2.getDate());
                }
                return compare;
            }
            function getFirstWeekStartDate(janFourth) {
                switch(janFourth.getDay()){
                    case 0:
                        return new Date(janFourth.getFullYear() - 1, 11, 29);
                    case 1:
                        return janFourth;
                    case 2:
                        return new Date(janFourth.getFullYear(), 0, 3);
                    case 3:
                        return new Date(janFourth.getFullYear(), 0, 2);
                    case 4:
                        return new Date(janFourth.getFullYear(), 0, 1);
                    case 5:
                        return new Date(janFourth.getFullYear() - 1, 11, 31);
                    case 6:
                        return new Date(janFourth.getFullYear() - 1, 11, 30);
                }
            }
            function getWeekBasedYear(date) {
                var thisDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);
                var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                    if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) return thisDate.getFullYear() + 1;
                    return thisDate.getFullYear();
                }
                return thisDate.getFullYear() - 1;
            }
            var EXPANSION_RULES_2 = {
                "%a": function(date) {
                    return WEEKDAYS[date.tm_wday].substring(0, 3);
                },
                "%A": function(date) {
                    return WEEKDAYS[date.tm_wday];
                },
                "%b": function(date) {
                    return MONTHS[date.tm_mon].substring(0, 3);
                },
                "%B": function(date) {
                    return MONTHS[date.tm_mon];
                },
                "%C": function(date) {
                    var year = date.tm_year + 1900;
                    return leadingNulls(year / 100 | 0, 2);
                },
                "%d": function(date) {
                    return leadingNulls(date.tm_mday, 2);
                },
                "%e": function(date) {
                    return leadingSomething(date.tm_mday, 2, " ");
                },
                "%g": function(date) {
                    return getWeekBasedYear(date).toString().substring(2);
                },
                "%G": function(date) {
                    return getWeekBasedYear(date);
                },
                "%H": function(date) {
                    return leadingNulls(date.tm_hour, 2);
                },
                "%I": function(date) {
                    var twelveHour = date.tm_hour;
                    if (twelveHour == 0) twelveHour = 12;
                    else if (twelveHour > 12) twelveHour -= 12;
                    return leadingNulls(twelveHour, 2);
                },
                "%j": function(date) {
                    return leadingNulls(date.tm_mday + __arraySum(__isLeapYear(date.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date.tm_mon - 1), 3);
                },
                "%m": function(date) {
                    return leadingNulls(date.tm_mon + 1, 2);
                },
                "%M": function(date) {
                    return leadingNulls(date.tm_min, 2);
                },
                "%n": function() {
                    return "\n";
                },
                "%p": function(date) {
                    if (date.tm_hour >= 0 && date.tm_hour < 12) return "AM";
                    return "PM";
                },
                "%S": function(date) {
                    return leadingNulls(date.tm_sec, 2);
                },
                "%t": function() {
                    return "	";
                },
                "%u": function(date) {
                    return date.tm_wday || 7;
                },
                "%U": function(date) {
                    var days = date.tm_yday + 7 - date.tm_wday;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                "%V": function(date) {
                    var val = Math.floor((date.tm_yday + 7 - (date.tm_wday + 6) % 7) / 7);
                    if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) val++;
                    if (!val) {
                        val = 52;
                        var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7;
                        if (dec31 == 4 || dec31 == 5 && __isLeapYear(date.tm_year % 400 - 1)) val++;
                    } else if (val == 53) {
                        var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7;
                        if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date.tm_year))) val = 1;
                    }
                    return leadingNulls(val, 2);
                },
                "%w": function(date) {
                    return date.tm_wday;
                },
                "%W": function(date) {
                    var days = date.tm_yday + 7 - (date.tm_wday + 6) % 7;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                "%y": function(date) {
                    return (date.tm_year + 1900).toString().substring(2);
                },
                "%Y": function(date) {
                    return date.tm_year + 1900;
                },
                "%z": function(date) {
                    var off = date.tm_gmtoff;
                    var ahead = off >= 0;
                    off = Math.abs(off) / 60;
                    off = off / 60 * 100 + off % 60;
                    return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
                },
                "%Z": function(date) {
                    return date.tm_zone;
                },
                "%%": function() {
                    return "%";
                }
            };
            pattern = pattern.replace(/%%/g, "\x00\x00");
            for(var rule in EXPANSION_RULES_2)if (pattern.includes(rule)) pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            pattern = pattern.replace(/\0\0/g, "%");
            var bytes = intArrayFromString(pattern, false);
            if (bytes.length > maxsize) return 0;
            writeArrayToMemory(bytes, s);
            return bytes.length - 1;
        }
        function _strftime_l(s, maxsize, format, tm, loc) {
            return _strftime(s, maxsize, format, tm);
        }
        function handleException(e) {
            if (e instanceof ExitStatus || e == "unwind") return EXITSTATUS;
            quit_(1, e);
        }
        function allocateUTF8OnStack(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function runAndAbortIfError(func) {
            try {
                return func();
            } catch (e) {
                abort(e);
            }
        }
        function maybeExit() {
            if (!keepRuntimeAlive()) try {
                _exit(EXITSTATUS);
            } catch (e) {
                handleException(e);
            }
        }
        function callUserCallback(func) {
            if (runtimeExited || ABORT) return;
            try {
                func();
                maybeExit();
            } catch (e) {
                handleException(e);
            }
        }
        function runtimeKeepalivePush() {
            runtimeKeepaliveCounter += 1;
        }
        function runtimeKeepalivePop() {
            runtimeKeepaliveCounter -= 1;
        }
        var Asyncify = {
            instrumentWasmImports: function(imports) {
                var ASYNCIFY_IMPORTS = [
                    "invoke_*",
                    "emscripten_sleep",
                    "emscripten_wget",
                    "emscripten_wget_data",
                    "emscripten_idb_load",
                    "emscripten_idb_store",
                    "emscripten_idb_delete",
                    "emscripten_idb_exists",
                    "emscripten_idb_load_blob",
                    "emscripten_idb_store_blob",
                    "SDL_Delay",
                    "emscripten_scan_registers",
                    "emscripten_lazy_load_code",
                    "emscripten_fiber_swap",
                    "__load_secondary_module",
                    "fd_sync",
                    "__wasi_fd_sync",
                    "_emval_await",
                    "_dlopen_js",
                    "__asyncjs__*"
                ];
                for(var x in imports)(function(x) {
                    var original = imports[x];
                    var sig = original.sig;
                    if (typeof original == "function") var isAsyncifyImport = ASYNCIFY_IMPORTS.indexOf(x) >= 0 || x.startsWith("__asyncjs__");
                })(x);
            },
            instrumentWasmExports: function(exports) {
                var ret = {};
                for(var x in exports)(function(x) {
                    var original = exports[x];
                    if (typeof original == "function") ret[x] = function() {
                        Asyncify.exportCallStack.push(x);
                        try {
                            return original.apply(null, arguments);
                        } finally{
                            if (!ABORT) {
                                var y = Asyncify.exportCallStack.pop();
                                assert(y === x);
                                Asyncify.maybeStopUnwind();
                            }
                        }
                    };
                    else ret[x] = original;
                })(x);
                return ret;
            },
            State: {
                Normal: 0,
                Unwinding: 1,
                Rewinding: 2,
                Disabled: 3
            },
            state: 0,
            StackSize: 8192,
            currData: null,
            handleSleepReturnValue: 0,
            exportCallStack: [],
            callStackNameToId: {},
            callStackIdToName: {},
            callStackId: 0,
            asyncPromiseHandlers: null,
            sleepCallbacks: [],
            getCallStackId: function(funcName) {
                var id = Asyncify.callStackNameToId[funcName];
                if (id === undefined) {
                    id = Asyncify.callStackId++;
                    Asyncify.callStackNameToId[funcName] = id;
                    Asyncify.callStackIdToName[id] = funcName;
                }
                return id;
            },
            maybeStopUnwind: function() {
                if (Asyncify.currData && Asyncify.state === Asyncify.State.Unwinding && Asyncify.exportCallStack.length === 0) {
                    Asyncify.state = Asyncify.State.Normal;
                    runtimeKeepalivePush();
                    runAndAbortIfError(_asyncify_stop_unwind);
                    if (typeof Fibers != "undefined") Fibers.trampoline();
                }
            },
            whenDone: function() {
                return new Promise((resolve, reject)=>{
                    Asyncify.asyncPromiseHandlers = {
                        resolve: resolve,
                        reject: reject
                    };
                });
            },
            allocateData: function() {
                var ptr = _malloc(12 + Asyncify.StackSize);
                Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
                Asyncify.setDataRewindFunc(ptr);
                return ptr;
            },
            setDataHeader: function(ptr, stack, stackSize) {
                HEAP32[ptr >> 2] = stack;
                HEAP32[ptr + 4 >> 2] = stack + stackSize;
            },
            setDataRewindFunc: function(ptr) {
                var bottomOfCallStack = Asyncify.exportCallStack[0];
                var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
                HEAP32[ptr + 8 >> 2] = rewindId;
            },
            getDataRewindFunc: function(ptr) {
                var id = HEAP32[ptr + 8 >> 2];
                var name = Asyncify.callStackIdToName[id];
                var func = Module["asm"][name];
                return func;
            },
            doRewind: function(ptr) {
                var start = Asyncify.getDataRewindFunc(ptr);
                runtimeKeepalivePop();
                return start();
            },
            handleSleep: function(startAsync) {
                if (ABORT) return;
                if (Asyncify.state === Asyncify.State.Normal) {
                    var reachedCallback = false;
                    var reachedAfterCallback = false;
                    startAsync((handleSleepReturnValue = 0)=>{
                        if (ABORT) return;
                        Asyncify.handleSleepReturnValue = handleSleepReturnValue;
                        reachedCallback = true;
                        if (!reachedAfterCallback) return;
                        Asyncify.state = Asyncify.State.Rewinding;
                        runAndAbortIfError(()=>_asyncify_start_rewind(Asyncify.currData));
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.resume();
                        var asyncWasmReturnValue, isError = false;
                        try {
                            asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
                        } catch (err) {
                            asyncWasmReturnValue = err;
                            isError = true;
                        }
                        var handled = false;
                        if (!Asyncify.currData) {
                            var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;
                            if (asyncPromiseHandlers) {
                                Asyncify.asyncPromiseHandlers = null;
                                (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(asyncWasmReturnValue);
                                handled = true;
                            }
                        }
                        if (isError && !handled) throw asyncWasmReturnValue;
                    });
                    reachedAfterCallback = true;
                    if (!reachedCallback) {
                        Asyncify.state = Asyncify.State.Unwinding;
                        Asyncify.currData = Asyncify.allocateData();
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.pause();
                        runAndAbortIfError(()=>_asyncify_start_unwind(Asyncify.currData));
                    }
                } else if (Asyncify.state === Asyncify.State.Rewinding) {
                    Asyncify.state = Asyncify.State.Normal;
                    runAndAbortIfError(_asyncify_stop_rewind);
                    _free(Asyncify.currData);
                    Asyncify.currData = null;
                    Asyncify.sleepCallbacks.forEach((func)=>callUserCallback(func));
                } else abort("invalid state: " + Asyncify.state);
                return Asyncify.handleSleepReturnValue;
            },
            handleAsync: function(startAsync) {
                return Asyncify.handleSleep((wakeUp)=>{
                    startAsync().then(wakeUp);
                });
            }
        };
        function AsciiToString(ptr) {
            var str = "";
            while(true){
                var ch = HEAPU8[ptr++ >> 0];
                if (!ch) return str;
                str += String.fromCharCode(ch);
            }
        }
        var FSNode = function(parent, name, mode, rdev) {
            if (!parent) parent = this;
            this.parent = parent;
            this.mount = parent.mount;
            this.mounted = null;
            this.id = FS.nextInode++;
            this.name = name;
            this.mode = mode;
            this.node_ops = {};
            this.stream_ops = {};
            this.rdev = rdev;
        };
        var readMode = 365;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
            read: {
                get: function() {
                    return (this.mode & readMode) === readMode;
                },
                set: function(val) {
                    val ? this.mode |= readMode : this.mode &= ~readMode;
                }
            },
            write: {
                get: function() {
                    return (this.mode & writeMode) === writeMode;
                },
                set: function(val) {
                    val ? this.mode |= writeMode : this.mode &= ~writeMode;
                }
            },
            isFolder: {
                get: function() {
                    return FS.isDir(this.mode);
                }
            },
            isDevice: {
                get: function() {
                    return FS.isChrdev(this.mode);
                }
            }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        var wasmImports = {
            "S": __asyncjs__emglken_fill_stdin_buffer,
            "k": ___cxa_begin_catch,
            "n": ___cxa_end_catch,
            "a": ___cxa_find_matching_catch_2,
            "d": ___cxa_find_matching_catch_3,
            "m": ___cxa_find_matching_catch_4,
            "s": ___cxa_find_matching_catch_5,
            "x": ___cxa_find_matching_catch_6,
            "ca": ___cxa_find_matching_catch_7,
            "K": ___cxa_rethrow,
            "o": ___cxa_throw,
            "ba": ___cxa_uncaught_exceptions,
            "g": ___resumeException,
            "aa": ___syscall_faccessat,
            "J": ___syscall_fcntl64,
            "$": ___syscall_getcwd,
            "_": ___syscall_ioctl,
            "Z": ___syscall_openat,
            "V": __emscripten_get_now_is_monotonic,
            "U": __localtime_js,
            "T": __tzset_js,
            "D": _abort,
            "B": _emscripten_date_now,
            "R": _emscripten_memcpy_big,
            "Q": _emscripten_resize_heap,
            "Y": _environ_get,
            "X": _environ_sizes_get,
            "C": _exit,
            "I": _fd_close,
            "W": _fd_read,
            "P": _fd_seek,
            "H": _fd_write,
            "G": invoke_diii,
            "F": invoke_fiii,
            "q": invoke_i,
            "b": invoke_ii,
            "c": invoke_iii,
            "e": invoke_iiii,
            "p": invoke_iiiii,
            "u": invoke_iiiiii,
            "w": invoke_iiiiiii,
            "E": invoke_iiiiiiii,
            "A": invoke_iiiiiiiiiiii,
            "O": invoke_ji,
            "N": invoke_jiiii,
            "h": invoke_v,
            "i": invoke_vi,
            "f": invoke_vii,
            "j": invoke_viii,
            "r": invoke_viiii,
            "t": invoke_viiiii,
            "v": invoke_viiiiiii,
            "y": invoke_viiiiiiiiii,
            "z": invoke_viiiiiiiiiiiiiii,
            "l": _llvm_eh_typeid_for,
            "M": _strftime,
            "L": _strftime_l
        };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
            return (___wasm_call_ctors = Module["asm"]["ea"]).apply(null, arguments);
        };
        var ___cxa_free_exception = function() {
            return (___cxa_free_exception = Module["asm"]["fa"]).apply(null, arguments);
        };
        var _fflush = Module["_fflush"] = function() {
            return (_fflush = Module["_fflush"] = Module["asm"]["ga"]).apply(null, arguments);
        };
        var ___errno_location = function() {
            return (___errno_location = Module["asm"]["ha"]).apply(null, arguments);
        };
        var _main = Module["_main"] = function() {
            return (_main = Module["_main"] = Module["asm"]["ia"]).apply(null, arguments);
        };
        var _malloc = function() {
            return (_malloc = Module["asm"]["ja"]).apply(null, arguments);
        };
        var _free = function() {
            return (_free = Module["asm"]["ka"]).apply(null, arguments);
        };
        var _gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = function() {
            return (_gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = Module["asm"]["la"]).apply(null, arguments);
        };
        var ___funcs_on_exit = function() {
            return (___funcs_on_exit = Module["asm"]["ma"]).apply(null, arguments);
        };
        var _setThrew = function() {
            return (_setThrew = Module["asm"]["oa"]).apply(null, arguments);
        };
        var setTempRet0 = function() {
            return (setTempRet0 = Module["asm"]["pa"]).apply(null, arguments);
        };
        var _emscripten_stack_set_limits = function() {
            return (_emscripten_stack_set_limits = Module["asm"]["emscripten_stack_set_limits"]).apply(null, arguments);
        };
        var _emscripten_stack_get_base = function() {
            return (_emscripten_stack_get_base = Module["asm"]["emscripten_stack_get_base"]).apply(null, arguments);
        };
        var _emscripten_stack_get_end = function() {
            return (_emscripten_stack_get_end = Module["asm"]["emscripten_stack_get_end"]).apply(null, arguments);
        };
        var stackSave = function() {
            return (stackSave = Module["asm"]["qa"]).apply(null, arguments);
        };
        var stackRestore = function() {
            return (stackRestore = Module["asm"]["ra"]).apply(null, arguments);
        };
        var stackAlloc = function() {
            return (stackAlloc = Module["asm"]["sa"]).apply(null, arguments);
        };
        var ___cxa_can_catch = function() {
            return (___cxa_can_catch = Module["asm"]["ta"]).apply(null, arguments);
        };
        var ___cxa_is_pointer_type = function() {
            return (___cxa_is_pointer_type = Module["asm"]["ua"]).apply(null, arguments);
        };
        var dynCall_ii = Module["dynCall_ii"] = function() {
            return (dynCall_ii = Module["dynCall_ii"] = Module["asm"]["va"]).apply(null, arguments);
        };
        var dynCall_iiii = Module["dynCall_iiii"] = function() {
            return (dynCall_iiii = Module["dynCall_iiii"] = Module["asm"]["wa"]).apply(null, arguments);
        };
        var dynCall_viii = Module["dynCall_viii"] = function() {
            return (dynCall_viii = Module["dynCall_viii"] = Module["asm"]["xa"]).apply(null, arguments);
        };
        var dynCall_v = Module["dynCall_v"] = function() {
            return (dynCall_v = Module["dynCall_v"] = Module["asm"]["ya"]).apply(null, arguments);
        };
        var dynCall_vi = Module["dynCall_vi"] = function() {
            return (dynCall_vi = Module["dynCall_vi"] = Module["asm"]["za"]).apply(null, arguments);
        };
        var dynCall_iii = Module["dynCall_iii"] = function() {
            return (dynCall_iii = Module["dynCall_iii"] = Module["asm"]["Aa"]).apply(null, arguments);
        };
        var dynCall_vii = Module["dynCall_vii"] = function() {
            return (dynCall_vii = Module["dynCall_vii"] = Module["asm"]["Ba"]).apply(null, arguments);
        };
        var dynCall_iiiiii = Module["dynCall_iiiiii"] = function() {
            return (dynCall_iiiiii = Module["dynCall_iiiiii"] = Module["asm"]["Ca"]).apply(null, arguments);
        };
        var dynCall_iiiii = Module["dynCall_iiiii"] = function() {
            return (dynCall_iiiii = Module["dynCall_iiiii"] = Module["asm"]["Da"]).apply(null, arguments);
        };
        var dynCall_i = Module["dynCall_i"] = function() {
            return (dynCall_i = Module["dynCall_i"] = Module["asm"]["Ea"]).apply(null, arguments);
        };
        var dynCall_iiiiiii = Module["dynCall_iiiiiii"] = function() {
            return (dynCall_iiiiiii = Module["dynCall_iiiiiii"] = Module["asm"]["Fa"]).apply(null, arguments);
        };
        var dynCall_viiii = Module["dynCall_viiii"] = function() {
            return (dynCall_viiii = Module["dynCall_viiii"] = Module["asm"]["Ga"]).apply(null, arguments);
        };
        var dynCall_ji = Module["dynCall_ji"] = function() {
            return (dynCall_ji = Module["dynCall_ji"] = Module["asm"]["Ha"]).apply(null, arguments);
        };
        var dynCall_viiiii = Module["dynCall_viiiii"] = function() {
            return (dynCall_viiiii = Module["dynCall_viiiii"] = Module["asm"]["Ia"]).apply(null, arguments);
        };
        var dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = function() {
            return (dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = Module["asm"]["Ja"]).apply(null, arguments);
        };
        var dynCall_jiiii = Module["dynCall_jiiii"] = function() {
            return (dynCall_jiiii = Module["dynCall_jiiii"] = Module["asm"]["Ka"]).apply(null, arguments);
        };
        var dynCall_fiii = Module["dynCall_fiii"] = function() {
            return (dynCall_fiii = Module["dynCall_fiii"] = Module["asm"]["La"]).apply(null, arguments);
        };
        var dynCall_diii = Module["dynCall_diii"] = function() {
            return (dynCall_diii = Module["dynCall_diii"] = Module["asm"]["Ma"]).apply(null, arguments);
        };
        var dynCall_viiiiiii = Module["dynCall_viiiiiii"] = function() {
            return (dynCall_viiiiiii = Module["dynCall_viiiiiii"] = Module["asm"]["Na"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiiiii = Module["dynCall_iiiiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiiiii = Module["dynCall_iiiiiiiiiiii"] = Module["asm"]["Oa"]).apply(null, arguments);
        };
        var dynCall_viiiiiiiiii = Module["dynCall_viiiiiiiiii"] = function() {
            return (dynCall_viiiiiiiiii = Module["dynCall_viiiiiiiiii"] = Module["asm"]["Pa"]).apply(null, arguments);
        };
        var dynCall_viiiiiiiiiiiiiii = Module["dynCall_viiiiiiiiiiiiiii"] = function() {
            return (dynCall_viiiiiiiiiiiiiii = Module["dynCall_viiiiiiiiiiiiiii"] = Module["asm"]["Qa"]).apply(null, arguments);
        };
        var _asyncify_start_unwind = function() {
            return (_asyncify_start_unwind = Module["asm"]["Ra"]).apply(null, arguments);
        };
        var _asyncify_stop_unwind = function() {
            return (_asyncify_stop_unwind = Module["asm"]["Sa"]).apply(null, arguments);
        };
        var _asyncify_start_rewind = function() {
            return (_asyncify_start_rewind = Module["asm"]["Ta"]).apply(null, arguments);
        };
        var _asyncify_stop_rewind = function() {
            return (_asyncify_stop_rewind = Module["asm"]["Ua"]).apply(null, arguments);
        };
        var ___start_em_js = Module["___start_em_js"] = 52440;
        var ___stop_em_js = Module["___stop_em_js"] = 55125;
        function invoke_ii(index, a1) {
            var sp = stackSave();
            try {
                return dynCall_ii(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                return dynCall_iiii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                dynCall_viii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_v(index) {
            var sp = stackSave();
            try {
                dynCall_v(index);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vi(index, a1) {
            var sp = stackSave();
            try {
                dynCall_vi(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iii(index, a1, a2) {
            var sp = stackSave();
            try {
                return dynCall_iii(index, a1, a2);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vii(index, a1, a2) {
            var sp = stackSave();
            try {
                dynCall_vii(index, a1, a2);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiii(index, a1, a2, a3, a4, a5) {
            var sp = stackSave();
            try {
                return dynCall_iiiiii(index, a1, a2, a3, a4, a5);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                return dynCall_iiiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiii(index, a1, a2, a3, a4, a5, a6) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiii(index, a1, a2, a3, a4, a5, a6);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                dynCall_viiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiii(index, a1, a2, a3, a4, a5) {
            var sp = stackSave();
            try {
                dynCall_viiiii(index, a1, a2, a3, a4, a5);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_fiii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                return dynCall_fiii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_diii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                return dynCall_diii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_i(index) {
            var sp = stackSave();
            try {
                return dynCall_i(index);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
            var sp = stackSave();
            try {
                dynCall_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
            var sp = stackSave();
            try {
                dynCall_viiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) {
            var sp = stackSave();
            try {
                dynCall_viiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_ji(index, a1) {
            var sp = stackSave();
            try {
                return dynCall_ji(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_jiiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                return dynCall_jiiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        Module["AsciiToString"] = AsciiToString;
        Module["FS"] = FS;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function callMain(args = []) {
            var entryFunction = _main;
            args.unshift(thisProgram);
            var argc = args.length;
            var argv = stackAlloc((argc + 1) * 4);
            var argv_ptr = argv >> 2;
            args.forEach((arg)=>{
                HEAP32[argv_ptr++] = allocateUTF8OnStack(arg);
            });
            HEAP32[argv_ptr] = 0;
            try {
                var ret = entryFunction(argc, argv);
                exitJS(ret, true);
                return ret;
            } catch (e) {
                return handleException(e);
            }
        }
        function run(args = arguments_) {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                preMain();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                if (shouldRunNow) callMain(args);
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        var shouldRunNow = true;
        if (Module["noInitialRun"]) shouldRunNow = false;
        run();
        return Module.ready;
    };
})();
var $1c3c240882313db4$export$2e2bcd8739ae039 = $1c3c240882313db4$var$Module;


class $cc564b5c889ac118$export$2e2bcd8739ae039 extends (0, $7c4ebf67e8338ec8$export$2e2bcd8739ae039) {
    default_options() {
        return {
            vmcore: (0, $1c3c240882313db4$export$2e2bcd8739ae039)
        };
    }
}


/*

Emglken port of Git
===================

Copyright (c) 2020 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ 
var $90bdb86e43292d66$exports = {};


$90bdb86e43292d66$exports = (parcelRequire("6kBsm")).getBundleURL("ejVIo") + (parcelRequire("n9Yfb")).resolve("9Qh6d");


var $a5c3b71e8affc86f$var$Module = (()=>{
    var _scriptDir = "file:///node_modules/emglken/build/git-core.js";
    return function(Module = {}) {
        var Module = typeof Module != "undefined" ? Module : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || false;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
            if (!condition) abort(text);
        }
        var UTF8Decoder = new TextDecoder("utf8");
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            return UTF8Decoder.decode(heapOrArray.buffer ? heapOrArray.subarray(idx, endPtr) : new Uint8Array(heapOrArray.slice(idx, endPtr)));
        }
        function UTF8ToString(ptr, maxBytesToRead) {
            if (!ptr) return "";
            var maxPtr = ptr + maxBytesToRead;
            for(var end = ptr; !(end >= maxPtr) && HEAPU8[end];)++end;
            return UTF8Decoder.decode(HEAPU8.subarray(ptr, end));
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATMAIN__ = [];
        var __ATEXIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeExited = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() {
            return noExitRuntime || runtimeKeepaliveCounter > 0;
        }
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
            FS.ignorePermissions = false;
            TTY.init();
            callRuntimeCallbacks(__ATINIT__);
        }
        function preMain() {
            callRuntimeCallbacks(__ATMAIN__);
        }
        function exitRuntime() {
            ___funcs_on_exit();
            callRuntimeCallbacks(__ATEXIT__);
            FS.quit();
            TTY.shutdown();
            runtimeExited = true;
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
            return id;
        }
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        if (Module["locateFile"]) {
            wasmBinaryFile = "git-core.wasm";
            if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        } else wasmBinaryFile = new URL($90bdb86e43292d66$exports).href;
        function getBinary(file) {
            try {
                if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                if (readBinary) return readBinary(file);
                throw "both async and sync fetching of the wasm failed";
            } catch (err) {
                abort(err);
            }
        }
        function getBinaryPromise(binaryFile) {
            if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                if (typeof fetch == "function") return fetch(binaryFile, {
                    credentials: "same-origin"
                }).then(function(response) {
                    if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                    return response["arrayBuffer"]();
                }).catch(function() {
                    return getBinary(binaryFile);
                });
            }
            return Promise.resolve().then(function() {
                return getBinary(binaryFile);
            });
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
            return getBinaryPromise(binaryFile).then(function(binary) {
                return WebAssembly.instantiate(binary, imports);
            }).then(function(instance) {
                return instance;
            }).then(receiver, function(reason) {
                err("failed to asynchronously prepare wasm: " + reason);
                abort(reason);
            });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
            if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                credentials: "same-origin"
            }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, imports);
                return result.then(callback, function(reason) {
                    err("wasm streaming compile failed: " + reason);
                    err("falling back to ArrayBuffer instantiation");
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                });
            });
            else return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                exports = Asyncify.instrumentWasmExports(exports);
                Module["asm"] = exports;
                wasmMemory = Module["asm"]["E"];
                updateMemoryViews();
                wasmTable = Module["asm"]["N"];
                addOnInit(Module["asm"]["F"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            function receiveInstantiationResult(result) {
                receiveInstance(result["instance"]);
            }
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
            return {};
        }
        var tempDouble;
        var tempI64;
        function emglken_common_buffer_transformer(buf, len, numchars, func, dont_reduce) {
            const index = buf >> 2;
            const utf32 = HEAPU32.subarray(index, index + numchars);
            const data = dont_reduce ? utf32 : utf32.reduce((prev, ch)=>prev + String.fromCodePoint(ch), "");
            const new_str = func(data);
            const newbuf = Uint32Array.from(new_str, (ch)=>ch.codePointAt(0));
            const newlen = newbuf.length;
            HEAPU32.set(newbuf.subarray(0, Math.min(len, newlen)), index);
            return newlen;
        }
        function glk_buffer_to_lower_case_uni(buf, len, numchars) {
            return emglken_common_buffer_transformer(buf, len, numchars, (str)=>str.toLowerCase());
        }
        function glk_buffer_to_upper_case_uni(buf, len, numchars) {
            return emglken_common_buffer_transformer(buf, len, numchars, (str)=>str.toUpperCase());
        }
        function glk_buffer_to_title_case_uni(buf, len, numchars, lowerrest) {
            return emglken_common_buffer_transformer(buf, len, numchars, (utf32)=>utf32.reduce((prev, ch, index)=>{
                    const special_cases = {
                        "\xdf": "Ss",
                        "Ǆ": "ǅ",
                        "ǅ": "ǅ",
                        "ǆ": "ǅ",
                        "Ǉ": "ǈ",
                        "ǈ": "ǈ",
                        "ǉ": "ǈ",
                        "Ǌ": "ǋ",
                        "ǋ": "ǋ",
                        "ǌ": "ǋ",
                        "Ǳ": "ǲ",
                        "ǲ": "ǲ",
                        "ǳ": "ǲ",
                        "և": "Եւ",
                        "ᾲ": "Ὰͅ",
                        "ᾳ": "ᾼ",
                        "ᾴ": "Άͅ",
                        "ᾷ": "ᾼ͂",
                        "ᾼ": "ᾼ",
                        "ῂ": "Ὴͅ",
                        "ῃ": "ῌ",
                        "ῄ": "Ήͅ",
                        "ῇ": "ῌ͂",
                        "ῌ": "ῌ",
                        "ῲ": "Ὼͅ",
                        "ῳ": "ῼ",
                        "ῴ": "Ώͅ",
                        "ῷ": "ῼ͂",
                        "ῼ": "ῼ",
                        "ﬀ": "Ff",
                        "ﬁ": "Fi",
                        "ﬂ": "Fl",
                        "ﬃ": "Ffi",
                        "ﬄ": "Ffl",
                        "ﬅ": "St",
                        "ﬆ": "St",
                        "ﬓ": "Մն",
                        "ﬔ": "Մե",
                        "ﬕ": "Մի",
                        "ﬖ": "Վն",
                        "ﬗ": "Մխ"
                    };
                    const slightly_less_special_cases = [
                        "ᾈᾉᾊᾋᾌᾍᾎᾏ",
                        "ᾘᾙᾚᾛᾜᾝᾞᾟ",
                        "ᾨᾩᾪᾫᾬᾭᾮᾯ"
                    ];
                    let thischar = String.fromCodePoint(ch);
                    if (index === 0) {
                        if (special_cases[thischar]) thischar = special_cases[thischar];
                        else if (ch >= 8064 && ch < 8112) thischar = slightly_less_special_cases[(ch - 8064) / 16 | 0][ch % 8];
                        else thischar = thischar.toUpperCase();
                    } else if (lowerrest) thischar = thischar.toLowerCase();
                    return prev + thischar;
                }, ""), 1);
        }
        function glk_buffer_canon_decompose_uni(buf, len, numchars) {
            return emglken_common_buffer_transformer(buf, len, numchars, (str)=>str.normalize("NFD"));
        }
        function glk_buffer_canon_normalize_uni(buf, len, numchars) {
            return emglken_common_buffer_transformer(buf, len, numchars, (str)=>str.normalize("NFC"));
        }
        function __asyncjs__emglken_fill_stdin_buffer(buffer, maxlen) {
            return Asyncify.handleAsync(async ()=>{
                if (!Module.emglken_stdin_buffers.length) await new Promise((resolve)=>{
                    Module.emglken_stdin_ready = resolve;
                });
                const input = Module.emglken_stdin_buffers.shift();
                const len = Math.min(input.length, maxlen);
                if (len == input.length) HEAPU8.set(input, buffer);
                else {
                    HEAPU8.set(input.subarray(0, len), buffer);
                    Module.emglken_stdin_buffers.unshift(input.subarray(len));
                }
                return len;
            });
        }
        function ExitStatus(status) {
            this.name = "ExitStatus";
            this.message = "Program terminated with exit(" + status + ")";
            this.status = status;
        }
        function callRuntimeCallbacks(callbacks) {
            while(callbacks.length > 0)callbacks.shift()(Module);
        }
        var PATH = {
            isAbs: (path)=>path.charAt(0) === "/",
            splitPath: (filename)=>{
                var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return splitPathRe.exec(filename).slice(1);
            },
            normalizeArray: (parts, allowAboveRoot)=>{
                var up = 0;
                for(var i = parts.length - 1; i >= 0; i--){
                    var last = parts[i];
                    if (last === ".") parts.splice(i, 1);
                    else if (last === "..") {
                        parts.splice(i, 1);
                        up++;
                    } else if (up) {
                        parts.splice(i, 1);
                        up--;
                    }
                }
                if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                return parts;
            },
            normalize: (path)=>{
                var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                if (!path && !isAbsolute) path = ".";
                if (path && trailingSlash) path += "/";
                return (isAbsolute ? "/" : "") + path;
            },
            dirname: (path)=>{
                var result = PATH.splitPath(path), root = result[0], dir = result[1];
                if (!root && !dir) return ".";
                if (dir) dir = dir.substr(0, dir.length - 1);
                return root + dir;
            },
            basename: (path)=>{
                if (path === "/") return "/";
                path = PATH.normalize(path);
                path = path.replace(/\/$/, "");
                var lastSlash = path.lastIndexOf("/");
                if (lastSlash === -1) return path;
                return path.substr(lastSlash + 1);
            },
            join: function() {
                var paths = Array.prototype.slice.call(arguments);
                return PATH.normalize(paths.join("/"));
            },
            join2: (l, r)=>{
                return PATH.normalize(l + "/" + r);
            }
        };
        function getRandomDevice() {
            if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                var randomBuffer = new Uint8Array(1);
                return ()=>{
                    crypto.getRandomValues(randomBuffer);
                    return randomBuffer[0];
                };
            } else return ()=>abort("randomDevice");
        }
        var PATH_FS = {
            resolve: function() {
                var resolvedPath = "", resolvedAbsolute = false;
                for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                    var path = i >= 0 ? arguments[i] : FS.cwd();
                    if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                    else if (!path) return "";
                    resolvedPath = path + "/" + resolvedPath;
                    resolvedAbsolute = PATH.isAbs(path);
                }
                resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
            },
            relative: (from, to)=>{
                from = PATH_FS.resolve(from).substr(1);
                to = PATH_FS.resolve(to).substr(1);
                function trim(arr) {
                    var start = 0;
                    for(; start < arr.length; start++){
                        if (arr[start] !== "") break;
                    }
                    var end = arr.length - 1;
                    for(; end >= 0; end--){
                        if (arr[end] !== "") break;
                    }
                    if (start > end) return [];
                    return arr.slice(start, end - start + 1);
                }
                var fromParts = trim(from.split("/"));
                var toParts = trim(to.split("/"));
                var length = Math.min(fromParts.length, toParts.length);
                var samePartsLength = length;
                for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i;
                    break;
                }
                var outputParts = [];
                for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                outputParts = outputParts.concat(toParts.slice(samePartsLength));
                return outputParts.join("/");
            }
        };
        function intArrayFromString(stringy, dontAddNull, length) {
            var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull) u8array.length = numBytesWritten;
            return u8array;
        }
        var TTY = {
            ttys: [],
            init: function() {},
            shutdown: function() {},
            register: function(dev, ops) {
                TTY.ttys[dev] = {
                    input: [],
                    output: [],
                    ops: ops
                };
                FS.registerDevice(dev, TTY.stream_ops);
            },
            stream_ops: {
                open: function(stream) {
                    var tty = TTY.ttys[stream.node.rdev];
                    if (!tty) throw new FS.ErrnoError(43);
                    stream.tty = tty;
                    stream.seekable = false;
                },
                close: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                fsync: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                read: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                    var bytesRead = 0;
                    for(var i = 0; i < length; i++){
                        var result;
                        try {
                            result = stream.tty.ops.get_char(stream.tty);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                        if (result === null || result === undefined) break;
                        bytesRead++;
                        buffer[offset + i] = result;
                    }
                    if (bytesRead) stream.node.timestamp = Date.now();
                    return bytesRead;
                },
                write: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                    try {
                        for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                    } catch (e) {
                        throw new FS.ErrnoError(29);
                    }
                    if (length) stream.node.timestamp = Date.now();
                    return i;
                }
            },
            default_tty_ops: {
                get_char: function(tty) {
                    if (!tty.input.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        tty.input = intArrayFromString(result, true);
                    }
                    return tty.input.shift();
                },
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            },
            default_tty1_ops: {
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            }
        };
        function mmapAlloc(size) {
            abort();
        }
        var MEMFS = {
            ops_table: null,
            mount: function(mount) {
                return MEMFS.createNode(null, "/", 16895, 0);
            },
            createNode: function(parent, name, mode, dev) {
                if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                if (!MEMFS.ops_table) MEMFS.ops_table = {
                    dir: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            lookup: MEMFS.node_ops.lookup,
                            mknod: MEMFS.node_ops.mknod,
                            rename: MEMFS.node_ops.rename,
                            unlink: MEMFS.node_ops.unlink,
                            rmdir: MEMFS.node_ops.rmdir,
                            readdir: MEMFS.node_ops.readdir,
                            symlink: MEMFS.node_ops.symlink
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek,
                            read: MEMFS.stream_ops.read,
                            write: MEMFS.stream_ops.write,
                            allocate: MEMFS.stream_ops.allocate,
                            mmap: MEMFS.stream_ops.mmap,
                            msync: MEMFS.stream_ops.msync
                        }
                    },
                    link: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            readlink: MEMFS.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: FS.chrdev_stream_ops
                    }
                };
                var node = FS.createNode(parent, name, mode, dev);
                if (FS.isDir(node.mode)) {
                    node.node_ops = MEMFS.ops_table.dir.node;
                    node.stream_ops = MEMFS.ops_table.dir.stream;
                    node.contents = {};
                } else if (FS.isFile(node.mode)) {
                    node.node_ops = MEMFS.ops_table.file.node;
                    node.stream_ops = MEMFS.ops_table.file.stream;
                    node.usedBytes = 0;
                    node.contents = null;
                } else if (FS.isLink(node.mode)) {
                    node.node_ops = MEMFS.ops_table.link.node;
                    node.stream_ops = MEMFS.ops_table.link.stream;
                } else if (FS.isChrdev(node.mode)) {
                    node.node_ops = MEMFS.ops_table.chrdev.node;
                    node.stream_ops = MEMFS.ops_table.chrdev.stream;
                }
                node.timestamp = Date.now();
                if (parent) {
                    parent.contents[name] = node;
                    parent.timestamp = node.timestamp;
                }
                return node;
            },
            getFileDataAsTypedArray: function(node) {
                if (!node.contents) return new Uint8Array(0);
                if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                return new Uint8Array(node.contents);
            },
            expandFileStorage: function(node, newCapacity) {
                var prevCapacity = node.contents ? node.contents.length : 0;
                if (prevCapacity >= newCapacity) return;
                var CAPACITY_DOUBLING_MAX = 1048576;
                newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                var oldContents = node.contents;
                node.contents = new Uint8Array(newCapacity);
                if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
            },
            resizeFileStorage: function(node, newSize) {
                if (node.usedBytes == newSize) return;
                if (newSize == 0) {
                    node.contents = null;
                    node.usedBytes = 0;
                } else {
                    var oldContents = node.contents;
                    node.contents = new Uint8Array(newSize);
                    if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                    node.usedBytes = newSize;
                }
            },
            node_ops: {
                getattr: function(node) {
                    var attr = {};
                    attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                    attr.ino = node.id;
                    attr.mode = node.mode;
                    attr.nlink = 1;
                    attr.uid = 0;
                    attr.gid = 0;
                    attr.rdev = node.rdev;
                    if (FS.isDir(node.mode)) attr.size = 4096;
                    else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                    else if (FS.isLink(node.mode)) attr.size = node.link.length;
                    else attr.size = 0;
                    attr.atime = new Date(node.timestamp);
                    attr.mtime = new Date(node.timestamp);
                    attr.ctime = new Date(node.timestamp);
                    attr.blksize = 4096;
                    attr.blocks = Math.ceil(attr.size / attr.blksize);
                    return attr;
                },
                setattr: function(node, attr) {
                    if (attr.mode !== undefined) node.mode = attr.mode;
                    if (attr.timestamp !== undefined) node.timestamp = attr.timestamp;
                    if (attr.size !== undefined) MEMFS.resizeFileStorage(node, attr.size);
                },
                lookup: function(parent, name) {
                    throw FS.genericErrors[44];
                },
                mknod: function(parent, name, mode, dev) {
                    return MEMFS.createNode(parent, name, mode, dev);
                },
                rename: function(old_node, new_dir, new_name) {
                    if (FS.isDir(old_node.mode)) {
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (new_node) {
                            for(var i in new_node.contents)throw new FS.ErrnoError(55);
                        }
                    }
                    delete old_node.parent.contents[old_node.name];
                    old_node.parent.timestamp = Date.now();
                    old_node.name = new_name;
                    new_dir.contents[new_name] = old_node;
                    new_dir.timestamp = old_node.parent.timestamp;
                    old_node.parent = new_dir;
                },
                unlink: function(parent, name) {
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                rmdir: function(parent, name) {
                    var node = FS.lookupNode(parent, name);
                    for(var i in node.contents)throw new FS.ErrnoError(55);
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                readdir: function(node) {
                    var entries = [
                        ".",
                        ".."
                    ];
                    for(var key in node.contents){
                        if (!node.contents.hasOwnProperty(key)) continue;
                        entries.push(key);
                    }
                    return entries;
                },
                symlink: function(parent, newname, oldpath) {
                    var node = MEMFS.createNode(parent, newname, 41471, 0);
                    node.link = oldpath;
                    return node;
                },
                readlink: function(node) {
                    if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                    return node.link;
                }
            },
            stream_ops: {
                read: function(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= stream.node.usedBytes) return 0;
                    var size = Math.min(stream.node.usedBytes - position, length);
                    if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    return size;
                },
                write: function(stream, buffer, offset, length, position, canOwn) {
                    if (buffer.buffer === HEAP8.buffer) canOwn = false;
                    if (!length) return 0;
                    var node = stream.node;
                    node.timestamp = Date.now();
                    if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                        if (canOwn) {
                            node.contents = buffer.subarray(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (node.usedBytes === 0 && position === 0) {
                            node.contents = buffer.slice(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (position + length <= node.usedBytes) {
                            node.contents.set(buffer.subarray(offset, offset + length), position);
                            return length;
                        }
                    }
                    MEMFS.expandFileStorage(node, position + length);
                    if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                    else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                    node.usedBytes = Math.max(node.usedBytes, position + length);
                    return length;
                },
                llseek: function(stream, offset, whence) {
                    var position = offset;
                    if (whence === 1) position += stream.position;
                    else if (whence === 2) {
                        if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                    }
                    if (position < 0) throw new FS.ErrnoError(28);
                    return position;
                },
                allocate: function(stream, offset, length) {
                    MEMFS.expandFileStorage(stream.node, offset + length);
                    stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                },
                mmap: function(stream, length, position, prot, flags) {
                    if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                    var ptr;
                    var allocated;
                    var contents = stream.node.contents;
                    if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                        allocated = false;
                        ptr = contents.byteOffset;
                    } else {
                        if (position > 0 || position + length < contents.length) {
                            if (contents.subarray) contents = contents.subarray(position, position + length);
                            else contents = Array.prototype.slice.call(contents, position, position + length);
                        }
                        allocated = true;
                        ptr = mmapAlloc(length);
                        if (!ptr) throw new FS.ErrnoError(48);
                        HEAP8.set(contents, ptr);
                    }
                    return {
                        ptr: ptr,
                        allocated: allocated
                    };
                },
                msync: function(stream, buffer, offset, length, mmapFlags) {
                    MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                    return 0;
                }
            }
        };
        function asyncLoad(url, onload, onerror, noRunDep) {
            var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
            readAsync(url, (arrayBuffer)=>{
                assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
                onload(new Uint8Array(arrayBuffer));
                if (dep) removeRunDependency(dep);
            }, (event)=>{
                if (onerror) onerror();
                else throw 'Loading data file "' + url + '" failed.';
            });
            if (dep) addRunDependency(dep);
        }
        var FS = {
            root: null,
            mounts: [],
            devices: {},
            streams: [],
            nextInode: 1,
            nameTable: null,
            currentPath: "/",
            initialized: false,
            ignorePermissions: true,
            ErrnoError: null,
            genericErrors: {},
            filesystems: null,
            syncFSRequests: 0,
            lookupPath: (path, opts = {})=>{
                path = PATH_FS.resolve(path);
                if (!path) return {
                    path: "",
                    node: null
                };
                var defaults = {
                    follow_mount: true,
                    recurse_count: 0
                };
                opts = Object.assign(defaults, opts);
                if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                var parts = path.split("/").filter((p)=>!!p);
                var current = FS.root;
                var current_path = "/";
                for(var i = 0; i < parts.length; i++){
                    var islast = i === parts.length - 1;
                    if (islast && opts.parent) break;
                    current = FS.lookupNode(current, parts[i]);
                    current_path = PATH.join2(current_path, parts[i]);
                    if (FS.isMountpoint(current)) {
                        if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                    }
                    if (!islast || opts.follow) {
                        var count = 0;
                        while(FS.isLink(current.mode)){
                            var link = FS.readlink(current_path);
                            current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                            var lookup = FS.lookupPath(current_path, {
                                recurse_count: opts.recurse_count + 1
                            });
                            current = lookup.node;
                            if (count++ > 40) throw new FS.ErrnoError(32);
                        }
                    }
                }
                return {
                    path: current_path,
                    node: current
                };
            },
            getPath: (node)=>{
                var path;
                while(true){
                    if (FS.isRoot(node)) {
                        var mount = node.mount.mountpoint;
                        if (!path) return mount;
                        return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
                    }
                    path = path ? node.name + "/" + path : node.name;
                    node = node.parent;
                }
            },
            hashName: (parentid, name)=>{
                var hash = 0;
                for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                return (parentid + hash >>> 0) % FS.nameTable.length;
            },
            hashAddNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                node.name_next = FS.nameTable[hash];
                FS.nameTable[hash] = node;
            },
            hashRemoveNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                else {
                    var current = FS.nameTable[hash];
                    while(current){
                        if (current.name_next === node) {
                            current.name_next = node.name_next;
                            break;
                        }
                        current = current.name_next;
                    }
                }
            },
            lookupNode: (parent, name)=>{
                var errCode = FS.mayLookup(parent);
                if (errCode) throw new FS.ErrnoError(errCode, parent);
                var hash = FS.hashName(parent.id, name);
                for(var node = FS.nameTable[hash]; node; node = node.name_next){
                    var nodeName = node.name;
                    if (node.parent.id === parent.id && nodeName === name) return node;
                }
                return FS.lookup(parent, name);
            },
            createNode: (parent, name, mode, rdev)=>{
                var node = new FS.FSNode(parent, name, mode, rdev);
                FS.hashAddNode(node);
                return node;
            },
            destroyNode: (node)=>{
                FS.hashRemoveNode(node);
            },
            isRoot: (node)=>{
                return node === node.parent;
            },
            isMountpoint: (node)=>{
                return !!node.mounted;
            },
            isFile: (mode)=>{
                return (mode & 61440) === 32768;
            },
            isDir: (mode)=>{
                return (mode & 61440) === 16384;
            },
            isLink: (mode)=>{
                return (mode & 61440) === 40960;
            },
            isChrdev: (mode)=>{
                return (mode & 61440) === 8192;
            },
            isBlkdev: (mode)=>{
                return (mode & 61440) === 24576;
            },
            isFIFO: (mode)=>{
                return (mode & 61440) === 4096;
            },
            isSocket: (mode)=>{
                return (mode & 49152) === 49152;
            },
            flagModes: {
                "r": 0,
                "r+": 2,
                "w": 577,
                "w+": 578,
                "a": 1089,
                "a+": 1090
            },
            modeStringToFlags: (str)=>{
                var flags = FS.flagModes[str];
                if (typeof flags == "undefined") throw new Error("Unknown file open mode: " + str);
                return flags;
            },
            flagsToPermissionString: (flag)=>{
                var perms = [
                    "r",
                    "w",
                    "rw"
                ][flag & 3];
                if (flag & 512) perms += "w";
                return perms;
            },
            nodePermissions: (node, perms)=>{
                if (FS.ignorePermissions) return 0;
                if (perms.includes("r") && !(node.mode & 292)) return 2;
                else if (perms.includes("w") && !(node.mode & 146)) return 2;
                else if (perms.includes("x") && !(node.mode & 73)) return 2;
                return 0;
            },
            mayLookup: (dir)=>{
                var errCode = FS.nodePermissions(dir, "x");
                if (errCode) return errCode;
                if (!dir.node_ops.lookup) return 2;
                return 0;
            },
            mayCreate: (dir, name)=>{
                try {
                    var node = FS.lookupNode(dir, name);
                    return 20;
                } catch (e) {}
                return FS.nodePermissions(dir, "wx");
            },
            mayDelete: (dir, name, isdir)=>{
                var node;
                try {
                    node = FS.lookupNode(dir, name);
                } catch (e) {
                    return e.errno;
                }
                var errCode = FS.nodePermissions(dir, "wx");
                if (errCode) return errCode;
                if (isdir) {
                    if (!FS.isDir(node.mode)) return 54;
                    if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                } else {
                    if (FS.isDir(node.mode)) return 31;
                }
                return 0;
            },
            mayOpen: (node, flags)=>{
                if (!node) return 44;
                if (FS.isLink(node.mode)) return 32;
                else if (FS.isDir(node.mode)) {
                    if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                }
                return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
            },
            MAX_OPEN_FDS: 4096,
            nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS)=>{
                for(var fd = fd_start; fd <= fd_end; fd++){
                    if (!FS.streams[fd]) return fd;
                }
                throw new FS.ErrnoError(33);
            },
            getStream: (fd)=>FS.streams[fd],
            createStream: (stream, fd_start, fd_end)=>{
                if (!FS.FSStream) {
                    FS.FSStream = function() {
                        this.shared = {};
                    };
                    FS.FSStream.prototype = {};
                    Object.defineProperties(FS.FSStream.prototype, {
                        object: {
                            get: function() {
                                return this.node;
                            },
                            set: function(val) {
                                this.node = val;
                            }
                        },
                        isRead: {
                            get: function() {
                                return (this.flags & 2097155) !== 1;
                            }
                        },
                        isWrite: {
                            get: function() {
                                return (this.flags & 2097155) !== 0;
                            }
                        },
                        isAppend: {
                            get: function() {
                                return this.flags & 1024;
                            }
                        },
                        flags: {
                            get: function() {
                                return this.shared.flags;
                            },
                            set: function(val) {
                                this.shared.flags = val;
                            }
                        },
                        position: {
                            get: function() {
                                return this.shared.position;
                            },
                            set: function(val) {
                                this.shared.position = val;
                            }
                        }
                    });
                }
                stream = Object.assign(new FS.FSStream(), stream);
                var fd = FS.nextfd(fd_start, fd_end);
                stream.fd = fd;
                FS.streams[fd] = stream;
                return stream;
            },
            closeStream: (fd)=>{
                FS.streams[fd] = null;
            },
            chrdev_stream_ops: {
                open: (stream)=>{
                    var device = FS.getDevice(stream.node.rdev);
                    stream.stream_ops = device.stream_ops;
                    if (stream.stream_ops.open) stream.stream_ops.open(stream);
                },
                llseek: ()=>{
                    throw new FS.ErrnoError(70);
                }
            },
            major: (dev)=>dev >> 8,
            minor: (dev)=>dev & 255,
            makedev: (ma, mi)=>ma << 8 | mi,
            registerDevice: (dev, ops)=>{
                FS.devices[dev] = {
                    stream_ops: ops
                };
            },
            getDevice: (dev)=>FS.devices[dev],
            getMounts: (mount)=>{
                var mounts = [];
                var check = [
                    mount
                ];
                while(check.length){
                    var m = check.pop();
                    mounts.push(m);
                    check.push.apply(check, m.mounts);
                }
                return mounts;
            },
            syncfs: (populate, callback)=>{
                if (typeof populate == "function") {
                    callback = populate;
                    populate = false;
                }
                FS.syncFSRequests++;
                if (FS.syncFSRequests > 1) err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
                var mounts = FS.getMounts(FS.root.mount);
                var completed = 0;
                function doCallback(errCode) {
                    FS.syncFSRequests--;
                    return callback(errCode);
                }
                function done(errCode) {
                    if (errCode) {
                        if (!done.errored) {
                            done.errored = true;
                            return doCallback(errCode);
                        }
                        return;
                    }
                    if (++completed >= mounts.length) doCallback(null);
                }
                mounts.forEach((mount)=>{
                    if (!mount.type.syncfs) return done(null);
                    mount.type.syncfs(mount, populate, done);
                });
            },
            mount: (type, opts, mountpoint)=>{
                var root = mountpoint === "/";
                var pseudo = !mountpoint;
                var node;
                if (root && FS.root) throw new FS.ErrnoError(10);
                else if (!root && !pseudo) {
                    var lookup = FS.lookupPath(mountpoint, {
                        follow_mount: false
                    });
                    mountpoint = lookup.path;
                    node = lookup.node;
                    if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                    if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                }
                var mount = {
                    type: type,
                    opts: opts,
                    mountpoint: mountpoint,
                    mounts: []
                };
                var mountRoot = type.mount(mount);
                mountRoot.mount = mount;
                mount.root = mountRoot;
                if (root) FS.root = mountRoot;
                else if (node) {
                    node.mounted = mount;
                    if (node.mount) node.mount.mounts.push(mount);
                }
                return mountRoot;
            },
            unmount: (mountpoint)=>{
                var lookup = FS.lookupPath(mountpoint, {
                    follow_mount: false
                });
                if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                var node = lookup.node;
                var mount = node.mounted;
                var mounts = FS.getMounts(mount);
                Object.keys(FS.nameTable).forEach((hash)=>{
                    var current = FS.nameTable[hash];
                    while(current){
                        var next = current.name_next;
                        if (mounts.includes(current.mount)) FS.destroyNode(current);
                        current = next;
                    }
                });
                node.mounted = null;
                var idx = node.mount.mounts.indexOf(mount);
                node.mount.mounts.splice(idx, 1);
            },
            lookup: (parent, name)=>{
                return parent.node_ops.lookup(parent, name);
            },
            mknod: (path, mode, dev)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                var errCode = FS.mayCreate(parent, name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                return parent.node_ops.mknod(parent, name, mode, dev);
            },
            create: (path, mode)=>{
                mode = mode !== undefined ? mode : 438;
                mode &= 4095;
                mode |= 32768;
                return FS.mknod(path, mode, 0);
            },
            mkdir: (path, mode)=>{
                mode = mode !== undefined ? mode : 511;
                mode &= 1023;
                mode |= 16384;
                return FS.mknod(path, mode, 0);
            },
            mkdirTree: (path, mode)=>{
                var dirs = path.split("/");
                var d = "";
                for(var i = 0; i < dirs.length; ++i){
                    if (!dirs[i]) continue;
                    d += "/" + dirs[i];
                    try {
                        FS.mkdir(d, mode);
                    } catch (e) {
                        if (e.errno != 20) throw e;
                    }
                }
            },
            mkdev: (path, mode, dev)=>{
                if (typeof dev == "undefined") {
                    dev = mode;
                    mode = 438;
                }
                mode |= 8192;
                return FS.mknod(path, mode, dev);
            },
            symlink: (oldpath, newpath)=>{
                if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                var lookup = FS.lookupPath(newpath, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var newname = PATH.basename(newpath);
                var errCode = FS.mayCreate(parent, newname);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                return parent.node_ops.symlink(parent, newname, oldpath);
            },
            rename: (old_path, new_path)=>{
                var old_dirname = PATH.dirname(old_path);
                var new_dirname = PATH.dirname(new_path);
                var old_name = PATH.basename(old_path);
                var new_name = PATH.basename(new_path);
                var lookup, old_dir, new_dir;
                lookup = FS.lookupPath(old_path, {
                    parent: true
                });
                old_dir = lookup.node;
                lookup = FS.lookupPath(new_path, {
                    parent: true
                });
                new_dir = lookup.node;
                if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                var old_node = FS.lookupNode(old_dir, old_name);
                var relative = PATH_FS.relative(old_path, new_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                relative = PATH_FS.relative(new_path, old_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                var new_node;
                try {
                    new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}
                if (old_node === new_node) return;
                var isdir = FS.isDir(old_node.mode);
                var errCode = FS.mayDelete(old_dir, old_name, isdir);
                if (errCode) throw new FS.ErrnoError(errCode);
                errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                if (new_dir !== old_dir) {
                    errCode = FS.nodePermissions(old_dir, "w");
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                FS.hashRemoveNode(old_node);
                try {
                    old_dir.node_ops.rename(old_node, new_dir, new_name);
                } catch (e) {
                    throw e;
                } finally{
                    FS.hashAddNode(old_node);
                }
            },
            rmdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, true);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.rmdir(parent, name);
                FS.destroyNode(node);
            },
            readdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                return node.node_ops.readdir(node);
            },
            unlink: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, false);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.unlink(parent, name);
                FS.destroyNode(node);
            },
            readlink: (path)=>{
                var lookup = FS.lookupPath(path);
                var link = lookup.node;
                if (!link) throw new FS.ErrnoError(44);
                if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
            },
            stat: (path, dontFollow)=>{
                var lookup = FS.lookupPath(path, {
                    follow: !dontFollow
                });
                var node = lookup.node;
                if (!node) throw new FS.ErrnoError(44);
                if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                return node.node_ops.getattr(node);
            },
            lstat: (path)=>{
                return FS.stat(path, true);
            },
            chmod: (path, mode, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    mode: mode & 4095 | node.mode & -4096,
                    timestamp: Date.now()
                });
            },
            lchmod: (path, mode)=>{
                FS.chmod(path, mode, true);
            },
            fchmod: (fd, mode)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chmod(stream.node, mode);
            },
            chown: (path, uid, gid, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    timestamp: Date.now()
                });
            },
            lchown: (path, uid, gid)=>{
                FS.chown(path, uid, gid, true);
            },
            fchown: (fd, uid, gid)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chown(stream.node, uid, gid);
            },
            truncate: (path, len)=>{
                if (len < 0) throw new FS.ErrnoError(28);
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                var errCode = FS.nodePermissions(node, "w");
                if (errCode) throw new FS.ErrnoError(errCode);
                node.node_ops.setattr(node, {
                    size: len,
                    timestamp: Date.now()
                });
            },
            ftruncate: (fd, len)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                FS.truncate(stream.node, len);
            },
            utime: (path, atime, mtime)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                node.node_ops.setattr(node, {
                    timestamp: Math.max(atime, mtime)
                });
            },
            open: (path, flags, mode)=>{
                if (path === "") throw new FS.ErrnoError(44);
                flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
                mode = typeof mode == "undefined" ? 438 : mode;
                if (flags & 64) mode = mode & 4095 | 32768;
                else mode = 0;
                var node;
                if (typeof path == "object") node = path;
                else {
                    path = PATH.normalize(path);
                    try {
                        var lookup = FS.lookupPath(path, {
                            follow: !(flags & 131072)
                        });
                        node = lookup.node;
                    } catch (e) {}
                }
                var created = false;
                if (flags & 64) {
                    if (node) {
                        if (flags & 128) throw new FS.ErrnoError(20);
                    } else {
                        node = FS.mknod(path, mode, 0);
                        created = true;
                    }
                }
                if (!node) throw new FS.ErrnoError(44);
                if (FS.isChrdev(node.mode)) flags &= -513;
                if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                if (!created) {
                    var errCode = FS.mayOpen(node, flags);
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                if (flags & 512 && !created) FS.truncate(node, 0);
                flags &= -131713;
                var stream = FS.createStream({
                    node: node,
                    path: FS.getPath(node),
                    flags: flags,
                    seekable: true,
                    position: 0,
                    stream_ops: node.stream_ops,
                    ungotten: [],
                    error: false
                });
                if (stream.stream_ops.open) stream.stream_ops.open(stream);
                if (Module["logReadFiles"] && !(flags & 1)) {
                    if (!FS.readFiles) FS.readFiles = {};
                    if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                }
                return stream;
            },
            close: (stream)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (stream.getdents) stream.getdents = null;
                try {
                    if (stream.stream_ops.close) stream.stream_ops.close(stream);
                } catch (e) {
                    throw e;
                } finally{
                    FS.closeStream(stream.fd);
                }
                stream.fd = null;
            },
            isClosed: (stream)=>{
                return stream.fd === null;
            },
            llseek: (stream, offset, whence)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                stream.position = stream.stream_ops.llseek(stream, offset, whence);
                stream.ungotten = [];
                return stream.position;
            },
            read: (stream, buffer, offset, length, position)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                if (!seeking) stream.position += bytesRead;
                return bytesRead;
            },
            write: (stream, buffer, offset, length, position, canOwn)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                if (!seeking) stream.position += bytesWritten;
                return bytesWritten;
            },
            allocate: (stream, offset, length)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                stream.stream_ops.allocate(stream, offset, length);
            },
            mmap: (stream, length, position, prot, flags)=>{
                if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                return stream.stream_ops.mmap(stream, length, position, prot, flags);
            },
            msync: (stream, buffer, offset, length, mmapFlags)=>{
                if (!stream.stream_ops.msync) return 0;
                return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
            },
            munmap: (stream)=>0,
            ioctl: (stream, cmd, arg)=>{
                if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                return stream.stream_ops.ioctl(stream, cmd, arg);
            },
            readFile: (path, opts = {})=>{
                opts.flags = opts.flags || 0;
                opts.encoding = opts.encoding || "binary";
                if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error('Invalid encoding type "' + opts.encoding + '"');
                var ret;
                var stream = FS.open(path, opts.flags);
                var stat = FS.stat(path);
                var length = stat.size;
                var buf = new Uint8Array(length);
                FS.read(stream, buf, 0, length, 0);
                if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                else if (opts.encoding === "binary") ret = buf;
                FS.close(stream);
                return ret;
            },
            writeFile: (path, data, opts = {})=>{
                opts.flags = opts.flags || 577;
                var stream = FS.open(path, opts.flags, opts.mode);
                if (typeof data == "string") {
                    var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                    var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                    FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn);
                } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn);
                else throw new Error("Unsupported data type");
                FS.close(stream);
            },
            cwd: ()=>FS.currentPath,
            chdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                if (lookup.node === null) throw new FS.ErrnoError(44);
                if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                var errCode = FS.nodePermissions(lookup.node, "x");
                if (errCode) throw new FS.ErrnoError(errCode);
                FS.currentPath = lookup.path;
            },
            createDefaultDirectories: ()=>{
                FS.mkdir("/tmp");
                FS.mkdir("/home");
                FS.mkdir("/home/web_user");
            },
            createDefaultDevices: ()=>{
                FS.mkdir("/dev");
                FS.registerDevice(FS.makedev(1, 3), {
                    read: ()=>0,
                    write: (stream, buffer, offset, length, pos)=>length
                });
                FS.mkdev("/dev/null", FS.makedev(1, 3));
                TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                FS.mkdev("/dev/tty", FS.makedev(5, 0));
                FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                var random_device = getRandomDevice();
                FS.createDevice("/dev", "random", random_device);
                FS.createDevice("/dev", "urandom", random_device);
                FS.mkdir("/dev/shm");
                FS.mkdir("/dev/shm/tmp");
            },
            createSpecialDirectories: ()=>{
                FS.mkdir("/proc");
                var proc_self = FS.mkdir("/proc/self");
                FS.mkdir("/proc/self/fd");
                FS.mount({
                    mount: ()=>{
                        var node = FS.createNode(proc_self, "fd", 16895, 73);
                        node.node_ops = {
                            lookup: (parent, name)=>{
                                var fd = +name;
                                var stream = FS.getStream(fd);
                                if (!stream) throw new FS.ErrnoError(8);
                                var ret = {
                                    parent: null,
                                    mount: {
                                        mountpoint: "fake"
                                    },
                                    node_ops: {
                                        readlink: ()=>stream.path
                                    }
                                };
                                ret.parent = ret;
                                return ret;
                            }
                        };
                        return node;
                    }
                }, {}, "/proc/self/fd");
            },
            createStandardStreams: ()=>{
                if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                else FS.symlink("/dev/tty", "/dev/stdin");
                if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                else FS.symlink("/dev/tty", "/dev/stdout");
                if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                else FS.symlink("/dev/tty1", "/dev/stderr");
                var stdin = FS.open("/dev/stdin", 0);
                var stdout = FS.open("/dev/stdout", 1);
                var stderr = FS.open("/dev/stderr", 1);
            },
            ensureErrnoError: ()=>{
                if (FS.ErrnoError) return;
                FS.ErrnoError = function ErrnoError(errno, node) {
                    this.name = "ErrnoError";
                    this.node = node;
                    this.setErrno = function(errno) {
                        this.errno = errno;
                    };
                    this.setErrno(errno);
                    this.message = "FS error";
                };
                FS.ErrnoError.prototype = new Error();
                FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                [
                    44
                ].forEach((code)=>{
                    FS.genericErrors[code] = new FS.ErrnoError(code);
                    FS.genericErrors[code].stack = "<generic error, no stack>";
                });
            },
            staticInit: ()=>{
                FS.ensureErrnoError();
                FS.nameTable = new Array(4096);
                FS.mount(MEMFS, {}, "/");
                FS.createDefaultDirectories();
                FS.createDefaultDevices();
                FS.createSpecialDirectories();
                FS.filesystems = {
                    "MEMFS": MEMFS
                };
            },
            init: (input, output, error)=>{
                FS.init.initialized = true;
                FS.ensureErrnoError();
                Module["stdin"] = input || Module["stdin"];
                Module["stdout"] = output || Module["stdout"];
                Module["stderr"] = error || Module["stderr"];
                FS.createStandardStreams();
            },
            quit: ()=>{
                FS.init.initialized = false;
                _fflush(0);
                for(var i = 0; i < FS.streams.length; i++){
                    var stream = FS.streams[i];
                    if (!stream) continue;
                    FS.close(stream);
                }
            },
            getMode: (canRead, canWrite)=>{
                var mode = 0;
                if (canRead) mode |= 365;
                if (canWrite) mode |= 146;
                return mode;
            },
            findObject: (path, dontResolveLastLink)=>{
                var ret = FS.analyzePath(path, dontResolveLastLink);
                if (!ret.exists) return null;
                return ret.object;
            },
            analyzePath: (path, dontResolveLastLink)=>{
                try {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    path = lookup.path;
                } catch (e) {}
                var ret = {
                    isRoot: false,
                    exists: false,
                    error: 0,
                    name: null,
                    path: null,
                    object: null,
                    parentExists: false,
                    parentPath: null,
                    parentObject: null
                };
                try {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    ret.parentExists = true;
                    ret.parentPath = lookup.path;
                    ret.parentObject = lookup.node;
                    ret.name = PATH.basename(path);
                    lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    ret.exists = true;
                    ret.path = lookup.path;
                    ret.object = lookup.node;
                    ret.name = lookup.node.name;
                    ret.isRoot = lookup.path === "/";
                } catch (e) {
                    ret.error = e.errno;
                }
                return ret;
            },
            createPath: (parent, path, canRead, canWrite)=>{
                parent = typeof parent == "string" ? parent : FS.getPath(parent);
                var parts = path.split("/").reverse();
                while(parts.length){
                    var part = parts.pop();
                    if (!part) continue;
                    var current = PATH.join2(parent, part);
                    try {
                        FS.mkdir(current);
                    } catch (e) {}
                    parent = current;
                }
                return current;
            },
            createFile: (parent, name, properties, canRead, canWrite)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(canRead, canWrite);
                return FS.create(path, mode);
            },
            createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                var path = name;
                if (parent) {
                    parent = typeof parent == "string" ? parent : FS.getPath(parent);
                    path = name ? PATH.join2(parent, name) : parent;
                }
                var mode = FS.getMode(canRead, canWrite);
                var node = FS.create(path, mode);
                if (data) {
                    if (typeof data == "string") {
                        var arr = new Array(data.length);
                        for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                        data = arr;
                    }
                    FS.chmod(node, mode | 146);
                    var stream = FS.open(node, 577);
                    FS.write(stream, data, 0, data.length, 0, canOwn);
                    FS.close(stream);
                    FS.chmod(node, mode);
                }
                return node;
            },
            createDevice: (parent, name, input, output)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(!!input, !!output);
                if (!FS.createDevice.major) FS.createDevice.major = 64;
                var dev = FS.makedev(FS.createDevice.major++, 0);
                FS.registerDevice(dev, {
                    open: (stream)=>{
                        stream.seekable = false;
                    },
                    close: (stream)=>{
                        if (output && output.buffer && output.buffer.length) output(10);
                    },
                    read: (stream, buffer, offset, length, pos)=>{
                        var bytesRead = 0;
                        for(var i = 0; i < length; i++){
                            var result;
                            try {
                                result = input();
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                            if (result === null || result === undefined) break;
                            bytesRead++;
                            buffer[offset + i] = result;
                        }
                        if (bytesRead) stream.node.timestamp = Date.now();
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, pos)=>{
                        for(var i = 0; i < length; i++)try {
                            output(buffer[offset + i]);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (length) stream.node.timestamp = Date.now();
                        return i;
                    }
                });
                return FS.mkdev(path, mode, dev);
            },
            forceLoadFile: (obj)=>{
                if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                else if (read_) try {
                    obj.contents = intArrayFromString(read_(obj.url), true);
                    obj.usedBytes = obj.contents.length;
                } catch (e) {
                    throw new FS.ErrnoError(29);
                }
                else throw new Error("Cannot load without read() or XMLHttpRequest.");
            },
            createLazyFile: (parent, name, url, canRead, canWrite)=>{
                function LazyUint8Array() {
                    this.lengthKnown = false;
                    this.chunks = [];
                }
                LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                    if (idx > this.length - 1 || idx < 0) return undefined;
                    var chunkOffset = idx % this.chunkSize;
                    var chunkNum = idx / this.chunkSize | 0;
                    return this.getter(chunkNum)[chunkOffset];
                };
                LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                    this.getter = getter;
                };
                LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                    var xhr = new XMLHttpRequest();
                    xhr.open("HEAD", url, false);
                    xhr.send(null);
                    if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                    var datalength = Number(xhr.getResponseHeader("Content-length"));
                    var header;
                    var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                    var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                    var chunkSize = 1048576;
                    if (!hasByteServing) chunkSize = datalength;
                    var doXHR = (from, to)=>{
                        if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                        if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
                        xhr.responseType = "arraybuffer";
                        if (xhr.overrideMimeType) xhr.overrideMimeType("text/plain; charset=x-user-defined");
                        xhr.send(null);
                        if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                        if (xhr.response !== undefined) return new Uint8Array(xhr.response || []);
                        return intArrayFromString(xhr.responseText || "", true);
                    };
                    var lazyArray = this;
                    lazyArray.setDataGetter((chunkNum)=>{
                        var start = chunkNum * chunkSize;
                        var end = (chunkNum + 1) * chunkSize - 1;
                        end = Math.min(end, datalength - 1);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") lazyArray.chunks[chunkNum] = doXHR(start, end);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                        return lazyArray.chunks[chunkNum];
                    });
                    if (usesGzip || !datalength) {
                        chunkSize = datalength = 1;
                        datalength = this.getter(0).length;
                        chunkSize = datalength;
                        out("LazyFiles on gzip forces download of the whole file when length is accessed");
                    }
                    this._length = datalength;
                    this._chunkSize = chunkSize;
                    this.lengthKnown = true;
                };
                if (typeof XMLHttpRequest != "undefined") {
                    if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                    var lazyArray = new LazyUint8Array();
                    Object.defineProperties(lazyArray, {
                        length: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._length;
                            }
                        },
                        chunkSize: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._chunkSize;
                            }
                        }
                    });
                    var properties = {
                        isDevice: false,
                        contents: lazyArray
                    };
                } else var properties = {
                    isDevice: false,
                    url: url
                };
                var node = FS.createFile(parent, name, properties, canRead, canWrite);
                if (properties.contents) node.contents = properties.contents;
                else if (properties.url) {
                    node.contents = null;
                    node.url = properties.url;
                }
                Object.defineProperties(node, {
                    usedBytes: {
                        get: function() {
                            return this.contents.length;
                        }
                    }
                });
                var stream_ops = {};
                var keys = Object.keys(node.stream_ops);
                keys.forEach((key)=>{
                    var fn = node.stream_ops[key];
                    stream_ops[key] = function forceLoadLazyFile() {
                        FS.forceLoadFile(node);
                        return fn.apply(null, arguments);
                    };
                });
                function writeChunks(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= contents.length) return 0;
                    var size = Math.min(contents.length - position, length);
                    if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                    return size;
                }
                stream_ops.read = (stream, buffer, offset, length, position)=>{
                    FS.forceLoadFile(node);
                    return writeChunks(stream, buffer, offset, length, position);
                };
                stream_ops.mmap = (stream, length, position, prot, flags)=>{
                    FS.forceLoadFile(node);
                    var ptr = mmapAlloc(length);
                    if (!ptr) throw new FS.ErrnoError(48);
                    writeChunks(stream, HEAP8, ptr, length, position);
                    return {
                        ptr: ptr,
                        allocated: true
                    };
                };
                node.stream_ops = stream_ops;
                return node;
            },
            createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish)=>{
                var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                var dep = getUniqueRunDependency("cp " + fullname);
                function processData(byteArray) {
                    function finish(byteArray) {
                        if (preFinish) preFinish();
                        if (!dontCreateFile) FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                        if (onload) onload();
                        removeRunDependency(dep);
                    }
                    if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                        if (onerror) onerror();
                        removeRunDependency(dep);
                    })) return;
                    finish(byteArray);
                }
                addRunDependency(dep);
                if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                else processData(url);
            },
            indexedDB: ()=>{
                return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
            },
            DB_NAME: ()=>{
                return "EM_FS_" + window.location.pathname;
            },
            DB_VERSION: 20,
            DB_STORE_NAME: "FILE_DATA",
            saveFilesToDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = ()=>{
                    out("creating db");
                    var db = openRequest.result;
                    db.createObjectStore(FS.DB_STORE_NAME);
                };
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    var transaction = db.transaction([
                        FS.DB_STORE_NAME
                    ], "readwrite");
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var putRequest = files.put(FS.analyzePath(path).object.contents, path);
                        putRequest.onsuccess = ()=>{
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        putRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            },
            loadFilesFromDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = onerror;
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    try {
                        var transaction = db.transaction([
                            FS.DB_STORE_NAME
                        ], "readonly");
                    } catch (e) {
                        onerror(e);
                        return;
                    }
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var getRequest = files.get(path);
                        getRequest.onsuccess = ()=>{
                            if (FS.analyzePath(path).exists) FS.unlink(path);
                            FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        getRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            }
        };
        var SYSCALLS = {
            DEFAULT_POLLMASK: 5,
            calculateAt: function(dirfd, path, allowEmpty) {
                if (PATH.isAbs(path)) return path;
                var dir;
                if (dirfd === -100) dir = FS.cwd();
                else {
                    var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                    dir = dirstream.path;
                }
                if (path.length == 0) {
                    if (!allowEmpty) throw new FS.ErrnoError(44);
                    return dir;
                }
                return PATH.join2(dir, path);
            },
            doStat: function(func, path, buf) {
                try {
                    var stat = func(path);
                } catch (e) {
                    if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                    throw e;
                }
                HEAP32[buf >> 2] = stat.dev;
                HEAP32[buf + 8 >> 2] = stat.ino;
                HEAP32[buf + 12 >> 2] = stat.mode;
                HEAPU32[buf + 16 >> 2] = stat.nlink;
                HEAP32[buf + 20 >> 2] = stat.uid;
                HEAP32[buf + 24 >> 2] = stat.gid;
                HEAP32[buf + 28 >> 2] = stat.rdev;
                tempI64 = [
                    stat.size >>> 0,
                    (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 40 >> 2] = tempI64[0], HEAP32[buf + 44 >> 2] = tempI64[1];
                HEAP32[buf + 48 >> 2] = 4096;
                HEAP32[buf + 52 >> 2] = stat.blocks;
                var atime = stat.atime.getTime();
                var mtime = stat.mtime.getTime();
                var ctime = stat.ctime.getTime();
                tempI64 = [
                    Math.floor(atime / 1e3) >>> 0,
                    (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 56 >> 2] = tempI64[0], HEAP32[buf + 60 >> 2] = tempI64[1];
                HEAPU32[buf + 64 >> 2] = atime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(mtime / 1e3) >>> 0,
                    (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 72 >> 2] = tempI64[0], HEAP32[buf + 76 >> 2] = tempI64[1];
                HEAPU32[buf + 80 >> 2] = mtime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(ctime / 1e3) >>> 0,
                    (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 88 >> 2] = tempI64[0], HEAP32[buf + 92 >> 2] = tempI64[1];
                HEAPU32[buf + 96 >> 2] = ctime % 1e3 * 1e3;
                tempI64 = [
                    stat.ino >>> 0,
                    (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 104 >> 2] = tempI64[0], HEAP32[buf + 108 >> 2] = tempI64[1];
                return 0;
            },
            doMsync: function(addr, stream, len, flags, offset) {
                if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                if (flags & 2) return 0;
                var buffer = HEAPU8.slice(addr, addr + len);
                FS.msync(stream, buffer, offset, len, flags);
            },
            varargs: undefined,
            get: function() {
                SYSCALLS.varargs += 4;
                var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
                return ret;
            },
            getStr: function(ptr) {
                var ret = UTF8ToString(ptr);
                return ret;
            },
            getStreamFromFD: function(fd) {
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                return stream;
            }
        };
        function ___syscall_faccessat(dirfd, path, amode, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (amode & -8) return -28;
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node) return -44;
                var perms = "";
                if (amode & 4) perms += "r";
                if (amode & 2) perms += "w";
                if (amode & 1) perms += "x";
                if (perms && FS.nodePermissions(node, perms)) return -2;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function setErrNo(value) {
            HEAP32[___errno_location() >> 2] = value;
            return value;
        }
        function ___syscall_fcntl64(fd, cmd, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(cmd){
                    case 0:
                        var arg = SYSCALLS.get();
                        if (arg < 0) return -28;
                        var newStream;
                        newStream = FS.createStream(stream, arg);
                        return newStream.fd;
                    case 1:
                    case 2:
                        return 0;
                    case 3:
                        return stream.flags;
                    case 4:
                        var arg = SYSCALLS.get();
                        stream.flags |= arg;
                        return 0;
                    case 5:
                        var arg = SYSCALLS.get();
                        var offset = 0;
                        HEAP16[arg + offset >> 1] = 2;
                        return 0;
                    case 6:
                    case 7:
                        return 0;
                    case 16:
                    case 8:
                        return -28;
                    case 9:
                        setErrNo(28);
                        return -1;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_getcwd(buf, size) {
            try {
                if (size === 0) return -28;
                var cwd = FS.cwd();
                var cwdLengthInBytes = lengthBytesUTF8(cwd) + 1;
                if (size < cwdLengthInBytes) return -68;
                stringToUTF8(cwd, buf, size);
                return cwdLengthInBytes;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_ioctl(fd, op, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(op){
                    case 21509:
                    case 21505:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21510:
                    case 21511:
                    case 21512:
                    case 21506:
                    case 21507:
                    case 21508:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21519:
                        if (!stream.tty) return -59;
                        var argp = SYSCALLS.get();
                        HEAP32[argp >> 2] = 0;
                        return 0;
                    case 21520:
                        if (!stream.tty) return -59;
                        return -28;
                    case 21531:
                        var argp = SYSCALLS.get();
                        return FS.ioctl(stream, op, argp);
                    case 21523:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21524:
                        if (!stream.tty) return -59;
                        return 0;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                var mode = varargs ? SYSCALLS.get() : 0;
                return FS.open(path, flags, mode).fd;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_stat64(path, buf) {
            try {
                path = SYSCALLS.getStr(path);
                return SYSCALLS.doStat(FS.stat, path, buf);
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_unlinkat(dirfd, path, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (flags === 0) FS.unlink(path);
                else if (flags === 512) FS.rmdir(path);
                else abort("Invalid flags passed to unlinkat");
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        var nowIsMonotonic = true;
        function __emscripten_get_now_is_monotonic() {
            return nowIsMonotonic;
        }
        function __emscripten_throw_longjmp() {
            throw Infinity;
        }
        function readI53FromI64(ptr) {
            return HEAPU32[ptr >> 2] + HEAP32[ptr + 4 >> 2] * 4294967296;
        }
        function __gmtime_js(time, tmPtr) {
            var date = new Date(readI53FromI64(time) * 1e3);
            HEAP32[tmPtr >> 2] = date.getUTCSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getUTCMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getUTCHours();
            HEAP32[tmPtr + 12 >> 2] = date.getUTCDate();
            HEAP32[tmPtr + 16 >> 2] = date.getUTCMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getUTCFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getUTCDay();
            var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
            var yday = (date.getTime() - start) / 86400000 | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
        }
        function __isLeapYear(year) {
            return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }
        var __MONTH_DAYS_LEAP_CUMULATIVE = [
            0,
            31,
            60,
            91,
            121,
            152,
            182,
            213,
            244,
            274,
            305,
            335
        ];
        var __MONTH_DAYS_REGULAR_CUMULATIVE = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
        function __yday_from_date(date) {
            var isLeapYear = __isLeapYear(date.getFullYear());
            var monthDaysCumulative = isLeapYear ? __MONTH_DAYS_LEAP_CUMULATIVE : __MONTH_DAYS_REGULAR_CUMULATIVE;
            var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
            return yday;
        }
        function __localtime_js(time, tmPtr) {
            var date = new Date(readI53FromI64(time) * 1e3);
            HEAP32[tmPtr >> 2] = date.getSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getHours();
            HEAP32[tmPtr + 12 >> 2] = date.getDate();
            HEAP32[tmPtr + 16 >> 2] = date.getMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getDay();
            var yday = __yday_from_date(date) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            HEAP32[tmPtr + 36 >> 2] = -(date.getTimezoneOffset() * 60);
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
            HEAP32[tmPtr + 32 >> 2] = dst;
        }
        function __mktime_js(tmPtr) {
            var date = new Date(HEAP32[tmPtr + 20 >> 2] + 1900, HEAP32[tmPtr + 16 >> 2], HEAP32[tmPtr + 12 >> 2], HEAP32[tmPtr + 8 >> 2], HEAP32[tmPtr + 4 >> 2], HEAP32[tmPtr >> 2], 0);
            var dst = HEAP32[tmPtr + 32 >> 2];
            var guessedOffset = date.getTimezoneOffset();
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dstOffset = Math.min(winterOffset, summerOffset);
            if (dst < 0) HEAP32[tmPtr + 32 >> 2] = Number(summerOffset != winterOffset && dstOffset == guessedOffset);
            else if (dst > 0 != (dstOffset == guessedOffset)) {
                var nonDstOffset = Math.max(winterOffset, summerOffset);
                var trueOffset = dst > 0 ? dstOffset : nonDstOffset;
                date.setTime(date.getTime() + (trueOffset - guessedOffset) * 6e4);
            }
            HEAP32[tmPtr + 24 >> 2] = date.getDay();
            var yday = __yday_from_date(date) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            HEAP32[tmPtr >> 2] = date.getSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getHours();
            HEAP32[tmPtr + 12 >> 2] = date.getDate();
            HEAP32[tmPtr + 16 >> 2] = date.getMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getYear();
            return date.getTime() / 1e3 | 0;
        }
        function __timegm_js(tmPtr) {
            var time = Date.UTC(HEAP32[tmPtr + 20 >> 2] + 1900, HEAP32[tmPtr + 16 >> 2], HEAP32[tmPtr + 12 >> 2], HEAP32[tmPtr + 8 >> 2], HEAP32[tmPtr + 4 >> 2], HEAP32[tmPtr >> 2], 0);
            var date = new Date(time);
            HEAP32[tmPtr + 24 >> 2] = date.getUTCDay();
            var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
            var yday = (date.getTime() - start) / 86400000 | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            return date.getTime() / 1e3 | 0;
        }
        function allocateUTF8(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = _malloc(size);
            if (ret) stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function __tzset_js(timezone, daylight, tzname) {
            var currentYear = new Date().getFullYear();
            var winter = new Date(currentYear, 0, 1);
            var summer = new Date(currentYear, 6, 1);
            var winterOffset = winter.getTimezoneOffset();
            var summerOffset = summer.getTimezoneOffset();
            var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
            HEAPU32[timezone >> 2] = stdTimezoneOffset * 60;
            HEAP32[daylight >> 2] = Number(winterOffset != summerOffset);
            function extractZone(date) {
                var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                return match ? match[1] : "GMT";
            }
            var winterName = extractZone(winter);
            var summerName = extractZone(summer);
            var winterNamePtr = allocateUTF8(winterName);
            var summerNamePtr = allocateUTF8(summerName);
            if (summerOffset < winterOffset) {
                HEAPU32[tzname >> 2] = winterNamePtr;
                HEAPU32[tzname + 4 >> 2] = summerNamePtr;
            } else {
                HEAPU32[tzname >> 2] = summerNamePtr;
                HEAPU32[tzname + 4 >> 2] = winterNamePtr;
            }
        }
        function _emscripten_date_now() {
            return Date.now();
        }
        var _emscripten_get_now;
        _emscripten_get_now = ()=>performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
            HEAPU8.copyWithin(dest, src, src + num);
        }
        function getHeapMax() {
            return 2147483648;
        }
        function emscripten_realloc_buffer(size) {
            var b = wasmMemory.buffer;
            try {
                wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
                updateMemoryViews();
                return 1;
            } catch (e) {}
        }
        function _emscripten_resize_heap(requestedSize) {
            var oldSize = HEAPU8.length;
            requestedSize = requestedSize >>> 0;
            var maxHeapSize = getHeapMax();
            if (requestedSize > maxHeapSize) return false;
            let alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
            for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                var replacement = emscripten_realloc_buffer(newSize);
                if (replacement) return true;
            }
            return false;
        }
        function _proc_exit(code) {
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
                if (Module["onExit"]) Module["onExit"](code);
                ABORT = true;
            }
            quit_(code, new ExitStatus(code));
        }
        function exitJS(status, implicit) {
            EXITSTATUS = status;
            if (!keepRuntimeAlive()) exitRuntime();
            _proc_exit(status);
        }
        var _exit = exitJS;
        function _fd_close(fd) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.close(stream);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doReadv(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.read(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (curr < len) break;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doReadv(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function convertI32PairToI53Checked(lo, hi) {
            return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
            try {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                if (isNaN(offset)) return 61;
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.llseek(stream, offset, whence);
                tempI64 = [
                    stream.position >>> 0,
                    (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[newOffset >> 2] = tempI64[0], HEAP32[newOffset + 4 >> 2] = tempI64[1];
                if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doWritev(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.write(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doWritev(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function handleException(e) {
            if (e instanceof ExitStatus || e == "unwind") return EXITSTATUS;
            quit_(1, e);
        }
        function allocateUTF8OnStack(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function runAndAbortIfError(func) {
            try {
                return func();
            } catch (e) {
                abort(e);
            }
        }
        function maybeExit() {
            if (!keepRuntimeAlive()) try {
                _exit(EXITSTATUS);
            } catch (e) {
                handleException(e);
            }
        }
        function callUserCallback(func) {
            if (runtimeExited || ABORT) return;
            try {
                func();
                maybeExit();
            } catch (e) {
                handleException(e);
            }
        }
        function runtimeKeepalivePush() {
            runtimeKeepaliveCounter += 1;
        }
        function runtimeKeepalivePop() {
            runtimeKeepaliveCounter -= 1;
        }
        var Asyncify = {
            instrumentWasmImports: function(imports) {
                var ASYNCIFY_IMPORTS = [
                    "emscripten_sleep",
                    "emscripten_wget",
                    "emscripten_wget_data",
                    "emscripten_idb_load",
                    "emscripten_idb_store",
                    "emscripten_idb_delete",
                    "emscripten_idb_exists",
                    "emscripten_idb_load_blob",
                    "emscripten_idb_store_blob",
                    "SDL_Delay",
                    "emscripten_scan_registers",
                    "emscripten_lazy_load_code",
                    "emscripten_fiber_swap",
                    "__load_secondary_module",
                    "fd_sync",
                    "__wasi_fd_sync",
                    "_emval_await",
                    "_dlopen_js",
                    "__asyncjs__*"
                ];
                for(var x in imports)(function(x) {
                    var original = imports[x];
                    var sig = original.sig;
                    if (typeof original == "function") var isAsyncifyImport = ASYNCIFY_IMPORTS.indexOf(x) >= 0 || x.startsWith("__asyncjs__");
                })(x);
            },
            instrumentWasmExports: function(exports) {
                var ret = {};
                for(var x in exports)(function(x) {
                    var original = exports[x];
                    if (typeof original == "function") ret[x] = function() {
                        Asyncify.exportCallStack.push(x);
                        try {
                            return original.apply(null, arguments);
                        } finally{
                            if (!ABORT) {
                                var y = Asyncify.exportCallStack.pop();
                                assert(y === x);
                                Asyncify.maybeStopUnwind();
                            }
                        }
                    };
                    else ret[x] = original;
                })(x);
                return ret;
            },
            State: {
                Normal: 0,
                Unwinding: 1,
                Rewinding: 2,
                Disabled: 3
            },
            state: 0,
            StackSize: 8192,
            currData: null,
            handleSleepReturnValue: 0,
            exportCallStack: [],
            callStackNameToId: {},
            callStackIdToName: {},
            callStackId: 0,
            asyncPromiseHandlers: null,
            sleepCallbacks: [],
            getCallStackId: function(funcName) {
                var id = Asyncify.callStackNameToId[funcName];
                if (id === undefined) {
                    id = Asyncify.callStackId++;
                    Asyncify.callStackNameToId[funcName] = id;
                    Asyncify.callStackIdToName[id] = funcName;
                }
                return id;
            },
            maybeStopUnwind: function() {
                if (Asyncify.currData && Asyncify.state === Asyncify.State.Unwinding && Asyncify.exportCallStack.length === 0) {
                    Asyncify.state = Asyncify.State.Normal;
                    runtimeKeepalivePush();
                    runAndAbortIfError(_asyncify_stop_unwind);
                    if (typeof Fibers != "undefined") Fibers.trampoline();
                }
            },
            whenDone: function() {
                return new Promise((resolve, reject)=>{
                    Asyncify.asyncPromiseHandlers = {
                        resolve: resolve,
                        reject: reject
                    };
                });
            },
            allocateData: function() {
                var ptr = _malloc(12 + Asyncify.StackSize);
                Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
                Asyncify.setDataRewindFunc(ptr);
                return ptr;
            },
            setDataHeader: function(ptr, stack, stackSize) {
                HEAP32[ptr >> 2] = stack;
                HEAP32[ptr + 4 >> 2] = stack + stackSize;
            },
            setDataRewindFunc: function(ptr) {
                var bottomOfCallStack = Asyncify.exportCallStack[0];
                var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
                HEAP32[ptr + 8 >> 2] = rewindId;
            },
            getDataRewindFunc: function(ptr) {
                var id = HEAP32[ptr + 8 >> 2];
                var name = Asyncify.callStackIdToName[id];
                var func = Module["asm"][name];
                return func;
            },
            doRewind: function(ptr) {
                var start = Asyncify.getDataRewindFunc(ptr);
                runtimeKeepalivePop();
                return start();
            },
            handleSleep: function(startAsync) {
                if (ABORT) return;
                if (Asyncify.state === Asyncify.State.Normal) {
                    var reachedCallback = false;
                    var reachedAfterCallback = false;
                    startAsync((handleSleepReturnValue = 0)=>{
                        if (ABORT) return;
                        Asyncify.handleSleepReturnValue = handleSleepReturnValue;
                        reachedCallback = true;
                        if (!reachedAfterCallback) return;
                        Asyncify.state = Asyncify.State.Rewinding;
                        runAndAbortIfError(()=>_asyncify_start_rewind(Asyncify.currData));
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.resume();
                        var asyncWasmReturnValue, isError = false;
                        try {
                            asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
                        } catch (err) {
                            asyncWasmReturnValue = err;
                            isError = true;
                        }
                        var handled = false;
                        if (!Asyncify.currData) {
                            var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;
                            if (asyncPromiseHandlers) {
                                Asyncify.asyncPromiseHandlers = null;
                                (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(asyncWasmReturnValue);
                                handled = true;
                            }
                        }
                        if (isError && !handled) throw asyncWasmReturnValue;
                    });
                    reachedAfterCallback = true;
                    if (!reachedCallback) {
                        Asyncify.state = Asyncify.State.Unwinding;
                        Asyncify.currData = Asyncify.allocateData();
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.pause();
                        runAndAbortIfError(()=>_asyncify_start_unwind(Asyncify.currData));
                    }
                } else if (Asyncify.state === Asyncify.State.Rewinding) {
                    Asyncify.state = Asyncify.State.Normal;
                    runAndAbortIfError(_asyncify_stop_rewind);
                    _free(Asyncify.currData);
                    Asyncify.currData = null;
                    Asyncify.sleepCallbacks.forEach((func)=>callUserCallback(func));
                } else abort("invalid state: " + Asyncify.state);
                return Asyncify.handleSleepReturnValue;
            },
            handleAsync: function(startAsync) {
                return Asyncify.handleSleep((wakeUp)=>{
                    startAsync().then(wakeUp);
                });
            }
        };
        function AsciiToString(ptr) {
            var str = "";
            while(true){
                var ch = HEAPU8[ptr++ >> 0];
                if (!ch) return str;
                str += String.fromCharCode(ch);
            }
        }
        var FSNode = function(parent, name, mode, rdev) {
            if (!parent) parent = this;
            this.parent = parent;
            this.mount = parent.mount;
            this.mounted = null;
            this.id = FS.nextInode++;
            this.name = name;
            this.mode = mode;
            this.node_ops = {};
            this.stream_ops = {};
            this.rdev = rdev;
        };
        var readMode = 365;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
            read: {
                get: function() {
                    return (this.mode & readMode) === readMode;
                },
                set: function(val) {
                    val ? this.mode |= readMode : this.mode &= ~readMode;
                }
            },
            write: {
                get: function() {
                    return (this.mode & writeMode) === writeMode;
                },
                set: function(val) {
                    val ? this.mode |= writeMode : this.mode &= ~writeMode;
                }
            },
            isFolder: {
                get: function() {
                    return FS.isDir(this.mode);
                }
            },
            isDevice: {
                get: function() {
                    return FS.isChrdev(this.mode);
                }
            }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        var wasmImports = {
            "q": __asyncjs__emglken_fill_stdin_buffer,
            "D": ___syscall_faccessat,
            "l": ___syscall_fcntl64,
            "C": ___syscall_getcwd,
            "B": ___syscall_ioctl,
            "k": ___syscall_openat,
            "A": ___syscall_stat64,
            "z": ___syscall_unlinkat,
            "x": __emscripten_get_now_is_monotonic,
            "w": __emscripten_throw_longjmp,
            "v": __gmtime_js,
            "u": __localtime_js,
            "t": __mktime_js,
            "s": __timegm_js,
            "r": __tzset_js,
            "i": _emscripten_date_now,
            "p": _emscripten_memcpy_big,
            "o": _emscripten_resize_heap,
            "a": _exit,
            "c": _fd_close,
            "y": _fd_read,
            "m": _fd_seek,
            "j": _fd_write,
            "h": glk_buffer_canon_decompose_uni,
            "g": glk_buffer_canon_normalize_uni,
            "f": glk_buffer_to_lower_case_uni,
            "e": glk_buffer_to_title_case_uni,
            "d": glk_buffer_to_upper_case_uni,
            "n": invoke_vi,
            "b": invoke_vii
        };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
            return (___wasm_call_ctors = Module["asm"]["F"]).apply(null, arguments);
        };
        var _malloc = function() {
            return (_malloc = Module["asm"]["G"]).apply(null, arguments);
        };
        var _free = function() {
            return (_free = Module["asm"]["H"]).apply(null, arguments);
        };
        var _main = Module["_main"] = function() {
            return (_main = Module["_main"] = Module["asm"]["I"]).apply(null, arguments);
        };
        var _gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = function() {
            return (_gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = Module["asm"]["J"]).apply(null, arguments);
        };
        var _fflush = Module["_fflush"] = function() {
            return (_fflush = Module["_fflush"] = Module["asm"]["K"]).apply(null, arguments);
        };
        var ___errno_location = function() {
            return (___errno_location = Module["asm"]["L"]).apply(null, arguments);
        };
        var ___funcs_on_exit = function() {
            return (___funcs_on_exit = Module["asm"]["M"]).apply(null, arguments);
        };
        var _setThrew = function() {
            return (_setThrew = Module["asm"]["O"]).apply(null, arguments);
        };
        var _saveSetjmp = function() {
            return (_saveSetjmp = Module["asm"]["saveSetjmp"]).apply(null, arguments);
        };
        var _emscripten_stack_set_limits = function() {
            return (_emscripten_stack_set_limits = Module["asm"]["emscripten_stack_set_limits"]).apply(null, arguments);
        };
        var _emscripten_stack_get_base = function() {
            return (_emscripten_stack_get_base = Module["asm"]["emscripten_stack_get_base"]).apply(null, arguments);
        };
        var _emscripten_stack_get_end = function() {
            return (_emscripten_stack_get_end = Module["asm"]["emscripten_stack_get_end"]).apply(null, arguments);
        };
        var stackSave = function() {
            return (stackSave = Module["asm"]["P"]).apply(null, arguments);
        };
        var stackRestore = function() {
            return (stackRestore = Module["asm"]["Q"]).apply(null, arguments);
        };
        var stackAlloc = function() {
            return (stackAlloc = Module["asm"]["R"]).apply(null, arguments);
        };
        var dynCall_vii = Module["dynCall_vii"] = function() {
            return (dynCall_vii = Module["dynCall_vii"] = Module["asm"]["S"]).apply(null, arguments);
        };
        var dynCall_vi = Module["dynCall_vi"] = function() {
            return (dynCall_vi = Module["dynCall_vi"] = Module["asm"]["T"]).apply(null, arguments);
        };
        var _asyncify_start_unwind = function() {
            return (_asyncify_start_unwind = Module["asm"]["U"]).apply(null, arguments);
        };
        var _asyncify_stop_unwind = function() {
            return (_asyncify_stop_unwind = Module["asm"]["V"]).apply(null, arguments);
        };
        var _asyncify_start_rewind = function() {
            return (_asyncify_start_rewind = Module["asm"]["W"]).apply(null, arguments);
        };
        var _asyncify_stop_rewind = function() {
            return (_asyncify_stop_rewind = Module["asm"]["X"]).apply(null, arguments);
        };
        var ___start_em_js = Module["___start_em_js"] = 33568;
        var ___stop_em_js = Module["___stop_em_js"] = 36253;
        function invoke_vii(index, a1, a2) {
            var sp = stackSave();
            try {
                dynCall_vii(index, a1, a2);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vi(index, a1) {
            var sp = stackSave();
            try {
                dynCall_vi(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        Module["AsciiToString"] = AsciiToString;
        Module["FS"] = FS;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function callMain(args = []) {
            var entryFunction = _main;
            args.unshift(thisProgram);
            var argc = args.length;
            var argv = stackAlloc((argc + 1) * 4);
            var argv_ptr = argv >> 2;
            args.forEach((arg)=>{
                HEAP32[argv_ptr++] = allocateUTF8OnStack(arg);
            });
            HEAP32[argv_ptr] = 0;
            try {
                var ret = entryFunction(argc, argv);
                exitJS(ret, true);
                return ret;
            } catch (e) {
                return handleException(e);
            }
        }
        function run(args = arguments_) {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                preMain();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                if (shouldRunNow) callMain(args);
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        var shouldRunNow = true;
        if (Module["noInitialRun"]) shouldRunNow = false;
        run();
        return Module.ready;
    };
})();
var $a5c3b71e8affc86f$export$2e2bcd8739ae039 = $a5c3b71e8affc86f$var$Module;


class $724db3da43d21d57$export$2e2bcd8739ae039 extends (0, $7c4ebf67e8338ec8$export$2e2bcd8739ae039) {
    default_options() {
        return {
            vmcore: (0, $a5c3b71e8affc86f$export$2e2bcd8739ae039)
        };
    }
}


/*

Emglken port of Hugo
====================

Copyright (c) 2020 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ 
var $b4505afa6c4299ab$exports = {};


$b4505afa6c4299ab$exports = (parcelRequire("6kBsm")).getBundleURL("ejVIo") + (parcelRequire("n9Yfb")).resolve("huVfu");


var $6b4c486f96eb5551$var$Module = (()=>{
    var _scriptDir = "file:///node_modules/emglken/build/hugo-core.js";
    return function(Module = {}) {
        var Module = typeof Module != "undefined" ? Module : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || false;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
            if (!condition) abort(text);
        }
        var UTF8Decoder = new TextDecoder("utf8");
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            return UTF8Decoder.decode(heapOrArray.buffer ? heapOrArray.subarray(idx, endPtr) : new Uint8Array(heapOrArray.slice(idx, endPtr)));
        }
        function UTF8ToString(ptr, maxBytesToRead) {
            if (!ptr) return "";
            var maxPtr = ptr + maxBytesToRead;
            for(var end = ptr; !(end >= maxPtr) && HEAPU8[end];)++end;
            return UTF8Decoder.decode(HEAPU8.subarray(ptr, end));
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATMAIN__ = [];
        var __ATEXIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeExited = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() {
            return noExitRuntime || runtimeKeepaliveCounter > 0;
        }
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
            FS.ignorePermissions = false;
            TTY.init();
            callRuntimeCallbacks(__ATINIT__);
        }
        function preMain() {
            callRuntimeCallbacks(__ATMAIN__);
        }
        function exitRuntime() {
            ___funcs_on_exit();
            callRuntimeCallbacks(__ATEXIT__);
            FS.quit();
            TTY.shutdown();
            runtimeExited = true;
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
            return id;
        }
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        if (Module["locateFile"]) {
            wasmBinaryFile = "hugo-core.wasm";
            if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        } else wasmBinaryFile = new URL($b4505afa6c4299ab$exports).href;
        function getBinary(file) {
            try {
                if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                if (readBinary) return readBinary(file);
                throw "both async and sync fetching of the wasm failed";
            } catch (err) {
                abort(err);
            }
        }
        function getBinaryPromise(binaryFile) {
            if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                if (typeof fetch == "function") return fetch(binaryFile, {
                    credentials: "same-origin"
                }).then(function(response) {
                    if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                    return response["arrayBuffer"]();
                }).catch(function() {
                    return getBinary(binaryFile);
                });
            }
            return Promise.resolve().then(function() {
                return getBinary(binaryFile);
            });
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
            return getBinaryPromise(binaryFile).then(function(binary) {
                return WebAssembly.instantiate(binary, imports);
            }).then(function(instance) {
                return instance;
            }).then(receiver, function(reason) {
                err("failed to asynchronously prepare wasm: " + reason);
                abort(reason);
            });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
            if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                credentials: "same-origin"
            }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, imports);
                return result.then(callback, function(reason) {
                    err("wasm streaming compile failed: " + reason);
                    err("falling back to ArrayBuffer instantiation");
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                });
            });
            else return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                exports = Asyncify.instrumentWasmExports(exports);
                Module["asm"] = exports;
                wasmMemory = Module["asm"]["t"];
                updateMemoryViews();
                wasmTable = Module["asm"]["C"];
                addOnInit(Module["asm"]["u"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            function receiveInstantiationResult(result) {
                receiveInstance(result["instance"]);
            }
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
            return {};
        }
        var tempDouble;
        var tempI64;
        function __asyncjs__emglken_fill_stdin_buffer(buffer, maxlen) {
            return Asyncify.handleAsync(async ()=>{
                if (!Module.emglken_stdin_buffers.length) await new Promise((resolve)=>{
                    Module.emglken_stdin_ready = resolve;
                });
                const input = Module.emglken_stdin_buffers.shift();
                const len = Math.min(input.length, maxlen);
                if (len == input.length) HEAPU8.set(input, buffer);
                else {
                    HEAPU8.set(input.subarray(0, len), buffer);
                    Module.emglken_stdin_buffers.unshift(input.subarray(len));
                }
                return len;
            });
        }
        function ExitStatus(status) {
            this.name = "ExitStatus";
            this.message = "Program terminated with exit(" + status + ")";
            this.status = status;
        }
        function callRuntimeCallbacks(callbacks) {
            while(callbacks.length > 0)callbacks.shift()(Module);
        }
        var PATH = {
            isAbs: (path)=>path.charAt(0) === "/",
            splitPath: (filename)=>{
                var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return splitPathRe.exec(filename).slice(1);
            },
            normalizeArray: (parts, allowAboveRoot)=>{
                var up = 0;
                for(var i = parts.length - 1; i >= 0; i--){
                    var last = parts[i];
                    if (last === ".") parts.splice(i, 1);
                    else if (last === "..") {
                        parts.splice(i, 1);
                        up++;
                    } else if (up) {
                        parts.splice(i, 1);
                        up--;
                    }
                }
                if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                return parts;
            },
            normalize: (path)=>{
                var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                if (!path && !isAbsolute) path = ".";
                if (path && trailingSlash) path += "/";
                return (isAbsolute ? "/" : "") + path;
            },
            dirname: (path)=>{
                var result = PATH.splitPath(path), root = result[0], dir = result[1];
                if (!root && !dir) return ".";
                if (dir) dir = dir.substr(0, dir.length - 1);
                return root + dir;
            },
            basename: (path)=>{
                if (path === "/") return "/";
                path = PATH.normalize(path);
                path = path.replace(/\/$/, "");
                var lastSlash = path.lastIndexOf("/");
                if (lastSlash === -1) return path;
                return path.substr(lastSlash + 1);
            },
            join: function() {
                var paths = Array.prototype.slice.call(arguments);
                return PATH.normalize(paths.join("/"));
            },
            join2: (l, r)=>{
                return PATH.normalize(l + "/" + r);
            }
        };
        function getRandomDevice() {
            if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                var randomBuffer = new Uint8Array(1);
                return ()=>{
                    crypto.getRandomValues(randomBuffer);
                    return randomBuffer[0];
                };
            } else return ()=>abort("randomDevice");
        }
        var PATH_FS = {
            resolve: function() {
                var resolvedPath = "", resolvedAbsolute = false;
                for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                    var path = i >= 0 ? arguments[i] : FS.cwd();
                    if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                    else if (!path) return "";
                    resolvedPath = path + "/" + resolvedPath;
                    resolvedAbsolute = PATH.isAbs(path);
                }
                resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
            },
            relative: (from, to)=>{
                from = PATH_FS.resolve(from).substr(1);
                to = PATH_FS.resolve(to).substr(1);
                function trim(arr) {
                    var start = 0;
                    for(; start < arr.length; start++){
                        if (arr[start] !== "") break;
                    }
                    var end = arr.length - 1;
                    for(; end >= 0; end--){
                        if (arr[end] !== "") break;
                    }
                    if (start > end) return [];
                    return arr.slice(start, end - start + 1);
                }
                var fromParts = trim(from.split("/"));
                var toParts = trim(to.split("/"));
                var length = Math.min(fromParts.length, toParts.length);
                var samePartsLength = length;
                for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i;
                    break;
                }
                var outputParts = [];
                for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                outputParts = outputParts.concat(toParts.slice(samePartsLength));
                return outputParts.join("/");
            }
        };
        function intArrayFromString(stringy, dontAddNull, length) {
            var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull) u8array.length = numBytesWritten;
            return u8array;
        }
        var TTY = {
            ttys: [],
            init: function() {},
            shutdown: function() {},
            register: function(dev, ops) {
                TTY.ttys[dev] = {
                    input: [],
                    output: [],
                    ops: ops
                };
                FS.registerDevice(dev, TTY.stream_ops);
            },
            stream_ops: {
                open: function(stream) {
                    var tty = TTY.ttys[stream.node.rdev];
                    if (!tty) throw new FS.ErrnoError(43);
                    stream.tty = tty;
                    stream.seekable = false;
                },
                close: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                fsync: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                read: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                    var bytesRead = 0;
                    for(var i = 0; i < length; i++){
                        var result;
                        try {
                            result = stream.tty.ops.get_char(stream.tty);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                        if (result === null || result === undefined) break;
                        bytesRead++;
                        buffer[offset + i] = result;
                    }
                    if (bytesRead) stream.node.timestamp = Date.now();
                    return bytesRead;
                },
                write: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                    try {
                        for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                    } catch (e) {
                        throw new FS.ErrnoError(29);
                    }
                    if (length) stream.node.timestamp = Date.now();
                    return i;
                }
            },
            default_tty_ops: {
                get_char: function(tty) {
                    if (!tty.input.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        tty.input = intArrayFromString(result, true);
                    }
                    return tty.input.shift();
                },
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            },
            default_tty1_ops: {
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            }
        };
        function mmapAlloc(size) {
            abort();
        }
        var MEMFS = {
            ops_table: null,
            mount: function(mount) {
                return MEMFS.createNode(null, "/", 16895, 0);
            },
            createNode: function(parent, name, mode, dev) {
                if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                if (!MEMFS.ops_table) MEMFS.ops_table = {
                    dir: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            lookup: MEMFS.node_ops.lookup,
                            mknod: MEMFS.node_ops.mknod,
                            rename: MEMFS.node_ops.rename,
                            unlink: MEMFS.node_ops.unlink,
                            rmdir: MEMFS.node_ops.rmdir,
                            readdir: MEMFS.node_ops.readdir,
                            symlink: MEMFS.node_ops.symlink
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek,
                            read: MEMFS.stream_ops.read,
                            write: MEMFS.stream_ops.write,
                            allocate: MEMFS.stream_ops.allocate,
                            mmap: MEMFS.stream_ops.mmap,
                            msync: MEMFS.stream_ops.msync
                        }
                    },
                    link: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            readlink: MEMFS.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: FS.chrdev_stream_ops
                    }
                };
                var node = FS.createNode(parent, name, mode, dev);
                if (FS.isDir(node.mode)) {
                    node.node_ops = MEMFS.ops_table.dir.node;
                    node.stream_ops = MEMFS.ops_table.dir.stream;
                    node.contents = {};
                } else if (FS.isFile(node.mode)) {
                    node.node_ops = MEMFS.ops_table.file.node;
                    node.stream_ops = MEMFS.ops_table.file.stream;
                    node.usedBytes = 0;
                    node.contents = null;
                } else if (FS.isLink(node.mode)) {
                    node.node_ops = MEMFS.ops_table.link.node;
                    node.stream_ops = MEMFS.ops_table.link.stream;
                } else if (FS.isChrdev(node.mode)) {
                    node.node_ops = MEMFS.ops_table.chrdev.node;
                    node.stream_ops = MEMFS.ops_table.chrdev.stream;
                }
                node.timestamp = Date.now();
                if (parent) {
                    parent.contents[name] = node;
                    parent.timestamp = node.timestamp;
                }
                return node;
            },
            getFileDataAsTypedArray: function(node) {
                if (!node.contents) return new Uint8Array(0);
                if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                return new Uint8Array(node.contents);
            },
            expandFileStorage: function(node, newCapacity) {
                var prevCapacity = node.contents ? node.contents.length : 0;
                if (prevCapacity >= newCapacity) return;
                var CAPACITY_DOUBLING_MAX = 1048576;
                newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                var oldContents = node.contents;
                node.contents = new Uint8Array(newCapacity);
                if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
            },
            resizeFileStorage: function(node, newSize) {
                if (node.usedBytes == newSize) return;
                if (newSize == 0) {
                    node.contents = null;
                    node.usedBytes = 0;
                } else {
                    var oldContents = node.contents;
                    node.contents = new Uint8Array(newSize);
                    if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                    node.usedBytes = newSize;
                }
            },
            node_ops: {
                getattr: function(node) {
                    var attr = {};
                    attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                    attr.ino = node.id;
                    attr.mode = node.mode;
                    attr.nlink = 1;
                    attr.uid = 0;
                    attr.gid = 0;
                    attr.rdev = node.rdev;
                    if (FS.isDir(node.mode)) attr.size = 4096;
                    else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                    else if (FS.isLink(node.mode)) attr.size = node.link.length;
                    else attr.size = 0;
                    attr.atime = new Date(node.timestamp);
                    attr.mtime = new Date(node.timestamp);
                    attr.ctime = new Date(node.timestamp);
                    attr.blksize = 4096;
                    attr.blocks = Math.ceil(attr.size / attr.blksize);
                    return attr;
                },
                setattr: function(node, attr) {
                    if (attr.mode !== undefined) node.mode = attr.mode;
                    if (attr.timestamp !== undefined) node.timestamp = attr.timestamp;
                    if (attr.size !== undefined) MEMFS.resizeFileStorage(node, attr.size);
                },
                lookup: function(parent, name) {
                    throw FS.genericErrors[44];
                },
                mknod: function(parent, name, mode, dev) {
                    return MEMFS.createNode(parent, name, mode, dev);
                },
                rename: function(old_node, new_dir, new_name) {
                    if (FS.isDir(old_node.mode)) {
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (new_node) {
                            for(var i in new_node.contents)throw new FS.ErrnoError(55);
                        }
                    }
                    delete old_node.parent.contents[old_node.name];
                    old_node.parent.timestamp = Date.now();
                    old_node.name = new_name;
                    new_dir.contents[new_name] = old_node;
                    new_dir.timestamp = old_node.parent.timestamp;
                    old_node.parent = new_dir;
                },
                unlink: function(parent, name) {
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                rmdir: function(parent, name) {
                    var node = FS.lookupNode(parent, name);
                    for(var i in node.contents)throw new FS.ErrnoError(55);
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                readdir: function(node) {
                    var entries = [
                        ".",
                        ".."
                    ];
                    for(var key in node.contents){
                        if (!node.contents.hasOwnProperty(key)) continue;
                        entries.push(key);
                    }
                    return entries;
                },
                symlink: function(parent, newname, oldpath) {
                    var node = MEMFS.createNode(parent, newname, 41471, 0);
                    node.link = oldpath;
                    return node;
                },
                readlink: function(node) {
                    if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                    return node.link;
                }
            },
            stream_ops: {
                read: function(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= stream.node.usedBytes) return 0;
                    var size = Math.min(stream.node.usedBytes - position, length);
                    if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    return size;
                },
                write: function(stream, buffer, offset, length, position, canOwn) {
                    if (buffer.buffer === HEAP8.buffer) canOwn = false;
                    if (!length) return 0;
                    var node = stream.node;
                    node.timestamp = Date.now();
                    if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                        if (canOwn) {
                            node.contents = buffer.subarray(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (node.usedBytes === 0 && position === 0) {
                            node.contents = buffer.slice(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (position + length <= node.usedBytes) {
                            node.contents.set(buffer.subarray(offset, offset + length), position);
                            return length;
                        }
                    }
                    MEMFS.expandFileStorage(node, position + length);
                    if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                    else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                    node.usedBytes = Math.max(node.usedBytes, position + length);
                    return length;
                },
                llseek: function(stream, offset, whence) {
                    var position = offset;
                    if (whence === 1) position += stream.position;
                    else if (whence === 2) {
                        if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                    }
                    if (position < 0) throw new FS.ErrnoError(28);
                    return position;
                },
                allocate: function(stream, offset, length) {
                    MEMFS.expandFileStorage(stream.node, offset + length);
                    stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                },
                mmap: function(stream, length, position, prot, flags) {
                    if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                    var ptr;
                    var allocated;
                    var contents = stream.node.contents;
                    if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                        allocated = false;
                        ptr = contents.byteOffset;
                    } else {
                        if (position > 0 || position + length < contents.length) {
                            if (contents.subarray) contents = contents.subarray(position, position + length);
                            else contents = Array.prototype.slice.call(contents, position, position + length);
                        }
                        allocated = true;
                        ptr = mmapAlloc(length);
                        if (!ptr) throw new FS.ErrnoError(48);
                        HEAP8.set(contents, ptr);
                    }
                    return {
                        ptr: ptr,
                        allocated: allocated
                    };
                },
                msync: function(stream, buffer, offset, length, mmapFlags) {
                    MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                    return 0;
                }
            }
        };
        function asyncLoad(url, onload, onerror, noRunDep) {
            var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
            readAsync(url, (arrayBuffer)=>{
                assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
                onload(new Uint8Array(arrayBuffer));
                if (dep) removeRunDependency(dep);
            }, (event)=>{
                if (onerror) onerror();
                else throw 'Loading data file "' + url + '" failed.';
            });
            if (dep) addRunDependency(dep);
        }
        var FS = {
            root: null,
            mounts: [],
            devices: {},
            streams: [],
            nextInode: 1,
            nameTable: null,
            currentPath: "/",
            initialized: false,
            ignorePermissions: true,
            ErrnoError: null,
            genericErrors: {},
            filesystems: null,
            syncFSRequests: 0,
            lookupPath: (path, opts = {})=>{
                path = PATH_FS.resolve(path);
                if (!path) return {
                    path: "",
                    node: null
                };
                var defaults = {
                    follow_mount: true,
                    recurse_count: 0
                };
                opts = Object.assign(defaults, opts);
                if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                var parts = path.split("/").filter((p)=>!!p);
                var current = FS.root;
                var current_path = "/";
                for(var i = 0; i < parts.length; i++){
                    var islast = i === parts.length - 1;
                    if (islast && opts.parent) break;
                    current = FS.lookupNode(current, parts[i]);
                    current_path = PATH.join2(current_path, parts[i]);
                    if (FS.isMountpoint(current)) {
                        if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                    }
                    if (!islast || opts.follow) {
                        var count = 0;
                        while(FS.isLink(current.mode)){
                            var link = FS.readlink(current_path);
                            current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                            var lookup = FS.lookupPath(current_path, {
                                recurse_count: opts.recurse_count + 1
                            });
                            current = lookup.node;
                            if (count++ > 40) throw new FS.ErrnoError(32);
                        }
                    }
                }
                return {
                    path: current_path,
                    node: current
                };
            },
            getPath: (node)=>{
                var path;
                while(true){
                    if (FS.isRoot(node)) {
                        var mount = node.mount.mountpoint;
                        if (!path) return mount;
                        return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
                    }
                    path = path ? node.name + "/" + path : node.name;
                    node = node.parent;
                }
            },
            hashName: (parentid, name)=>{
                var hash = 0;
                for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                return (parentid + hash >>> 0) % FS.nameTable.length;
            },
            hashAddNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                node.name_next = FS.nameTable[hash];
                FS.nameTable[hash] = node;
            },
            hashRemoveNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                else {
                    var current = FS.nameTable[hash];
                    while(current){
                        if (current.name_next === node) {
                            current.name_next = node.name_next;
                            break;
                        }
                        current = current.name_next;
                    }
                }
            },
            lookupNode: (parent, name)=>{
                var errCode = FS.mayLookup(parent);
                if (errCode) throw new FS.ErrnoError(errCode, parent);
                var hash = FS.hashName(parent.id, name);
                for(var node = FS.nameTable[hash]; node; node = node.name_next){
                    var nodeName = node.name;
                    if (node.parent.id === parent.id && nodeName === name) return node;
                }
                return FS.lookup(parent, name);
            },
            createNode: (parent, name, mode, rdev)=>{
                var node = new FS.FSNode(parent, name, mode, rdev);
                FS.hashAddNode(node);
                return node;
            },
            destroyNode: (node)=>{
                FS.hashRemoveNode(node);
            },
            isRoot: (node)=>{
                return node === node.parent;
            },
            isMountpoint: (node)=>{
                return !!node.mounted;
            },
            isFile: (mode)=>{
                return (mode & 61440) === 32768;
            },
            isDir: (mode)=>{
                return (mode & 61440) === 16384;
            },
            isLink: (mode)=>{
                return (mode & 61440) === 40960;
            },
            isChrdev: (mode)=>{
                return (mode & 61440) === 8192;
            },
            isBlkdev: (mode)=>{
                return (mode & 61440) === 24576;
            },
            isFIFO: (mode)=>{
                return (mode & 61440) === 4096;
            },
            isSocket: (mode)=>{
                return (mode & 49152) === 49152;
            },
            flagModes: {
                "r": 0,
                "r+": 2,
                "w": 577,
                "w+": 578,
                "a": 1089,
                "a+": 1090
            },
            modeStringToFlags: (str)=>{
                var flags = FS.flagModes[str];
                if (typeof flags == "undefined") throw new Error("Unknown file open mode: " + str);
                return flags;
            },
            flagsToPermissionString: (flag)=>{
                var perms = [
                    "r",
                    "w",
                    "rw"
                ][flag & 3];
                if (flag & 512) perms += "w";
                return perms;
            },
            nodePermissions: (node, perms)=>{
                if (FS.ignorePermissions) return 0;
                if (perms.includes("r") && !(node.mode & 292)) return 2;
                else if (perms.includes("w") && !(node.mode & 146)) return 2;
                else if (perms.includes("x") && !(node.mode & 73)) return 2;
                return 0;
            },
            mayLookup: (dir)=>{
                var errCode = FS.nodePermissions(dir, "x");
                if (errCode) return errCode;
                if (!dir.node_ops.lookup) return 2;
                return 0;
            },
            mayCreate: (dir, name)=>{
                try {
                    var node = FS.lookupNode(dir, name);
                    return 20;
                } catch (e) {}
                return FS.nodePermissions(dir, "wx");
            },
            mayDelete: (dir, name, isdir)=>{
                var node;
                try {
                    node = FS.lookupNode(dir, name);
                } catch (e) {
                    return e.errno;
                }
                var errCode = FS.nodePermissions(dir, "wx");
                if (errCode) return errCode;
                if (isdir) {
                    if (!FS.isDir(node.mode)) return 54;
                    if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                } else {
                    if (FS.isDir(node.mode)) return 31;
                }
                return 0;
            },
            mayOpen: (node, flags)=>{
                if (!node) return 44;
                if (FS.isLink(node.mode)) return 32;
                else if (FS.isDir(node.mode)) {
                    if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                }
                return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
            },
            MAX_OPEN_FDS: 4096,
            nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS)=>{
                for(var fd = fd_start; fd <= fd_end; fd++){
                    if (!FS.streams[fd]) return fd;
                }
                throw new FS.ErrnoError(33);
            },
            getStream: (fd)=>FS.streams[fd],
            createStream: (stream, fd_start, fd_end)=>{
                if (!FS.FSStream) {
                    FS.FSStream = function() {
                        this.shared = {};
                    };
                    FS.FSStream.prototype = {};
                    Object.defineProperties(FS.FSStream.prototype, {
                        object: {
                            get: function() {
                                return this.node;
                            },
                            set: function(val) {
                                this.node = val;
                            }
                        },
                        isRead: {
                            get: function() {
                                return (this.flags & 2097155) !== 1;
                            }
                        },
                        isWrite: {
                            get: function() {
                                return (this.flags & 2097155) !== 0;
                            }
                        },
                        isAppend: {
                            get: function() {
                                return this.flags & 1024;
                            }
                        },
                        flags: {
                            get: function() {
                                return this.shared.flags;
                            },
                            set: function(val) {
                                this.shared.flags = val;
                            }
                        },
                        position: {
                            get: function() {
                                return this.shared.position;
                            },
                            set: function(val) {
                                this.shared.position = val;
                            }
                        }
                    });
                }
                stream = Object.assign(new FS.FSStream(), stream);
                var fd = FS.nextfd(fd_start, fd_end);
                stream.fd = fd;
                FS.streams[fd] = stream;
                return stream;
            },
            closeStream: (fd)=>{
                FS.streams[fd] = null;
            },
            chrdev_stream_ops: {
                open: (stream)=>{
                    var device = FS.getDevice(stream.node.rdev);
                    stream.stream_ops = device.stream_ops;
                    if (stream.stream_ops.open) stream.stream_ops.open(stream);
                },
                llseek: ()=>{
                    throw new FS.ErrnoError(70);
                }
            },
            major: (dev)=>dev >> 8,
            minor: (dev)=>dev & 255,
            makedev: (ma, mi)=>ma << 8 | mi,
            registerDevice: (dev, ops)=>{
                FS.devices[dev] = {
                    stream_ops: ops
                };
            },
            getDevice: (dev)=>FS.devices[dev],
            getMounts: (mount)=>{
                var mounts = [];
                var check = [
                    mount
                ];
                while(check.length){
                    var m = check.pop();
                    mounts.push(m);
                    check.push.apply(check, m.mounts);
                }
                return mounts;
            },
            syncfs: (populate, callback)=>{
                if (typeof populate == "function") {
                    callback = populate;
                    populate = false;
                }
                FS.syncFSRequests++;
                if (FS.syncFSRequests > 1) err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
                var mounts = FS.getMounts(FS.root.mount);
                var completed = 0;
                function doCallback(errCode) {
                    FS.syncFSRequests--;
                    return callback(errCode);
                }
                function done(errCode) {
                    if (errCode) {
                        if (!done.errored) {
                            done.errored = true;
                            return doCallback(errCode);
                        }
                        return;
                    }
                    if (++completed >= mounts.length) doCallback(null);
                }
                mounts.forEach((mount)=>{
                    if (!mount.type.syncfs) return done(null);
                    mount.type.syncfs(mount, populate, done);
                });
            },
            mount: (type, opts, mountpoint)=>{
                var root = mountpoint === "/";
                var pseudo = !mountpoint;
                var node;
                if (root && FS.root) throw new FS.ErrnoError(10);
                else if (!root && !pseudo) {
                    var lookup = FS.lookupPath(mountpoint, {
                        follow_mount: false
                    });
                    mountpoint = lookup.path;
                    node = lookup.node;
                    if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                    if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                }
                var mount = {
                    type: type,
                    opts: opts,
                    mountpoint: mountpoint,
                    mounts: []
                };
                var mountRoot = type.mount(mount);
                mountRoot.mount = mount;
                mount.root = mountRoot;
                if (root) FS.root = mountRoot;
                else if (node) {
                    node.mounted = mount;
                    if (node.mount) node.mount.mounts.push(mount);
                }
                return mountRoot;
            },
            unmount: (mountpoint)=>{
                var lookup = FS.lookupPath(mountpoint, {
                    follow_mount: false
                });
                if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                var node = lookup.node;
                var mount = node.mounted;
                var mounts = FS.getMounts(mount);
                Object.keys(FS.nameTable).forEach((hash)=>{
                    var current = FS.nameTable[hash];
                    while(current){
                        var next = current.name_next;
                        if (mounts.includes(current.mount)) FS.destroyNode(current);
                        current = next;
                    }
                });
                node.mounted = null;
                var idx = node.mount.mounts.indexOf(mount);
                node.mount.mounts.splice(idx, 1);
            },
            lookup: (parent, name)=>{
                return parent.node_ops.lookup(parent, name);
            },
            mknod: (path, mode, dev)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                var errCode = FS.mayCreate(parent, name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                return parent.node_ops.mknod(parent, name, mode, dev);
            },
            create: (path, mode)=>{
                mode = mode !== undefined ? mode : 438;
                mode &= 4095;
                mode |= 32768;
                return FS.mknod(path, mode, 0);
            },
            mkdir: (path, mode)=>{
                mode = mode !== undefined ? mode : 511;
                mode &= 1023;
                mode |= 16384;
                return FS.mknod(path, mode, 0);
            },
            mkdirTree: (path, mode)=>{
                var dirs = path.split("/");
                var d = "";
                for(var i = 0; i < dirs.length; ++i){
                    if (!dirs[i]) continue;
                    d += "/" + dirs[i];
                    try {
                        FS.mkdir(d, mode);
                    } catch (e) {
                        if (e.errno != 20) throw e;
                    }
                }
            },
            mkdev: (path, mode, dev)=>{
                if (typeof dev == "undefined") {
                    dev = mode;
                    mode = 438;
                }
                mode |= 8192;
                return FS.mknod(path, mode, dev);
            },
            symlink: (oldpath, newpath)=>{
                if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                var lookup = FS.lookupPath(newpath, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var newname = PATH.basename(newpath);
                var errCode = FS.mayCreate(parent, newname);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                return parent.node_ops.symlink(parent, newname, oldpath);
            },
            rename: (old_path, new_path)=>{
                var old_dirname = PATH.dirname(old_path);
                var new_dirname = PATH.dirname(new_path);
                var old_name = PATH.basename(old_path);
                var new_name = PATH.basename(new_path);
                var lookup, old_dir, new_dir;
                lookup = FS.lookupPath(old_path, {
                    parent: true
                });
                old_dir = lookup.node;
                lookup = FS.lookupPath(new_path, {
                    parent: true
                });
                new_dir = lookup.node;
                if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                var old_node = FS.lookupNode(old_dir, old_name);
                var relative = PATH_FS.relative(old_path, new_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                relative = PATH_FS.relative(new_path, old_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                var new_node;
                try {
                    new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}
                if (old_node === new_node) return;
                var isdir = FS.isDir(old_node.mode);
                var errCode = FS.mayDelete(old_dir, old_name, isdir);
                if (errCode) throw new FS.ErrnoError(errCode);
                errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                if (new_dir !== old_dir) {
                    errCode = FS.nodePermissions(old_dir, "w");
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                FS.hashRemoveNode(old_node);
                try {
                    old_dir.node_ops.rename(old_node, new_dir, new_name);
                } catch (e) {
                    throw e;
                } finally{
                    FS.hashAddNode(old_node);
                }
            },
            rmdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, true);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.rmdir(parent, name);
                FS.destroyNode(node);
            },
            readdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                return node.node_ops.readdir(node);
            },
            unlink: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, false);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.unlink(parent, name);
                FS.destroyNode(node);
            },
            readlink: (path)=>{
                var lookup = FS.lookupPath(path);
                var link = lookup.node;
                if (!link) throw new FS.ErrnoError(44);
                if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
            },
            stat: (path, dontFollow)=>{
                var lookup = FS.lookupPath(path, {
                    follow: !dontFollow
                });
                var node = lookup.node;
                if (!node) throw new FS.ErrnoError(44);
                if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                return node.node_ops.getattr(node);
            },
            lstat: (path)=>{
                return FS.stat(path, true);
            },
            chmod: (path, mode, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    mode: mode & 4095 | node.mode & -4096,
                    timestamp: Date.now()
                });
            },
            lchmod: (path, mode)=>{
                FS.chmod(path, mode, true);
            },
            fchmod: (fd, mode)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chmod(stream.node, mode);
            },
            chown: (path, uid, gid, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    timestamp: Date.now()
                });
            },
            lchown: (path, uid, gid)=>{
                FS.chown(path, uid, gid, true);
            },
            fchown: (fd, uid, gid)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chown(stream.node, uid, gid);
            },
            truncate: (path, len)=>{
                if (len < 0) throw new FS.ErrnoError(28);
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                var errCode = FS.nodePermissions(node, "w");
                if (errCode) throw new FS.ErrnoError(errCode);
                node.node_ops.setattr(node, {
                    size: len,
                    timestamp: Date.now()
                });
            },
            ftruncate: (fd, len)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                FS.truncate(stream.node, len);
            },
            utime: (path, atime, mtime)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                node.node_ops.setattr(node, {
                    timestamp: Math.max(atime, mtime)
                });
            },
            open: (path, flags, mode)=>{
                if (path === "") throw new FS.ErrnoError(44);
                flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
                mode = typeof mode == "undefined" ? 438 : mode;
                if (flags & 64) mode = mode & 4095 | 32768;
                else mode = 0;
                var node;
                if (typeof path == "object") node = path;
                else {
                    path = PATH.normalize(path);
                    try {
                        var lookup = FS.lookupPath(path, {
                            follow: !(flags & 131072)
                        });
                        node = lookup.node;
                    } catch (e) {}
                }
                var created = false;
                if (flags & 64) {
                    if (node) {
                        if (flags & 128) throw new FS.ErrnoError(20);
                    } else {
                        node = FS.mknod(path, mode, 0);
                        created = true;
                    }
                }
                if (!node) throw new FS.ErrnoError(44);
                if (FS.isChrdev(node.mode)) flags &= -513;
                if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                if (!created) {
                    var errCode = FS.mayOpen(node, flags);
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                if (flags & 512 && !created) FS.truncate(node, 0);
                flags &= -131713;
                var stream = FS.createStream({
                    node: node,
                    path: FS.getPath(node),
                    flags: flags,
                    seekable: true,
                    position: 0,
                    stream_ops: node.stream_ops,
                    ungotten: [],
                    error: false
                });
                if (stream.stream_ops.open) stream.stream_ops.open(stream);
                if (Module["logReadFiles"] && !(flags & 1)) {
                    if (!FS.readFiles) FS.readFiles = {};
                    if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                }
                return stream;
            },
            close: (stream)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (stream.getdents) stream.getdents = null;
                try {
                    if (stream.stream_ops.close) stream.stream_ops.close(stream);
                } catch (e) {
                    throw e;
                } finally{
                    FS.closeStream(stream.fd);
                }
                stream.fd = null;
            },
            isClosed: (stream)=>{
                return stream.fd === null;
            },
            llseek: (stream, offset, whence)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                stream.position = stream.stream_ops.llseek(stream, offset, whence);
                stream.ungotten = [];
                return stream.position;
            },
            read: (stream, buffer, offset, length, position)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                if (!seeking) stream.position += bytesRead;
                return bytesRead;
            },
            write: (stream, buffer, offset, length, position, canOwn)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                if (!seeking) stream.position += bytesWritten;
                return bytesWritten;
            },
            allocate: (stream, offset, length)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                stream.stream_ops.allocate(stream, offset, length);
            },
            mmap: (stream, length, position, prot, flags)=>{
                if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                return stream.stream_ops.mmap(stream, length, position, prot, flags);
            },
            msync: (stream, buffer, offset, length, mmapFlags)=>{
                if (!stream.stream_ops.msync) return 0;
                return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
            },
            munmap: (stream)=>0,
            ioctl: (stream, cmd, arg)=>{
                if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                return stream.stream_ops.ioctl(stream, cmd, arg);
            },
            readFile: (path, opts = {})=>{
                opts.flags = opts.flags || 0;
                opts.encoding = opts.encoding || "binary";
                if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error('Invalid encoding type "' + opts.encoding + '"');
                var ret;
                var stream = FS.open(path, opts.flags);
                var stat = FS.stat(path);
                var length = stat.size;
                var buf = new Uint8Array(length);
                FS.read(stream, buf, 0, length, 0);
                if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                else if (opts.encoding === "binary") ret = buf;
                FS.close(stream);
                return ret;
            },
            writeFile: (path, data, opts = {})=>{
                opts.flags = opts.flags || 577;
                var stream = FS.open(path, opts.flags, opts.mode);
                if (typeof data == "string") {
                    var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                    var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                    FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn);
                } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn);
                else throw new Error("Unsupported data type");
                FS.close(stream);
            },
            cwd: ()=>FS.currentPath,
            chdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                if (lookup.node === null) throw new FS.ErrnoError(44);
                if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                var errCode = FS.nodePermissions(lookup.node, "x");
                if (errCode) throw new FS.ErrnoError(errCode);
                FS.currentPath = lookup.path;
            },
            createDefaultDirectories: ()=>{
                FS.mkdir("/tmp");
                FS.mkdir("/home");
                FS.mkdir("/home/web_user");
            },
            createDefaultDevices: ()=>{
                FS.mkdir("/dev");
                FS.registerDevice(FS.makedev(1, 3), {
                    read: ()=>0,
                    write: (stream, buffer, offset, length, pos)=>length
                });
                FS.mkdev("/dev/null", FS.makedev(1, 3));
                TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                FS.mkdev("/dev/tty", FS.makedev(5, 0));
                FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                var random_device = getRandomDevice();
                FS.createDevice("/dev", "random", random_device);
                FS.createDevice("/dev", "urandom", random_device);
                FS.mkdir("/dev/shm");
                FS.mkdir("/dev/shm/tmp");
            },
            createSpecialDirectories: ()=>{
                FS.mkdir("/proc");
                var proc_self = FS.mkdir("/proc/self");
                FS.mkdir("/proc/self/fd");
                FS.mount({
                    mount: ()=>{
                        var node = FS.createNode(proc_self, "fd", 16895, 73);
                        node.node_ops = {
                            lookup: (parent, name)=>{
                                var fd = +name;
                                var stream = FS.getStream(fd);
                                if (!stream) throw new FS.ErrnoError(8);
                                var ret = {
                                    parent: null,
                                    mount: {
                                        mountpoint: "fake"
                                    },
                                    node_ops: {
                                        readlink: ()=>stream.path
                                    }
                                };
                                ret.parent = ret;
                                return ret;
                            }
                        };
                        return node;
                    }
                }, {}, "/proc/self/fd");
            },
            createStandardStreams: ()=>{
                if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                else FS.symlink("/dev/tty", "/dev/stdin");
                if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                else FS.symlink("/dev/tty", "/dev/stdout");
                if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                else FS.symlink("/dev/tty1", "/dev/stderr");
                var stdin = FS.open("/dev/stdin", 0);
                var stdout = FS.open("/dev/stdout", 1);
                var stderr = FS.open("/dev/stderr", 1);
            },
            ensureErrnoError: ()=>{
                if (FS.ErrnoError) return;
                FS.ErrnoError = function ErrnoError(errno, node) {
                    this.name = "ErrnoError";
                    this.node = node;
                    this.setErrno = function(errno) {
                        this.errno = errno;
                    };
                    this.setErrno(errno);
                    this.message = "FS error";
                };
                FS.ErrnoError.prototype = new Error();
                FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                [
                    44
                ].forEach((code)=>{
                    FS.genericErrors[code] = new FS.ErrnoError(code);
                    FS.genericErrors[code].stack = "<generic error, no stack>";
                });
            },
            staticInit: ()=>{
                FS.ensureErrnoError();
                FS.nameTable = new Array(4096);
                FS.mount(MEMFS, {}, "/");
                FS.createDefaultDirectories();
                FS.createDefaultDevices();
                FS.createSpecialDirectories();
                FS.filesystems = {
                    "MEMFS": MEMFS
                };
            },
            init: (input, output, error)=>{
                FS.init.initialized = true;
                FS.ensureErrnoError();
                Module["stdin"] = input || Module["stdin"];
                Module["stdout"] = output || Module["stdout"];
                Module["stderr"] = error || Module["stderr"];
                FS.createStandardStreams();
            },
            quit: ()=>{
                FS.init.initialized = false;
                _fflush(0);
                for(var i = 0; i < FS.streams.length; i++){
                    var stream = FS.streams[i];
                    if (!stream) continue;
                    FS.close(stream);
                }
            },
            getMode: (canRead, canWrite)=>{
                var mode = 0;
                if (canRead) mode |= 365;
                if (canWrite) mode |= 146;
                return mode;
            },
            findObject: (path, dontResolveLastLink)=>{
                var ret = FS.analyzePath(path, dontResolveLastLink);
                if (!ret.exists) return null;
                return ret.object;
            },
            analyzePath: (path, dontResolveLastLink)=>{
                try {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    path = lookup.path;
                } catch (e) {}
                var ret = {
                    isRoot: false,
                    exists: false,
                    error: 0,
                    name: null,
                    path: null,
                    object: null,
                    parentExists: false,
                    parentPath: null,
                    parentObject: null
                };
                try {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    ret.parentExists = true;
                    ret.parentPath = lookup.path;
                    ret.parentObject = lookup.node;
                    ret.name = PATH.basename(path);
                    lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    ret.exists = true;
                    ret.path = lookup.path;
                    ret.object = lookup.node;
                    ret.name = lookup.node.name;
                    ret.isRoot = lookup.path === "/";
                } catch (e) {
                    ret.error = e.errno;
                }
                return ret;
            },
            createPath: (parent, path, canRead, canWrite)=>{
                parent = typeof parent == "string" ? parent : FS.getPath(parent);
                var parts = path.split("/").reverse();
                while(parts.length){
                    var part = parts.pop();
                    if (!part) continue;
                    var current = PATH.join2(parent, part);
                    try {
                        FS.mkdir(current);
                    } catch (e) {}
                    parent = current;
                }
                return current;
            },
            createFile: (parent, name, properties, canRead, canWrite)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(canRead, canWrite);
                return FS.create(path, mode);
            },
            createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                var path = name;
                if (parent) {
                    parent = typeof parent == "string" ? parent : FS.getPath(parent);
                    path = name ? PATH.join2(parent, name) : parent;
                }
                var mode = FS.getMode(canRead, canWrite);
                var node = FS.create(path, mode);
                if (data) {
                    if (typeof data == "string") {
                        var arr = new Array(data.length);
                        for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                        data = arr;
                    }
                    FS.chmod(node, mode | 146);
                    var stream = FS.open(node, 577);
                    FS.write(stream, data, 0, data.length, 0, canOwn);
                    FS.close(stream);
                    FS.chmod(node, mode);
                }
                return node;
            },
            createDevice: (parent, name, input, output)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(!!input, !!output);
                if (!FS.createDevice.major) FS.createDevice.major = 64;
                var dev = FS.makedev(FS.createDevice.major++, 0);
                FS.registerDevice(dev, {
                    open: (stream)=>{
                        stream.seekable = false;
                    },
                    close: (stream)=>{
                        if (output && output.buffer && output.buffer.length) output(10);
                    },
                    read: (stream, buffer, offset, length, pos)=>{
                        var bytesRead = 0;
                        for(var i = 0; i < length; i++){
                            var result;
                            try {
                                result = input();
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                            if (result === null || result === undefined) break;
                            bytesRead++;
                            buffer[offset + i] = result;
                        }
                        if (bytesRead) stream.node.timestamp = Date.now();
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, pos)=>{
                        for(var i = 0; i < length; i++)try {
                            output(buffer[offset + i]);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (length) stream.node.timestamp = Date.now();
                        return i;
                    }
                });
                return FS.mkdev(path, mode, dev);
            },
            forceLoadFile: (obj)=>{
                if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                else if (read_) try {
                    obj.contents = intArrayFromString(read_(obj.url), true);
                    obj.usedBytes = obj.contents.length;
                } catch (e) {
                    throw new FS.ErrnoError(29);
                }
                else throw new Error("Cannot load without read() or XMLHttpRequest.");
            },
            createLazyFile: (parent, name, url, canRead, canWrite)=>{
                function LazyUint8Array() {
                    this.lengthKnown = false;
                    this.chunks = [];
                }
                LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                    if (idx > this.length - 1 || idx < 0) return undefined;
                    var chunkOffset = idx % this.chunkSize;
                    var chunkNum = idx / this.chunkSize | 0;
                    return this.getter(chunkNum)[chunkOffset];
                };
                LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                    this.getter = getter;
                };
                LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                    var xhr = new XMLHttpRequest();
                    xhr.open("HEAD", url, false);
                    xhr.send(null);
                    if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                    var datalength = Number(xhr.getResponseHeader("Content-length"));
                    var header;
                    var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                    var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                    var chunkSize = 1048576;
                    if (!hasByteServing) chunkSize = datalength;
                    var doXHR = (from, to)=>{
                        if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                        if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
                        xhr.responseType = "arraybuffer";
                        if (xhr.overrideMimeType) xhr.overrideMimeType("text/plain; charset=x-user-defined");
                        xhr.send(null);
                        if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                        if (xhr.response !== undefined) return new Uint8Array(xhr.response || []);
                        return intArrayFromString(xhr.responseText || "", true);
                    };
                    var lazyArray = this;
                    lazyArray.setDataGetter((chunkNum)=>{
                        var start = chunkNum * chunkSize;
                        var end = (chunkNum + 1) * chunkSize - 1;
                        end = Math.min(end, datalength - 1);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") lazyArray.chunks[chunkNum] = doXHR(start, end);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                        return lazyArray.chunks[chunkNum];
                    });
                    if (usesGzip || !datalength) {
                        chunkSize = datalength = 1;
                        datalength = this.getter(0).length;
                        chunkSize = datalength;
                        out("LazyFiles on gzip forces download of the whole file when length is accessed");
                    }
                    this._length = datalength;
                    this._chunkSize = chunkSize;
                    this.lengthKnown = true;
                };
                if (typeof XMLHttpRequest != "undefined") {
                    if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                    var lazyArray = new LazyUint8Array();
                    Object.defineProperties(lazyArray, {
                        length: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._length;
                            }
                        },
                        chunkSize: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._chunkSize;
                            }
                        }
                    });
                    var properties = {
                        isDevice: false,
                        contents: lazyArray
                    };
                } else var properties = {
                    isDevice: false,
                    url: url
                };
                var node = FS.createFile(parent, name, properties, canRead, canWrite);
                if (properties.contents) node.contents = properties.contents;
                else if (properties.url) {
                    node.contents = null;
                    node.url = properties.url;
                }
                Object.defineProperties(node, {
                    usedBytes: {
                        get: function() {
                            return this.contents.length;
                        }
                    }
                });
                var stream_ops = {};
                var keys = Object.keys(node.stream_ops);
                keys.forEach((key)=>{
                    var fn = node.stream_ops[key];
                    stream_ops[key] = function forceLoadLazyFile() {
                        FS.forceLoadFile(node);
                        return fn.apply(null, arguments);
                    };
                });
                function writeChunks(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= contents.length) return 0;
                    var size = Math.min(contents.length - position, length);
                    if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                    return size;
                }
                stream_ops.read = (stream, buffer, offset, length, position)=>{
                    FS.forceLoadFile(node);
                    return writeChunks(stream, buffer, offset, length, position);
                };
                stream_ops.mmap = (stream, length, position, prot, flags)=>{
                    FS.forceLoadFile(node);
                    var ptr = mmapAlloc(length);
                    if (!ptr) throw new FS.ErrnoError(48);
                    writeChunks(stream, HEAP8, ptr, length, position);
                    return {
                        ptr: ptr,
                        allocated: true
                    };
                };
                node.stream_ops = stream_ops;
                return node;
            },
            createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish)=>{
                var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                var dep = getUniqueRunDependency("cp " + fullname);
                function processData(byteArray) {
                    function finish(byteArray) {
                        if (preFinish) preFinish();
                        if (!dontCreateFile) FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                        if (onload) onload();
                        removeRunDependency(dep);
                    }
                    if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                        if (onerror) onerror();
                        removeRunDependency(dep);
                    })) return;
                    finish(byteArray);
                }
                addRunDependency(dep);
                if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                else processData(url);
            },
            indexedDB: ()=>{
                return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
            },
            DB_NAME: ()=>{
                return "EM_FS_" + window.location.pathname;
            },
            DB_VERSION: 20,
            DB_STORE_NAME: "FILE_DATA",
            saveFilesToDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = ()=>{
                    out("creating db");
                    var db = openRequest.result;
                    db.createObjectStore(FS.DB_STORE_NAME);
                };
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    var transaction = db.transaction([
                        FS.DB_STORE_NAME
                    ], "readwrite");
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var putRequest = files.put(FS.analyzePath(path).object.contents, path);
                        putRequest.onsuccess = ()=>{
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        putRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            },
            loadFilesFromDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = onerror;
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    try {
                        var transaction = db.transaction([
                            FS.DB_STORE_NAME
                        ], "readonly");
                    } catch (e) {
                        onerror(e);
                        return;
                    }
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var getRequest = files.get(path);
                        getRequest.onsuccess = ()=>{
                            if (FS.analyzePath(path).exists) FS.unlink(path);
                            FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        getRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            }
        };
        var SYSCALLS = {
            DEFAULT_POLLMASK: 5,
            calculateAt: function(dirfd, path, allowEmpty) {
                if (PATH.isAbs(path)) return path;
                var dir;
                if (dirfd === -100) dir = FS.cwd();
                else {
                    var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                    dir = dirstream.path;
                }
                if (path.length == 0) {
                    if (!allowEmpty) throw new FS.ErrnoError(44);
                    return dir;
                }
                return PATH.join2(dir, path);
            },
            doStat: function(func, path, buf) {
                try {
                    var stat = func(path);
                } catch (e) {
                    if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                    throw e;
                }
                HEAP32[buf >> 2] = stat.dev;
                HEAP32[buf + 8 >> 2] = stat.ino;
                HEAP32[buf + 12 >> 2] = stat.mode;
                HEAPU32[buf + 16 >> 2] = stat.nlink;
                HEAP32[buf + 20 >> 2] = stat.uid;
                HEAP32[buf + 24 >> 2] = stat.gid;
                HEAP32[buf + 28 >> 2] = stat.rdev;
                tempI64 = [
                    stat.size >>> 0,
                    (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 40 >> 2] = tempI64[0], HEAP32[buf + 44 >> 2] = tempI64[1];
                HEAP32[buf + 48 >> 2] = 4096;
                HEAP32[buf + 52 >> 2] = stat.blocks;
                var atime = stat.atime.getTime();
                var mtime = stat.mtime.getTime();
                var ctime = stat.ctime.getTime();
                tempI64 = [
                    Math.floor(atime / 1e3) >>> 0,
                    (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 56 >> 2] = tempI64[0], HEAP32[buf + 60 >> 2] = tempI64[1];
                HEAPU32[buf + 64 >> 2] = atime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(mtime / 1e3) >>> 0,
                    (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 72 >> 2] = tempI64[0], HEAP32[buf + 76 >> 2] = tempI64[1];
                HEAPU32[buf + 80 >> 2] = mtime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(ctime / 1e3) >>> 0,
                    (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 88 >> 2] = tempI64[0], HEAP32[buf + 92 >> 2] = tempI64[1];
                HEAPU32[buf + 96 >> 2] = ctime % 1e3 * 1e3;
                tempI64 = [
                    stat.ino >>> 0,
                    (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 104 >> 2] = tempI64[0], HEAP32[buf + 108 >> 2] = tempI64[1];
                return 0;
            },
            doMsync: function(addr, stream, len, flags, offset) {
                if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                if (flags & 2) return 0;
                var buffer = HEAPU8.slice(addr, addr + len);
                FS.msync(stream, buffer, offset, len, flags);
            },
            varargs: undefined,
            get: function() {
                SYSCALLS.varargs += 4;
                var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
                return ret;
            },
            getStr: function(ptr) {
                var ret = UTF8ToString(ptr);
                return ret;
            },
            getStreamFromFD: function(fd) {
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                return stream;
            }
        };
        function ___syscall_faccessat(dirfd, path, amode, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (amode & -8) return -28;
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node) return -44;
                var perms = "";
                if (amode & 4) perms += "r";
                if (amode & 2) perms += "w";
                if (amode & 1) perms += "x";
                if (perms && FS.nodePermissions(node, perms)) return -2;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function setErrNo(value) {
            HEAP32[___errno_location() >> 2] = value;
            return value;
        }
        function ___syscall_fcntl64(fd, cmd, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(cmd){
                    case 0:
                        var arg = SYSCALLS.get();
                        if (arg < 0) return -28;
                        var newStream;
                        newStream = FS.createStream(stream, arg);
                        return newStream.fd;
                    case 1:
                    case 2:
                        return 0;
                    case 3:
                        return stream.flags;
                    case 4:
                        var arg = SYSCALLS.get();
                        stream.flags |= arg;
                        return 0;
                    case 5:
                        var arg = SYSCALLS.get();
                        var offset = 0;
                        HEAP16[arg + offset >> 1] = 2;
                        return 0;
                    case 6:
                    case 7:
                        return 0;
                    case 16:
                    case 8:
                        return -28;
                    case 9:
                        setErrNo(28);
                        return -1;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_getcwd(buf, size) {
            try {
                if (size === 0) return -28;
                var cwd = FS.cwd();
                var cwdLengthInBytes = lengthBytesUTF8(cwd) + 1;
                if (size < cwdLengthInBytes) return -68;
                stringToUTF8(cwd, buf, size);
                return cwdLengthInBytes;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_ioctl(fd, op, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(op){
                    case 21509:
                    case 21505:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21510:
                    case 21511:
                    case 21512:
                    case 21506:
                    case 21507:
                    case 21508:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21519:
                        if (!stream.tty) return -59;
                        var argp = SYSCALLS.get();
                        HEAP32[argp >> 2] = 0;
                        return 0;
                    case 21520:
                        if (!stream.tty) return -59;
                        return -28;
                    case 21531:
                        var argp = SYSCALLS.get();
                        return FS.ioctl(stream, op, argp);
                    case 21523:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21524:
                        if (!stream.tty) return -59;
                        return 0;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                var mode = varargs ? SYSCALLS.get() : 0;
                return FS.open(path, flags, mode).fd;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_stat64(path, buf) {
            try {
                path = SYSCALLS.getStr(path);
                return SYSCALLS.doStat(FS.stat, path, buf);
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        var nowIsMonotonic = true;
        function __emscripten_get_now_is_monotonic() {
            return nowIsMonotonic;
        }
        function readI53FromI64(ptr) {
            return HEAPU32[ptr >> 2] + HEAP32[ptr + 4 >> 2] * 4294967296;
        }
        function __isLeapYear(year) {
            return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }
        var __MONTH_DAYS_LEAP_CUMULATIVE = [
            0,
            31,
            60,
            91,
            121,
            152,
            182,
            213,
            244,
            274,
            305,
            335
        ];
        var __MONTH_DAYS_REGULAR_CUMULATIVE = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
        function __yday_from_date(date) {
            var isLeapYear = __isLeapYear(date.getFullYear());
            var monthDaysCumulative = isLeapYear ? __MONTH_DAYS_LEAP_CUMULATIVE : __MONTH_DAYS_REGULAR_CUMULATIVE;
            var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
            return yday;
        }
        function __localtime_js(time, tmPtr) {
            var date = new Date(readI53FromI64(time) * 1e3);
            HEAP32[tmPtr >> 2] = date.getSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getHours();
            HEAP32[tmPtr + 12 >> 2] = date.getDate();
            HEAP32[tmPtr + 16 >> 2] = date.getMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getDay();
            var yday = __yday_from_date(date) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            HEAP32[tmPtr + 36 >> 2] = -(date.getTimezoneOffset() * 60);
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
            HEAP32[tmPtr + 32 >> 2] = dst;
        }
        function allocateUTF8(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = _malloc(size);
            if (ret) stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function __tzset_js(timezone, daylight, tzname) {
            var currentYear = new Date().getFullYear();
            var winter = new Date(currentYear, 0, 1);
            var summer = new Date(currentYear, 6, 1);
            var winterOffset = winter.getTimezoneOffset();
            var summerOffset = summer.getTimezoneOffset();
            var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
            HEAPU32[timezone >> 2] = stdTimezoneOffset * 60;
            HEAP32[daylight >> 2] = Number(winterOffset != summerOffset);
            function extractZone(date) {
                var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                return match ? match[1] : "GMT";
            }
            var winterName = extractZone(winter);
            var summerName = extractZone(summer);
            var winterNamePtr = allocateUTF8(winterName);
            var summerNamePtr = allocateUTF8(summerName);
            if (summerOffset < winterOffset) {
                HEAPU32[tzname >> 2] = winterNamePtr;
                HEAPU32[tzname + 4 >> 2] = summerNamePtr;
            } else {
                HEAPU32[tzname >> 2] = summerNamePtr;
                HEAPU32[tzname + 4 >> 2] = winterNamePtr;
            }
        }
        function _emscripten_date_now() {
            return Date.now();
        }
        var _emscripten_get_now;
        _emscripten_get_now = ()=>performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
            HEAPU8.copyWithin(dest, src, src + num);
        }
        function getHeapMax() {
            return 2147483648;
        }
        function emscripten_realloc_buffer(size) {
            var b = wasmMemory.buffer;
            try {
                wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
                updateMemoryViews();
                return 1;
            } catch (e) {}
        }
        function _emscripten_resize_heap(requestedSize) {
            var oldSize = HEAPU8.length;
            requestedSize = requestedSize >>> 0;
            var maxHeapSize = getHeapMax();
            if (requestedSize > maxHeapSize) return false;
            let alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
            for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                var replacement = emscripten_realloc_buffer(newSize);
                if (replacement) return true;
            }
            return false;
        }
        function _proc_exit(code) {
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
                if (Module["onExit"]) Module["onExit"](code);
                ABORT = true;
            }
            quit_(code, new ExitStatus(code));
        }
        function exitJS(status, implicit) {
            EXITSTATUS = status;
            if (!keepRuntimeAlive()) exitRuntime();
            _proc_exit(status);
        }
        var _exit = exitJS;
        function _fd_close(fd) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.close(stream);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doReadv(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.read(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (curr < len) break;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doReadv(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function convertI32PairToI53Checked(lo, hi) {
            return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
            try {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                if (isNaN(offset)) return 61;
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.llseek(stream, offset, whence);
                tempI64 = [
                    stream.position >>> 0,
                    (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[newOffset >> 2] = tempI64[0], HEAP32[newOffset + 4 >> 2] = tempI64[1];
                if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doWritev(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.write(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doWritev(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function __arraySum(array, index) {
            var sum = 0;
            for(var i = 0; i <= index; sum += array[i++]);
            return sum;
        }
        var __MONTH_DAYS_LEAP = [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        var __MONTH_DAYS_REGULAR = [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        function __addDays(date, days) {
            var newDate = new Date(date.getTime());
            while(days > 0){
                var leap = __isLeapYear(newDate.getFullYear());
                var currentMonth = newDate.getMonth();
                var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];
                if (days > daysInCurrentMonth - newDate.getDate()) {
                    days -= daysInCurrentMonth - newDate.getDate() + 1;
                    newDate.setDate(1);
                    if (currentMonth < 11) newDate.setMonth(currentMonth + 1);
                    else {
                        newDate.setMonth(0);
                        newDate.setFullYear(newDate.getFullYear() + 1);
                    }
                } else {
                    newDate.setDate(newDate.getDate() + days);
                    return newDate;
                }
            }
            return newDate;
        }
        function writeArrayToMemory(array, buffer) {
            HEAP8.set(array, buffer);
        }
        function _strftime(s, maxsize, format, tm) {
            var tm_zone = HEAP32[tm + 40 >> 2];
            var date = {
                tm_sec: HEAP32[tm >> 2],
                tm_min: HEAP32[tm + 4 >> 2],
                tm_hour: HEAP32[tm + 8 >> 2],
                tm_mday: HEAP32[tm + 12 >> 2],
                tm_mon: HEAP32[tm + 16 >> 2],
                tm_year: HEAP32[tm + 20 >> 2],
                tm_wday: HEAP32[tm + 24 >> 2],
                tm_yday: HEAP32[tm + 28 >> 2],
                tm_isdst: HEAP32[tm + 32 >> 2],
                tm_gmtoff: HEAP32[tm + 36 >> 2],
                tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
            };
            var pattern = UTF8ToString(format);
            var EXPANSION_RULES_1 = {
                "%c": "%a %b %d %H:%M:%S %Y",
                "%D": "%m/%d/%y",
                "%F": "%Y-%m-%d",
                "%h": "%b",
                "%r": "%I:%M:%S %p",
                "%R": "%H:%M",
                "%T": "%H:%M:%S",
                "%x": "%m/%d/%y",
                "%X": "%H:%M:%S",
                "%Ec": "%c",
                "%EC": "%C",
                "%Ex": "%m/%d/%y",
                "%EX": "%H:%M:%S",
                "%Ey": "%y",
                "%EY": "%Y",
                "%Od": "%d",
                "%Oe": "%e",
                "%OH": "%H",
                "%OI": "%I",
                "%Om": "%m",
                "%OM": "%M",
                "%OS": "%S",
                "%Ou": "%u",
                "%OU": "%U",
                "%OV": "%V",
                "%Ow": "%w",
                "%OW": "%W",
                "%Oy": "%y"
            };
            for(var rule in EXPANSION_RULES_1)pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
            var WEEKDAYS = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ];
            var MONTHS = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
            function leadingSomething(value, digits, character) {
                var str = typeof value == "number" ? value.toString() : value || "";
                while(str.length < digits)str = character[0] + str;
                return str;
            }
            function leadingNulls(value, digits) {
                return leadingSomething(value, digits, "0");
            }
            function compareByDay(date1, date2) {
                function sgn(value) {
                    return value < 0 ? -1 : value > 0 ? 1 : 0;
                }
                var compare;
                if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                    if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) compare = sgn(date1.getDate() - date2.getDate());
                }
                return compare;
            }
            function getFirstWeekStartDate(janFourth) {
                switch(janFourth.getDay()){
                    case 0:
                        return new Date(janFourth.getFullYear() - 1, 11, 29);
                    case 1:
                        return janFourth;
                    case 2:
                        return new Date(janFourth.getFullYear(), 0, 3);
                    case 3:
                        return new Date(janFourth.getFullYear(), 0, 2);
                    case 4:
                        return new Date(janFourth.getFullYear(), 0, 1);
                    case 5:
                        return new Date(janFourth.getFullYear() - 1, 11, 31);
                    case 6:
                        return new Date(janFourth.getFullYear() - 1, 11, 30);
                }
            }
            function getWeekBasedYear(date) {
                var thisDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);
                var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                    if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) return thisDate.getFullYear() + 1;
                    return thisDate.getFullYear();
                }
                return thisDate.getFullYear() - 1;
            }
            var EXPANSION_RULES_2 = {
                "%a": function(date) {
                    return WEEKDAYS[date.tm_wday].substring(0, 3);
                },
                "%A": function(date) {
                    return WEEKDAYS[date.tm_wday];
                },
                "%b": function(date) {
                    return MONTHS[date.tm_mon].substring(0, 3);
                },
                "%B": function(date) {
                    return MONTHS[date.tm_mon];
                },
                "%C": function(date) {
                    var year = date.tm_year + 1900;
                    return leadingNulls(year / 100 | 0, 2);
                },
                "%d": function(date) {
                    return leadingNulls(date.tm_mday, 2);
                },
                "%e": function(date) {
                    return leadingSomething(date.tm_mday, 2, " ");
                },
                "%g": function(date) {
                    return getWeekBasedYear(date).toString().substring(2);
                },
                "%G": function(date) {
                    return getWeekBasedYear(date);
                },
                "%H": function(date) {
                    return leadingNulls(date.tm_hour, 2);
                },
                "%I": function(date) {
                    var twelveHour = date.tm_hour;
                    if (twelveHour == 0) twelveHour = 12;
                    else if (twelveHour > 12) twelveHour -= 12;
                    return leadingNulls(twelveHour, 2);
                },
                "%j": function(date) {
                    return leadingNulls(date.tm_mday + __arraySum(__isLeapYear(date.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date.tm_mon - 1), 3);
                },
                "%m": function(date) {
                    return leadingNulls(date.tm_mon + 1, 2);
                },
                "%M": function(date) {
                    return leadingNulls(date.tm_min, 2);
                },
                "%n": function() {
                    return "\n";
                },
                "%p": function(date) {
                    if (date.tm_hour >= 0 && date.tm_hour < 12) return "AM";
                    return "PM";
                },
                "%S": function(date) {
                    return leadingNulls(date.tm_sec, 2);
                },
                "%t": function() {
                    return "	";
                },
                "%u": function(date) {
                    return date.tm_wday || 7;
                },
                "%U": function(date) {
                    var days = date.tm_yday + 7 - date.tm_wday;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                "%V": function(date) {
                    var val = Math.floor((date.tm_yday + 7 - (date.tm_wday + 6) % 7) / 7);
                    if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) val++;
                    if (!val) {
                        val = 52;
                        var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7;
                        if (dec31 == 4 || dec31 == 5 && __isLeapYear(date.tm_year % 400 - 1)) val++;
                    } else if (val == 53) {
                        var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7;
                        if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date.tm_year))) val = 1;
                    }
                    return leadingNulls(val, 2);
                },
                "%w": function(date) {
                    return date.tm_wday;
                },
                "%W": function(date) {
                    var days = date.tm_yday + 7 - (date.tm_wday + 6) % 7;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                "%y": function(date) {
                    return (date.tm_year + 1900).toString().substring(2);
                },
                "%Y": function(date) {
                    return date.tm_year + 1900;
                },
                "%z": function(date) {
                    var off = date.tm_gmtoff;
                    var ahead = off >= 0;
                    off = Math.abs(off) / 60;
                    off = off / 60 * 100 + off % 60;
                    return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
                },
                "%Z": function(date) {
                    return date.tm_zone;
                },
                "%%": function() {
                    return "%";
                }
            };
            pattern = pattern.replace(/%%/g, "\x00\x00");
            for(var rule in EXPANSION_RULES_2)if (pattern.includes(rule)) pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            pattern = pattern.replace(/\0\0/g, "%");
            var bytes = intArrayFromString(pattern, false);
            if (bytes.length > maxsize) return 0;
            writeArrayToMemory(bytes, s);
            return bytes.length - 1;
        }
        function handleException(e) {
            if (e instanceof ExitStatus || e == "unwind") return EXITSTATUS;
            quit_(1, e);
        }
        function allocateUTF8OnStack(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function runAndAbortIfError(func) {
            try {
                return func();
            } catch (e) {
                abort(e);
            }
        }
        function maybeExit() {
            if (!keepRuntimeAlive()) try {
                _exit(EXITSTATUS);
            } catch (e) {
                handleException(e);
            }
        }
        function callUserCallback(func) {
            if (runtimeExited || ABORT) return;
            try {
                func();
                maybeExit();
            } catch (e) {
                handleException(e);
            }
        }
        function runtimeKeepalivePush() {
            runtimeKeepaliveCounter += 1;
        }
        function runtimeKeepalivePop() {
            runtimeKeepaliveCounter -= 1;
        }
        var Asyncify = {
            instrumentWasmImports: function(imports) {
                var ASYNCIFY_IMPORTS = [
                    "emscripten_sleep",
                    "emscripten_wget",
                    "emscripten_wget_data",
                    "emscripten_idb_load",
                    "emscripten_idb_store",
                    "emscripten_idb_delete",
                    "emscripten_idb_exists",
                    "emscripten_idb_load_blob",
                    "emscripten_idb_store_blob",
                    "SDL_Delay",
                    "emscripten_scan_registers",
                    "emscripten_lazy_load_code",
                    "emscripten_fiber_swap",
                    "__load_secondary_module",
                    "fd_sync",
                    "__wasi_fd_sync",
                    "_emval_await",
                    "_dlopen_js",
                    "__asyncjs__*"
                ];
                for(var x in imports)(function(x) {
                    var original = imports[x];
                    var sig = original.sig;
                    if (typeof original == "function") var isAsyncifyImport = ASYNCIFY_IMPORTS.indexOf(x) >= 0 || x.startsWith("__asyncjs__");
                })(x);
            },
            instrumentWasmExports: function(exports) {
                var ret = {};
                for(var x in exports)(function(x) {
                    var original = exports[x];
                    if (typeof original == "function") ret[x] = function() {
                        Asyncify.exportCallStack.push(x);
                        try {
                            return original.apply(null, arguments);
                        } finally{
                            if (!ABORT) {
                                var y = Asyncify.exportCallStack.pop();
                                assert(y === x);
                                Asyncify.maybeStopUnwind();
                            }
                        }
                    };
                    else ret[x] = original;
                })(x);
                return ret;
            },
            State: {
                Normal: 0,
                Unwinding: 1,
                Rewinding: 2,
                Disabled: 3
            },
            state: 0,
            StackSize: 8192,
            currData: null,
            handleSleepReturnValue: 0,
            exportCallStack: [],
            callStackNameToId: {},
            callStackIdToName: {},
            callStackId: 0,
            asyncPromiseHandlers: null,
            sleepCallbacks: [],
            getCallStackId: function(funcName) {
                var id = Asyncify.callStackNameToId[funcName];
                if (id === undefined) {
                    id = Asyncify.callStackId++;
                    Asyncify.callStackNameToId[funcName] = id;
                    Asyncify.callStackIdToName[id] = funcName;
                }
                return id;
            },
            maybeStopUnwind: function() {
                if (Asyncify.currData && Asyncify.state === Asyncify.State.Unwinding && Asyncify.exportCallStack.length === 0) {
                    Asyncify.state = Asyncify.State.Normal;
                    runtimeKeepalivePush();
                    runAndAbortIfError(_asyncify_stop_unwind);
                    if (typeof Fibers != "undefined") Fibers.trampoline();
                }
            },
            whenDone: function() {
                return new Promise((resolve, reject)=>{
                    Asyncify.asyncPromiseHandlers = {
                        resolve: resolve,
                        reject: reject
                    };
                });
            },
            allocateData: function() {
                var ptr = _malloc(12 + Asyncify.StackSize);
                Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
                Asyncify.setDataRewindFunc(ptr);
                return ptr;
            },
            setDataHeader: function(ptr, stack, stackSize) {
                HEAP32[ptr >> 2] = stack;
                HEAP32[ptr + 4 >> 2] = stack + stackSize;
            },
            setDataRewindFunc: function(ptr) {
                var bottomOfCallStack = Asyncify.exportCallStack[0];
                var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
                HEAP32[ptr + 8 >> 2] = rewindId;
            },
            getDataRewindFunc: function(ptr) {
                var id = HEAP32[ptr + 8 >> 2];
                var name = Asyncify.callStackIdToName[id];
                var func = Module["asm"][name];
                return func;
            },
            doRewind: function(ptr) {
                var start = Asyncify.getDataRewindFunc(ptr);
                runtimeKeepalivePop();
                return start();
            },
            handleSleep: function(startAsync) {
                if (ABORT) return;
                if (Asyncify.state === Asyncify.State.Normal) {
                    var reachedCallback = false;
                    var reachedAfterCallback = false;
                    startAsync((handleSleepReturnValue = 0)=>{
                        if (ABORT) return;
                        Asyncify.handleSleepReturnValue = handleSleepReturnValue;
                        reachedCallback = true;
                        if (!reachedAfterCallback) return;
                        Asyncify.state = Asyncify.State.Rewinding;
                        runAndAbortIfError(()=>_asyncify_start_rewind(Asyncify.currData));
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.resume();
                        var asyncWasmReturnValue, isError = false;
                        try {
                            asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
                        } catch (err) {
                            asyncWasmReturnValue = err;
                            isError = true;
                        }
                        var handled = false;
                        if (!Asyncify.currData) {
                            var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;
                            if (asyncPromiseHandlers) {
                                Asyncify.asyncPromiseHandlers = null;
                                (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(asyncWasmReturnValue);
                                handled = true;
                            }
                        }
                        if (isError && !handled) throw asyncWasmReturnValue;
                    });
                    reachedAfterCallback = true;
                    if (!reachedCallback) {
                        Asyncify.state = Asyncify.State.Unwinding;
                        Asyncify.currData = Asyncify.allocateData();
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.pause();
                        runAndAbortIfError(()=>_asyncify_start_unwind(Asyncify.currData));
                    }
                } else if (Asyncify.state === Asyncify.State.Rewinding) {
                    Asyncify.state = Asyncify.State.Normal;
                    runAndAbortIfError(_asyncify_stop_rewind);
                    _free(Asyncify.currData);
                    Asyncify.currData = null;
                    Asyncify.sleepCallbacks.forEach((func)=>callUserCallback(func));
                } else abort("invalid state: " + Asyncify.state);
                return Asyncify.handleSleepReturnValue;
            },
            handleAsync: function(startAsync) {
                return Asyncify.handleSleep((wakeUp)=>{
                    startAsync().then(wakeUp);
                });
            }
        };
        function AsciiToString(ptr) {
            var str = "";
            while(true){
                var ch = HEAPU8[ptr++ >> 0];
                if (!ch) return str;
                str += String.fromCharCode(ch);
            }
        }
        var FSNode = function(parent, name, mode, rdev) {
            if (!parent) parent = this;
            this.parent = parent;
            this.mount = parent.mount;
            this.mounted = null;
            this.id = FS.nextInode++;
            this.name = name;
            this.mode = mode;
            this.node_ops = {};
            this.stream_ops = {};
            this.rdev = rdev;
        };
        var readMode = 365;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
            read: {
                get: function() {
                    return (this.mode & readMode) === readMode;
                },
                set: function(val) {
                    val ? this.mode |= readMode : this.mode &= ~readMode;
                }
            },
            write: {
                get: function() {
                    return (this.mode & writeMode) === writeMode;
                },
                set: function(val) {
                    val ? this.mode |= writeMode : this.mode &= ~writeMode;
                }
            },
            isFolder: {
                get: function() {
                    return FS.isDir(this.mode);
                }
            },
            isDevice: {
                get: function() {
                    return FS.isChrdev(this.mode);
                }
            }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        var wasmImports = {
            "j": __asyncjs__emglken_fill_stdin_buffer,
            "s": ___syscall_faccessat,
            "e": ___syscall_fcntl64,
            "r": ___syscall_getcwd,
            "q": ___syscall_ioctl,
            "p": ___syscall_openat,
            "o": ___syscall_stat64,
            "m": __emscripten_get_now_is_monotonic,
            "l": __localtime_js,
            "k": __tzset_js,
            "b": _emscripten_date_now,
            "i": _emscripten_memcpy_big,
            "h": _emscripten_resize_heap,
            "a": _exit,
            "d": _fd_close,
            "n": _fd_read,
            "g": _fd_seek,
            "c": _fd_write,
            "f": _strftime
        };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
            return (___wasm_call_ctors = Module["asm"]["u"]).apply(null, arguments);
        };
        var _malloc = function() {
            return (_malloc = Module["asm"]["v"]).apply(null, arguments);
        };
        var _free = function() {
            return (_free = Module["asm"]["w"]).apply(null, arguments);
        };
        var _main = Module["_main"] = function() {
            return (_main = Module["_main"] = Module["asm"]["x"]).apply(null, arguments);
        };
        var _gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = function() {
            return (_gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = Module["asm"]["y"]).apply(null, arguments);
        };
        var _fflush = Module["_fflush"] = function() {
            return (_fflush = Module["_fflush"] = Module["asm"]["z"]).apply(null, arguments);
        };
        var ___errno_location = function() {
            return (___errno_location = Module["asm"]["A"]).apply(null, arguments);
        };
        var ___funcs_on_exit = function() {
            return (___funcs_on_exit = Module["asm"]["B"]).apply(null, arguments);
        };
        var _emscripten_stack_set_limits = function() {
            return (_emscripten_stack_set_limits = Module["asm"]["emscripten_stack_set_limits"]).apply(null, arguments);
        };
        var _emscripten_stack_get_base = function() {
            return (_emscripten_stack_get_base = Module["asm"]["emscripten_stack_get_base"]).apply(null, arguments);
        };
        var _emscripten_stack_get_end = function() {
            return (_emscripten_stack_get_end = Module["asm"]["emscripten_stack_get_end"]).apply(null, arguments);
        };
        var stackAlloc = function() {
            return (stackAlloc = Module["asm"]["D"]).apply(null, arguments);
        };
        var _asyncify_start_unwind = function() {
            return (_asyncify_start_unwind = Module["asm"]["E"]).apply(null, arguments);
        };
        var _asyncify_stop_unwind = function() {
            return (_asyncify_stop_unwind = Module["asm"]["F"]).apply(null, arguments);
        };
        var _asyncify_start_rewind = function() {
            return (_asyncify_start_rewind = Module["asm"]["G"]).apply(null, arguments);
        };
        var _asyncify_stop_rewind = function() {
            return (_asyncify_stop_rewind = Module["asm"]["H"]).apply(null, arguments);
        };
        var ___start_em_js = Module["___start_em_js"] = 18128;
        var ___stop_em_js = Module["___stop_em_js"] = 20813;
        Module["AsciiToString"] = AsciiToString;
        Module["FS"] = FS;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function callMain(args = []) {
            var entryFunction = _main;
            args.unshift(thisProgram);
            var argc = args.length;
            var argv = stackAlloc((argc + 1) * 4);
            var argv_ptr = argv >> 2;
            args.forEach((arg)=>{
                HEAP32[argv_ptr++] = allocateUTF8OnStack(arg);
            });
            HEAP32[argv_ptr] = 0;
            try {
                var ret = entryFunction(argc, argv);
                exitJS(ret, true);
                return ret;
            } catch (e) {
                return handleException(e);
            }
        }
        function run(args = arguments_) {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                preMain();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                if (shouldRunNow) callMain(args);
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        var shouldRunNow = true;
        if (Module["noInitialRun"]) shouldRunNow = false;
        run();
        return Module.ready;
    };
})();
var $6b4c486f96eb5551$export$2e2bcd8739ae039 = $6b4c486f96eb5551$var$Module;


class $93f872a37763fb75$export$2e2bcd8739ae039 extends (0, $7c4ebf67e8338ec8$export$2e2bcd8739ae039) {
    default_options() {
        return {
            vmcore: (0, $6b4c486f96eb5551$export$2e2bcd8739ae039)
        };
    }
}


/*

Emglken port of TADS
====================

Copyright (c) 2020 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ 
var $56d7e4ab31bcd78a$exports = {};


$56d7e4ab31bcd78a$exports = (parcelRequire("6kBsm")).getBundleURL("ejVIo") + (parcelRequire("n9Yfb")).resolve("b8QSH");


var $5da5b9828ec10744$var$Module = (()=>{
    var _scriptDir = "file:///node_modules/emglken/build/tads-core.js";
    return function(Module = {}) {
        var Module = typeof Module != "undefined" ? Module : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || false;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
            if (!condition) abort(text);
        }
        var UTF8Decoder = new TextDecoder("utf8");
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            return UTF8Decoder.decode(heapOrArray.buffer ? heapOrArray.subarray(idx, endPtr) : new Uint8Array(heapOrArray.slice(idx, endPtr)));
        }
        function UTF8ToString(ptr, maxBytesToRead) {
            if (!ptr) return "";
            var maxPtr = ptr + maxBytesToRead;
            for(var end = ptr; !(end >= maxPtr) && HEAPU8[end];)++end;
            return UTF8Decoder.decode(HEAPU8.subarray(ptr, end));
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATMAIN__ = [];
        var __ATEXIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeExited = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() {
            return noExitRuntime || runtimeKeepaliveCounter > 0;
        }
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
            FS.ignorePermissions = false;
            TTY.init();
            callRuntimeCallbacks(__ATINIT__);
        }
        function preMain() {
            callRuntimeCallbacks(__ATMAIN__);
        }
        function exitRuntime() {
            ___funcs_on_exit();
            callRuntimeCallbacks(__ATEXIT__);
            FS.quit();
            TTY.shutdown();
            runtimeExited = true;
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
            return id;
        }
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        if (Module["locateFile"]) {
            wasmBinaryFile = "tads-core.wasm";
            if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        } else wasmBinaryFile = new URL($56d7e4ab31bcd78a$exports).href;
        function getBinary(file) {
            try {
                if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                if (readBinary) return readBinary(file);
                throw "both async and sync fetching of the wasm failed";
            } catch (err) {
                abort(err);
            }
        }
        function getBinaryPromise(binaryFile) {
            if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                if (typeof fetch == "function") return fetch(binaryFile, {
                    credentials: "same-origin"
                }).then(function(response) {
                    if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                    return response["arrayBuffer"]();
                }).catch(function() {
                    return getBinary(binaryFile);
                });
            }
            return Promise.resolve().then(function() {
                return getBinary(binaryFile);
            });
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
            return getBinaryPromise(binaryFile).then(function(binary) {
                return WebAssembly.instantiate(binary, imports);
            }).then(function(instance) {
                return instance;
            }).then(receiver, function(reason) {
                err("failed to asynchronously prepare wasm: " + reason);
                abort(reason);
            });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
            if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                credentials: "same-origin"
            }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, imports);
                return result.then(callback, function(reason) {
                    err("wasm streaming compile failed: " + reason);
                    err("falling back to ArrayBuffer instantiation");
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                });
            });
            else return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                exports = Asyncify.instrumentWasmExports(exports);
                Module["asm"] = exports;
                wasmMemory = Module["asm"]["ha"];
                updateMemoryViews();
                wasmTable = Module["asm"]["qa"];
                addOnInit(Module["asm"]["ia"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            function receiveInstantiationResult(result) {
                receiveInstance(result["instance"]);
            }
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
            return {};
        }
        var tempDouble;
        var tempI64;
        function __asyncjs__emglken_fill_stdin_buffer(buffer, maxlen) {
            return Asyncify.handleAsync(async ()=>{
                if (!Module.emglken_stdin_buffers.length) await new Promise((resolve)=>{
                    Module.emglken_stdin_ready = resolve;
                });
                const input = Module.emglken_stdin_buffers.shift();
                const len = Math.min(input.length, maxlen);
                if (len == input.length) HEAPU8.set(input, buffer);
                else {
                    HEAPU8.set(input.subarray(0, len), buffer);
                    Module.emglken_stdin_buffers.unshift(input.subarray(len));
                }
                return len;
            });
        }
        function ExitStatus(status) {
            this.name = "ExitStatus";
            this.message = "Program terminated with exit(" + status + ")";
            this.status = status;
        }
        function callRuntimeCallbacks(callbacks) {
            while(callbacks.length > 0)callbacks.shift()(Module);
        }
        var PATH = {
            isAbs: (path)=>path.charAt(0) === "/",
            splitPath: (filename)=>{
                var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return splitPathRe.exec(filename).slice(1);
            },
            normalizeArray: (parts, allowAboveRoot)=>{
                var up = 0;
                for(var i = parts.length - 1; i >= 0; i--){
                    var last = parts[i];
                    if (last === ".") parts.splice(i, 1);
                    else if (last === "..") {
                        parts.splice(i, 1);
                        up++;
                    } else if (up) {
                        parts.splice(i, 1);
                        up--;
                    }
                }
                if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                return parts;
            },
            normalize: (path)=>{
                var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                if (!path && !isAbsolute) path = ".";
                if (path && trailingSlash) path += "/";
                return (isAbsolute ? "/" : "") + path;
            },
            dirname: (path)=>{
                var result = PATH.splitPath(path), root = result[0], dir = result[1];
                if (!root && !dir) return ".";
                if (dir) dir = dir.substr(0, dir.length - 1);
                return root + dir;
            },
            basename: (path)=>{
                if (path === "/") return "/";
                path = PATH.normalize(path);
                path = path.replace(/\/$/, "");
                var lastSlash = path.lastIndexOf("/");
                if (lastSlash === -1) return path;
                return path.substr(lastSlash + 1);
            },
            join: function() {
                var paths = Array.prototype.slice.call(arguments);
                return PATH.normalize(paths.join("/"));
            },
            join2: (l, r)=>{
                return PATH.normalize(l + "/" + r);
            }
        };
        function getRandomDevice() {
            if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                var randomBuffer = new Uint8Array(1);
                return ()=>{
                    crypto.getRandomValues(randomBuffer);
                    return randomBuffer[0];
                };
            } else return ()=>abort("randomDevice");
        }
        var PATH_FS = {
            resolve: function() {
                var resolvedPath = "", resolvedAbsolute = false;
                for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                    var path = i >= 0 ? arguments[i] : FS.cwd();
                    if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                    else if (!path) return "";
                    resolvedPath = path + "/" + resolvedPath;
                    resolvedAbsolute = PATH.isAbs(path);
                }
                resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
            },
            relative: (from, to)=>{
                from = PATH_FS.resolve(from).substr(1);
                to = PATH_FS.resolve(to).substr(1);
                function trim(arr) {
                    var start = 0;
                    for(; start < arr.length; start++){
                        if (arr[start] !== "") break;
                    }
                    var end = arr.length - 1;
                    for(; end >= 0; end--){
                        if (arr[end] !== "") break;
                    }
                    if (start > end) return [];
                    return arr.slice(start, end - start + 1);
                }
                var fromParts = trim(from.split("/"));
                var toParts = trim(to.split("/"));
                var length = Math.min(fromParts.length, toParts.length);
                var samePartsLength = length;
                for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i;
                    break;
                }
                var outputParts = [];
                for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                outputParts = outputParts.concat(toParts.slice(samePartsLength));
                return outputParts.join("/");
            }
        };
        function intArrayFromString(stringy, dontAddNull, length) {
            var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull) u8array.length = numBytesWritten;
            return u8array;
        }
        var TTY = {
            ttys: [],
            init: function() {},
            shutdown: function() {},
            register: function(dev, ops) {
                TTY.ttys[dev] = {
                    input: [],
                    output: [],
                    ops: ops
                };
                FS.registerDevice(dev, TTY.stream_ops);
            },
            stream_ops: {
                open: function(stream) {
                    var tty = TTY.ttys[stream.node.rdev];
                    if (!tty) throw new FS.ErrnoError(43);
                    stream.tty = tty;
                    stream.seekable = false;
                },
                close: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                fsync: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                read: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                    var bytesRead = 0;
                    for(var i = 0; i < length; i++){
                        var result;
                        try {
                            result = stream.tty.ops.get_char(stream.tty);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                        if (result === null || result === undefined) break;
                        bytesRead++;
                        buffer[offset + i] = result;
                    }
                    if (bytesRead) stream.node.timestamp = Date.now();
                    return bytesRead;
                },
                write: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                    try {
                        for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                    } catch (e) {
                        throw new FS.ErrnoError(29);
                    }
                    if (length) stream.node.timestamp = Date.now();
                    return i;
                }
            },
            default_tty_ops: {
                get_char: function(tty) {
                    if (!tty.input.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        tty.input = intArrayFromString(result, true);
                    }
                    return tty.input.shift();
                },
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            },
            default_tty1_ops: {
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            }
        };
        function mmapAlloc(size) {
            abort();
        }
        var MEMFS = {
            ops_table: null,
            mount: function(mount) {
                return MEMFS.createNode(null, "/", 16895, 0);
            },
            createNode: function(parent, name, mode, dev) {
                if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                if (!MEMFS.ops_table) MEMFS.ops_table = {
                    dir: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            lookup: MEMFS.node_ops.lookup,
                            mknod: MEMFS.node_ops.mknod,
                            rename: MEMFS.node_ops.rename,
                            unlink: MEMFS.node_ops.unlink,
                            rmdir: MEMFS.node_ops.rmdir,
                            readdir: MEMFS.node_ops.readdir,
                            symlink: MEMFS.node_ops.symlink
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek,
                            read: MEMFS.stream_ops.read,
                            write: MEMFS.stream_ops.write,
                            allocate: MEMFS.stream_ops.allocate,
                            mmap: MEMFS.stream_ops.mmap,
                            msync: MEMFS.stream_ops.msync
                        }
                    },
                    link: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            readlink: MEMFS.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: FS.chrdev_stream_ops
                    }
                };
                var node = FS.createNode(parent, name, mode, dev);
                if (FS.isDir(node.mode)) {
                    node.node_ops = MEMFS.ops_table.dir.node;
                    node.stream_ops = MEMFS.ops_table.dir.stream;
                    node.contents = {};
                } else if (FS.isFile(node.mode)) {
                    node.node_ops = MEMFS.ops_table.file.node;
                    node.stream_ops = MEMFS.ops_table.file.stream;
                    node.usedBytes = 0;
                    node.contents = null;
                } else if (FS.isLink(node.mode)) {
                    node.node_ops = MEMFS.ops_table.link.node;
                    node.stream_ops = MEMFS.ops_table.link.stream;
                } else if (FS.isChrdev(node.mode)) {
                    node.node_ops = MEMFS.ops_table.chrdev.node;
                    node.stream_ops = MEMFS.ops_table.chrdev.stream;
                }
                node.timestamp = Date.now();
                if (parent) {
                    parent.contents[name] = node;
                    parent.timestamp = node.timestamp;
                }
                return node;
            },
            getFileDataAsTypedArray: function(node) {
                if (!node.contents) return new Uint8Array(0);
                if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                return new Uint8Array(node.contents);
            },
            expandFileStorage: function(node, newCapacity) {
                var prevCapacity = node.contents ? node.contents.length : 0;
                if (prevCapacity >= newCapacity) return;
                var CAPACITY_DOUBLING_MAX = 1048576;
                newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                var oldContents = node.contents;
                node.contents = new Uint8Array(newCapacity);
                if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
            },
            resizeFileStorage: function(node, newSize) {
                if (node.usedBytes == newSize) return;
                if (newSize == 0) {
                    node.contents = null;
                    node.usedBytes = 0;
                } else {
                    var oldContents = node.contents;
                    node.contents = new Uint8Array(newSize);
                    if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                    node.usedBytes = newSize;
                }
            },
            node_ops: {
                getattr: function(node) {
                    var attr = {};
                    attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                    attr.ino = node.id;
                    attr.mode = node.mode;
                    attr.nlink = 1;
                    attr.uid = 0;
                    attr.gid = 0;
                    attr.rdev = node.rdev;
                    if (FS.isDir(node.mode)) attr.size = 4096;
                    else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                    else if (FS.isLink(node.mode)) attr.size = node.link.length;
                    else attr.size = 0;
                    attr.atime = new Date(node.timestamp);
                    attr.mtime = new Date(node.timestamp);
                    attr.ctime = new Date(node.timestamp);
                    attr.blksize = 4096;
                    attr.blocks = Math.ceil(attr.size / attr.blksize);
                    return attr;
                },
                setattr: function(node, attr) {
                    if (attr.mode !== undefined) node.mode = attr.mode;
                    if (attr.timestamp !== undefined) node.timestamp = attr.timestamp;
                    if (attr.size !== undefined) MEMFS.resizeFileStorage(node, attr.size);
                },
                lookup: function(parent, name) {
                    throw FS.genericErrors[44];
                },
                mknod: function(parent, name, mode, dev) {
                    return MEMFS.createNode(parent, name, mode, dev);
                },
                rename: function(old_node, new_dir, new_name) {
                    if (FS.isDir(old_node.mode)) {
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (new_node) {
                            for(var i in new_node.contents)throw new FS.ErrnoError(55);
                        }
                    }
                    delete old_node.parent.contents[old_node.name];
                    old_node.parent.timestamp = Date.now();
                    old_node.name = new_name;
                    new_dir.contents[new_name] = old_node;
                    new_dir.timestamp = old_node.parent.timestamp;
                    old_node.parent = new_dir;
                },
                unlink: function(parent, name) {
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                rmdir: function(parent, name) {
                    var node = FS.lookupNode(parent, name);
                    for(var i in node.contents)throw new FS.ErrnoError(55);
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                readdir: function(node) {
                    var entries = [
                        ".",
                        ".."
                    ];
                    for(var key in node.contents){
                        if (!node.contents.hasOwnProperty(key)) continue;
                        entries.push(key);
                    }
                    return entries;
                },
                symlink: function(parent, newname, oldpath) {
                    var node = MEMFS.createNode(parent, newname, 41471, 0);
                    node.link = oldpath;
                    return node;
                },
                readlink: function(node) {
                    if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                    return node.link;
                }
            },
            stream_ops: {
                read: function(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= stream.node.usedBytes) return 0;
                    var size = Math.min(stream.node.usedBytes - position, length);
                    if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    return size;
                },
                write: function(stream, buffer, offset, length, position, canOwn) {
                    if (buffer.buffer === HEAP8.buffer) canOwn = false;
                    if (!length) return 0;
                    var node = stream.node;
                    node.timestamp = Date.now();
                    if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                        if (canOwn) {
                            node.contents = buffer.subarray(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (node.usedBytes === 0 && position === 0) {
                            node.contents = buffer.slice(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (position + length <= node.usedBytes) {
                            node.contents.set(buffer.subarray(offset, offset + length), position);
                            return length;
                        }
                    }
                    MEMFS.expandFileStorage(node, position + length);
                    if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                    else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                    node.usedBytes = Math.max(node.usedBytes, position + length);
                    return length;
                },
                llseek: function(stream, offset, whence) {
                    var position = offset;
                    if (whence === 1) position += stream.position;
                    else if (whence === 2) {
                        if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                    }
                    if (position < 0) throw new FS.ErrnoError(28);
                    return position;
                },
                allocate: function(stream, offset, length) {
                    MEMFS.expandFileStorage(stream.node, offset + length);
                    stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                },
                mmap: function(stream, length, position, prot, flags) {
                    if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                    var ptr;
                    var allocated;
                    var contents = stream.node.contents;
                    if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                        allocated = false;
                        ptr = contents.byteOffset;
                    } else {
                        if (position > 0 || position + length < contents.length) {
                            if (contents.subarray) contents = contents.subarray(position, position + length);
                            else contents = Array.prototype.slice.call(contents, position, position + length);
                        }
                        allocated = true;
                        ptr = mmapAlloc(length);
                        if (!ptr) throw new FS.ErrnoError(48);
                        HEAP8.set(contents, ptr);
                    }
                    return {
                        ptr: ptr,
                        allocated: allocated
                    };
                },
                msync: function(stream, buffer, offset, length, mmapFlags) {
                    MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                    return 0;
                }
            }
        };
        function asyncLoad(url, onload, onerror, noRunDep) {
            var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
            readAsync(url, (arrayBuffer)=>{
                assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
                onload(new Uint8Array(arrayBuffer));
                if (dep) removeRunDependency(dep);
            }, (event)=>{
                if (onerror) onerror();
                else throw 'Loading data file "' + url + '" failed.';
            });
            if (dep) addRunDependency(dep);
        }
        var FS = {
            root: null,
            mounts: [],
            devices: {},
            streams: [],
            nextInode: 1,
            nameTable: null,
            currentPath: "/",
            initialized: false,
            ignorePermissions: true,
            ErrnoError: null,
            genericErrors: {},
            filesystems: null,
            syncFSRequests: 0,
            lookupPath: (path, opts = {})=>{
                path = PATH_FS.resolve(path);
                if (!path) return {
                    path: "",
                    node: null
                };
                var defaults = {
                    follow_mount: true,
                    recurse_count: 0
                };
                opts = Object.assign(defaults, opts);
                if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                var parts = path.split("/").filter((p)=>!!p);
                var current = FS.root;
                var current_path = "/";
                for(var i = 0; i < parts.length; i++){
                    var islast = i === parts.length - 1;
                    if (islast && opts.parent) break;
                    current = FS.lookupNode(current, parts[i]);
                    current_path = PATH.join2(current_path, parts[i]);
                    if (FS.isMountpoint(current)) {
                        if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                    }
                    if (!islast || opts.follow) {
                        var count = 0;
                        while(FS.isLink(current.mode)){
                            var link = FS.readlink(current_path);
                            current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                            var lookup = FS.lookupPath(current_path, {
                                recurse_count: opts.recurse_count + 1
                            });
                            current = lookup.node;
                            if (count++ > 40) throw new FS.ErrnoError(32);
                        }
                    }
                }
                return {
                    path: current_path,
                    node: current
                };
            },
            getPath: (node)=>{
                var path;
                while(true){
                    if (FS.isRoot(node)) {
                        var mount = node.mount.mountpoint;
                        if (!path) return mount;
                        return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
                    }
                    path = path ? node.name + "/" + path : node.name;
                    node = node.parent;
                }
            },
            hashName: (parentid, name)=>{
                var hash = 0;
                for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                return (parentid + hash >>> 0) % FS.nameTable.length;
            },
            hashAddNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                node.name_next = FS.nameTable[hash];
                FS.nameTable[hash] = node;
            },
            hashRemoveNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                else {
                    var current = FS.nameTable[hash];
                    while(current){
                        if (current.name_next === node) {
                            current.name_next = node.name_next;
                            break;
                        }
                        current = current.name_next;
                    }
                }
            },
            lookupNode: (parent, name)=>{
                var errCode = FS.mayLookup(parent);
                if (errCode) throw new FS.ErrnoError(errCode, parent);
                var hash = FS.hashName(parent.id, name);
                for(var node = FS.nameTable[hash]; node; node = node.name_next){
                    var nodeName = node.name;
                    if (node.parent.id === parent.id && nodeName === name) return node;
                }
                return FS.lookup(parent, name);
            },
            createNode: (parent, name, mode, rdev)=>{
                var node = new FS.FSNode(parent, name, mode, rdev);
                FS.hashAddNode(node);
                return node;
            },
            destroyNode: (node)=>{
                FS.hashRemoveNode(node);
            },
            isRoot: (node)=>{
                return node === node.parent;
            },
            isMountpoint: (node)=>{
                return !!node.mounted;
            },
            isFile: (mode)=>{
                return (mode & 61440) === 32768;
            },
            isDir: (mode)=>{
                return (mode & 61440) === 16384;
            },
            isLink: (mode)=>{
                return (mode & 61440) === 40960;
            },
            isChrdev: (mode)=>{
                return (mode & 61440) === 8192;
            },
            isBlkdev: (mode)=>{
                return (mode & 61440) === 24576;
            },
            isFIFO: (mode)=>{
                return (mode & 61440) === 4096;
            },
            isSocket: (mode)=>{
                return (mode & 49152) === 49152;
            },
            flagModes: {
                "r": 0,
                "r+": 2,
                "w": 577,
                "w+": 578,
                "a": 1089,
                "a+": 1090
            },
            modeStringToFlags: (str)=>{
                var flags = FS.flagModes[str];
                if (typeof flags == "undefined") throw new Error("Unknown file open mode: " + str);
                return flags;
            },
            flagsToPermissionString: (flag)=>{
                var perms = [
                    "r",
                    "w",
                    "rw"
                ][flag & 3];
                if (flag & 512) perms += "w";
                return perms;
            },
            nodePermissions: (node, perms)=>{
                if (FS.ignorePermissions) return 0;
                if (perms.includes("r") && !(node.mode & 292)) return 2;
                else if (perms.includes("w") && !(node.mode & 146)) return 2;
                else if (perms.includes("x") && !(node.mode & 73)) return 2;
                return 0;
            },
            mayLookup: (dir)=>{
                var errCode = FS.nodePermissions(dir, "x");
                if (errCode) return errCode;
                if (!dir.node_ops.lookup) return 2;
                return 0;
            },
            mayCreate: (dir, name)=>{
                try {
                    var node = FS.lookupNode(dir, name);
                    return 20;
                } catch (e) {}
                return FS.nodePermissions(dir, "wx");
            },
            mayDelete: (dir, name, isdir)=>{
                var node;
                try {
                    node = FS.lookupNode(dir, name);
                } catch (e) {
                    return e.errno;
                }
                var errCode = FS.nodePermissions(dir, "wx");
                if (errCode) return errCode;
                if (isdir) {
                    if (!FS.isDir(node.mode)) return 54;
                    if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                } else {
                    if (FS.isDir(node.mode)) return 31;
                }
                return 0;
            },
            mayOpen: (node, flags)=>{
                if (!node) return 44;
                if (FS.isLink(node.mode)) return 32;
                else if (FS.isDir(node.mode)) {
                    if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                }
                return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
            },
            MAX_OPEN_FDS: 4096,
            nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS)=>{
                for(var fd = fd_start; fd <= fd_end; fd++){
                    if (!FS.streams[fd]) return fd;
                }
                throw new FS.ErrnoError(33);
            },
            getStream: (fd)=>FS.streams[fd],
            createStream: (stream, fd_start, fd_end)=>{
                if (!FS.FSStream) {
                    FS.FSStream = function() {
                        this.shared = {};
                    };
                    FS.FSStream.prototype = {};
                    Object.defineProperties(FS.FSStream.prototype, {
                        object: {
                            get: function() {
                                return this.node;
                            },
                            set: function(val) {
                                this.node = val;
                            }
                        },
                        isRead: {
                            get: function() {
                                return (this.flags & 2097155) !== 1;
                            }
                        },
                        isWrite: {
                            get: function() {
                                return (this.flags & 2097155) !== 0;
                            }
                        },
                        isAppend: {
                            get: function() {
                                return this.flags & 1024;
                            }
                        },
                        flags: {
                            get: function() {
                                return this.shared.flags;
                            },
                            set: function(val) {
                                this.shared.flags = val;
                            }
                        },
                        position: {
                            get: function() {
                                return this.shared.position;
                            },
                            set: function(val) {
                                this.shared.position = val;
                            }
                        }
                    });
                }
                stream = Object.assign(new FS.FSStream(), stream);
                var fd = FS.nextfd(fd_start, fd_end);
                stream.fd = fd;
                FS.streams[fd] = stream;
                return stream;
            },
            closeStream: (fd)=>{
                FS.streams[fd] = null;
            },
            chrdev_stream_ops: {
                open: (stream)=>{
                    var device = FS.getDevice(stream.node.rdev);
                    stream.stream_ops = device.stream_ops;
                    if (stream.stream_ops.open) stream.stream_ops.open(stream);
                },
                llseek: ()=>{
                    throw new FS.ErrnoError(70);
                }
            },
            major: (dev)=>dev >> 8,
            minor: (dev)=>dev & 255,
            makedev: (ma, mi)=>ma << 8 | mi,
            registerDevice: (dev, ops)=>{
                FS.devices[dev] = {
                    stream_ops: ops
                };
            },
            getDevice: (dev)=>FS.devices[dev],
            getMounts: (mount)=>{
                var mounts = [];
                var check = [
                    mount
                ];
                while(check.length){
                    var m = check.pop();
                    mounts.push(m);
                    check.push.apply(check, m.mounts);
                }
                return mounts;
            },
            syncfs: (populate, callback)=>{
                if (typeof populate == "function") {
                    callback = populate;
                    populate = false;
                }
                FS.syncFSRequests++;
                if (FS.syncFSRequests > 1) err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
                var mounts = FS.getMounts(FS.root.mount);
                var completed = 0;
                function doCallback(errCode) {
                    FS.syncFSRequests--;
                    return callback(errCode);
                }
                function done(errCode) {
                    if (errCode) {
                        if (!done.errored) {
                            done.errored = true;
                            return doCallback(errCode);
                        }
                        return;
                    }
                    if (++completed >= mounts.length) doCallback(null);
                }
                mounts.forEach((mount)=>{
                    if (!mount.type.syncfs) return done(null);
                    mount.type.syncfs(mount, populate, done);
                });
            },
            mount: (type, opts, mountpoint)=>{
                var root = mountpoint === "/";
                var pseudo = !mountpoint;
                var node;
                if (root && FS.root) throw new FS.ErrnoError(10);
                else if (!root && !pseudo) {
                    var lookup = FS.lookupPath(mountpoint, {
                        follow_mount: false
                    });
                    mountpoint = lookup.path;
                    node = lookup.node;
                    if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                    if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                }
                var mount = {
                    type: type,
                    opts: opts,
                    mountpoint: mountpoint,
                    mounts: []
                };
                var mountRoot = type.mount(mount);
                mountRoot.mount = mount;
                mount.root = mountRoot;
                if (root) FS.root = mountRoot;
                else if (node) {
                    node.mounted = mount;
                    if (node.mount) node.mount.mounts.push(mount);
                }
                return mountRoot;
            },
            unmount: (mountpoint)=>{
                var lookup = FS.lookupPath(mountpoint, {
                    follow_mount: false
                });
                if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                var node = lookup.node;
                var mount = node.mounted;
                var mounts = FS.getMounts(mount);
                Object.keys(FS.nameTable).forEach((hash)=>{
                    var current = FS.nameTable[hash];
                    while(current){
                        var next = current.name_next;
                        if (mounts.includes(current.mount)) FS.destroyNode(current);
                        current = next;
                    }
                });
                node.mounted = null;
                var idx = node.mount.mounts.indexOf(mount);
                node.mount.mounts.splice(idx, 1);
            },
            lookup: (parent, name)=>{
                return parent.node_ops.lookup(parent, name);
            },
            mknod: (path, mode, dev)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                var errCode = FS.mayCreate(parent, name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                return parent.node_ops.mknod(parent, name, mode, dev);
            },
            create: (path, mode)=>{
                mode = mode !== undefined ? mode : 438;
                mode &= 4095;
                mode |= 32768;
                return FS.mknod(path, mode, 0);
            },
            mkdir: (path, mode)=>{
                mode = mode !== undefined ? mode : 511;
                mode &= 1023;
                mode |= 16384;
                return FS.mknod(path, mode, 0);
            },
            mkdirTree: (path, mode)=>{
                var dirs = path.split("/");
                var d = "";
                for(var i = 0; i < dirs.length; ++i){
                    if (!dirs[i]) continue;
                    d += "/" + dirs[i];
                    try {
                        FS.mkdir(d, mode);
                    } catch (e) {
                        if (e.errno != 20) throw e;
                    }
                }
            },
            mkdev: (path, mode, dev)=>{
                if (typeof dev == "undefined") {
                    dev = mode;
                    mode = 438;
                }
                mode |= 8192;
                return FS.mknod(path, mode, dev);
            },
            symlink: (oldpath, newpath)=>{
                if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                var lookup = FS.lookupPath(newpath, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var newname = PATH.basename(newpath);
                var errCode = FS.mayCreate(parent, newname);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                return parent.node_ops.symlink(parent, newname, oldpath);
            },
            rename: (old_path, new_path)=>{
                var old_dirname = PATH.dirname(old_path);
                var new_dirname = PATH.dirname(new_path);
                var old_name = PATH.basename(old_path);
                var new_name = PATH.basename(new_path);
                var lookup, old_dir, new_dir;
                lookup = FS.lookupPath(old_path, {
                    parent: true
                });
                old_dir = lookup.node;
                lookup = FS.lookupPath(new_path, {
                    parent: true
                });
                new_dir = lookup.node;
                if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                var old_node = FS.lookupNode(old_dir, old_name);
                var relative = PATH_FS.relative(old_path, new_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                relative = PATH_FS.relative(new_path, old_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                var new_node;
                try {
                    new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}
                if (old_node === new_node) return;
                var isdir = FS.isDir(old_node.mode);
                var errCode = FS.mayDelete(old_dir, old_name, isdir);
                if (errCode) throw new FS.ErrnoError(errCode);
                errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                if (new_dir !== old_dir) {
                    errCode = FS.nodePermissions(old_dir, "w");
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                FS.hashRemoveNode(old_node);
                try {
                    old_dir.node_ops.rename(old_node, new_dir, new_name);
                } catch (e) {
                    throw e;
                } finally{
                    FS.hashAddNode(old_node);
                }
            },
            rmdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, true);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.rmdir(parent, name);
                FS.destroyNode(node);
            },
            readdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                return node.node_ops.readdir(node);
            },
            unlink: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, false);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.unlink(parent, name);
                FS.destroyNode(node);
            },
            readlink: (path)=>{
                var lookup = FS.lookupPath(path);
                var link = lookup.node;
                if (!link) throw new FS.ErrnoError(44);
                if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
            },
            stat: (path, dontFollow)=>{
                var lookup = FS.lookupPath(path, {
                    follow: !dontFollow
                });
                var node = lookup.node;
                if (!node) throw new FS.ErrnoError(44);
                if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                return node.node_ops.getattr(node);
            },
            lstat: (path)=>{
                return FS.stat(path, true);
            },
            chmod: (path, mode, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    mode: mode & 4095 | node.mode & -4096,
                    timestamp: Date.now()
                });
            },
            lchmod: (path, mode)=>{
                FS.chmod(path, mode, true);
            },
            fchmod: (fd, mode)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chmod(stream.node, mode);
            },
            chown: (path, uid, gid, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    timestamp: Date.now()
                });
            },
            lchown: (path, uid, gid)=>{
                FS.chown(path, uid, gid, true);
            },
            fchown: (fd, uid, gid)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chown(stream.node, uid, gid);
            },
            truncate: (path, len)=>{
                if (len < 0) throw new FS.ErrnoError(28);
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                var errCode = FS.nodePermissions(node, "w");
                if (errCode) throw new FS.ErrnoError(errCode);
                node.node_ops.setattr(node, {
                    size: len,
                    timestamp: Date.now()
                });
            },
            ftruncate: (fd, len)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                FS.truncate(stream.node, len);
            },
            utime: (path, atime, mtime)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                node.node_ops.setattr(node, {
                    timestamp: Math.max(atime, mtime)
                });
            },
            open: (path, flags, mode)=>{
                if (path === "") throw new FS.ErrnoError(44);
                flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
                mode = typeof mode == "undefined" ? 438 : mode;
                if (flags & 64) mode = mode & 4095 | 32768;
                else mode = 0;
                var node;
                if (typeof path == "object") node = path;
                else {
                    path = PATH.normalize(path);
                    try {
                        var lookup = FS.lookupPath(path, {
                            follow: !(flags & 131072)
                        });
                        node = lookup.node;
                    } catch (e) {}
                }
                var created = false;
                if (flags & 64) {
                    if (node) {
                        if (flags & 128) throw new FS.ErrnoError(20);
                    } else {
                        node = FS.mknod(path, mode, 0);
                        created = true;
                    }
                }
                if (!node) throw new FS.ErrnoError(44);
                if (FS.isChrdev(node.mode)) flags &= -513;
                if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                if (!created) {
                    var errCode = FS.mayOpen(node, flags);
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                if (flags & 512 && !created) FS.truncate(node, 0);
                flags &= -131713;
                var stream = FS.createStream({
                    node: node,
                    path: FS.getPath(node),
                    flags: flags,
                    seekable: true,
                    position: 0,
                    stream_ops: node.stream_ops,
                    ungotten: [],
                    error: false
                });
                if (stream.stream_ops.open) stream.stream_ops.open(stream);
                if (Module["logReadFiles"] && !(flags & 1)) {
                    if (!FS.readFiles) FS.readFiles = {};
                    if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                }
                return stream;
            },
            close: (stream)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (stream.getdents) stream.getdents = null;
                try {
                    if (stream.stream_ops.close) stream.stream_ops.close(stream);
                } catch (e) {
                    throw e;
                } finally{
                    FS.closeStream(stream.fd);
                }
                stream.fd = null;
            },
            isClosed: (stream)=>{
                return stream.fd === null;
            },
            llseek: (stream, offset, whence)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                stream.position = stream.stream_ops.llseek(stream, offset, whence);
                stream.ungotten = [];
                return stream.position;
            },
            read: (stream, buffer, offset, length, position)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                if (!seeking) stream.position += bytesRead;
                return bytesRead;
            },
            write: (stream, buffer, offset, length, position, canOwn)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                if (!seeking) stream.position += bytesWritten;
                return bytesWritten;
            },
            allocate: (stream, offset, length)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                stream.stream_ops.allocate(stream, offset, length);
            },
            mmap: (stream, length, position, prot, flags)=>{
                if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                return stream.stream_ops.mmap(stream, length, position, prot, flags);
            },
            msync: (stream, buffer, offset, length, mmapFlags)=>{
                if (!stream.stream_ops.msync) return 0;
                return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
            },
            munmap: (stream)=>0,
            ioctl: (stream, cmd, arg)=>{
                if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                return stream.stream_ops.ioctl(stream, cmd, arg);
            },
            readFile: (path, opts = {})=>{
                opts.flags = opts.flags || 0;
                opts.encoding = opts.encoding || "binary";
                if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error('Invalid encoding type "' + opts.encoding + '"');
                var ret;
                var stream = FS.open(path, opts.flags);
                var stat = FS.stat(path);
                var length = stat.size;
                var buf = new Uint8Array(length);
                FS.read(stream, buf, 0, length, 0);
                if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                else if (opts.encoding === "binary") ret = buf;
                FS.close(stream);
                return ret;
            },
            writeFile: (path, data, opts = {})=>{
                opts.flags = opts.flags || 577;
                var stream = FS.open(path, opts.flags, opts.mode);
                if (typeof data == "string") {
                    var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                    var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                    FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn);
                } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn);
                else throw new Error("Unsupported data type");
                FS.close(stream);
            },
            cwd: ()=>FS.currentPath,
            chdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                if (lookup.node === null) throw new FS.ErrnoError(44);
                if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                var errCode = FS.nodePermissions(lookup.node, "x");
                if (errCode) throw new FS.ErrnoError(errCode);
                FS.currentPath = lookup.path;
            },
            createDefaultDirectories: ()=>{
                FS.mkdir("/tmp");
                FS.mkdir("/home");
                FS.mkdir("/home/web_user");
            },
            createDefaultDevices: ()=>{
                FS.mkdir("/dev");
                FS.registerDevice(FS.makedev(1, 3), {
                    read: ()=>0,
                    write: (stream, buffer, offset, length, pos)=>length
                });
                FS.mkdev("/dev/null", FS.makedev(1, 3));
                TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                FS.mkdev("/dev/tty", FS.makedev(5, 0));
                FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                var random_device = getRandomDevice();
                FS.createDevice("/dev", "random", random_device);
                FS.createDevice("/dev", "urandom", random_device);
                FS.mkdir("/dev/shm");
                FS.mkdir("/dev/shm/tmp");
            },
            createSpecialDirectories: ()=>{
                FS.mkdir("/proc");
                var proc_self = FS.mkdir("/proc/self");
                FS.mkdir("/proc/self/fd");
                FS.mount({
                    mount: ()=>{
                        var node = FS.createNode(proc_self, "fd", 16895, 73);
                        node.node_ops = {
                            lookup: (parent, name)=>{
                                var fd = +name;
                                var stream = FS.getStream(fd);
                                if (!stream) throw new FS.ErrnoError(8);
                                var ret = {
                                    parent: null,
                                    mount: {
                                        mountpoint: "fake"
                                    },
                                    node_ops: {
                                        readlink: ()=>stream.path
                                    }
                                };
                                ret.parent = ret;
                                return ret;
                            }
                        };
                        return node;
                    }
                }, {}, "/proc/self/fd");
            },
            createStandardStreams: ()=>{
                if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                else FS.symlink("/dev/tty", "/dev/stdin");
                if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                else FS.symlink("/dev/tty", "/dev/stdout");
                if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                else FS.symlink("/dev/tty1", "/dev/stderr");
                var stdin = FS.open("/dev/stdin", 0);
                var stdout = FS.open("/dev/stdout", 1);
                var stderr = FS.open("/dev/stderr", 1);
            },
            ensureErrnoError: ()=>{
                if (FS.ErrnoError) return;
                FS.ErrnoError = function ErrnoError(errno, node) {
                    this.name = "ErrnoError";
                    this.node = node;
                    this.setErrno = function(errno) {
                        this.errno = errno;
                    };
                    this.setErrno(errno);
                    this.message = "FS error";
                };
                FS.ErrnoError.prototype = new Error();
                FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                [
                    44
                ].forEach((code)=>{
                    FS.genericErrors[code] = new FS.ErrnoError(code);
                    FS.genericErrors[code].stack = "<generic error, no stack>";
                });
            },
            staticInit: ()=>{
                FS.ensureErrnoError();
                FS.nameTable = new Array(4096);
                FS.mount(MEMFS, {}, "/");
                FS.createDefaultDirectories();
                FS.createDefaultDevices();
                FS.createSpecialDirectories();
                FS.filesystems = {
                    "MEMFS": MEMFS
                };
            },
            init: (input, output, error)=>{
                FS.init.initialized = true;
                FS.ensureErrnoError();
                Module["stdin"] = input || Module["stdin"];
                Module["stdout"] = output || Module["stdout"];
                Module["stderr"] = error || Module["stderr"];
                FS.createStandardStreams();
            },
            quit: ()=>{
                FS.init.initialized = false;
                _fflush(0);
                for(var i = 0; i < FS.streams.length; i++){
                    var stream = FS.streams[i];
                    if (!stream) continue;
                    FS.close(stream);
                }
            },
            getMode: (canRead, canWrite)=>{
                var mode = 0;
                if (canRead) mode |= 365;
                if (canWrite) mode |= 146;
                return mode;
            },
            findObject: (path, dontResolveLastLink)=>{
                var ret = FS.analyzePath(path, dontResolveLastLink);
                if (!ret.exists) return null;
                return ret.object;
            },
            analyzePath: (path, dontResolveLastLink)=>{
                try {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    path = lookup.path;
                } catch (e) {}
                var ret = {
                    isRoot: false,
                    exists: false,
                    error: 0,
                    name: null,
                    path: null,
                    object: null,
                    parentExists: false,
                    parentPath: null,
                    parentObject: null
                };
                try {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    ret.parentExists = true;
                    ret.parentPath = lookup.path;
                    ret.parentObject = lookup.node;
                    ret.name = PATH.basename(path);
                    lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    ret.exists = true;
                    ret.path = lookup.path;
                    ret.object = lookup.node;
                    ret.name = lookup.node.name;
                    ret.isRoot = lookup.path === "/";
                } catch (e) {
                    ret.error = e.errno;
                }
                return ret;
            },
            createPath: (parent, path, canRead, canWrite)=>{
                parent = typeof parent == "string" ? parent : FS.getPath(parent);
                var parts = path.split("/").reverse();
                while(parts.length){
                    var part = parts.pop();
                    if (!part) continue;
                    var current = PATH.join2(parent, part);
                    try {
                        FS.mkdir(current);
                    } catch (e) {}
                    parent = current;
                }
                return current;
            },
            createFile: (parent, name, properties, canRead, canWrite)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(canRead, canWrite);
                return FS.create(path, mode);
            },
            createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                var path = name;
                if (parent) {
                    parent = typeof parent == "string" ? parent : FS.getPath(parent);
                    path = name ? PATH.join2(parent, name) : parent;
                }
                var mode = FS.getMode(canRead, canWrite);
                var node = FS.create(path, mode);
                if (data) {
                    if (typeof data == "string") {
                        var arr = new Array(data.length);
                        for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                        data = arr;
                    }
                    FS.chmod(node, mode | 146);
                    var stream = FS.open(node, 577);
                    FS.write(stream, data, 0, data.length, 0, canOwn);
                    FS.close(stream);
                    FS.chmod(node, mode);
                }
                return node;
            },
            createDevice: (parent, name, input, output)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(!!input, !!output);
                if (!FS.createDevice.major) FS.createDevice.major = 64;
                var dev = FS.makedev(FS.createDevice.major++, 0);
                FS.registerDevice(dev, {
                    open: (stream)=>{
                        stream.seekable = false;
                    },
                    close: (stream)=>{
                        if (output && output.buffer && output.buffer.length) output(10);
                    },
                    read: (stream, buffer, offset, length, pos)=>{
                        var bytesRead = 0;
                        for(var i = 0; i < length; i++){
                            var result;
                            try {
                                result = input();
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                            if (result === null || result === undefined) break;
                            bytesRead++;
                            buffer[offset + i] = result;
                        }
                        if (bytesRead) stream.node.timestamp = Date.now();
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, pos)=>{
                        for(var i = 0; i < length; i++)try {
                            output(buffer[offset + i]);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (length) stream.node.timestamp = Date.now();
                        return i;
                    }
                });
                return FS.mkdev(path, mode, dev);
            },
            forceLoadFile: (obj)=>{
                if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                else if (read_) try {
                    obj.contents = intArrayFromString(read_(obj.url), true);
                    obj.usedBytes = obj.contents.length;
                } catch (e) {
                    throw new FS.ErrnoError(29);
                }
                else throw new Error("Cannot load without read() or XMLHttpRequest.");
            },
            createLazyFile: (parent, name, url, canRead, canWrite)=>{
                function LazyUint8Array() {
                    this.lengthKnown = false;
                    this.chunks = [];
                }
                LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                    if (idx > this.length - 1 || idx < 0) return undefined;
                    var chunkOffset = idx % this.chunkSize;
                    var chunkNum = idx / this.chunkSize | 0;
                    return this.getter(chunkNum)[chunkOffset];
                };
                LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                    this.getter = getter;
                };
                LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                    var xhr = new XMLHttpRequest();
                    xhr.open("HEAD", url, false);
                    xhr.send(null);
                    if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                    var datalength = Number(xhr.getResponseHeader("Content-length"));
                    var header;
                    var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                    var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                    var chunkSize = 1048576;
                    if (!hasByteServing) chunkSize = datalength;
                    var doXHR = (from, to)=>{
                        if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                        if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
                        xhr.responseType = "arraybuffer";
                        if (xhr.overrideMimeType) xhr.overrideMimeType("text/plain; charset=x-user-defined");
                        xhr.send(null);
                        if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                        if (xhr.response !== undefined) return new Uint8Array(xhr.response || []);
                        return intArrayFromString(xhr.responseText || "", true);
                    };
                    var lazyArray = this;
                    lazyArray.setDataGetter((chunkNum)=>{
                        var start = chunkNum * chunkSize;
                        var end = (chunkNum + 1) * chunkSize - 1;
                        end = Math.min(end, datalength - 1);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") lazyArray.chunks[chunkNum] = doXHR(start, end);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                        return lazyArray.chunks[chunkNum];
                    });
                    if (usesGzip || !datalength) {
                        chunkSize = datalength = 1;
                        datalength = this.getter(0).length;
                        chunkSize = datalength;
                        out("LazyFiles on gzip forces download of the whole file when length is accessed");
                    }
                    this._length = datalength;
                    this._chunkSize = chunkSize;
                    this.lengthKnown = true;
                };
                if (typeof XMLHttpRequest != "undefined") {
                    if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                    var lazyArray = new LazyUint8Array();
                    Object.defineProperties(lazyArray, {
                        length: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._length;
                            }
                        },
                        chunkSize: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._chunkSize;
                            }
                        }
                    });
                    var properties = {
                        isDevice: false,
                        contents: lazyArray
                    };
                } else var properties = {
                    isDevice: false,
                    url: url
                };
                var node = FS.createFile(parent, name, properties, canRead, canWrite);
                if (properties.contents) node.contents = properties.contents;
                else if (properties.url) {
                    node.contents = null;
                    node.url = properties.url;
                }
                Object.defineProperties(node, {
                    usedBytes: {
                        get: function() {
                            return this.contents.length;
                        }
                    }
                });
                var stream_ops = {};
                var keys = Object.keys(node.stream_ops);
                keys.forEach((key)=>{
                    var fn = node.stream_ops[key];
                    stream_ops[key] = function forceLoadLazyFile() {
                        FS.forceLoadFile(node);
                        return fn.apply(null, arguments);
                    };
                });
                function writeChunks(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= contents.length) return 0;
                    var size = Math.min(contents.length - position, length);
                    if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                    return size;
                }
                stream_ops.read = (stream, buffer, offset, length, position)=>{
                    FS.forceLoadFile(node);
                    return writeChunks(stream, buffer, offset, length, position);
                };
                stream_ops.mmap = (stream, length, position, prot, flags)=>{
                    FS.forceLoadFile(node);
                    var ptr = mmapAlloc(length);
                    if (!ptr) throw new FS.ErrnoError(48);
                    writeChunks(stream, HEAP8, ptr, length, position);
                    return {
                        ptr: ptr,
                        allocated: true
                    };
                };
                node.stream_ops = stream_ops;
                return node;
            },
            createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish)=>{
                var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                var dep = getUniqueRunDependency("cp " + fullname);
                function processData(byteArray) {
                    function finish(byteArray) {
                        if (preFinish) preFinish();
                        if (!dontCreateFile) FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                        if (onload) onload();
                        removeRunDependency(dep);
                    }
                    if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                        if (onerror) onerror();
                        removeRunDependency(dep);
                    })) return;
                    finish(byteArray);
                }
                addRunDependency(dep);
                if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                else processData(url);
            },
            indexedDB: ()=>{
                return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
            },
            DB_NAME: ()=>{
                return "EM_FS_" + window.location.pathname;
            },
            DB_VERSION: 20,
            DB_STORE_NAME: "FILE_DATA",
            saveFilesToDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = ()=>{
                    out("creating db");
                    var db = openRequest.result;
                    db.createObjectStore(FS.DB_STORE_NAME);
                };
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    var transaction = db.transaction([
                        FS.DB_STORE_NAME
                    ], "readwrite");
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var putRequest = files.put(FS.analyzePath(path).object.contents, path);
                        putRequest.onsuccess = ()=>{
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        putRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            },
            loadFilesFromDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = onerror;
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    try {
                        var transaction = db.transaction([
                            FS.DB_STORE_NAME
                        ], "readonly");
                    } catch (e) {
                        onerror(e);
                        return;
                    }
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var getRequest = files.get(path);
                        getRequest.onsuccess = ()=>{
                            if (FS.analyzePath(path).exists) FS.unlink(path);
                            FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        getRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            }
        };
        var SYSCALLS = {
            DEFAULT_POLLMASK: 5,
            calculateAt: function(dirfd, path, allowEmpty) {
                if (PATH.isAbs(path)) return path;
                var dir;
                if (dirfd === -100) dir = FS.cwd();
                else {
                    var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                    dir = dirstream.path;
                }
                if (path.length == 0) {
                    if (!allowEmpty) throw new FS.ErrnoError(44);
                    return dir;
                }
                return PATH.join2(dir, path);
            },
            doStat: function(func, path, buf) {
                try {
                    var stat = func(path);
                } catch (e) {
                    if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                    throw e;
                }
                HEAP32[buf >> 2] = stat.dev;
                HEAP32[buf + 8 >> 2] = stat.ino;
                HEAP32[buf + 12 >> 2] = stat.mode;
                HEAPU32[buf + 16 >> 2] = stat.nlink;
                HEAP32[buf + 20 >> 2] = stat.uid;
                HEAP32[buf + 24 >> 2] = stat.gid;
                HEAP32[buf + 28 >> 2] = stat.rdev;
                tempI64 = [
                    stat.size >>> 0,
                    (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 40 >> 2] = tempI64[0], HEAP32[buf + 44 >> 2] = tempI64[1];
                HEAP32[buf + 48 >> 2] = 4096;
                HEAP32[buf + 52 >> 2] = stat.blocks;
                var atime = stat.atime.getTime();
                var mtime = stat.mtime.getTime();
                var ctime = stat.ctime.getTime();
                tempI64 = [
                    Math.floor(atime / 1e3) >>> 0,
                    (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 56 >> 2] = tempI64[0], HEAP32[buf + 60 >> 2] = tempI64[1];
                HEAPU32[buf + 64 >> 2] = atime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(mtime / 1e3) >>> 0,
                    (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 72 >> 2] = tempI64[0], HEAP32[buf + 76 >> 2] = tempI64[1];
                HEAPU32[buf + 80 >> 2] = mtime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(ctime / 1e3) >>> 0,
                    (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 88 >> 2] = tempI64[0], HEAP32[buf + 92 >> 2] = tempI64[1];
                HEAPU32[buf + 96 >> 2] = ctime % 1e3 * 1e3;
                tempI64 = [
                    stat.ino >>> 0,
                    (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 104 >> 2] = tempI64[0], HEAP32[buf + 108 >> 2] = tempI64[1];
                return 0;
            },
            doMsync: function(addr, stream, len, flags, offset) {
                if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                if (flags & 2) return 0;
                var buffer = HEAPU8.slice(addr, addr + len);
                FS.msync(stream, buffer, offset, len, flags);
            },
            varargs: undefined,
            get: function() {
                SYSCALLS.varargs += 4;
                var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
                return ret;
            },
            getStr: function(ptr) {
                var ret = UTF8ToString(ptr);
                return ret;
            },
            getStreamFromFD: function(fd) {
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                return stream;
            }
        };
        function ___syscall_dup(fd) {
            try {
                var old = SYSCALLS.getStreamFromFD(fd);
                return FS.createStream(old, 0).fd;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_faccessat(dirfd, path, amode, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (amode & -8) return -28;
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node) return -44;
                var perms = "";
                if (amode & 4) perms += "r";
                if (amode & 2) perms += "w";
                if (amode & 1) perms += "x";
                if (perms && FS.nodePermissions(node, perms)) return -2;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function setErrNo(value) {
            HEAP32[___errno_location() >> 2] = value;
            return value;
        }
        function ___syscall_fcntl64(fd, cmd, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(cmd){
                    case 0:
                        var arg = SYSCALLS.get();
                        if (arg < 0) return -28;
                        var newStream;
                        newStream = FS.createStream(stream, arg);
                        return newStream.fd;
                    case 1:
                    case 2:
                        return 0;
                    case 3:
                        return stream.flags;
                    case 4:
                        var arg = SYSCALLS.get();
                        stream.flags |= arg;
                        return 0;
                    case 5:
                        var arg = SYSCALLS.get();
                        var offset = 0;
                        HEAP16[arg + offset >> 1] = 2;
                        return 0;
                    case 6:
                    case 7:
                        return 0;
                    case 16:
                    case 8:
                        return -28;
                    case 9:
                        setErrNo(28);
                        return -1;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_getcwd(buf, size) {
            try {
                if (size === 0) return -28;
                var cwd = FS.cwd();
                var cwdLengthInBytes = lengthBytesUTF8(cwd) + 1;
                if (size < cwdLengthInBytes) return -68;
                stringToUTF8(cwd, buf, size);
                return cwdLengthInBytes;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_getdents64(fd, dirp, count) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                if (!stream.getdents) stream.getdents = FS.readdir(stream.path);
                var struct_size = 280;
                var pos = 0;
                var off = FS.llseek(stream, 0, 1);
                var idx = Math.floor(off / struct_size);
                while(idx < stream.getdents.length && pos + struct_size <= count){
                    var id;
                    var type;
                    var name = stream.getdents[idx];
                    if (name === ".") {
                        id = stream.node.id;
                        type = 4;
                    } else if (name === "..") {
                        var lookup = FS.lookupPath(stream.path, {
                            parent: true
                        });
                        id = lookup.node.id;
                        type = 4;
                    } else {
                        var child = FS.lookupNode(stream.node, name);
                        id = child.id;
                        type = FS.isChrdev(child.mode) ? 2 : FS.isDir(child.mode) ? 4 : FS.isLink(child.mode) ? 10 : 8;
                    }
                    tempI64 = [
                        id >>> 0,
                        (tempDouble = id, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                    ], HEAP32[dirp + pos >> 2] = tempI64[0], HEAP32[dirp + pos + 4 >> 2] = tempI64[1];
                    tempI64 = [
                        (idx + 1) * struct_size >>> 0,
                        (tempDouble = (idx + 1) * struct_size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                    ], HEAP32[dirp + pos + 8 >> 2] = tempI64[0], HEAP32[dirp + pos + 12 >> 2] = tempI64[1];
                    HEAP16[dirp + pos + 16 >> 1] = 280;
                    HEAP8[dirp + pos + 18 >> 0] = type;
                    stringToUTF8(name, dirp + pos + 19, 256);
                    pos += struct_size;
                    idx += 1;
                }
                FS.llseek(stream, idx * struct_size, 0);
                return pos;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_ioctl(fd, op, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(op){
                    case 21509:
                    case 21505:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21510:
                    case 21511:
                    case 21512:
                    case 21506:
                    case 21507:
                    case 21508:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21519:
                        if (!stream.tty) return -59;
                        var argp = SYSCALLS.get();
                        HEAP32[argp >> 2] = 0;
                        return 0;
                    case 21520:
                        if (!stream.tty) return -59;
                        return -28;
                    case 21531:
                        var argp = SYSCALLS.get();
                        return FS.ioctl(stream, op, argp);
                    case 21523:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21524:
                        if (!stream.tty) return -59;
                        return 0;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_lstat64(path, buf) {
            try {
                path = SYSCALLS.getStr(path);
                return SYSCALLS.doStat(FS.lstat, path, buf);
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_mkdirat(dirfd, path, mode) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                path = PATH.normalize(path);
                if (path[path.length - 1] === "/") path = path.substr(0, path.length - 1);
                FS.mkdir(path, mode, 0);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_newfstatat(dirfd, path, buf, flags) {
            try {
                path = SYSCALLS.getStr(path);
                var nofollow = flags & 256;
                var allowEmpty = flags & 4096;
                flags = flags & -6401;
                path = SYSCALLS.calculateAt(dirfd, path, allowEmpty);
                return SYSCALLS.doStat(nofollow ? FS.lstat : FS.stat, path, buf);
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                var mode = varargs ? SYSCALLS.get() : 0;
                return FS.open(path, flags, mode).fd;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_readlinkat(dirfd, path, buf, bufsize) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (bufsize <= 0) return -28;
                var ret = FS.readlink(path);
                var len = Math.min(bufsize, lengthBytesUTF8(ret));
                var endChar = HEAP8[buf + len];
                stringToUTF8(ret, buf, bufsize + 1);
                HEAP8[buf + len] = endChar;
                return len;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_renameat(olddirfd, oldpath, newdirfd, newpath) {
            try {
                oldpath = SYSCALLS.getStr(oldpath);
                newpath = SYSCALLS.getStr(newpath);
                oldpath = SYSCALLS.calculateAt(olddirfd, oldpath);
                newpath = SYSCALLS.calculateAt(newdirfd, newpath);
                FS.rename(oldpath, newpath);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_rmdir(path) {
            try {
                path = SYSCALLS.getStr(path);
                FS.rmdir(path);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_stat64(path, buf) {
            try {
                path = SYSCALLS.getStr(path);
                return SYSCALLS.doStat(FS.stat, path, buf);
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_unlinkat(dirfd, path, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (flags === 0) FS.unlink(path);
                else if (flags === 512) FS.rmdir(path);
                else abort("Invalid flags passed to unlinkat");
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        var nowIsMonotonic = true;
        function __emscripten_get_now_is_monotonic() {
            return nowIsMonotonic;
        }
        function __emscripten_throw_longjmp() {
            throw Infinity;
        }
        function readI53FromI64(ptr) {
            return HEAPU32[ptr >> 2] + HEAP32[ptr + 4 >> 2] * 4294967296;
        }
        function __gmtime_js(time, tmPtr) {
            var date = new Date(readI53FromI64(time) * 1e3);
            HEAP32[tmPtr >> 2] = date.getUTCSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getUTCMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getUTCHours();
            HEAP32[tmPtr + 12 >> 2] = date.getUTCDate();
            HEAP32[tmPtr + 16 >> 2] = date.getUTCMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getUTCFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getUTCDay();
            var start = Date.UTC(date.getUTCFullYear(), 0, 1, 0, 0, 0, 0);
            var yday = (date.getTime() - start) / 86400000 | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
        }
        function __isLeapYear(year) {
            return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }
        var __MONTH_DAYS_LEAP_CUMULATIVE = [
            0,
            31,
            60,
            91,
            121,
            152,
            182,
            213,
            244,
            274,
            305,
            335
        ];
        var __MONTH_DAYS_REGULAR_CUMULATIVE = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
        function __yday_from_date(date) {
            var isLeapYear = __isLeapYear(date.getFullYear());
            var monthDaysCumulative = isLeapYear ? __MONTH_DAYS_LEAP_CUMULATIVE : __MONTH_DAYS_REGULAR_CUMULATIVE;
            var yday = monthDaysCumulative[date.getMonth()] + date.getDate() - 1;
            return yday;
        }
        function __localtime_js(time, tmPtr) {
            var date = new Date(readI53FromI64(time) * 1e3);
            HEAP32[tmPtr >> 2] = date.getSeconds();
            HEAP32[tmPtr + 4 >> 2] = date.getMinutes();
            HEAP32[tmPtr + 8 >> 2] = date.getHours();
            HEAP32[tmPtr + 12 >> 2] = date.getDate();
            HEAP32[tmPtr + 16 >> 2] = date.getMonth();
            HEAP32[tmPtr + 20 >> 2] = date.getFullYear() - 1900;
            HEAP32[tmPtr + 24 >> 2] = date.getDay();
            var yday = __yday_from_date(date) | 0;
            HEAP32[tmPtr + 28 >> 2] = yday;
            HEAP32[tmPtr + 36 >> 2] = -(date.getTimezoneOffset() * 60);
            var start = new Date(date.getFullYear(), 0, 1);
            var summerOffset = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
            var winterOffset = start.getTimezoneOffset();
            var dst = (summerOffset != winterOffset && date.getTimezoneOffset() == Math.min(winterOffset, summerOffset)) | 0;
            HEAP32[tmPtr + 32 >> 2] = dst;
        }
        function allocateUTF8(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = _malloc(size);
            if (ret) stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function __tzset_js(timezone, daylight, tzname) {
            var currentYear = new Date().getFullYear();
            var winter = new Date(currentYear, 0, 1);
            var summer = new Date(currentYear, 6, 1);
            var winterOffset = winter.getTimezoneOffset();
            var summerOffset = summer.getTimezoneOffset();
            var stdTimezoneOffset = Math.max(winterOffset, summerOffset);
            HEAPU32[timezone >> 2] = stdTimezoneOffset * 60;
            HEAP32[daylight >> 2] = Number(winterOffset != summerOffset);
            function extractZone(date) {
                var match = date.toTimeString().match(/\(([A-Za-z ]+)\)$/);
                return match ? match[1] : "GMT";
            }
            var winterName = extractZone(winter);
            var summerName = extractZone(summer);
            var winterNamePtr = allocateUTF8(winterName);
            var summerNamePtr = allocateUTF8(summerName);
            if (summerOffset < winterOffset) {
                HEAPU32[tzname >> 2] = winterNamePtr;
                HEAPU32[tzname + 4 >> 2] = summerNamePtr;
            } else {
                HEAPU32[tzname >> 2] = summerNamePtr;
                HEAPU32[tzname + 4 >> 2] = winterNamePtr;
            }
        }
        function _abort() {
            abort("");
        }
        function _emscripten_date_now() {
            return Date.now();
        }
        var _emscripten_get_now;
        _emscripten_get_now = ()=>performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
            HEAPU8.copyWithin(dest, src, src + num);
        }
        function getHeapMax() {
            return 2147483648;
        }
        function emscripten_realloc_buffer(size) {
            var b = wasmMemory.buffer;
            try {
                wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
                updateMemoryViews();
                return 1;
            } catch (e) {}
        }
        function _emscripten_resize_heap(requestedSize) {
            var oldSize = HEAPU8.length;
            requestedSize = requestedSize >>> 0;
            var maxHeapSize = getHeapMax();
            if (requestedSize > maxHeapSize) return false;
            let alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
            for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                var replacement = emscripten_realloc_buffer(newSize);
                if (replacement) return true;
            }
            return false;
        }
        var ENV = {};
        function getExecutableName() {
            return thisProgram || "./this.program";
        }
        function getEnvStrings() {
            if (!getEnvStrings.strings) {
                var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                var env = {
                    "USER": "web_user",
                    "LOGNAME": "web_user",
                    "PATH": "/",
                    "PWD": "/",
                    "HOME": "/home/web_user",
                    "LANG": lang,
                    "_": getExecutableName()
                };
                for(var x in ENV)if (ENV[x] === undefined) delete env[x];
                else env[x] = ENV[x];
                var strings = [];
                for(var x in env)strings.push(x + "=" + env[x]);
                getEnvStrings.strings = strings;
            }
            return getEnvStrings.strings;
        }
        function writeAsciiToMemory(str, buffer, dontAddNull) {
            for(var i = 0; i < str.length; ++i)HEAP8[buffer++ >> 0] = str.charCodeAt(i);
            if (!dontAddNull) HEAP8[buffer >> 0] = 0;
        }
        function _environ_get(__environ, environ_buf) {
            var bufSize = 0;
            getEnvStrings().forEach(function(string, i) {
                var ptr = environ_buf + bufSize;
                HEAPU32[__environ + i * 4 >> 2] = ptr;
                writeAsciiToMemory(string, ptr);
                bufSize += string.length + 1;
            });
            return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
            var strings = getEnvStrings();
            HEAPU32[penviron_count >> 2] = strings.length;
            var bufSize = 0;
            strings.forEach(function(string) {
                bufSize += string.length + 1;
            });
            HEAPU32[penviron_buf_size >> 2] = bufSize;
            return 0;
        }
        function _proc_exit(code) {
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
                if (Module["onExit"]) Module["onExit"](code);
                ABORT = true;
            }
            quit_(code, new ExitStatus(code));
        }
        function exitJS(status, implicit) {
            EXITSTATUS = status;
            if (!keepRuntimeAlive()) exitRuntime();
            _proc_exit(status);
        }
        var _exit = exitJS;
        function _fd_close(fd) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.close(stream);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doReadv(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.read(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (curr < len) break;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doReadv(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function convertI32PairToI53Checked(lo, hi) {
            return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
            try {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                if (isNaN(offset)) return 61;
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.llseek(stream, offset, whence);
                tempI64 = [
                    stream.position >>> 0,
                    (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[newOffset >> 2] = tempI64[0], HEAP32[newOffset + 4 >> 2] = tempI64[1];
                if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doWritev(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.write(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doWritev(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function __arraySum(array, index) {
            var sum = 0;
            for(var i = 0; i <= index; sum += array[i++]);
            return sum;
        }
        var __MONTH_DAYS_LEAP = [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        var __MONTH_DAYS_REGULAR = [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ];
        function __addDays(date, days) {
            var newDate = new Date(date.getTime());
            while(days > 0){
                var leap = __isLeapYear(newDate.getFullYear());
                var currentMonth = newDate.getMonth();
                var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];
                if (days > daysInCurrentMonth - newDate.getDate()) {
                    days -= daysInCurrentMonth - newDate.getDate() + 1;
                    newDate.setDate(1);
                    if (currentMonth < 11) newDate.setMonth(currentMonth + 1);
                    else {
                        newDate.setMonth(0);
                        newDate.setFullYear(newDate.getFullYear() + 1);
                    }
                } else {
                    newDate.setDate(newDate.getDate() + days);
                    return newDate;
                }
            }
            return newDate;
        }
        function writeArrayToMemory(array, buffer) {
            HEAP8.set(array, buffer);
        }
        function _strftime(s, maxsize, format, tm) {
            var tm_zone = HEAP32[tm + 40 >> 2];
            var date = {
                tm_sec: HEAP32[tm >> 2],
                tm_min: HEAP32[tm + 4 >> 2],
                tm_hour: HEAP32[tm + 8 >> 2],
                tm_mday: HEAP32[tm + 12 >> 2],
                tm_mon: HEAP32[tm + 16 >> 2],
                tm_year: HEAP32[tm + 20 >> 2],
                tm_wday: HEAP32[tm + 24 >> 2],
                tm_yday: HEAP32[tm + 28 >> 2],
                tm_isdst: HEAP32[tm + 32 >> 2],
                tm_gmtoff: HEAP32[tm + 36 >> 2],
                tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
            };
            var pattern = UTF8ToString(format);
            var EXPANSION_RULES_1 = {
                "%c": "%a %b %d %H:%M:%S %Y",
                "%D": "%m/%d/%y",
                "%F": "%Y-%m-%d",
                "%h": "%b",
                "%r": "%I:%M:%S %p",
                "%R": "%H:%M",
                "%T": "%H:%M:%S",
                "%x": "%m/%d/%y",
                "%X": "%H:%M:%S",
                "%Ec": "%c",
                "%EC": "%C",
                "%Ex": "%m/%d/%y",
                "%EX": "%H:%M:%S",
                "%Ey": "%y",
                "%EY": "%Y",
                "%Od": "%d",
                "%Oe": "%e",
                "%OH": "%H",
                "%OI": "%I",
                "%Om": "%m",
                "%OM": "%M",
                "%OS": "%S",
                "%Ou": "%u",
                "%OU": "%U",
                "%OV": "%V",
                "%Ow": "%w",
                "%OW": "%W",
                "%Oy": "%y"
            };
            for(var rule in EXPANSION_RULES_1)pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
            var WEEKDAYS = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ];
            var MONTHS = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
            function leadingSomething(value, digits, character) {
                var str = typeof value == "number" ? value.toString() : value || "";
                while(str.length < digits)str = character[0] + str;
                return str;
            }
            function leadingNulls(value, digits) {
                return leadingSomething(value, digits, "0");
            }
            function compareByDay(date1, date2) {
                function sgn(value) {
                    return value < 0 ? -1 : value > 0 ? 1 : 0;
                }
                var compare;
                if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
                    if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) compare = sgn(date1.getDate() - date2.getDate());
                }
                return compare;
            }
            function getFirstWeekStartDate(janFourth) {
                switch(janFourth.getDay()){
                    case 0:
                        return new Date(janFourth.getFullYear() - 1, 11, 29);
                    case 1:
                        return janFourth;
                    case 2:
                        return new Date(janFourth.getFullYear(), 0, 3);
                    case 3:
                        return new Date(janFourth.getFullYear(), 0, 2);
                    case 4:
                        return new Date(janFourth.getFullYear(), 0, 1);
                    case 5:
                        return new Date(janFourth.getFullYear() - 1, 11, 31);
                    case 6:
                        return new Date(janFourth.getFullYear() - 1, 11, 30);
                }
            }
            function getWeekBasedYear(date) {
                var thisDate = __addDays(new Date(date.tm_year + 1900, 0, 1), date.tm_yday);
                var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
                var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
                var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
                var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);
                if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
                    if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) return thisDate.getFullYear() + 1;
                    return thisDate.getFullYear();
                }
                return thisDate.getFullYear() - 1;
            }
            var EXPANSION_RULES_2 = {
                "%a": function(date) {
                    return WEEKDAYS[date.tm_wday].substring(0, 3);
                },
                "%A": function(date) {
                    return WEEKDAYS[date.tm_wday];
                },
                "%b": function(date) {
                    return MONTHS[date.tm_mon].substring(0, 3);
                },
                "%B": function(date) {
                    return MONTHS[date.tm_mon];
                },
                "%C": function(date) {
                    var year = date.tm_year + 1900;
                    return leadingNulls(year / 100 | 0, 2);
                },
                "%d": function(date) {
                    return leadingNulls(date.tm_mday, 2);
                },
                "%e": function(date) {
                    return leadingSomething(date.tm_mday, 2, " ");
                },
                "%g": function(date) {
                    return getWeekBasedYear(date).toString().substring(2);
                },
                "%G": function(date) {
                    return getWeekBasedYear(date);
                },
                "%H": function(date) {
                    return leadingNulls(date.tm_hour, 2);
                },
                "%I": function(date) {
                    var twelveHour = date.tm_hour;
                    if (twelveHour == 0) twelveHour = 12;
                    else if (twelveHour > 12) twelveHour -= 12;
                    return leadingNulls(twelveHour, 2);
                },
                "%j": function(date) {
                    return leadingNulls(date.tm_mday + __arraySum(__isLeapYear(date.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date.tm_mon - 1), 3);
                },
                "%m": function(date) {
                    return leadingNulls(date.tm_mon + 1, 2);
                },
                "%M": function(date) {
                    return leadingNulls(date.tm_min, 2);
                },
                "%n": function() {
                    return "\n";
                },
                "%p": function(date) {
                    if (date.tm_hour >= 0 && date.tm_hour < 12) return "AM";
                    return "PM";
                },
                "%S": function(date) {
                    return leadingNulls(date.tm_sec, 2);
                },
                "%t": function() {
                    return "	";
                },
                "%u": function(date) {
                    return date.tm_wday || 7;
                },
                "%U": function(date) {
                    var days = date.tm_yday + 7 - date.tm_wday;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                "%V": function(date) {
                    var val = Math.floor((date.tm_yday + 7 - (date.tm_wday + 6) % 7) / 7);
                    if ((date.tm_wday + 371 - date.tm_yday - 2) % 7 <= 2) val++;
                    if (!val) {
                        val = 52;
                        var dec31 = (date.tm_wday + 7 - date.tm_yday - 1) % 7;
                        if (dec31 == 4 || dec31 == 5 && __isLeapYear(date.tm_year % 400 - 1)) val++;
                    } else if (val == 53) {
                        var jan1 = (date.tm_wday + 371 - date.tm_yday) % 7;
                        if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date.tm_year))) val = 1;
                    }
                    return leadingNulls(val, 2);
                },
                "%w": function(date) {
                    return date.tm_wday;
                },
                "%W": function(date) {
                    var days = date.tm_yday + 7 - (date.tm_wday + 6) % 7;
                    return leadingNulls(Math.floor(days / 7), 2);
                },
                "%y": function(date) {
                    return (date.tm_year + 1900).toString().substring(2);
                },
                "%Y": function(date) {
                    return date.tm_year + 1900;
                },
                "%z": function(date) {
                    var off = date.tm_gmtoff;
                    var ahead = off >= 0;
                    off = Math.abs(off) / 60;
                    off = off / 60 * 100 + off % 60;
                    return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
                },
                "%Z": function(date) {
                    return date.tm_zone;
                },
                "%%": function() {
                    return "%";
                }
            };
            pattern = pattern.replace(/%%/g, "\x00\x00");
            for(var rule in EXPANSION_RULES_2)if (pattern.includes(rule)) pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            pattern = pattern.replace(/\0\0/g, "%");
            var bytes = intArrayFromString(pattern, false);
            if (bytes.length > maxsize) return 0;
            writeArrayToMemory(bytes, s);
            return bytes.length - 1;
        }
        function handleException(e) {
            if (e instanceof ExitStatus || e == "unwind") return EXITSTATUS;
            quit_(1, e);
        }
        function allocateUTF8OnStack(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function runAndAbortIfError(func) {
            try {
                return func();
            } catch (e) {
                abort(e);
            }
        }
        function maybeExit() {
            if (!keepRuntimeAlive()) try {
                _exit(EXITSTATUS);
            } catch (e) {
                handleException(e);
            }
        }
        function callUserCallback(func) {
            if (runtimeExited || ABORT) return;
            try {
                func();
                maybeExit();
            } catch (e) {
                handleException(e);
            }
        }
        function runtimeKeepalivePush() {
            runtimeKeepaliveCounter += 1;
        }
        function runtimeKeepalivePop() {
            runtimeKeepaliveCounter -= 1;
        }
        var Asyncify = {
            instrumentWasmImports: function(imports) {
                var ASYNCIFY_IMPORTS = [
                    "invoke_*",
                    "emscripten_sleep",
                    "emscripten_wget",
                    "emscripten_wget_data",
                    "emscripten_idb_load",
                    "emscripten_idb_store",
                    "emscripten_idb_delete",
                    "emscripten_idb_exists",
                    "emscripten_idb_load_blob",
                    "emscripten_idb_store_blob",
                    "SDL_Delay",
                    "emscripten_scan_registers",
                    "emscripten_lazy_load_code",
                    "emscripten_fiber_swap",
                    "__load_secondary_module",
                    "fd_sync",
                    "__wasi_fd_sync",
                    "_emval_await",
                    "_dlopen_js",
                    "__asyncjs__*"
                ];
                for(var x in imports)(function(x) {
                    var original = imports[x];
                    var sig = original.sig;
                    if (typeof original == "function") var isAsyncifyImport = ASYNCIFY_IMPORTS.indexOf(x) >= 0 || x.startsWith("__asyncjs__");
                })(x);
            },
            instrumentWasmExports: function(exports) {
                var ret = {};
                for(var x in exports)(function(x) {
                    var original = exports[x];
                    if (typeof original == "function") ret[x] = function() {
                        Asyncify.exportCallStack.push(x);
                        try {
                            return original.apply(null, arguments);
                        } finally{
                            if (!ABORT) {
                                var y = Asyncify.exportCallStack.pop();
                                assert(y === x);
                                Asyncify.maybeStopUnwind();
                            }
                        }
                    };
                    else ret[x] = original;
                })(x);
                return ret;
            },
            State: {
                Normal: 0,
                Unwinding: 1,
                Rewinding: 2,
                Disabled: 3
            },
            state: 0,
            StackSize: 8192,
            currData: null,
            handleSleepReturnValue: 0,
            exportCallStack: [],
            callStackNameToId: {},
            callStackIdToName: {},
            callStackId: 0,
            asyncPromiseHandlers: null,
            sleepCallbacks: [],
            getCallStackId: function(funcName) {
                var id = Asyncify.callStackNameToId[funcName];
                if (id === undefined) {
                    id = Asyncify.callStackId++;
                    Asyncify.callStackNameToId[funcName] = id;
                    Asyncify.callStackIdToName[id] = funcName;
                }
                return id;
            },
            maybeStopUnwind: function() {
                if (Asyncify.currData && Asyncify.state === Asyncify.State.Unwinding && Asyncify.exportCallStack.length === 0) {
                    Asyncify.state = Asyncify.State.Normal;
                    runtimeKeepalivePush();
                    runAndAbortIfError(_asyncify_stop_unwind);
                    if (typeof Fibers != "undefined") Fibers.trampoline();
                }
            },
            whenDone: function() {
                return new Promise((resolve, reject)=>{
                    Asyncify.asyncPromiseHandlers = {
                        resolve: resolve,
                        reject: reject
                    };
                });
            },
            allocateData: function() {
                var ptr = _malloc(12 + Asyncify.StackSize);
                Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
                Asyncify.setDataRewindFunc(ptr);
                return ptr;
            },
            setDataHeader: function(ptr, stack, stackSize) {
                HEAP32[ptr >> 2] = stack;
                HEAP32[ptr + 4 >> 2] = stack + stackSize;
            },
            setDataRewindFunc: function(ptr) {
                var bottomOfCallStack = Asyncify.exportCallStack[0];
                var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
                HEAP32[ptr + 8 >> 2] = rewindId;
            },
            getDataRewindFunc: function(ptr) {
                var id = HEAP32[ptr + 8 >> 2];
                var name = Asyncify.callStackIdToName[id];
                var func = Module["asm"][name];
                return func;
            },
            doRewind: function(ptr) {
                var start = Asyncify.getDataRewindFunc(ptr);
                runtimeKeepalivePop();
                return start();
            },
            handleSleep: function(startAsync) {
                if (ABORT) return;
                if (Asyncify.state === Asyncify.State.Normal) {
                    var reachedCallback = false;
                    var reachedAfterCallback = false;
                    startAsync((handleSleepReturnValue = 0)=>{
                        if (ABORT) return;
                        Asyncify.handleSleepReturnValue = handleSleepReturnValue;
                        reachedCallback = true;
                        if (!reachedAfterCallback) return;
                        Asyncify.state = Asyncify.State.Rewinding;
                        runAndAbortIfError(()=>_asyncify_start_rewind(Asyncify.currData));
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.resume();
                        var asyncWasmReturnValue, isError = false;
                        try {
                            asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
                        } catch (err) {
                            asyncWasmReturnValue = err;
                            isError = true;
                        }
                        var handled = false;
                        if (!Asyncify.currData) {
                            var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;
                            if (asyncPromiseHandlers) {
                                Asyncify.asyncPromiseHandlers = null;
                                (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(asyncWasmReturnValue);
                                handled = true;
                            }
                        }
                        if (isError && !handled) throw asyncWasmReturnValue;
                    });
                    reachedAfterCallback = true;
                    if (!reachedCallback) {
                        Asyncify.state = Asyncify.State.Unwinding;
                        Asyncify.currData = Asyncify.allocateData();
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.pause();
                        runAndAbortIfError(()=>_asyncify_start_unwind(Asyncify.currData));
                    }
                } else if (Asyncify.state === Asyncify.State.Rewinding) {
                    Asyncify.state = Asyncify.State.Normal;
                    runAndAbortIfError(_asyncify_stop_rewind);
                    _free(Asyncify.currData);
                    Asyncify.currData = null;
                    Asyncify.sleepCallbacks.forEach((func)=>callUserCallback(func));
                } else abort("invalid state: " + Asyncify.state);
                return Asyncify.handleSleepReturnValue;
            },
            handleAsync: function(startAsync) {
                return Asyncify.handleSleep((wakeUp)=>{
                    startAsync().then(wakeUp);
                });
            }
        };
        function AsciiToString(ptr) {
            var str = "";
            while(true){
                var ch = HEAPU8[ptr++ >> 0];
                if (!ch) return str;
                str += String.fromCharCode(ch);
            }
        }
        var FSNode = function(parent, name, mode, rdev) {
            if (!parent) parent = this;
            this.parent = parent;
            this.mount = parent.mount;
            this.mounted = null;
            this.id = FS.nextInode++;
            this.name = name;
            this.mode = mode;
            this.node_ops = {};
            this.stream_ops = {};
            this.rdev = rdev;
        };
        var readMode = 365;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
            read: {
                get: function() {
                    return (this.mode & readMode) === readMode;
                },
                set: function(val) {
                    val ? this.mode |= readMode : this.mode &= ~readMode;
                }
            },
            write: {
                get: function() {
                    return (this.mode & writeMode) === writeMode;
                },
                set: function(val) {
                    val ? this.mode |= writeMode : this.mode &= ~writeMode;
                }
            },
            isFolder: {
                get: function() {
                    return FS.isDir(this.mode);
                }
            },
            isDevice: {
                get: function() {
                    return FS.isChrdev(this.mode);
                }
            }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        var wasmImports = {
            "O": __asyncjs__emglken_fill_stdin_buffer,
            "ga": ___syscall_dup,
            "fa": ___syscall_faccessat,
            "G": ___syscall_fcntl64,
            "ea": ___syscall_getcwd,
            "da": ___syscall_getdents64,
            "ca": ___syscall_ioctl,
            "ba": ___syscall_lstat64,
            "aa": ___syscall_mkdirat,
            "$": ___syscall_newfstatat,
            "F": ___syscall_openat,
            "_": ___syscall_readlinkat,
            "Z": ___syscall_renameat,
            "E": ___syscall_rmdir,
            "Y": ___syscall_stat64,
            "X": ___syscall_unlinkat,
            "T": __emscripten_get_now_is_monotonic,
            "S": __emscripten_throw_longjmp,
            "R": __gmtime_js,
            "Q": __localtime_js,
            "P": __tzset_js,
            "C": _abort,
            "B": _emscripten_date_now,
            "A": _emscripten_get_now,
            "N": _emscripten_memcpy_big,
            "M": _emscripten_resize_heap,
            "W": _environ_get,
            "V": _environ_sizes_get,
            "y": _exit,
            "w": _fd_close,
            "U": _fd_read,
            "I": _fd_seek,
            "D": _fd_write,
            "L": invoke_i,
            "b": invoke_ii,
            "f": invoke_iii,
            "e": invoke_iiii,
            "c": invoke_iiiii,
            "j": invoke_iiiiii,
            "l": invoke_iiiiiii,
            "m": invoke_iiiiiiii,
            "s": invoke_iiiiiiiii,
            "t": invoke_iiiiiiiiii,
            "p": invoke_iiiiiiiiiii,
            "x": invoke_iiiiiiiiiiii,
            "q": invoke_iiiiiiiiiiiiii,
            "z": invoke_iiiiiiiiiiiiiiii,
            "v": invoke_iiiiiiiiiiiiiiiiii,
            "i": invoke_v,
            "h": invoke_vi,
            "d": invoke_vii,
            "a": invoke_viii,
            "g": invoke_viiii,
            "o": invoke_viiiii,
            "n": invoke_viiiiii,
            "K": invoke_viiiiiii,
            "r": invoke_viiiiiiii,
            "k": invoke_viiiiiiiii,
            "u": invoke_viiiiiiiiiii,
            "J": invoke_viiiiiiiiiiiiiii,
            "H": _strftime
        };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
            return (___wasm_call_ctors = Module["asm"]["ia"]).apply(null, arguments);
        };
        var _malloc = function() {
            return (_malloc = Module["asm"]["ja"]).apply(null, arguments);
        };
        var _free = function() {
            return (_free = Module["asm"]["ka"]).apply(null, arguments);
        };
        var _fflush = Module["_fflush"] = function() {
            return (_fflush = Module["_fflush"] = Module["asm"]["la"]).apply(null, arguments);
        };
        var _main = Module["_main"] = function() {
            return (_main = Module["_main"] = Module["asm"]["ma"]).apply(null, arguments);
        };
        var _gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = function() {
            return (_gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = Module["asm"]["na"]).apply(null, arguments);
        };
        var ___errno_location = function() {
            return (___errno_location = Module["asm"]["oa"]).apply(null, arguments);
        };
        var ___funcs_on_exit = function() {
            return (___funcs_on_exit = Module["asm"]["pa"]).apply(null, arguments);
        };
        var _setThrew = function() {
            return (_setThrew = Module["asm"]["ra"]).apply(null, arguments);
        };
        var _saveSetjmp = function() {
            return (_saveSetjmp = Module["asm"]["saveSetjmp"]).apply(null, arguments);
        };
        var _emscripten_stack_set_limits = function() {
            return (_emscripten_stack_set_limits = Module["asm"]["emscripten_stack_set_limits"]).apply(null, arguments);
        };
        var _emscripten_stack_get_base = function() {
            return (_emscripten_stack_get_base = Module["asm"]["emscripten_stack_get_base"]).apply(null, arguments);
        };
        var _emscripten_stack_get_end = function() {
            return (_emscripten_stack_get_end = Module["asm"]["emscripten_stack_get_end"]).apply(null, arguments);
        };
        var stackSave = function() {
            return (stackSave = Module["asm"]["sa"]).apply(null, arguments);
        };
        var stackRestore = function() {
            return (stackRestore = Module["asm"]["ta"]).apply(null, arguments);
        };
        var stackAlloc = function() {
            return (stackAlloc = Module["asm"]["ua"]).apply(null, arguments);
        };
        var dynCall_iiiii = Module["dynCall_iiiii"] = function() {
            return (dynCall_iiiii = Module["dynCall_iiiii"] = Module["asm"]["va"]).apply(null, arguments);
        };
        var dynCall_ii = Module["dynCall_ii"] = function() {
            return (dynCall_ii = Module["dynCall_ii"] = Module["asm"]["wa"]).apply(null, arguments);
        };
        var dynCall_vi = Module["dynCall_vi"] = function() {
            return (dynCall_vi = Module["dynCall_vi"] = Module["asm"]["xa"]).apply(null, arguments);
        };
        var dynCall_iii = Module["dynCall_iii"] = function() {
            return (dynCall_iii = Module["dynCall_iii"] = Module["asm"]["ya"]).apply(null, arguments);
        };
        var dynCall_viii = Module["dynCall_viii"] = function() {
            return (dynCall_viii = Module["dynCall_viii"] = Module["asm"]["za"]).apply(null, arguments);
        };
        var dynCall_viiiiiiii = Module["dynCall_viiiiiiii"] = function() {
            return (dynCall_viiiiiiii = Module["dynCall_viiiiiiii"] = Module["asm"]["Aa"]).apply(null, arguments);
        };
        var dynCall_vii = Module["dynCall_vii"] = function() {
            return (dynCall_vii = Module["dynCall_vii"] = Module["asm"]["Ba"]).apply(null, arguments);
        };
        var dynCall_viiiii = Module["dynCall_viiiii"] = function() {
            return (dynCall_viiiii = Module["dynCall_viiiii"] = Module["asm"]["Ca"]).apply(null, arguments);
        };
        var dynCall_iiiiii = Module["dynCall_iiiiii"] = function() {
            return (dynCall_iiiiii = Module["dynCall_iiiiii"] = Module["asm"]["Da"]).apply(null, arguments);
        };
        var dynCall_viiiiii = Module["dynCall_viiiiii"] = function() {
            return (dynCall_viiiiii = Module["dynCall_viiiiii"] = Module["asm"]["Ea"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiii = Module["dynCall_iiiiiiiii"] = function() {
            return (dynCall_iiiiiiiii = Module["dynCall_iiiiiiiii"] = Module["asm"]["Fa"]).apply(null, arguments);
        };
        var dynCall_iiii = Module["dynCall_iiii"] = function() {
            return (dynCall_iiii = Module["dynCall_iiii"] = Module["asm"]["Ga"]).apply(null, arguments);
        };
        var dynCall_viiiiiiiii = Module["dynCall_viiiiiiiii"] = function() {
            return (dynCall_viiiiiiiii = Module["dynCall_viiiiiiiii"] = Module["asm"]["Ha"]).apply(null, arguments);
        };
        var dynCall_viiii = Module["dynCall_viiii"] = function() {
            return (dynCall_viiii = Module["dynCall_viiii"] = Module["asm"]["Ia"]).apply(null, arguments);
        };
        var dynCall_iiiiiii = Module["dynCall_iiiiiii"] = function() {
            return (dynCall_iiiiiii = Module["dynCall_iiiiiii"] = Module["asm"]["Ja"]).apply(null, arguments);
        };
        var dynCall_viiiiiiiiiii = Module["dynCall_viiiiiiiiiii"] = function() {
            return (dynCall_viiiiiiiiiii = Module["dynCall_viiiiiiiiiii"] = Module["asm"]["Ka"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiii = Module["dynCall_iiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiii = Module["dynCall_iiiiiiiiii"] = Module["asm"]["La"]).apply(null, arguments);
        };
        var dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = function() {
            return (dynCall_iiiiiiii = Module["dynCall_iiiiiiii"] = Module["asm"]["Ma"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiiii = Module["dynCall_iiiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiiii = Module["dynCall_iiiiiiiiiii"] = Module["asm"]["Na"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiiiiiii = Module["dynCall_iiiiiiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiiiiiii = Module["dynCall_iiiiiiiiiiiiii"] = Module["asm"]["Oa"]).apply(null, arguments);
        };
        var dynCall_v = Module["dynCall_v"] = function() {
            return (dynCall_v = Module["dynCall_v"] = Module["asm"]["Pa"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiiiiiiiiiii = Module["dynCall_iiiiiiiiiiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiiiiiiiiiii = Module["dynCall_iiiiiiiiiiiiiiiiii"] = Module["asm"]["Qa"]).apply(null, arguments);
        };
        var dynCall_viiiiiii = Module["dynCall_viiiiiii"] = function() {
            return (dynCall_viiiiiii = Module["dynCall_viiiiiii"] = Module["asm"]["Ra"]).apply(null, arguments);
        };
        var dynCall_viiiiiiiiiiiiiii = Module["dynCall_viiiiiiiiiiiiiii"] = function() {
            return (dynCall_viiiiiiiiiiiiiii = Module["dynCall_viiiiiiiiiiiiiii"] = Module["asm"]["Sa"]).apply(null, arguments);
        };
        var dynCall_i = Module["dynCall_i"] = function() {
            return (dynCall_i = Module["dynCall_i"] = Module["asm"]["Ta"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiiiii = Module["dynCall_iiiiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiiiii = Module["dynCall_iiiiiiiiiiii"] = Module["asm"]["Ua"]).apply(null, arguments);
        };
        var dynCall_iiiiiiiiiiiiiiii = Module["dynCall_iiiiiiiiiiiiiiii"] = function() {
            return (dynCall_iiiiiiiiiiiiiiii = Module["dynCall_iiiiiiiiiiiiiiii"] = Module["asm"]["Va"]).apply(null, arguments);
        };
        var _asyncify_start_unwind = function() {
            return (_asyncify_start_unwind = Module["asm"]["Wa"]).apply(null, arguments);
        };
        var _asyncify_stop_unwind = function() {
            return (_asyncify_stop_unwind = Module["asm"]["Xa"]).apply(null, arguments);
        };
        var _asyncify_start_rewind = function() {
            return (_asyncify_start_rewind = Module["asm"]["Ya"]).apply(null, arguments);
        };
        var _asyncify_stop_rewind = function() {
            return (_asyncify_stop_rewind = Module["asm"]["Za"]).apply(null, arguments);
        };
        var ___start_em_js = Module["___start_em_js"] = 356528;
        var ___stop_em_js = Module["___stop_em_js"] = 359213;
        function invoke_viii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                dynCall_viii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vii(index, a1, a2) {
            var sp = stackSave();
            try {
                dynCall_vii(index, a1, a2);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiii(index, a1, a2, a3, a4, a5) {
            var sp = stackSave();
            try {
                return dynCall_iiiiii(index, a1, a2, a3, a4, a5);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iii(index, a1, a2) {
            var sp = stackSave();
            try {
                return dynCall_iii(index, a1, a2);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiii(index, a1, a2, a3, a4, a5, a6) {
            var sp = stackSave();
            try {
                dynCall_viiiiii(index, a1, a2, a3, a4, a5, a6);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                return dynCall_iiii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            var sp = stackSave();
            try {
                dynCall_viiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vi(index, a1) {
            var sp = stackSave();
            try {
                dynCall_vi(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                dynCall_viiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_ii(index, a1) {
            var sp = stackSave();
            try {
                return dynCall_ii(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiii(index, a1, a2, a3, a4, a5, a6) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiii(index, a1, a2, a3, a4, a5, a6);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) {
            var sp = stackSave();
            try {
                dynCall_viiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiii(index, a1, a2, a3, a4, a5) {
            var sp = stackSave();
            try {
                dynCall_viiiii(index, a1, a2, a3, a4, a5);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                return dynCall_iiiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiii(index, a1, a2, a3, a4, a5, a6, a7);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_v(index) {
            var sp = stackSave();
            try {
                dynCall_v(index);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8) {
            var sp = stackSave();
            try {
                dynCall_viiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7) {
            var sp = stackSave();
            try {
                dynCall_viiiiiii(index, a1, a2, a3, a4, a5, a6, a7);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) {
            var sp = stackSave();
            try {
                dynCall_viiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_i(index) {
            var sp = stackSave();
            try {
                return dynCall_i(index);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15) {
            var sp = stackSave();
            try {
                return dynCall_iiiiiiiiiiiiiiii(index, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        Module["AsciiToString"] = AsciiToString;
        Module["FS"] = FS;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function callMain(args = []) {
            var entryFunction = _main;
            args.unshift(thisProgram);
            var argc = args.length;
            var argv = stackAlloc((argc + 1) * 4);
            var argv_ptr = argv >> 2;
            args.forEach((arg)=>{
                HEAP32[argv_ptr++] = allocateUTF8OnStack(arg);
            });
            HEAP32[argv_ptr] = 0;
            try {
                var ret = entryFunction(argc, argv);
                exitJS(ret, true);
                return ret;
            } catch (e) {
                return handleException(e);
            }
        }
        function run(args = arguments_) {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                preMain();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                if (shouldRunNow) callMain(args);
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        var shouldRunNow = true;
        if (Module["noInitialRun"]) shouldRunNow = false;
        run();
        return Module.ready;
    };
})();
var $5da5b9828ec10744$export$2e2bcd8739ae039 = $5da5b9828ec10744$var$Module;


class $fe7c55ec16cd7a3a$export$2e2bcd8739ae039 extends (0, $7c4ebf67e8338ec8$export$2e2bcd8739ae039) {
    default_options() {
        return {
            vmcore: (0, $5da5b9828ec10744$export$2e2bcd8739ae039)
        };
    }
}


/*

Emglken port of Scare
=====================

Copyright (c) 2023 Dannii Willis
MIT licenced
https://github.com/curiousdannii/emglken

*/ 
var $9057ad164b194cd9$exports = {};


$9057ad164b194cd9$exports = (parcelRequire("6kBsm")).getBundleURL("ejVIo") + (parcelRequire("n9Yfb")).resolve("iM1SU");


var $504b148d08d37416$var$Module = (()=>{
    var _scriptDir = "file:///node_modules/emglken/build/scare-core.js";
    return function(Module = {}) {
        var Module = typeof Module != "undefined" ? Module : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function(resolve, reject) {
            readyPromiseResolve = resolve;
            readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var arguments_ = [];
        var thisProgram = "./this.program";
        var quit_ = (status, toThrow)=>{
            throw toThrow;
        };
        var ENVIRONMENT_IS_WEB = true;
        var ENVIRONMENT_IS_WORKER = false;
        var scriptDirectory = "";
        function locateFile(path) {
            if (Module["locateFile"]) return Module["locateFile"](path, scriptDirectory);
            return scriptDirectory + path;
        }
        var read_, readAsync, readBinary, setWindowTitle;
        if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
            if (ENVIRONMENT_IS_WORKER) scriptDirectory = self.location.href;
            else if (typeof document != "undefined" && document.currentScript) scriptDirectory = document.currentScript.src;
            if (_scriptDir) scriptDirectory = _scriptDir;
            if (scriptDirectory.indexOf("blob:") !== 0) scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
            else scriptDirectory = "";
            read_ = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.send(null);
                return xhr.responseText;
            };
            if (ENVIRONMENT_IS_WORKER) readBinary = (url)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
            };
            readAsync = (url, onload, onerror)=>{
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "arraybuffer";
                xhr.onload = ()=>{
                    if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                        onload(xhr.response);
                        return;
                    }
                    onerror();
                };
                xhr.onerror = onerror;
                xhr.send(null);
            };
            setWindowTitle = (title)=>document.title = title;
        }
        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) arguments_ = Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || false;
        if (typeof WebAssembly != "object") abort("no native wasm support detected");
        var wasmMemory;
        var ABORT = false;
        var EXITSTATUS;
        function assert(condition, text) {
            if (!condition) abort(text);
        }
        var UTF8Decoder = new TextDecoder("utf8");
        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
            var endIdx = idx + maxBytesToRead;
            var endPtr = idx;
            while(heapOrArray[endPtr] && !(endPtr >= endIdx))++endPtr;
            return UTF8Decoder.decode(heapOrArray.buffer ? heapOrArray.subarray(idx, endPtr) : new Uint8Array(heapOrArray.slice(idx, endPtr)));
        }
        function UTF8ToString(ptr, maxBytesToRead) {
            if (!ptr) return "";
            var maxPtr = ptr + maxBytesToRead;
            for(var end = ptr; !(end >= maxPtr) && HEAPU8[end];)++end;
            return UTF8Decoder.decode(HEAPU8.subarray(ptr, end));
        }
        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
            if (!(maxBytesToWrite > 0)) return 0;
            var startIdx = outIdx;
            var endIdx = outIdx + maxBytesToWrite - 1;
            for(var i = 0; i < str.length; ++i){
                var u = str.charCodeAt(i);
                if (u >= 55296 && u <= 57343) {
                    var u1 = str.charCodeAt(++i);
                    u = 65536 + ((u & 1023) << 10) | u1 & 1023;
                }
                if (u <= 127) {
                    if (outIdx >= endIdx) break;
                    heap[outIdx++] = u;
                } else if (u <= 2047) {
                    if (outIdx + 1 >= endIdx) break;
                    heap[outIdx++] = 192 | u >> 6;
                    heap[outIdx++] = 128 | u & 63;
                } else if (u <= 65535) {
                    if (outIdx + 2 >= endIdx) break;
                    heap[outIdx++] = 224 | u >> 12;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                } else {
                    if (outIdx + 3 >= endIdx) break;
                    heap[outIdx++] = 240 | u >> 18;
                    heap[outIdx++] = 128 | u >> 12 & 63;
                    heap[outIdx++] = 128 | u >> 6 & 63;
                    heap[outIdx++] = 128 | u & 63;
                }
            }
            heap[outIdx] = 0;
            return outIdx - startIdx;
        }
        function stringToUTF8(str, outPtr, maxBytesToWrite) {
            return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }
        function lengthBytesUTF8(str) {
            var len = 0;
            for(var i = 0; i < str.length; ++i){
                var c = str.charCodeAt(i);
                if (c <= 127) len++;
                else if (c <= 2047) len += 2;
                else if (c >= 55296 && c <= 57343) {
                    len += 4;
                    ++i;
                } else len += 3;
            }
            return len;
        }
        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
        function updateMemoryViews() {
            var b = wasmMemory.buffer;
            Module["HEAP8"] = HEAP8 = new Int8Array(b);
            Module["HEAP16"] = HEAP16 = new Int16Array(b);
            Module["HEAP32"] = HEAP32 = new Int32Array(b);
            Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
            Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
            Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
            Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
            Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATMAIN__ = [];
        var __ATEXIT__ = [];
        var __ATPOSTRUN__ = [];
        var runtimeInitialized = false;
        var runtimeExited = false;
        var runtimeKeepaliveCounter = 0;
        function keepRuntimeAlive() {
            return noExitRuntime || runtimeKeepaliveCounter > 0;
        }
        function preRun() {
            if (Module["preRun"]) {
                if (typeof Module["preRun"] == "function") Module["preRun"] = [
                    Module["preRun"]
                ];
                while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
            }
            callRuntimeCallbacks(__ATPRERUN__);
        }
        function initRuntime() {
            runtimeInitialized = true;
            if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
            FS.ignorePermissions = false;
            TTY.init();
            callRuntimeCallbacks(__ATINIT__);
        }
        function preMain() {
            callRuntimeCallbacks(__ATMAIN__);
        }
        function exitRuntime() {
            ___funcs_on_exit();
            callRuntimeCallbacks(__ATEXIT__);
            FS.quit();
            TTY.shutdown();
            runtimeExited = true;
        }
        function postRun() {
            if (Module["postRun"]) {
                if (typeof Module["postRun"] == "function") Module["postRun"] = [
                    Module["postRun"]
                ];
                while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
            }
            callRuntimeCallbacks(__ATPOSTRUN__);
        }
        function addOnPreRun(cb) {
            __ATPRERUN__.unshift(cb);
        }
        function addOnInit(cb) {
            __ATINIT__.unshift(cb);
        }
        function addOnPostRun(cb) {
            __ATPOSTRUN__.unshift(cb);
        }
        var runDependencies = 0;
        var runDependencyWatcher = null;
        var dependenciesFulfilled = null;
        function getUniqueRunDependency(id) {
            return id;
        }
        function addRunDependency(id) {
            runDependencies++;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        }
        function removeRunDependency(id) {
            runDependencies--;
            if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
            if (runDependencies == 0) {
                if (runDependencyWatcher !== null) {
                    clearInterval(runDependencyWatcher);
                    runDependencyWatcher = null;
                }
                if (dependenciesFulfilled) {
                    var callback = dependenciesFulfilled;
                    dependenciesFulfilled = null;
                    callback();
                }
            }
        }
        function abort(what) {
            if (Module["onAbort"]) Module["onAbort"](what);
            what = "Aborted(" + what + ")";
            err(what);
            ABORT = true;
            EXITSTATUS = 1;
            what += ". Build with -sASSERTIONS for more info.";
            var e = new WebAssembly.RuntimeError(what);
            readyPromiseReject(e);
            throw e;
        }
        var dataURIPrefix = "data:application/octet-stream;base64,";
        function isDataURI(filename) {
            return filename.startsWith(dataURIPrefix);
        }
        var wasmBinaryFile;
        if (Module["locateFile"]) {
            wasmBinaryFile = "scare-core.wasm";
            if (!isDataURI(wasmBinaryFile)) wasmBinaryFile = locateFile(wasmBinaryFile);
        } else wasmBinaryFile = new URL($9057ad164b194cd9$exports).href;
        function getBinary(file) {
            try {
                if (file == wasmBinaryFile && wasmBinary) return new Uint8Array(wasmBinary);
                if (readBinary) return readBinary(file);
                throw "both async and sync fetching of the wasm failed";
            } catch (err) {
                abort(err);
            }
        }
        function getBinaryPromise(binaryFile) {
            if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
                if (typeof fetch == "function") return fetch(binaryFile, {
                    credentials: "same-origin"
                }).then(function(response) {
                    if (!response["ok"]) throw "failed to load wasm binary file at '" + binaryFile + "'";
                    return response["arrayBuffer"]();
                }).catch(function() {
                    return getBinary(binaryFile);
                });
            }
            return Promise.resolve().then(function() {
                return getBinary(binaryFile);
            });
        }
        function instantiateArrayBuffer(binaryFile, imports, receiver) {
            return getBinaryPromise(binaryFile).then(function(binary) {
                return WebAssembly.instantiate(binary, imports);
            }).then(function(instance) {
                return instance;
            }).then(receiver, function(reason) {
                err("failed to asynchronously prepare wasm: " + reason);
                abort(reason);
            });
        }
        function instantiateAsync(binary, binaryFile, imports, callback) {
            if (!binary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(binaryFile) && typeof fetch == "function") return fetch(binaryFile, {
                credentials: "same-origin"
            }).then(function(response) {
                var result = WebAssembly.instantiateStreaming(response, imports);
                return result.then(callback, function(reason) {
                    err("wasm streaming compile failed: " + reason);
                    err("falling back to ArrayBuffer instantiation");
                    return instantiateArrayBuffer(binaryFile, imports, callback);
                });
            });
            else return instantiateArrayBuffer(binaryFile, imports, callback);
        }
        function createWasm() {
            var info = {
                "a": wasmImports
            };
            function receiveInstance(instance, module) {
                var exports = instance.exports;
                exports = Asyncify.instrumentWasmExports(exports);
                Module["asm"] = exports;
                wasmMemory = Module["asm"]["E"];
                updateMemoryViews();
                wasmTable = Module["asm"]["N"];
                addOnInit(Module["asm"]["F"]);
                removeRunDependency("wasm-instantiate");
                return exports;
            }
            addRunDependency("wasm-instantiate");
            function receiveInstantiationResult(result) {
                receiveInstance(result["instance"]);
            }
            if (Module["instantiateWasm"]) try {
                return Module["instantiateWasm"](info, receiveInstance);
            } catch (e) {
                err("Module.instantiateWasm callback failed with error: " + e);
                readyPromiseReject(e);
            }
            instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
            return {};
        }
        var tempDouble;
        var tempI64;
        function __asyncjs__emglken_fill_stdin_buffer(buffer, maxlen) {
            return Asyncify.handleAsync(async ()=>{
                if (!Module.emglken_stdin_buffers.length) await new Promise((resolve)=>{
                    Module.emglken_stdin_ready = resolve;
                });
                const input = Module.emglken_stdin_buffers.shift();
                const len = Math.min(input.length, maxlen);
                if (len == input.length) HEAPU8.set(input, buffer);
                else {
                    HEAPU8.set(input.subarray(0, len), buffer);
                    Module.emglken_stdin_buffers.unshift(input.subarray(len));
                }
                return len;
            });
        }
        function ExitStatus(status) {
            this.name = "ExitStatus";
            this.message = "Program terminated with exit(" + status + ")";
            this.status = status;
        }
        function callRuntimeCallbacks(callbacks) {
            while(callbacks.length > 0)callbacks.shift()(Module);
        }
        var PATH = {
            isAbs: (path)=>path.charAt(0) === "/",
            splitPath: (filename)=>{
                var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return splitPathRe.exec(filename).slice(1);
            },
            normalizeArray: (parts, allowAboveRoot)=>{
                var up = 0;
                for(var i = parts.length - 1; i >= 0; i--){
                    var last = parts[i];
                    if (last === ".") parts.splice(i, 1);
                    else if (last === "..") {
                        parts.splice(i, 1);
                        up++;
                    } else if (up) {
                        parts.splice(i, 1);
                        up--;
                    }
                }
                if (allowAboveRoot) for(; up; up--)parts.unshift("..");
                return parts;
            },
            normalize: (path)=>{
                var isAbsolute = PATH.isAbs(path), trailingSlash = path.substr(-1) === "/";
                path = PATH.normalizeArray(path.split("/").filter((p)=>!!p), !isAbsolute).join("/");
                if (!path && !isAbsolute) path = ".";
                if (path && trailingSlash) path += "/";
                return (isAbsolute ? "/" : "") + path;
            },
            dirname: (path)=>{
                var result = PATH.splitPath(path), root = result[0], dir = result[1];
                if (!root && !dir) return ".";
                if (dir) dir = dir.substr(0, dir.length - 1);
                return root + dir;
            },
            basename: (path)=>{
                if (path === "/") return "/";
                path = PATH.normalize(path);
                path = path.replace(/\/$/, "");
                var lastSlash = path.lastIndexOf("/");
                if (lastSlash === -1) return path;
                return path.substr(lastSlash + 1);
            },
            join: function() {
                var paths = Array.prototype.slice.call(arguments);
                return PATH.normalize(paths.join("/"));
            },
            join2: (l, r)=>{
                return PATH.normalize(l + "/" + r);
            }
        };
        function getRandomDevice() {
            if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
                var randomBuffer = new Uint8Array(1);
                return ()=>{
                    crypto.getRandomValues(randomBuffer);
                    return randomBuffer[0];
                };
            } else return ()=>abort("randomDevice");
        }
        var PATH_FS = {
            resolve: function() {
                var resolvedPath = "", resolvedAbsolute = false;
                for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
                    var path = i >= 0 ? arguments[i] : FS.cwd();
                    if (typeof path != "string") throw new TypeError("Arguments to path.resolve must be strings");
                    else if (!path) return "";
                    resolvedPath = path + "/" + resolvedPath;
                    resolvedAbsolute = PATH.isAbs(path);
                }
                resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
                return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
            },
            relative: (from, to)=>{
                from = PATH_FS.resolve(from).substr(1);
                to = PATH_FS.resolve(to).substr(1);
                function trim(arr) {
                    var start = 0;
                    for(; start < arr.length; start++){
                        if (arr[start] !== "") break;
                    }
                    var end = arr.length - 1;
                    for(; end >= 0; end--){
                        if (arr[end] !== "") break;
                    }
                    if (start > end) return [];
                    return arr.slice(start, end - start + 1);
                }
                var fromParts = trim(from.split("/"));
                var toParts = trim(to.split("/"));
                var length = Math.min(fromParts.length, toParts.length);
                var samePartsLength = length;
                for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
                    samePartsLength = i;
                    break;
                }
                var outputParts = [];
                for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
                outputParts = outputParts.concat(toParts.slice(samePartsLength));
                return outputParts.join("/");
            }
        };
        function intArrayFromString(stringy, dontAddNull, length) {
            var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
            var u8array = new Array(len);
            var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
            if (dontAddNull) u8array.length = numBytesWritten;
            return u8array;
        }
        var TTY = {
            ttys: [],
            init: function() {},
            shutdown: function() {},
            register: function(dev, ops) {
                TTY.ttys[dev] = {
                    input: [],
                    output: [],
                    ops: ops
                };
                FS.registerDevice(dev, TTY.stream_ops);
            },
            stream_ops: {
                open: function(stream) {
                    var tty = TTY.ttys[stream.node.rdev];
                    if (!tty) throw new FS.ErrnoError(43);
                    stream.tty = tty;
                    stream.seekable = false;
                },
                close: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                fsync: function(stream) {
                    stream.tty.ops.fsync(stream.tty);
                },
                read: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.get_char) throw new FS.ErrnoError(60);
                    var bytesRead = 0;
                    for(var i = 0; i < length; i++){
                        var result;
                        try {
                            result = stream.tty.ops.get_char(stream.tty);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                        if (result === null || result === undefined) break;
                        bytesRead++;
                        buffer[offset + i] = result;
                    }
                    if (bytesRead) stream.node.timestamp = Date.now();
                    return bytesRead;
                },
                write: function(stream, buffer, offset, length, pos) {
                    if (!stream.tty || !stream.tty.ops.put_char) throw new FS.ErrnoError(60);
                    try {
                        for(var i = 0; i < length; i++)stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                    } catch (e) {
                        throw new FS.ErrnoError(29);
                    }
                    if (length) stream.node.timestamp = Date.now();
                    return i;
                }
            },
            default_tty_ops: {
                get_char: function(tty) {
                    if (!tty.input.length) {
                        var result = null;
                        if (typeof window != "undefined" && typeof window.prompt == "function") {
                            result = window.prompt("Input: ");
                            if (result !== null) result += "\n";
                        } else if (typeof readline == "function") {
                            result = readline();
                            if (result !== null) result += "\n";
                        }
                        if (!result) return null;
                        tty.input = intArrayFromString(result, true);
                    }
                    return tty.input.shift();
                },
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        out(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            },
            default_tty1_ops: {
                put_char: function(tty, val) {
                    if (val === null || val === 10) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    } else if (val != 0) tty.output.push(val);
                },
                fsync: function(tty) {
                    if (tty.output && tty.output.length > 0) {
                        err(UTF8ArrayToString(tty.output, 0));
                        tty.output = [];
                    }
                }
            }
        };
        function mmapAlloc(size) {
            abort();
        }
        var MEMFS = {
            ops_table: null,
            mount: function(mount) {
                return MEMFS.createNode(null, "/", 16895, 0);
            },
            createNode: function(parent, name, mode, dev) {
                if (FS.isBlkdev(mode) || FS.isFIFO(mode)) throw new FS.ErrnoError(63);
                if (!MEMFS.ops_table) MEMFS.ops_table = {
                    dir: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            lookup: MEMFS.node_ops.lookup,
                            mknod: MEMFS.node_ops.mknod,
                            rename: MEMFS.node_ops.rename,
                            unlink: MEMFS.node_ops.unlink,
                            rmdir: MEMFS.node_ops.rmdir,
                            readdir: MEMFS.node_ops.readdir,
                            symlink: MEMFS.node_ops.symlink
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: {
                            llseek: MEMFS.stream_ops.llseek,
                            read: MEMFS.stream_ops.read,
                            write: MEMFS.stream_ops.write,
                            allocate: MEMFS.stream_ops.allocate,
                            mmap: MEMFS.stream_ops.mmap,
                            msync: MEMFS.stream_ops.msync
                        }
                    },
                    link: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr,
                            readlink: MEMFS.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: MEMFS.node_ops.getattr,
                            setattr: MEMFS.node_ops.setattr
                        },
                        stream: FS.chrdev_stream_ops
                    }
                };
                var node = FS.createNode(parent, name, mode, dev);
                if (FS.isDir(node.mode)) {
                    node.node_ops = MEMFS.ops_table.dir.node;
                    node.stream_ops = MEMFS.ops_table.dir.stream;
                    node.contents = {};
                } else if (FS.isFile(node.mode)) {
                    node.node_ops = MEMFS.ops_table.file.node;
                    node.stream_ops = MEMFS.ops_table.file.stream;
                    node.usedBytes = 0;
                    node.contents = null;
                } else if (FS.isLink(node.mode)) {
                    node.node_ops = MEMFS.ops_table.link.node;
                    node.stream_ops = MEMFS.ops_table.link.stream;
                } else if (FS.isChrdev(node.mode)) {
                    node.node_ops = MEMFS.ops_table.chrdev.node;
                    node.stream_ops = MEMFS.ops_table.chrdev.stream;
                }
                node.timestamp = Date.now();
                if (parent) {
                    parent.contents[name] = node;
                    parent.timestamp = node.timestamp;
                }
                return node;
            },
            getFileDataAsTypedArray: function(node) {
                if (!node.contents) return new Uint8Array(0);
                if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
                return new Uint8Array(node.contents);
            },
            expandFileStorage: function(node, newCapacity) {
                var prevCapacity = node.contents ? node.contents.length : 0;
                if (prevCapacity >= newCapacity) return;
                var CAPACITY_DOUBLING_MAX = 1048576;
                newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
                if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
                var oldContents = node.contents;
                node.contents = new Uint8Array(newCapacity);
                if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
            },
            resizeFileStorage: function(node, newSize) {
                if (node.usedBytes == newSize) return;
                if (newSize == 0) {
                    node.contents = null;
                    node.usedBytes = 0;
                } else {
                    var oldContents = node.contents;
                    node.contents = new Uint8Array(newSize);
                    if (oldContents) node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
                    node.usedBytes = newSize;
                }
            },
            node_ops: {
                getattr: function(node) {
                    var attr = {};
                    attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
                    attr.ino = node.id;
                    attr.mode = node.mode;
                    attr.nlink = 1;
                    attr.uid = 0;
                    attr.gid = 0;
                    attr.rdev = node.rdev;
                    if (FS.isDir(node.mode)) attr.size = 4096;
                    else if (FS.isFile(node.mode)) attr.size = node.usedBytes;
                    else if (FS.isLink(node.mode)) attr.size = node.link.length;
                    else attr.size = 0;
                    attr.atime = new Date(node.timestamp);
                    attr.mtime = new Date(node.timestamp);
                    attr.ctime = new Date(node.timestamp);
                    attr.blksize = 4096;
                    attr.blocks = Math.ceil(attr.size / attr.blksize);
                    return attr;
                },
                setattr: function(node, attr) {
                    if (attr.mode !== undefined) node.mode = attr.mode;
                    if (attr.timestamp !== undefined) node.timestamp = attr.timestamp;
                    if (attr.size !== undefined) MEMFS.resizeFileStorage(node, attr.size);
                },
                lookup: function(parent, name) {
                    throw FS.genericErrors[44];
                },
                mknod: function(parent, name, mode, dev) {
                    return MEMFS.createNode(parent, name, mode, dev);
                },
                rename: function(old_node, new_dir, new_name) {
                    if (FS.isDir(old_node.mode)) {
                        var new_node;
                        try {
                            new_node = FS.lookupNode(new_dir, new_name);
                        } catch (e) {}
                        if (new_node) {
                            for(var i in new_node.contents)throw new FS.ErrnoError(55);
                        }
                    }
                    delete old_node.parent.contents[old_node.name];
                    old_node.parent.timestamp = Date.now();
                    old_node.name = new_name;
                    new_dir.contents[new_name] = old_node;
                    new_dir.timestamp = old_node.parent.timestamp;
                    old_node.parent = new_dir;
                },
                unlink: function(parent, name) {
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                rmdir: function(parent, name) {
                    var node = FS.lookupNode(parent, name);
                    for(var i in node.contents)throw new FS.ErrnoError(55);
                    delete parent.contents[name];
                    parent.timestamp = Date.now();
                },
                readdir: function(node) {
                    var entries = [
                        ".",
                        ".."
                    ];
                    for(var key in node.contents){
                        if (!node.contents.hasOwnProperty(key)) continue;
                        entries.push(key);
                    }
                    return entries;
                },
                symlink: function(parent, newname, oldpath) {
                    var node = MEMFS.createNode(parent, newname, 41471, 0);
                    node.link = oldpath;
                    return node;
                },
                readlink: function(node) {
                    if (!FS.isLink(node.mode)) throw new FS.ErrnoError(28);
                    return node.link;
                }
            },
            stream_ops: {
                read: function(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= stream.node.usedBytes) return 0;
                    var size = Math.min(stream.node.usedBytes - position, length);
                    if (size > 8 && contents.subarray) buffer.set(contents.subarray(position, position + size), offset);
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    return size;
                },
                write: function(stream, buffer, offset, length, position, canOwn) {
                    if (buffer.buffer === HEAP8.buffer) canOwn = false;
                    if (!length) return 0;
                    var node = stream.node;
                    node.timestamp = Date.now();
                    if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                        if (canOwn) {
                            node.contents = buffer.subarray(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (node.usedBytes === 0 && position === 0) {
                            node.contents = buffer.slice(offset, offset + length);
                            node.usedBytes = length;
                            return length;
                        } else if (position + length <= node.usedBytes) {
                            node.contents.set(buffer.subarray(offset, offset + length), position);
                            return length;
                        }
                    }
                    MEMFS.expandFileStorage(node, position + length);
                    if (node.contents.subarray && buffer.subarray) node.contents.set(buffer.subarray(offset, offset + length), position);
                    else for(var i = 0; i < length; i++)node.contents[position + i] = buffer[offset + i];
                    node.usedBytes = Math.max(node.usedBytes, position + length);
                    return length;
                },
                llseek: function(stream, offset, whence) {
                    var position = offset;
                    if (whence === 1) position += stream.position;
                    else if (whence === 2) {
                        if (FS.isFile(stream.node.mode)) position += stream.node.usedBytes;
                    }
                    if (position < 0) throw new FS.ErrnoError(28);
                    return position;
                },
                allocate: function(stream, offset, length) {
                    MEMFS.expandFileStorage(stream.node, offset + length);
                    stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
                },
                mmap: function(stream, length, position, prot, flags) {
                    if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                    var ptr;
                    var allocated;
                    var contents = stream.node.contents;
                    if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                        allocated = false;
                        ptr = contents.byteOffset;
                    } else {
                        if (position > 0 || position + length < contents.length) {
                            if (contents.subarray) contents = contents.subarray(position, position + length);
                            else contents = Array.prototype.slice.call(contents, position, position + length);
                        }
                        allocated = true;
                        ptr = mmapAlloc(length);
                        if (!ptr) throw new FS.ErrnoError(48);
                        HEAP8.set(contents, ptr);
                    }
                    return {
                        ptr: ptr,
                        allocated: allocated
                    };
                },
                msync: function(stream, buffer, offset, length, mmapFlags) {
                    MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
                    return 0;
                }
            }
        };
        function asyncLoad(url, onload, onerror, noRunDep) {
            var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
            readAsync(url, (arrayBuffer)=>{
                assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
                onload(new Uint8Array(arrayBuffer));
                if (dep) removeRunDependency(dep);
            }, (event)=>{
                if (onerror) onerror();
                else throw 'Loading data file "' + url + '" failed.';
            });
            if (dep) addRunDependency(dep);
        }
        var FS = {
            root: null,
            mounts: [],
            devices: {},
            streams: [],
            nextInode: 1,
            nameTable: null,
            currentPath: "/",
            initialized: false,
            ignorePermissions: true,
            ErrnoError: null,
            genericErrors: {},
            filesystems: null,
            syncFSRequests: 0,
            lookupPath: (path, opts = {})=>{
                path = PATH_FS.resolve(path);
                if (!path) return {
                    path: "",
                    node: null
                };
                var defaults = {
                    follow_mount: true,
                    recurse_count: 0
                };
                opts = Object.assign(defaults, opts);
                if (opts.recurse_count > 8) throw new FS.ErrnoError(32);
                var parts = path.split("/").filter((p)=>!!p);
                var current = FS.root;
                var current_path = "/";
                for(var i = 0; i < parts.length; i++){
                    var islast = i === parts.length - 1;
                    if (islast && opts.parent) break;
                    current = FS.lookupNode(current, parts[i]);
                    current_path = PATH.join2(current_path, parts[i]);
                    if (FS.isMountpoint(current)) {
                        if (!islast || islast && opts.follow_mount) current = current.mounted.root;
                    }
                    if (!islast || opts.follow) {
                        var count = 0;
                        while(FS.isLink(current.mode)){
                            var link = FS.readlink(current_path);
                            current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                            var lookup = FS.lookupPath(current_path, {
                                recurse_count: opts.recurse_count + 1
                            });
                            current = lookup.node;
                            if (count++ > 40) throw new FS.ErrnoError(32);
                        }
                    }
                }
                return {
                    path: current_path,
                    node: current
                };
            },
            getPath: (node)=>{
                var path;
                while(true){
                    if (FS.isRoot(node)) {
                        var mount = node.mount.mountpoint;
                        if (!path) return mount;
                        return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
                    }
                    path = path ? node.name + "/" + path : node.name;
                    node = node.parent;
                }
            },
            hashName: (parentid, name)=>{
                var hash = 0;
                for(var i = 0; i < name.length; i++)hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
                return (parentid + hash >>> 0) % FS.nameTable.length;
            },
            hashAddNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                node.name_next = FS.nameTable[hash];
                FS.nameTable[hash] = node;
            },
            hashRemoveNode: (node)=>{
                var hash = FS.hashName(node.parent.id, node.name);
                if (FS.nameTable[hash] === node) FS.nameTable[hash] = node.name_next;
                else {
                    var current = FS.nameTable[hash];
                    while(current){
                        if (current.name_next === node) {
                            current.name_next = node.name_next;
                            break;
                        }
                        current = current.name_next;
                    }
                }
            },
            lookupNode: (parent, name)=>{
                var errCode = FS.mayLookup(parent);
                if (errCode) throw new FS.ErrnoError(errCode, parent);
                var hash = FS.hashName(parent.id, name);
                for(var node = FS.nameTable[hash]; node; node = node.name_next){
                    var nodeName = node.name;
                    if (node.parent.id === parent.id && nodeName === name) return node;
                }
                return FS.lookup(parent, name);
            },
            createNode: (parent, name, mode, rdev)=>{
                var node = new FS.FSNode(parent, name, mode, rdev);
                FS.hashAddNode(node);
                return node;
            },
            destroyNode: (node)=>{
                FS.hashRemoveNode(node);
            },
            isRoot: (node)=>{
                return node === node.parent;
            },
            isMountpoint: (node)=>{
                return !!node.mounted;
            },
            isFile: (mode)=>{
                return (mode & 61440) === 32768;
            },
            isDir: (mode)=>{
                return (mode & 61440) === 16384;
            },
            isLink: (mode)=>{
                return (mode & 61440) === 40960;
            },
            isChrdev: (mode)=>{
                return (mode & 61440) === 8192;
            },
            isBlkdev: (mode)=>{
                return (mode & 61440) === 24576;
            },
            isFIFO: (mode)=>{
                return (mode & 61440) === 4096;
            },
            isSocket: (mode)=>{
                return (mode & 49152) === 49152;
            },
            flagModes: {
                "r": 0,
                "r+": 2,
                "w": 577,
                "w+": 578,
                "a": 1089,
                "a+": 1090
            },
            modeStringToFlags: (str)=>{
                var flags = FS.flagModes[str];
                if (typeof flags == "undefined") throw new Error("Unknown file open mode: " + str);
                return flags;
            },
            flagsToPermissionString: (flag)=>{
                var perms = [
                    "r",
                    "w",
                    "rw"
                ][flag & 3];
                if (flag & 512) perms += "w";
                return perms;
            },
            nodePermissions: (node, perms)=>{
                if (FS.ignorePermissions) return 0;
                if (perms.includes("r") && !(node.mode & 292)) return 2;
                else if (perms.includes("w") && !(node.mode & 146)) return 2;
                else if (perms.includes("x") && !(node.mode & 73)) return 2;
                return 0;
            },
            mayLookup: (dir)=>{
                var errCode = FS.nodePermissions(dir, "x");
                if (errCode) return errCode;
                if (!dir.node_ops.lookup) return 2;
                return 0;
            },
            mayCreate: (dir, name)=>{
                try {
                    var node = FS.lookupNode(dir, name);
                    return 20;
                } catch (e) {}
                return FS.nodePermissions(dir, "wx");
            },
            mayDelete: (dir, name, isdir)=>{
                var node;
                try {
                    node = FS.lookupNode(dir, name);
                } catch (e) {
                    return e.errno;
                }
                var errCode = FS.nodePermissions(dir, "wx");
                if (errCode) return errCode;
                if (isdir) {
                    if (!FS.isDir(node.mode)) return 54;
                    if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) return 10;
                } else {
                    if (FS.isDir(node.mode)) return 31;
                }
                return 0;
            },
            mayOpen: (node, flags)=>{
                if (!node) return 44;
                if (FS.isLink(node.mode)) return 32;
                else if (FS.isDir(node.mode)) {
                    if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) return 31;
                }
                return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
            },
            MAX_OPEN_FDS: 4096,
            nextfd: (fd_start = 0, fd_end = FS.MAX_OPEN_FDS)=>{
                for(var fd = fd_start; fd <= fd_end; fd++){
                    if (!FS.streams[fd]) return fd;
                }
                throw new FS.ErrnoError(33);
            },
            getStream: (fd)=>FS.streams[fd],
            createStream: (stream, fd_start, fd_end)=>{
                if (!FS.FSStream) {
                    FS.FSStream = function() {
                        this.shared = {};
                    };
                    FS.FSStream.prototype = {};
                    Object.defineProperties(FS.FSStream.prototype, {
                        object: {
                            get: function() {
                                return this.node;
                            },
                            set: function(val) {
                                this.node = val;
                            }
                        },
                        isRead: {
                            get: function() {
                                return (this.flags & 2097155) !== 1;
                            }
                        },
                        isWrite: {
                            get: function() {
                                return (this.flags & 2097155) !== 0;
                            }
                        },
                        isAppend: {
                            get: function() {
                                return this.flags & 1024;
                            }
                        },
                        flags: {
                            get: function() {
                                return this.shared.flags;
                            },
                            set: function(val) {
                                this.shared.flags = val;
                            }
                        },
                        position: {
                            get: function() {
                                return this.shared.position;
                            },
                            set: function(val) {
                                this.shared.position = val;
                            }
                        }
                    });
                }
                stream = Object.assign(new FS.FSStream(), stream);
                var fd = FS.nextfd(fd_start, fd_end);
                stream.fd = fd;
                FS.streams[fd] = stream;
                return stream;
            },
            closeStream: (fd)=>{
                FS.streams[fd] = null;
            },
            chrdev_stream_ops: {
                open: (stream)=>{
                    var device = FS.getDevice(stream.node.rdev);
                    stream.stream_ops = device.stream_ops;
                    if (stream.stream_ops.open) stream.stream_ops.open(stream);
                },
                llseek: ()=>{
                    throw new FS.ErrnoError(70);
                }
            },
            major: (dev)=>dev >> 8,
            minor: (dev)=>dev & 255,
            makedev: (ma, mi)=>ma << 8 | mi,
            registerDevice: (dev, ops)=>{
                FS.devices[dev] = {
                    stream_ops: ops
                };
            },
            getDevice: (dev)=>FS.devices[dev],
            getMounts: (mount)=>{
                var mounts = [];
                var check = [
                    mount
                ];
                while(check.length){
                    var m = check.pop();
                    mounts.push(m);
                    check.push.apply(check, m.mounts);
                }
                return mounts;
            },
            syncfs: (populate, callback)=>{
                if (typeof populate == "function") {
                    callback = populate;
                    populate = false;
                }
                FS.syncFSRequests++;
                if (FS.syncFSRequests > 1) err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
                var mounts = FS.getMounts(FS.root.mount);
                var completed = 0;
                function doCallback(errCode) {
                    FS.syncFSRequests--;
                    return callback(errCode);
                }
                function done(errCode) {
                    if (errCode) {
                        if (!done.errored) {
                            done.errored = true;
                            return doCallback(errCode);
                        }
                        return;
                    }
                    if (++completed >= mounts.length) doCallback(null);
                }
                mounts.forEach((mount)=>{
                    if (!mount.type.syncfs) return done(null);
                    mount.type.syncfs(mount, populate, done);
                });
            },
            mount: (type, opts, mountpoint)=>{
                var root = mountpoint === "/";
                var pseudo = !mountpoint;
                var node;
                if (root && FS.root) throw new FS.ErrnoError(10);
                else if (!root && !pseudo) {
                    var lookup = FS.lookupPath(mountpoint, {
                        follow_mount: false
                    });
                    mountpoint = lookup.path;
                    node = lookup.node;
                    if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                    if (!FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                }
                var mount = {
                    type: type,
                    opts: opts,
                    mountpoint: mountpoint,
                    mounts: []
                };
                var mountRoot = type.mount(mount);
                mountRoot.mount = mount;
                mount.root = mountRoot;
                if (root) FS.root = mountRoot;
                else if (node) {
                    node.mounted = mount;
                    if (node.mount) node.mount.mounts.push(mount);
                }
                return mountRoot;
            },
            unmount: (mountpoint)=>{
                var lookup = FS.lookupPath(mountpoint, {
                    follow_mount: false
                });
                if (!FS.isMountpoint(lookup.node)) throw new FS.ErrnoError(28);
                var node = lookup.node;
                var mount = node.mounted;
                var mounts = FS.getMounts(mount);
                Object.keys(FS.nameTable).forEach((hash)=>{
                    var current = FS.nameTable[hash];
                    while(current){
                        var next = current.name_next;
                        if (mounts.includes(current.mount)) FS.destroyNode(current);
                        current = next;
                    }
                });
                node.mounted = null;
                var idx = node.mount.mounts.indexOf(mount);
                node.mount.mounts.splice(idx, 1);
            },
            lookup: (parent, name)=>{
                return parent.node_ops.lookup(parent, name);
            },
            mknod: (path, mode, dev)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                if (!name || name === "." || name === "..") throw new FS.ErrnoError(28);
                var errCode = FS.mayCreate(parent, name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.mknod) throw new FS.ErrnoError(63);
                return parent.node_ops.mknod(parent, name, mode, dev);
            },
            create: (path, mode)=>{
                mode = mode !== undefined ? mode : 438;
                mode &= 4095;
                mode |= 32768;
                return FS.mknod(path, mode, 0);
            },
            mkdir: (path, mode)=>{
                mode = mode !== undefined ? mode : 511;
                mode &= 1023;
                mode |= 16384;
                return FS.mknod(path, mode, 0);
            },
            mkdirTree: (path, mode)=>{
                var dirs = path.split("/");
                var d = "";
                for(var i = 0; i < dirs.length; ++i){
                    if (!dirs[i]) continue;
                    d += "/" + dirs[i];
                    try {
                        FS.mkdir(d, mode);
                    } catch (e) {
                        if (e.errno != 20) throw e;
                    }
                }
            },
            mkdev: (path, mode, dev)=>{
                if (typeof dev == "undefined") {
                    dev = mode;
                    mode = 438;
                }
                mode |= 8192;
                return FS.mknod(path, mode, dev);
            },
            symlink: (oldpath, newpath)=>{
                if (!PATH_FS.resolve(oldpath)) throw new FS.ErrnoError(44);
                var lookup = FS.lookupPath(newpath, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var newname = PATH.basename(newpath);
                var errCode = FS.mayCreate(parent, newname);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.symlink) throw new FS.ErrnoError(63);
                return parent.node_ops.symlink(parent, newname, oldpath);
            },
            rename: (old_path, new_path)=>{
                var old_dirname = PATH.dirname(old_path);
                var new_dirname = PATH.dirname(new_path);
                var old_name = PATH.basename(old_path);
                var new_name = PATH.basename(new_path);
                var lookup, old_dir, new_dir;
                lookup = FS.lookupPath(old_path, {
                    parent: true
                });
                old_dir = lookup.node;
                lookup = FS.lookupPath(new_path, {
                    parent: true
                });
                new_dir = lookup.node;
                if (!old_dir || !new_dir) throw new FS.ErrnoError(44);
                if (old_dir.mount !== new_dir.mount) throw new FS.ErrnoError(75);
                var old_node = FS.lookupNode(old_dir, old_name);
                var relative = PATH_FS.relative(old_path, new_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(28);
                relative = PATH_FS.relative(new_path, old_dirname);
                if (relative.charAt(0) !== ".") throw new FS.ErrnoError(55);
                var new_node;
                try {
                    new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}
                if (old_node === new_node) return;
                var isdir = FS.isDir(old_node.mode);
                var errCode = FS.mayDelete(old_dir, old_name, isdir);
                if (errCode) throw new FS.ErrnoError(errCode);
                errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!old_dir.node_ops.rename) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) throw new FS.ErrnoError(10);
                if (new_dir !== old_dir) {
                    errCode = FS.nodePermissions(old_dir, "w");
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                FS.hashRemoveNode(old_node);
                try {
                    old_dir.node_ops.rename(old_node, new_dir, new_name);
                } catch (e) {
                    throw e;
                } finally{
                    FS.hashAddNode(old_node);
                }
            },
            rmdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, true);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.rmdir) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.rmdir(parent, name);
                FS.destroyNode(node);
            },
            readdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node.node_ops.readdir) throw new FS.ErrnoError(54);
                return node.node_ops.readdir(node);
            },
            unlink: (path)=>{
                var lookup = FS.lookupPath(path, {
                    parent: true
                });
                var parent = lookup.node;
                if (!parent) throw new FS.ErrnoError(44);
                var name = PATH.basename(path);
                var node = FS.lookupNode(parent, name);
                var errCode = FS.mayDelete(parent, name, false);
                if (errCode) throw new FS.ErrnoError(errCode);
                if (!parent.node_ops.unlink) throw new FS.ErrnoError(63);
                if (FS.isMountpoint(node)) throw new FS.ErrnoError(10);
                parent.node_ops.unlink(parent, name);
                FS.destroyNode(node);
            },
            readlink: (path)=>{
                var lookup = FS.lookupPath(path);
                var link = lookup.node;
                if (!link) throw new FS.ErrnoError(44);
                if (!link.node_ops.readlink) throw new FS.ErrnoError(28);
                return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
            },
            stat: (path, dontFollow)=>{
                var lookup = FS.lookupPath(path, {
                    follow: !dontFollow
                });
                var node = lookup.node;
                if (!node) throw new FS.ErrnoError(44);
                if (!node.node_ops.getattr) throw new FS.ErrnoError(63);
                return node.node_ops.getattr(node);
            },
            lstat: (path)=>{
                return FS.stat(path, true);
            },
            chmod: (path, mode, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    mode: mode & 4095 | node.mode & -4096,
                    timestamp: Date.now()
                });
            },
            lchmod: (path, mode)=>{
                FS.chmod(path, mode, true);
            },
            fchmod: (fd, mode)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chmod(stream.node, mode);
            },
            chown: (path, uid, gid, dontFollow)=>{
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontFollow
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                node.node_ops.setattr(node, {
                    timestamp: Date.now()
                });
            },
            lchown: (path, uid, gid)=>{
                FS.chown(path, uid, gid, true);
            },
            fchown: (fd, uid, gid)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                FS.chown(stream.node, uid, gid);
            },
            truncate: (path, len)=>{
                if (len < 0) throw new FS.ErrnoError(28);
                var node;
                if (typeof path == "string") {
                    var lookup = FS.lookupPath(path, {
                        follow: true
                    });
                    node = lookup.node;
                } else node = path;
                if (!node.node_ops.setattr) throw new FS.ErrnoError(63);
                if (FS.isDir(node.mode)) throw new FS.ErrnoError(31);
                if (!FS.isFile(node.mode)) throw new FS.ErrnoError(28);
                var errCode = FS.nodePermissions(node, "w");
                if (errCode) throw new FS.ErrnoError(errCode);
                node.node_ops.setattr(node, {
                    size: len,
                    timestamp: Date.now()
                });
            },
            ftruncate: (fd, len)=>{
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(28);
                FS.truncate(stream.node, len);
            },
            utime: (path, atime, mtime)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                node.node_ops.setattr(node, {
                    timestamp: Math.max(atime, mtime)
                });
            },
            open: (path, flags, mode)=>{
                if (path === "") throw new FS.ErrnoError(44);
                flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
                mode = typeof mode == "undefined" ? 438 : mode;
                if (flags & 64) mode = mode & 4095 | 32768;
                else mode = 0;
                var node;
                if (typeof path == "object") node = path;
                else {
                    path = PATH.normalize(path);
                    try {
                        var lookup = FS.lookupPath(path, {
                            follow: !(flags & 131072)
                        });
                        node = lookup.node;
                    } catch (e) {}
                }
                var created = false;
                if (flags & 64) {
                    if (node) {
                        if (flags & 128) throw new FS.ErrnoError(20);
                    } else {
                        node = FS.mknod(path, mode, 0);
                        created = true;
                    }
                }
                if (!node) throw new FS.ErrnoError(44);
                if (FS.isChrdev(node.mode)) flags &= -513;
                if (flags & 65536 && !FS.isDir(node.mode)) throw new FS.ErrnoError(54);
                if (!created) {
                    var errCode = FS.mayOpen(node, flags);
                    if (errCode) throw new FS.ErrnoError(errCode);
                }
                if (flags & 512 && !created) FS.truncate(node, 0);
                flags &= -131713;
                var stream = FS.createStream({
                    node: node,
                    path: FS.getPath(node),
                    flags: flags,
                    seekable: true,
                    position: 0,
                    stream_ops: node.stream_ops,
                    ungotten: [],
                    error: false
                });
                if (stream.stream_ops.open) stream.stream_ops.open(stream);
                if (Module["logReadFiles"] && !(flags & 1)) {
                    if (!FS.readFiles) FS.readFiles = {};
                    if (!(path in FS.readFiles)) FS.readFiles[path] = 1;
                }
                return stream;
            },
            close: (stream)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (stream.getdents) stream.getdents = null;
                try {
                    if (stream.stream_ops.close) stream.stream_ops.close(stream);
                } catch (e) {
                    throw e;
                } finally{
                    FS.closeStream(stream.fd);
                }
                stream.fd = null;
            },
            isClosed: (stream)=>{
                return stream.fd === null;
            },
            llseek: (stream, offset, whence)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (!stream.seekable || !stream.stream_ops.llseek) throw new FS.ErrnoError(70);
                if (whence != 0 && whence != 1 && whence != 2) throw new FS.ErrnoError(28);
                stream.position = stream.stream_ops.llseek(stream, offset, whence);
                stream.ungotten = [];
                return stream.position;
            },
            read: (stream, buffer, offset, length, position)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.read) throw new FS.ErrnoError(28);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
                if (!seeking) stream.position += bytesRead;
                return bytesRead;
            },
            write: (stream, buffer, offset, length, position, canOwn)=>{
                if (length < 0 || position < 0) throw new FS.ErrnoError(28);
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (FS.isDir(stream.node.mode)) throw new FS.ErrnoError(31);
                if (!stream.stream_ops.write) throw new FS.ErrnoError(28);
                if (stream.seekable && stream.flags & 1024) FS.llseek(stream, 0, 2);
                var seeking = typeof position != "undefined";
                if (!seeking) position = stream.position;
                else if (!stream.seekable) throw new FS.ErrnoError(70);
                var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
                if (!seeking) stream.position += bytesWritten;
                return bytesWritten;
            },
            allocate: (stream, offset, length)=>{
                if (FS.isClosed(stream)) throw new FS.ErrnoError(8);
                if (offset < 0 || length <= 0) throw new FS.ErrnoError(28);
                if ((stream.flags & 2097155) === 0) throw new FS.ErrnoError(8);
                if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) throw new FS.ErrnoError(43);
                if (!stream.stream_ops.allocate) throw new FS.ErrnoError(138);
                stream.stream_ops.allocate(stream, offset, length);
            },
            mmap: (stream, length, position, prot, flags)=>{
                if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) throw new FS.ErrnoError(2);
                if ((stream.flags & 2097155) === 1) throw new FS.ErrnoError(2);
                if (!stream.stream_ops.mmap) throw new FS.ErrnoError(43);
                return stream.stream_ops.mmap(stream, length, position, prot, flags);
            },
            msync: (stream, buffer, offset, length, mmapFlags)=>{
                if (!stream.stream_ops.msync) return 0;
                return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
            },
            munmap: (stream)=>0,
            ioctl: (stream, cmd, arg)=>{
                if (!stream.stream_ops.ioctl) throw new FS.ErrnoError(59);
                return stream.stream_ops.ioctl(stream, cmd, arg);
            },
            readFile: (path, opts = {})=>{
                opts.flags = opts.flags || 0;
                opts.encoding = opts.encoding || "binary";
                if (opts.encoding !== "utf8" && opts.encoding !== "binary") throw new Error('Invalid encoding type "' + opts.encoding + '"');
                var ret;
                var stream = FS.open(path, opts.flags);
                var stat = FS.stat(path);
                var length = stat.size;
                var buf = new Uint8Array(length);
                FS.read(stream, buf, 0, length, 0);
                if (opts.encoding === "utf8") ret = UTF8ArrayToString(buf, 0);
                else if (opts.encoding === "binary") ret = buf;
                FS.close(stream);
                return ret;
            },
            writeFile: (path, data, opts = {})=>{
                opts.flags = opts.flags || 577;
                var stream = FS.open(path, opts.flags, opts.mode);
                if (typeof data == "string") {
                    var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
                    var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
                    FS.write(stream, buf, 0, actualNumBytes, undefined, opts.canOwn);
                } else if (ArrayBuffer.isView(data)) FS.write(stream, data, 0, data.byteLength, undefined, opts.canOwn);
                else throw new Error("Unsupported data type");
                FS.close(stream);
            },
            cwd: ()=>FS.currentPath,
            chdir: (path)=>{
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                if (lookup.node === null) throw new FS.ErrnoError(44);
                if (!FS.isDir(lookup.node.mode)) throw new FS.ErrnoError(54);
                var errCode = FS.nodePermissions(lookup.node, "x");
                if (errCode) throw new FS.ErrnoError(errCode);
                FS.currentPath = lookup.path;
            },
            createDefaultDirectories: ()=>{
                FS.mkdir("/tmp");
                FS.mkdir("/home");
                FS.mkdir("/home/web_user");
            },
            createDefaultDevices: ()=>{
                FS.mkdir("/dev");
                FS.registerDevice(FS.makedev(1, 3), {
                    read: ()=>0,
                    write: (stream, buffer, offset, length, pos)=>length
                });
                FS.mkdev("/dev/null", FS.makedev(1, 3));
                TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
                TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
                FS.mkdev("/dev/tty", FS.makedev(5, 0));
                FS.mkdev("/dev/tty1", FS.makedev(6, 0));
                var random_device = getRandomDevice();
                FS.createDevice("/dev", "random", random_device);
                FS.createDevice("/dev", "urandom", random_device);
                FS.mkdir("/dev/shm");
                FS.mkdir("/dev/shm/tmp");
            },
            createSpecialDirectories: ()=>{
                FS.mkdir("/proc");
                var proc_self = FS.mkdir("/proc/self");
                FS.mkdir("/proc/self/fd");
                FS.mount({
                    mount: ()=>{
                        var node = FS.createNode(proc_self, "fd", 16895, 73);
                        node.node_ops = {
                            lookup: (parent, name)=>{
                                var fd = +name;
                                var stream = FS.getStream(fd);
                                if (!stream) throw new FS.ErrnoError(8);
                                var ret = {
                                    parent: null,
                                    mount: {
                                        mountpoint: "fake"
                                    },
                                    node_ops: {
                                        readlink: ()=>stream.path
                                    }
                                };
                                ret.parent = ret;
                                return ret;
                            }
                        };
                        return node;
                    }
                }, {}, "/proc/self/fd");
            },
            createStandardStreams: ()=>{
                if (Module["stdin"]) FS.createDevice("/dev", "stdin", Module["stdin"]);
                else FS.symlink("/dev/tty", "/dev/stdin");
                if (Module["stdout"]) FS.createDevice("/dev", "stdout", null, Module["stdout"]);
                else FS.symlink("/dev/tty", "/dev/stdout");
                if (Module["stderr"]) FS.createDevice("/dev", "stderr", null, Module["stderr"]);
                else FS.symlink("/dev/tty1", "/dev/stderr");
                var stdin = FS.open("/dev/stdin", 0);
                var stdout = FS.open("/dev/stdout", 1);
                var stderr = FS.open("/dev/stderr", 1);
            },
            ensureErrnoError: ()=>{
                if (FS.ErrnoError) return;
                FS.ErrnoError = function ErrnoError(errno, node) {
                    this.name = "ErrnoError";
                    this.node = node;
                    this.setErrno = function(errno) {
                        this.errno = errno;
                    };
                    this.setErrno(errno);
                    this.message = "FS error";
                };
                FS.ErrnoError.prototype = new Error();
                FS.ErrnoError.prototype.constructor = FS.ErrnoError;
                [
                    44
                ].forEach((code)=>{
                    FS.genericErrors[code] = new FS.ErrnoError(code);
                    FS.genericErrors[code].stack = "<generic error, no stack>";
                });
            },
            staticInit: ()=>{
                FS.ensureErrnoError();
                FS.nameTable = new Array(4096);
                FS.mount(MEMFS, {}, "/");
                FS.createDefaultDirectories();
                FS.createDefaultDevices();
                FS.createSpecialDirectories();
                FS.filesystems = {
                    "MEMFS": MEMFS
                };
            },
            init: (input, output, error)=>{
                FS.init.initialized = true;
                FS.ensureErrnoError();
                Module["stdin"] = input || Module["stdin"];
                Module["stdout"] = output || Module["stdout"];
                Module["stderr"] = error || Module["stderr"];
                FS.createStandardStreams();
            },
            quit: ()=>{
                FS.init.initialized = false;
                _fflush(0);
                for(var i = 0; i < FS.streams.length; i++){
                    var stream = FS.streams[i];
                    if (!stream) continue;
                    FS.close(stream);
                }
            },
            getMode: (canRead, canWrite)=>{
                var mode = 0;
                if (canRead) mode |= 365;
                if (canWrite) mode |= 146;
                return mode;
            },
            findObject: (path, dontResolveLastLink)=>{
                var ret = FS.analyzePath(path, dontResolveLastLink);
                if (!ret.exists) return null;
                return ret.object;
            },
            analyzePath: (path, dontResolveLastLink)=>{
                try {
                    var lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    path = lookup.path;
                } catch (e) {}
                var ret = {
                    isRoot: false,
                    exists: false,
                    error: 0,
                    name: null,
                    path: null,
                    object: null,
                    parentExists: false,
                    parentPath: null,
                    parentObject: null
                };
                try {
                    var lookup = FS.lookupPath(path, {
                        parent: true
                    });
                    ret.parentExists = true;
                    ret.parentPath = lookup.path;
                    ret.parentObject = lookup.node;
                    ret.name = PATH.basename(path);
                    lookup = FS.lookupPath(path, {
                        follow: !dontResolveLastLink
                    });
                    ret.exists = true;
                    ret.path = lookup.path;
                    ret.object = lookup.node;
                    ret.name = lookup.node.name;
                    ret.isRoot = lookup.path === "/";
                } catch (e) {
                    ret.error = e.errno;
                }
                return ret;
            },
            createPath: (parent, path, canRead, canWrite)=>{
                parent = typeof parent == "string" ? parent : FS.getPath(parent);
                var parts = path.split("/").reverse();
                while(parts.length){
                    var part = parts.pop();
                    if (!part) continue;
                    var current = PATH.join2(parent, part);
                    try {
                        FS.mkdir(current);
                    } catch (e) {}
                    parent = current;
                }
                return current;
            },
            createFile: (parent, name, properties, canRead, canWrite)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(canRead, canWrite);
                return FS.create(path, mode);
            },
            createDataFile: (parent, name, data, canRead, canWrite, canOwn)=>{
                var path = name;
                if (parent) {
                    parent = typeof parent == "string" ? parent : FS.getPath(parent);
                    path = name ? PATH.join2(parent, name) : parent;
                }
                var mode = FS.getMode(canRead, canWrite);
                var node = FS.create(path, mode);
                if (data) {
                    if (typeof data == "string") {
                        var arr = new Array(data.length);
                        for(var i = 0, len = data.length; i < len; ++i)arr[i] = data.charCodeAt(i);
                        data = arr;
                    }
                    FS.chmod(node, mode | 146);
                    var stream = FS.open(node, 577);
                    FS.write(stream, data, 0, data.length, 0, canOwn);
                    FS.close(stream);
                    FS.chmod(node, mode);
                }
                return node;
            },
            createDevice: (parent, name, input, output)=>{
                var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
                var mode = FS.getMode(!!input, !!output);
                if (!FS.createDevice.major) FS.createDevice.major = 64;
                var dev = FS.makedev(FS.createDevice.major++, 0);
                FS.registerDevice(dev, {
                    open: (stream)=>{
                        stream.seekable = false;
                    },
                    close: (stream)=>{
                        if (output && output.buffer && output.buffer.length) output(10);
                    },
                    read: (stream, buffer, offset, length, pos)=>{
                        var bytesRead = 0;
                        for(var i = 0; i < length; i++){
                            var result;
                            try {
                                result = input();
                            } catch (e) {
                                throw new FS.ErrnoError(29);
                            }
                            if (result === undefined && bytesRead === 0) throw new FS.ErrnoError(6);
                            if (result === null || result === undefined) break;
                            bytesRead++;
                            buffer[offset + i] = result;
                        }
                        if (bytesRead) stream.node.timestamp = Date.now();
                        return bytesRead;
                    },
                    write: (stream, buffer, offset, length, pos)=>{
                        for(var i = 0; i < length; i++)try {
                            output(buffer[offset + i]);
                        } catch (e) {
                            throw new FS.ErrnoError(29);
                        }
                        if (length) stream.node.timestamp = Date.now();
                        return i;
                    }
                });
                return FS.mkdev(path, mode, dev);
            },
            forceLoadFile: (obj)=>{
                if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;
                if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                else if (read_) try {
                    obj.contents = intArrayFromString(read_(obj.url), true);
                    obj.usedBytes = obj.contents.length;
                } catch (e) {
                    throw new FS.ErrnoError(29);
                }
                else throw new Error("Cannot load without read() or XMLHttpRequest.");
            },
            createLazyFile: (parent, name, url, canRead, canWrite)=>{
                function LazyUint8Array() {
                    this.lengthKnown = false;
                    this.chunks = [];
                }
                LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
                    if (idx > this.length - 1 || idx < 0) return undefined;
                    var chunkOffset = idx % this.chunkSize;
                    var chunkNum = idx / this.chunkSize | 0;
                    return this.getter(chunkNum)[chunkOffset];
                };
                LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
                    this.getter = getter;
                };
                LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
                    var xhr = new XMLHttpRequest();
                    xhr.open("HEAD", url, false);
                    xhr.send(null);
                    if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                    var datalength = Number(xhr.getResponseHeader("Content-length"));
                    var header;
                    var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
                    var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
                    var chunkSize = 1048576;
                    if (!hasByteServing) chunkSize = datalength;
                    var doXHR = (from, to)=>{
                        if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                        if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, false);
                        if (datalength !== chunkSize) xhr.setRequestHeader("Range", "bytes=" + from + "-" + to);
                        xhr.responseType = "arraybuffer";
                        if (xhr.overrideMimeType) xhr.overrideMimeType("text/plain; charset=x-user-defined");
                        xhr.send(null);
                        if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
                        if (xhr.response !== undefined) return new Uint8Array(xhr.response || []);
                        return intArrayFromString(xhr.responseText || "", true);
                    };
                    var lazyArray = this;
                    lazyArray.setDataGetter((chunkNum)=>{
                        var start = chunkNum * chunkSize;
                        var end = (chunkNum + 1) * chunkSize - 1;
                        end = Math.min(end, datalength - 1);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") lazyArray.chunks[chunkNum] = doXHR(start, end);
                        if (typeof lazyArray.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                        return lazyArray.chunks[chunkNum];
                    });
                    if (usesGzip || !datalength) {
                        chunkSize = datalength = 1;
                        datalength = this.getter(0).length;
                        chunkSize = datalength;
                        out("LazyFiles on gzip forces download of the whole file when length is accessed");
                    }
                    this._length = datalength;
                    this._chunkSize = chunkSize;
                    this.lengthKnown = true;
                };
                if (typeof XMLHttpRequest != "undefined") {
                    if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                    var lazyArray = new LazyUint8Array();
                    Object.defineProperties(lazyArray, {
                        length: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._length;
                            }
                        },
                        chunkSize: {
                            get: function() {
                                if (!this.lengthKnown) this.cacheLength();
                                return this._chunkSize;
                            }
                        }
                    });
                    var properties = {
                        isDevice: false,
                        contents: lazyArray
                    };
                } else var properties = {
                    isDevice: false,
                    url: url
                };
                var node = FS.createFile(parent, name, properties, canRead, canWrite);
                if (properties.contents) node.contents = properties.contents;
                else if (properties.url) {
                    node.contents = null;
                    node.url = properties.url;
                }
                Object.defineProperties(node, {
                    usedBytes: {
                        get: function() {
                            return this.contents.length;
                        }
                    }
                });
                var stream_ops = {};
                var keys = Object.keys(node.stream_ops);
                keys.forEach((key)=>{
                    var fn = node.stream_ops[key];
                    stream_ops[key] = function forceLoadLazyFile() {
                        FS.forceLoadFile(node);
                        return fn.apply(null, arguments);
                    };
                });
                function writeChunks(stream, buffer, offset, length, position) {
                    var contents = stream.node.contents;
                    if (position >= contents.length) return 0;
                    var size = Math.min(contents.length - position, length);
                    if (contents.slice) for(var i = 0; i < size; i++)buffer[offset + i] = contents[position + i];
                    else for(var i = 0; i < size; i++)buffer[offset + i] = contents.get(position + i);
                    return size;
                }
                stream_ops.read = (stream, buffer, offset, length, position)=>{
                    FS.forceLoadFile(node);
                    return writeChunks(stream, buffer, offset, length, position);
                };
                stream_ops.mmap = (stream, length, position, prot, flags)=>{
                    FS.forceLoadFile(node);
                    var ptr = mmapAlloc(length);
                    if (!ptr) throw new FS.ErrnoError(48);
                    writeChunks(stream, HEAP8, ptr, length, position);
                    return {
                        ptr: ptr,
                        allocated: true
                    };
                };
                node.stream_ops = stream_ops;
                return node;
            },
            createPreloadedFile: (parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish)=>{
                var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;
                var dep = getUniqueRunDependency("cp " + fullname);
                function processData(byteArray) {
                    function finish(byteArray) {
                        if (preFinish) preFinish();
                        if (!dontCreateFile) FS.createDataFile(parent, name, byteArray, canRead, canWrite, canOwn);
                        if (onload) onload();
                        removeRunDependency(dep);
                    }
                    if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, ()=>{
                        if (onerror) onerror();
                        removeRunDependency(dep);
                    })) return;
                    finish(byteArray);
                }
                addRunDependency(dep);
                if (typeof url == "string") asyncLoad(url, (byteArray)=>processData(byteArray), onerror);
                else processData(url);
            },
            indexedDB: ()=>{
                return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
            },
            DB_NAME: ()=>{
                return "EM_FS_" + window.location.pathname;
            },
            DB_VERSION: 20,
            DB_STORE_NAME: "FILE_DATA",
            saveFilesToDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = ()=>{
                    out("creating db");
                    var db = openRequest.result;
                    db.createObjectStore(FS.DB_STORE_NAME);
                };
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    var transaction = db.transaction([
                        FS.DB_STORE_NAME
                    ], "readwrite");
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var putRequest = files.put(FS.analyzePath(path).object.contents, path);
                        putRequest.onsuccess = ()=>{
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        putRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            },
            loadFilesFromDB: (paths, onload = ()=>{}, onerror = ()=>{})=>{
                var indexedDB = FS.indexedDB();
                try {
                    var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
                } catch (e) {
                    return onerror(e);
                }
                openRequest.onupgradeneeded = onerror;
                openRequest.onsuccess = ()=>{
                    var db = openRequest.result;
                    try {
                        var transaction = db.transaction([
                            FS.DB_STORE_NAME
                        ], "readonly");
                    } catch (e) {
                        onerror(e);
                        return;
                    }
                    var files = transaction.objectStore(FS.DB_STORE_NAME);
                    var ok = 0, fail = 0, total = paths.length;
                    function finish() {
                        if (fail == 0) onload();
                        else onerror();
                    }
                    paths.forEach((path)=>{
                        var getRequest = files.get(path);
                        getRequest.onsuccess = ()=>{
                            if (FS.analyzePath(path).exists) FS.unlink(path);
                            FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                            ok++;
                            if (ok + fail == total) finish();
                        };
                        getRequest.onerror = ()=>{
                            fail++;
                            if (ok + fail == total) finish();
                        };
                    });
                    transaction.onerror = onerror;
                };
                openRequest.onerror = onerror;
            }
        };
        var SYSCALLS = {
            DEFAULT_POLLMASK: 5,
            calculateAt: function(dirfd, path, allowEmpty) {
                if (PATH.isAbs(path)) return path;
                var dir;
                if (dirfd === -100) dir = FS.cwd();
                else {
                    var dirstream = SYSCALLS.getStreamFromFD(dirfd);
                    dir = dirstream.path;
                }
                if (path.length == 0) {
                    if (!allowEmpty) throw new FS.ErrnoError(44);
                    return dir;
                }
                return PATH.join2(dir, path);
            },
            doStat: function(func, path, buf) {
                try {
                    var stat = func(path);
                } catch (e) {
                    if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) return -54;
                    throw e;
                }
                HEAP32[buf >> 2] = stat.dev;
                HEAP32[buf + 8 >> 2] = stat.ino;
                HEAP32[buf + 12 >> 2] = stat.mode;
                HEAPU32[buf + 16 >> 2] = stat.nlink;
                HEAP32[buf + 20 >> 2] = stat.uid;
                HEAP32[buf + 24 >> 2] = stat.gid;
                HEAP32[buf + 28 >> 2] = stat.rdev;
                tempI64 = [
                    stat.size >>> 0,
                    (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 40 >> 2] = tempI64[0], HEAP32[buf + 44 >> 2] = tempI64[1];
                HEAP32[buf + 48 >> 2] = 4096;
                HEAP32[buf + 52 >> 2] = stat.blocks;
                var atime = stat.atime.getTime();
                var mtime = stat.mtime.getTime();
                var ctime = stat.ctime.getTime();
                tempI64 = [
                    Math.floor(atime / 1e3) >>> 0,
                    (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 56 >> 2] = tempI64[0], HEAP32[buf + 60 >> 2] = tempI64[1];
                HEAPU32[buf + 64 >> 2] = atime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(mtime / 1e3) >>> 0,
                    (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 72 >> 2] = tempI64[0], HEAP32[buf + 76 >> 2] = tempI64[1];
                HEAPU32[buf + 80 >> 2] = mtime % 1e3 * 1e3;
                tempI64 = [
                    Math.floor(ctime / 1e3) >>> 0,
                    (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 88 >> 2] = tempI64[0], HEAP32[buf + 92 >> 2] = tempI64[1];
                HEAPU32[buf + 96 >> 2] = ctime % 1e3 * 1e3;
                tempI64 = [
                    stat.ino >>> 0,
                    (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[buf + 104 >> 2] = tempI64[0], HEAP32[buf + 108 >> 2] = tempI64[1];
                return 0;
            },
            doMsync: function(addr, stream, len, flags, offset) {
                if (!FS.isFile(stream.node.mode)) throw new FS.ErrnoError(43);
                if (flags & 2) return 0;
                var buffer = HEAPU8.slice(addr, addr + len);
                FS.msync(stream, buffer, offset, len, flags);
            },
            varargs: undefined,
            get: function() {
                SYSCALLS.varargs += 4;
                var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
                return ret;
            },
            getStr: function(ptr) {
                var ret = UTF8ToString(ptr);
                return ret;
            },
            getStreamFromFD: function(fd) {
                var stream = FS.getStream(fd);
                if (!stream) throw new FS.ErrnoError(8);
                return stream;
            }
        };
        function ___syscall_faccessat(dirfd, path, amode, flags) {
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                if (amode & -8) return -28;
                var lookup = FS.lookupPath(path, {
                    follow: true
                });
                var node = lookup.node;
                if (!node) return -44;
                var perms = "";
                if (amode & 4) perms += "r";
                if (amode & 2) perms += "w";
                if (amode & 1) perms += "x";
                if (perms && FS.nodePermissions(node, perms)) return -2;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function setErrNo(value) {
            HEAP32[___errno_location() >> 2] = value;
            return value;
        }
        function ___syscall_fcntl64(fd, cmd, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(cmd){
                    case 0:
                        var arg = SYSCALLS.get();
                        if (arg < 0) return -28;
                        var newStream;
                        newStream = FS.createStream(stream, arg);
                        return newStream.fd;
                    case 1:
                    case 2:
                        return 0;
                    case 3:
                        return stream.flags;
                    case 4:
                        var arg = SYSCALLS.get();
                        stream.flags |= arg;
                        return 0;
                    case 5:
                        var arg = SYSCALLS.get();
                        var offset = 0;
                        HEAP16[arg + offset >> 1] = 2;
                        return 0;
                    case 6:
                    case 7:
                        return 0;
                    case 16:
                    case 8:
                        return -28;
                    case 9:
                        setErrNo(28);
                        return -1;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_getcwd(buf, size) {
            try {
                if (size === 0) return -28;
                var cwd = FS.cwd();
                var cwdLengthInBytes = lengthBytesUTF8(cwd) + 1;
                if (size < cwdLengthInBytes) return -68;
                stringToUTF8(cwd, buf, size);
                return cwdLengthInBytes;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_ioctl(fd, op, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                switch(op){
                    case 21509:
                    case 21505:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21510:
                    case 21511:
                    case 21512:
                    case 21506:
                    case 21507:
                    case 21508:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21519:
                        if (!stream.tty) return -59;
                        var argp = SYSCALLS.get();
                        HEAP32[argp >> 2] = 0;
                        return 0;
                    case 21520:
                        if (!stream.tty) return -59;
                        return -28;
                    case 21531:
                        var argp = SYSCALLS.get();
                        return FS.ioctl(stream, op, argp);
                    case 21523:
                        if (!stream.tty) return -59;
                        return 0;
                    case 21524:
                        if (!stream.tty) return -59;
                        return 0;
                    default:
                        return -28;
                }
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_openat(dirfd, path, flags, varargs) {
            SYSCALLS.varargs = varargs;
            try {
                path = SYSCALLS.getStr(path);
                path = SYSCALLS.calculateAt(dirfd, path);
                var mode = varargs ? SYSCALLS.get() : 0;
                return FS.open(path, flags, mode).fd;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        function ___syscall_stat64(path, buf) {
            try {
                path = SYSCALLS.getStr(path);
                return SYSCALLS.doStat(FS.stat, path, buf);
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return -e.errno;
            }
        }
        var nowIsMonotonic = true;
        function __emscripten_get_now_is_monotonic() {
            return nowIsMonotonic;
        }
        function __emscripten_throw_longjmp() {
            throw Infinity;
        }
        function _abort() {
            abort("");
        }
        function _emscripten_date_now() {
            return Date.now();
        }
        var _emscripten_get_now;
        _emscripten_get_now = ()=>performance.now();
        function _emscripten_memcpy_big(dest, src, num) {
            HEAPU8.copyWithin(dest, src, src + num);
        }
        function getHeapMax() {
            return 2147483648;
        }
        function emscripten_realloc_buffer(size) {
            var b = wasmMemory.buffer;
            try {
                wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
                updateMemoryViews();
                return 1;
            } catch (e) {}
        }
        function _emscripten_resize_heap(requestedSize) {
            var oldSize = HEAPU8.length;
            requestedSize = requestedSize >>> 0;
            var maxHeapSize = getHeapMax();
            if (requestedSize > maxHeapSize) return false;
            let alignUp = (x, multiple)=>x + (multiple - x % multiple) % multiple;
            for(var cutDown = 1; cutDown <= 4; cutDown *= 2){
                var overGrownHeapSize = oldSize * (1 + .2 / cutDown);
                overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
                var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
                var replacement = emscripten_realloc_buffer(newSize);
                if (replacement) return true;
            }
            return false;
        }
        var ENV = {};
        function getExecutableName() {
            return thisProgram || "./this.program";
        }
        function getEnvStrings() {
            if (!getEnvStrings.strings) {
                var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
                var env = {
                    "USER": "web_user",
                    "LOGNAME": "web_user",
                    "PATH": "/",
                    "PWD": "/",
                    "HOME": "/home/web_user",
                    "LANG": lang,
                    "_": getExecutableName()
                };
                for(var x in ENV)if (ENV[x] === undefined) delete env[x];
                else env[x] = ENV[x];
                var strings = [];
                for(var x in env)strings.push(x + "=" + env[x]);
                getEnvStrings.strings = strings;
            }
            return getEnvStrings.strings;
        }
        function writeAsciiToMemory(str, buffer, dontAddNull) {
            for(var i = 0; i < str.length; ++i)HEAP8[buffer++ >> 0] = str.charCodeAt(i);
            if (!dontAddNull) HEAP8[buffer >> 0] = 0;
        }
        function _environ_get(__environ, environ_buf) {
            var bufSize = 0;
            getEnvStrings().forEach(function(string, i) {
                var ptr = environ_buf + bufSize;
                HEAPU32[__environ + i * 4 >> 2] = ptr;
                writeAsciiToMemory(string, ptr);
                bufSize += string.length + 1;
            });
            return 0;
        }
        function _environ_sizes_get(penviron_count, penviron_buf_size) {
            var strings = getEnvStrings();
            HEAPU32[penviron_count >> 2] = strings.length;
            var bufSize = 0;
            strings.forEach(function(string) {
                bufSize += string.length + 1;
            });
            HEAPU32[penviron_buf_size >> 2] = bufSize;
            return 0;
        }
        function _proc_exit(code) {
            EXITSTATUS = code;
            if (!keepRuntimeAlive()) {
                if (Module["onExit"]) Module["onExit"](code);
                ABORT = true;
            }
            quit_(code, new ExitStatus(code));
        }
        function exitJS(status, implicit) {
            EXITSTATUS = status;
            if (!keepRuntimeAlive()) exitRuntime();
            _proc_exit(status);
        }
        var _exit = exitJS;
        function _fd_close(fd) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.close(stream);
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doReadv(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.read(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (curr < len) break;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_read(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doReadv(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function convertI32PairToI53Checked(lo, hi) {
            return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }
        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
            try {
                var offset = convertI32PairToI53Checked(offset_low, offset_high);
                if (isNaN(offset)) return 61;
                var stream = SYSCALLS.getStreamFromFD(fd);
                FS.llseek(stream, offset, whence);
                tempI64 = [
                    stream.position >>> 0,
                    (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[newOffset >> 2] = tempI64[0], HEAP32[newOffset + 4 >> 2] = tempI64[1];
                if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function doWritev(stream, iov, iovcnt, offset) {
            var ret = 0;
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAPU32[iov >> 2];
                var len = HEAPU32[iov + 4 >> 2];
                iov += 8;
                var curr = FS.write(stream, HEAP8, ptr, len, offset);
                if (curr < 0) return -1;
                ret += curr;
                if (typeof offset !== "undefined") offset += curr;
            }
            return ret;
        }
        function _fd_write(fd, iov, iovcnt, pnum) {
            try {
                var stream = SYSCALLS.getStreamFromFD(fd);
                var num = doWritev(stream, iov, iovcnt);
                HEAPU32[pnum >> 2] = num;
                return 0;
            } catch (e) {
                if (typeof FS == "undefined" || !(e.name === "ErrnoError")) throw e;
                return e.errno;
            }
        }
        function handleException(e) {
            if (e instanceof ExitStatus || e == "unwind") return EXITSTATUS;
            quit_(1, e);
        }
        function allocateUTF8OnStack(str) {
            var size = lengthBytesUTF8(str) + 1;
            var ret = stackAlloc(size);
            stringToUTF8Array(str, HEAP8, ret, size);
            return ret;
        }
        function runAndAbortIfError(func) {
            try {
                return func();
            } catch (e) {
                abort(e);
            }
        }
        function maybeExit() {
            if (!keepRuntimeAlive()) try {
                _exit(EXITSTATUS);
            } catch (e) {
                handleException(e);
            }
        }
        function callUserCallback(func) {
            if (runtimeExited || ABORT) return;
            try {
                func();
                maybeExit();
            } catch (e) {
                handleException(e);
            }
        }
        function runtimeKeepalivePush() {
            runtimeKeepaliveCounter += 1;
        }
        function runtimeKeepalivePop() {
            runtimeKeepaliveCounter -= 1;
        }
        var Asyncify = {
            instrumentWasmImports: function(imports) {
                var ASYNCIFY_IMPORTS = [
                    "invoke_*",
                    "emscripten_sleep",
                    "emscripten_wget",
                    "emscripten_wget_data",
                    "emscripten_idb_load",
                    "emscripten_idb_store",
                    "emscripten_idb_delete",
                    "emscripten_idb_exists",
                    "emscripten_idb_load_blob",
                    "emscripten_idb_store_blob",
                    "SDL_Delay",
                    "emscripten_scan_registers",
                    "emscripten_lazy_load_code",
                    "emscripten_fiber_swap",
                    "__load_secondary_module",
                    "fd_sync",
                    "__wasi_fd_sync",
                    "_emval_await",
                    "_dlopen_js",
                    "__asyncjs__*"
                ];
                for(var x in imports)(function(x) {
                    var original = imports[x];
                    var sig = original.sig;
                    if (typeof original == "function") var isAsyncifyImport = ASYNCIFY_IMPORTS.indexOf(x) >= 0 || x.startsWith("__asyncjs__");
                })(x);
            },
            instrumentWasmExports: function(exports) {
                var ret = {};
                for(var x in exports)(function(x) {
                    var original = exports[x];
                    if (typeof original == "function") ret[x] = function() {
                        Asyncify.exportCallStack.push(x);
                        try {
                            return original.apply(null, arguments);
                        } finally{
                            if (!ABORT) {
                                var y = Asyncify.exportCallStack.pop();
                                assert(y === x);
                                Asyncify.maybeStopUnwind();
                            }
                        }
                    };
                    else ret[x] = original;
                })(x);
                return ret;
            },
            State: {
                Normal: 0,
                Unwinding: 1,
                Rewinding: 2,
                Disabled: 3
            },
            state: 0,
            StackSize: 8192,
            currData: null,
            handleSleepReturnValue: 0,
            exportCallStack: [],
            callStackNameToId: {},
            callStackIdToName: {},
            callStackId: 0,
            asyncPromiseHandlers: null,
            sleepCallbacks: [],
            getCallStackId: function(funcName) {
                var id = Asyncify.callStackNameToId[funcName];
                if (id === undefined) {
                    id = Asyncify.callStackId++;
                    Asyncify.callStackNameToId[funcName] = id;
                    Asyncify.callStackIdToName[id] = funcName;
                }
                return id;
            },
            maybeStopUnwind: function() {
                if (Asyncify.currData && Asyncify.state === Asyncify.State.Unwinding && Asyncify.exportCallStack.length === 0) {
                    Asyncify.state = Asyncify.State.Normal;
                    runtimeKeepalivePush();
                    runAndAbortIfError(_asyncify_stop_unwind);
                    if (typeof Fibers != "undefined") Fibers.trampoline();
                }
            },
            whenDone: function() {
                return new Promise((resolve, reject)=>{
                    Asyncify.asyncPromiseHandlers = {
                        resolve: resolve,
                        reject: reject
                    };
                });
            },
            allocateData: function() {
                var ptr = _malloc(12 + Asyncify.StackSize);
                Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
                Asyncify.setDataRewindFunc(ptr);
                return ptr;
            },
            setDataHeader: function(ptr, stack, stackSize) {
                HEAP32[ptr >> 2] = stack;
                HEAP32[ptr + 4 >> 2] = stack + stackSize;
            },
            setDataRewindFunc: function(ptr) {
                var bottomOfCallStack = Asyncify.exportCallStack[0];
                var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
                HEAP32[ptr + 8 >> 2] = rewindId;
            },
            getDataRewindFunc: function(ptr) {
                var id = HEAP32[ptr + 8 >> 2];
                var name = Asyncify.callStackIdToName[id];
                var func = Module["asm"][name];
                return func;
            },
            doRewind: function(ptr) {
                var start = Asyncify.getDataRewindFunc(ptr);
                runtimeKeepalivePop();
                return start();
            },
            handleSleep: function(startAsync) {
                if (ABORT) return;
                if (Asyncify.state === Asyncify.State.Normal) {
                    var reachedCallback = false;
                    var reachedAfterCallback = false;
                    startAsync((handleSleepReturnValue = 0)=>{
                        if (ABORT) return;
                        Asyncify.handleSleepReturnValue = handleSleepReturnValue;
                        reachedCallback = true;
                        if (!reachedAfterCallback) return;
                        Asyncify.state = Asyncify.State.Rewinding;
                        runAndAbortIfError(()=>_asyncify_start_rewind(Asyncify.currData));
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.resume();
                        var asyncWasmReturnValue, isError = false;
                        try {
                            asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
                        } catch (err) {
                            asyncWasmReturnValue = err;
                            isError = true;
                        }
                        var handled = false;
                        if (!Asyncify.currData) {
                            var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;
                            if (asyncPromiseHandlers) {
                                Asyncify.asyncPromiseHandlers = null;
                                (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(asyncWasmReturnValue);
                                handled = true;
                            }
                        }
                        if (isError && !handled) throw asyncWasmReturnValue;
                    });
                    reachedAfterCallback = true;
                    if (!reachedCallback) {
                        Asyncify.state = Asyncify.State.Unwinding;
                        Asyncify.currData = Asyncify.allocateData();
                        if (typeof Browser != "undefined" && Browser.mainLoop.func) Browser.mainLoop.pause();
                        runAndAbortIfError(()=>_asyncify_start_unwind(Asyncify.currData));
                    }
                } else if (Asyncify.state === Asyncify.State.Rewinding) {
                    Asyncify.state = Asyncify.State.Normal;
                    runAndAbortIfError(_asyncify_stop_rewind);
                    _free(Asyncify.currData);
                    Asyncify.currData = null;
                    Asyncify.sleepCallbacks.forEach((func)=>callUserCallback(func));
                } else abort("invalid state: " + Asyncify.state);
                return Asyncify.handleSleepReturnValue;
            },
            handleAsync: function(startAsync) {
                return Asyncify.handleSleep((wakeUp)=>{
                    startAsync().then(wakeUp);
                });
            }
        };
        function AsciiToString(ptr) {
            var str = "";
            while(true){
                var ch = HEAPU8[ptr++ >> 0];
                if (!ch) return str;
                str += String.fromCharCode(ch);
            }
        }
        var FSNode = function(parent, name, mode, rdev) {
            if (!parent) parent = this;
            this.parent = parent;
            this.mount = parent.mount;
            this.mounted = null;
            this.id = FS.nextInode++;
            this.name = name;
            this.mode = mode;
            this.node_ops = {};
            this.stream_ops = {};
            this.rdev = rdev;
        };
        var readMode = 365;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
            read: {
                get: function() {
                    return (this.mode & readMode) === readMode;
                },
                set: function(val) {
                    val ? this.mode |= readMode : this.mode &= ~readMode;
                }
            },
            write: {
                get: function() {
                    return (this.mode & writeMode) === writeMode;
                },
                set: function(val) {
                    val ? this.mode |= writeMode : this.mode &= ~writeMode;
                }
            },
            isFolder: {
                get: function() {
                    return FS.isDir(this.mode);
                }
            },
            isDevice: {
                get: function() {
                    return FS.isChrdev(this.mode);
                }
            }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        var wasmImports = {
            "s": __asyncjs__emglken_fill_stdin_buffer,
            "D": ___syscall_faccessat,
            "n": ___syscall_fcntl64,
            "C": ___syscall_getcwd,
            "B": ___syscall_ioctl,
            "A": ___syscall_openat,
            "z": ___syscall_stat64,
            "v": __emscripten_get_now_is_monotonic,
            "u": __emscripten_throw_longjmp,
            "t": _abort,
            "k": _emscripten_date_now,
            "r": _emscripten_memcpy_big,
            "q": _emscripten_resize_heap,
            "y": _environ_get,
            "x": _environ_sizes_get,
            "i": _exit,
            "m": _fd_close,
            "w": _fd_read,
            "p": _fd_seek,
            "l": _fd_write,
            "c": invoke_i,
            "g": invoke_ii,
            "f": invoke_iiii,
            "d": invoke_iiiii,
            "o": invoke_ji,
            "j": invoke_v,
            "b": invoke_vi,
            "a": invoke_vii,
            "h": invoke_viii,
            "e": invoke_viiii
        };
        var asm = createWasm();
        var ___wasm_call_ctors = function() {
            return (___wasm_call_ctors = Module["asm"]["F"]).apply(null, arguments);
        };
        var _free = function() {
            return (_free = Module["asm"]["G"]).apply(null, arguments);
        };
        var _malloc = function() {
            return (_malloc = Module["asm"]["H"]).apply(null, arguments);
        };
        var _main = Module["_main"] = function() {
            return (_main = Module["_main"] = Module["asm"]["I"]).apply(null, arguments);
        };
        var _gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = function() {
            return (_gidispatch_get_game_id = Module["_gidispatch_get_game_id"] = Module["asm"]["J"]).apply(null, arguments);
        };
        var _fflush = Module["_fflush"] = function() {
            return (_fflush = Module["_fflush"] = Module["asm"]["K"]).apply(null, arguments);
        };
        var ___errno_location = function() {
            return (___errno_location = Module["asm"]["L"]).apply(null, arguments);
        };
        var ___funcs_on_exit = function() {
            return (___funcs_on_exit = Module["asm"]["M"]).apply(null, arguments);
        };
        var _setThrew = function() {
            return (_setThrew = Module["asm"]["O"]).apply(null, arguments);
        };
        var _saveSetjmp = function() {
            return (_saveSetjmp = Module["asm"]["saveSetjmp"]).apply(null, arguments);
        };
        var _emscripten_stack_set_limits = function() {
            return (_emscripten_stack_set_limits = Module["asm"]["emscripten_stack_set_limits"]).apply(null, arguments);
        };
        var _emscripten_stack_get_base = function() {
            return (_emscripten_stack_get_base = Module["asm"]["emscripten_stack_get_base"]).apply(null, arguments);
        };
        var _emscripten_stack_get_end = function() {
            return (_emscripten_stack_get_end = Module["asm"]["emscripten_stack_get_end"]).apply(null, arguments);
        };
        var stackSave = function() {
            return (stackSave = Module["asm"]["P"]).apply(null, arguments);
        };
        var stackRestore = function() {
            return (stackRestore = Module["asm"]["Q"]).apply(null, arguments);
        };
        var stackAlloc = function() {
            return (stackAlloc = Module["asm"]["R"]).apply(null, arguments);
        };
        var dynCall_vi = Module["dynCall_vi"] = function() {
            return (dynCall_vi = Module["dynCall_vi"] = Module["asm"]["S"]).apply(null, arguments);
        };
        var dynCall_iiii = Module["dynCall_iiii"] = function() {
            return (dynCall_iiii = Module["dynCall_iiii"] = Module["asm"]["T"]).apply(null, arguments);
        };
        var dynCall_ii = Module["dynCall_ii"] = function() {
            return (dynCall_ii = Module["dynCall_ii"] = Module["asm"]["U"]).apply(null, arguments);
        };
        var dynCall_vii = Module["dynCall_vii"] = function() {
            return (dynCall_vii = Module["dynCall_vii"] = Module["asm"]["V"]).apply(null, arguments);
        };
        var dynCall_i = Module["dynCall_i"] = function() {
            return (dynCall_i = Module["dynCall_i"] = Module["asm"]["W"]).apply(null, arguments);
        };
        var dynCall_v = Module["dynCall_v"] = function() {
            return (dynCall_v = Module["dynCall_v"] = Module["asm"]["X"]).apply(null, arguments);
        };
        var dynCall_iiiii = Module["dynCall_iiiii"] = function() {
            return (dynCall_iiiii = Module["dynCall_iiiii"] = Module["asm"]["Y"]).apply(null, arguments);
        };
        var dynCall_viii = Module["dynCall_viii"] = function() {
            return (dynCall_viii = Module["dynCall_viii"] = Module["asm"]["Z"]).apply(null, arguments);
        };
        var dynCall_viiii = Module["dynCall_viiii"] = function() {
            return (dynCall_viiii = Module["dynCall_viiii"] = Module["asm"]["_"]).apply(null, arguments);
        };
        var dynCall_ji = Module["dynCall_ji"] = function() {
            return (dynCall_ji = Module["dynCall_ji"] = Module["asm"]["$"]).apply(null, arguments);
        };
        var _asyncify_start_unwind = function() {
            return (_asyncify_start_unwind = Module["asm"]["aa"]).apply(null, arguments);
        };
        var _asyncify_stop_unwind = function() {
            return (_asyncify_stop_unwind = Module["asm"]["ba"]).apply(null, arguments);
        };
        var _asyncify_start_rewind = function() {
            return (_asyncify_start_rewind = Module["asm"]["ca"]).apply(null, arguments);
        };
        var _asyncify_stop_rewind = function() {
            return (_asyncify_stop_rewind = Module["asm"]["da"]).apply(null, arguments);
        };
        var ___start_em_js = Module["___start_em_js"] = 107504;
        var ___stop_em_js = Module["___stop_em_js"] = 110189;
        function invoke_ii(index, a1) {
            var sp = stackSave();
            try {
                return dynCall_ii(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vii(index, a1, a2) {
            var sp = stackSave();
            try {
                dynCall_vii(index, a1, a2);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_i(index) {
            var sp = stackSave();
            try {
                return dynCall_i(index);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_v(index) {
            var sp = stackSave();
            try {
                dynCall_v(index);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_vi(index, a1) {
            var sp = stackSave();
            try {
                dynCall_vi(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                return dynCall_iiiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                dynCall_viii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_iiii(index, a1, a2, a3) {
            var sp = stackSave();
            try {
                return dynCall_iiii(index, a1, a2, a3);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_viiii(index, a1, a2, a3, a4) {
            var sp = stackSave();
            try {
                dynCall_viiii(index, a1, a2, a3, a4);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        function invoke_ji(index, a1) {
            var sp = stackSave();
            try {
                return dynCall_ji(index, a1);
            } catch (e) {
                stackRestore(sp);
                if (e !== e + 0) throw e;
                _setThrew(1, 0);
            }
        }
        Module["AsciiToString"] = AsciiToString;
        Module["FS"] = FS;
        var calledRun;
        dependenciesFulfilled = function runCaller() {
            if (!calledRun) run();
            if (!calledRun) dependenciesFulfilled = runCaller;
        };
        function callMain(args = []) {
            var entryFunction = _main;
            args.unshift(thisProgram);
            var argc = args.length;
            var argv = stackAlloc((argc + 1) * 4);
            var argv_ptr = argv >> 2;
            args.forEach((arg)=>{
                HEAP32[argv_ptr++] = allocateUTF8OnStack(arg);
            });
            HEAP32[argv_ptr] = 0;
            try {
                var ret = entryFunction(argc, argv);
                exitJS(ret, true);
                return ret;
            } catch (e) {
                return handleException(e);
            }
        }
        function run(args = arguments_) {
            if (runDependencies > 0) return;
            preRun();
            if (runDependencies > 0) return;
            function doRun() {
                if (calledRun) return;
                calledRun = true;
                Module["calledRun"] = true;
                if (ABORT) return;
                initRuntime();
                preMain();
                readyPromiseResolve(Module);
                if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
                if (shouldRunNow) callMain(args);
                postRun();
            }
            if (Module["setStatus"]) {
                Module["setStatus"]("Running...");
                setTimeout(function() {
                    setTimeout(function() {
                        Module["setStatus"]("");
                    }, 1);
                    doRun();
                }, 1);
            } else doRun();
        }
        if (Module["preInit"]) {
            if (typeof Module["preInit"] == "function") Module["preInit"] = [
                Module["preInit"]
            ];
            while(Module["preInit"].length > 0)Module["preInit"].pop()();
        }
        var shouldRunNow = true;
        if (Module["noInitialRun"]) shouldRunNow = false;
        run();
        return Module.ready;
    };
})();
var $504b148d08d37416$export$2e2bcd8739ae039 = $504b148d08d37416$var$Module;


class $707ef77e10663475$export$2e2bcd8739ae039 extends (0, $7c4ebf67e8338ec8$export$2e2bcd8739ae039) {
    default_options() {
        return {
            vmcore: (0, $504b148d08d37416$export$2e2bcd8739ae039)
        };
    }
}


const $11084da5888c7d7e$var$formats = [
    {
        id: "bocfel",
        extensions: /z([3458]|blorb)$/,
        engine: (0, $cc564b5c889ac118$export$2e2bcd8739ae039)
    },
    {
        id: "git",
        extensions: /(gblorb|ulx)$/,
        engine: (0, $724db3da43d21d57$export$2e2bcd8739ae039)
    },
    {
        id: "hugo",
        extensions: /hex$/,
        engine: (0, $93f872a37763fb75$export$2e2bcd8739ae039)
    },
    {
        id: "scare",
        extensions: /taf$/,
        engine: (0, $707ef77e10663475$export$2e2bcd8739ae039)
    },
    {
        id: "tads",
        extensions: /(gam|t3)$/,
        engine: (0, $fe7c55ec16cd7a3a$export$2e2bcd8739ae039)
    }
];
const $11084da5888c7d7e$export$1784a1ff765207b7 = (filename)=>{
    const format = $11084da5888c7d7e$var$formats.find((x)=>x.extensions.test(filename));
    if (format) return {
        ...format,
        /* @see staticFiles in package.json */ wasmBinaryName: `emglken/${format.id}-core.wasm`
    };
    throw new Error("Unsupported file type");
};




/**
 * @see: https://github.com/curiousdannii/glkote-term/blob/master/src/glkote-dumb.js
 * @see: https://github.com/curiousdannii/glkote-term/blob/master/src/electrofs.js
 */ class $5e25d1360d04c823$var$FakeDialog {
    constructor(handlers, loggers){
        this.streaming = false;
        this.handlers = handlers;
        this.loggers = loggers;
    }
    file_ref_exists({ usage: usage }) {
        return usage === "save" ? true : false;
    }
    file_remove_ref() {
        return true;
    }
    file_construct_ref(filename, usage) {
        return {
            filename: filename,
            usage: usage || ""
        };
    }
    file_read(dirent, israw) {
        return this.handlers.onFileRead(dirent, israw);
    }
    file_write(dirent, content, israw) {
        if (content.length === 0) return void 0;
        this.handlers.onFileWrite(dirent, content, israw);
    }
    open(tosave, usage, gameid, callback) {
        this.handlers.onFileNameRequest(tosave, usage, gameid, callback);
    }
    log(message) {
        this.loggers.log(message);
    }
    warning(message) {
        this.loggers.warn(message);
    }
    error(message) {
        this.loggers.error(message);
    }
}
var $5e25d1360d04c823$export$2e2bcd8739ae039 = $5e25d1360d04c823$var$FakeDialog;


/**
 * @see: https://github.com/curiousdannii/glkote-term/blob/master/src/glkote-dumb.js
 */ /**
 * @see: https://github.com/curiousdannii/glkote-term/blob/master/src/glkote-term.js
 */ class $640511b266482529$var$GlkOte {
    constructor({ width: width, height: height }){
        this.width = width;
        this.height = height;
        this.current_metrics = null;
        this.disabled = false;
        this.generation = 0;
        this.interface = null;
        this.version = "0.5.1";
    }
    measure_window() {
        return {
            width: this.width,
            height: this.height,
            buffercharheight: 1,
            buffercharwidth: 1,
            buffermarginx: 0,
            buffermarginy: 0,
            graphicsmarginx: 0,
            graphicsmarginy: 0,
            gridcharheight: 1,
            gridcharwidth: 1,
            gridmarginx: 0,
            gridmarginy: 0,
            inspacingx: 0,
            inspacingy: 0,
            outspacingx: 0,
            outspacingy: 0
        };
    }
    getinterface() {
        return this.interface;
    }
    init(iface) {
        if (!iface) this.error("No game interface object has been provided.");
        if (!iface.accept) this.error("The game interface object must have an accept() function.");
        this.interface = iface;
        this.current_metrics = this.measure_window();
        this.send_response("init", null, this.current_metrics);
    }
    update(data) {
        if (data.type === "error") this.error(data.message);
        if (data.type === "pass") return;
        if (data.type !== "update" && data.type !== "exit") {
            this.log(`Ignoring unknown message type: ${data.type}`);
            return;
        }
        if (data.gen === this.generation) {
            this.log(`Ignoring repeated generation number: ${data.gen}`);
            return;
        }
        if (data.gen < this.generation) {
            this.log(`Ignoring out-of-order generation number: got ${data.gen}, currently at ${this.generation}`);
            return;
        }
        this.generation = data.gen;
        if (this.disabled) this.disable(false);
        /* Handle the update */ if (data.input != null) this.cancel_inputs(data.input);
        if (data.windows != null) this.update_windows(data.windows);
        if (data.content != null && data.content.length) this.update_content(data.content);
        if (data.input != null) this.update_inputs(data.input);
        /* Disable everything if requested */ this.disabled = false;
        if (data.disabled || data.specialinput) this.disable(true);
        if (data.specialinput != null) this.accept_specialinput(data.specialinput);
        /* Detach all handlers and exit */ if (data.type === "exit") this.exit();
    }
    send_response(type, win, val, val2) {
        const res = {
            type: type,
            gen: this.generation
        };
        if (win) res.window = win.id;
        if (type === "init" || type === "arrange") res.metrics = val;
        if (type === "init") res.support = this.support();
        if (type === "char") res.value = val;
        if (type === "line") res.value = val;
        if (type === "specialresponse") {
            res.response = val;
            res.value = val2;
        }
        this.interface.accept(res);
    }
    support() {
        return [];
    }
}
var $640511b266482529$export$2e2bcd8739ae039 = $640511b266482529$var$GlkOte;


class $25e930408cddd3f8$var$CheapGlkOte extends (0, $640511b266482529$export$2e2bcd8739ae039) {
    constructor(handlers, loggers, size){
        super(size);
        this.handlers = handlers;
        this.loggers = loggers;
    }
    sendFn(message, type, window) {
        this.send_response(type, window, message);
    }
    init(iface) {
        this.handlers.onInit();
        super.init(iface);
    }
    update_inputs(data) {
        if (!data.length) return [];
        this.handlers.onUpdateInputs(data);
    }
    accept_specialinput(data) {
        if (data.type === "fileref_prompt") {
            const callback = (ref)=>this.send_response("specialresponse", null, "fileref_prompt", ref);
            this.interface.Dialog.open(data.filemode !== "read", data.filetype, data.gameid, callback);
        } else this.error("Request for unknown special input type: " + data.type);
    }
    update_content(messages) {
        this.handlers.onUpdateContent(messages);
    }
    exit() {
        this.handlers.onExit();
        super.exit();
    }
    cancel_inputs(data) {
        this.handlers.onUpdateInputs(data);
    }
    disable(data) {
        this.handlers.onDisable(data);
    }
    update_windows(windows) {
        this.handlers.onUpdateWindows(windows);
    }
    log(message) {
        this.loggers.log(message);
    }
    warning(message) {
        this.loggers.warn(message);
    }
    error(message) {
        this.loggers.error(message);
    }
}
var $25e930408cddd3f8$export$2e2bcd8739ae039 = $25e930408cddd3f8$var$CheapGlkOte;


const $db6ac6276ae4f3e4$var$noop = ()=>void 0;
const $db6ac6276ae4f3e4$var$defaultHandlers = [
    "onInit",
    "onUpdateWindows",
    "onUpdateInputs",
    "onUpdateContent",
    "onDisable",
    "onFileNameRequest",
    "onFileRead",
    "onFileWrite",
    "onExit"
].reduce((acc, x)=>(acc[x] = $db6ac6276ae4f3e4$var$noop, acc), {});
const $db6ac6276ae4f3e4$var$defaultLoggers = {
    log: console.log,
    warning: console.warn,
    error: console.error
};
const $db6ac6276ae4f3e4$var$defaultSize = {
    width: 80,
    height: 25
};
var $db6ac6276ae4f3e4$export$2e2bcd8739ae039 = (handlers_, { loggers: loggers_, size: size_ } = {})=>{
    const handlers = Object.assign({}, $db6ac6276ae4f3e4$var$defaultHandlers, handlers_);
    const loggers = Object.assign({}, $db6ac6276ae4f3e4$var$defaultLoggers, loggers_);
    const size = Object.assign({}, $db6ac6276ae4f3e4$var$defaultSize, size_);
    const Dialog = new (0, $5e25d1360d04c823$export$2e2bcd8739ae039)(handlers, loggers);
    const GlkOte = new (0, $25e930408cddd3f8$export$2e2bcd8739ae039)(handlers, loggers, size);
    const send = GlkOte.sendFn.bind(GlkOte);
    return {
        Dialog: Dialog,
        GlkOte: GlkOte,
        send: send
    };
};





var $7742cff3645aa0b6$exports = {};

$parcel$export($7742cff3645aa0b6$exports, "emphasized", function () { return $7742cff3645aa0b6$export$1ee2ee71de083e4d; }, function (v) { return $7742cff3645aa0b6$export$1ee2ee71de083e4d = v; });
$parcel$export($7742cff3645aa0b6$exports, "input", function () { return $7742cff3645aa0b6$export$b7e3ae3d7c15e42e; }, function (v) { return $7742cff3645aa0b6$export$b7e3ae3d7c15e42e = v; });
$parcel$export($7742cff3645aa0b6$exports, "message", function () { return $7742cff3645aa0b6$export$a8ecead220dd38a6; }, function (v) { return $7742cff3645aa0b6$export$a8ecead220dd38a6 = v; });
$parcel$export($7742cff3645aa0b6$exports, "scrollTarget", function () { return $7742cff3645aa0b6$export$64cbebf88d5f7b08; }, function (v) { return $7742cff3645aa0b6$export$64cbebf88d5f7b08 = v; });
$parcel$export($7742cff3645aa0b6$exports, "subheader", function () { return $7742cff3645aa0b6$export$d61e5f8e032e1547; }, function (v) { return $7742cff3645aa0b6$export$d61e5f8e032e1547 = v; });
var $7742cff3645aa0b6$export$1ee2ee71de083e4d;
var $7742cff3645aa0b6$export$b7e3ae3d7c15e42e;
var $7742cff3645aa0b6$export$a8ecead220dd38a6;
var $7742cff3645aa0b6$export$64cbebf88d5f7b08;
var $7742cff3645aa0b6$export$d61e5f8e032e1547;
$7742cff3645aa0b6$export$1ee2ee71de083e4d = `hBGgUq_emphasized`;
$7742cff3645aa0b6$export$b7e3ae3d7c15e42e = `hBGgUq_input`;
$7742cff3645aa0b6$export$a8ecead220dd38a6 = `hBGgUq_message`;
$7742cff3645aa0b6$export$64cbebf88d5f7b08 = `hBGgUq_scrollTarget`;
$7742cff3645aa0b6$export$d61e5f8e032e1547 = `hBGgUq_subheader`;


function $0f82f0e8d6bc47f2$export$2e2bcd8739ae039({ style: style, text: text }) {
    const defaultContent = /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("span", {
        className: [
            $7742cff3645aa0b6$exports.message,
            $7742cff3645aa0b6$exports[style]
        ].join(" "),
        children: text
    });
    return ({
        grid: text?.length > 0 ? /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
            children: text
        }) : /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {}),
        input: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("span", {
            className: [
                $7742cff3645aa0b6$exports.message,
                $7742cff3645aa0b6$exports.input
            ].join(" "),
            children: [
                "> ",
                text
            ]
        }),
        subheader: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("strong", {
            className: [
                $7742cff3645aa0b6$exports.message,
                $7742cff3645aa0b6$exports.subheader
            ].join(" "),
            children: text
        }),
        emphasized: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("em", {
            className: [
                $7742cff3645aa0b6$exports.message,
                $7742cff3645aa0b6$exports.emphasized
            ].join(" "),
            children: text
        }),
        scrollTarget: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
            className: [
                $7742cff3645aa0b6$exports.scrollTarget,
                style
            ].join(" ")
        }),
        endOfLine: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("br", {})
    })[style] || defaultContent;
}


var $7264401512871bae$export$ab1029bcae9ddb4a;
var $7264401512871bae$export$d7f0ba9e5e132b36;
var $7264401512871bae$export$347a3a46df242257;
var $7264401512871bae$export$c789db2c85949867;
var $7264401512871bae$export$6181eef8f2dfdf3c;
$7264401512871bae$export$ab1029bcae9ddb4a = `PwGQsW_buffer`;
$7264401512871bae$export$d7f0ba9e5e132b36 = `PwGQsW_elseifplayer`;
$7264401512871bae$export$347a3a46df242257 = `PwGQsW_gridBuffer`;
$7264401512871bae$export$c789db2c85949867 = `PwGQsW_output`;
$7264401512871bae$export$6181eef8f2dfdf3c = `PwGQsW_textBuffer`;


const $c5dda773199830f0$var$eol = {
    style: "endOfLine"
};
const $c5dda773199830f0$var$scrollTarget = {
    style: "scrollTarget"
};
const $c5dda773199830f0$var$isFakeStatus = (w)=>w.height < 5;
const $c5dda773199830f0$var$trimInputPrompt = (messages)=>messages.length < 1 ? messages : messages.slice(-1)[0].text === ">" ? messages.slice(0, messages.length - 1) : messages;
const $c5dda773199830f0$var$parseInbox = (inbox, currentWindow)=>{
    const currentInbox = inbox.find(({ id: id })=>id === currentWindow.id);
    if (!currentInbox) return {
        clear: false,
        incoming: [
            $c5dda773199830f0$var$scrollTarget
        ]
    };
    const { text: inboxMessagesRaw } = currentInbox;
    const incoming = inboxMessagesRaw/* Normalize. */ .map(({ content: content })=>content ? [
            ...$c5dda773199830f0$var$trimInputPrompt(content),
            $c5dda773199830f0$var$eol
        ] : [
            $c5dda773199830f0$var$eol
        ])/* Flatten. */ .reduce((acc, x)=>acc.concat(x), [
        $c5dda773199830f0$var$scrollTarget
    ]);
    return {
        incoming: incoming,
        clear: $c5dda773199830f0$var$isFakeStatus(currentWindow) ? true : currentInbox.clear
    };
};
function $c5dda773199830f0$export$2e2bcd8739ae039({ inbox: inbox, currentWindow: currentWindow }) {
    const [messages, setMessages] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)([]);
    const textBufferEl = (0, $5c5fa90583e4b8e8$export$b8f5890fc79d6aca)(null);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        const { incoming: incoming, clear: clear } = $c5dda773199830f0$var$parseInbox(inbox, currentWindow);
        setMessages((messages)=>clear ? incoming : messages.concat(incoming));
        setTimeout(()=>{
            const scrollTargets = textBufferEl.current.querySelectorAll(`.${$c5dda773199830f0$var$scrollTarget.style}`);
            const freshScrollTarget = scrollTargets[scrollTargets.length - 1];
            freshScrollTarget ? freshScrollTarget.scrollIntoView() : textBufferEl.current.scrollTo({
                top: textBufferEl.current.scrollHeight,
                behavior: "smooth"
            });
        }, 0);
    }, [
        currentWindow,
        inbox
    ]);
    const classes = ()=>[
            $7264401512871bae$export$ab1029bcae9ddb4a,
            $c5dda773199830f0$var$isFakeStatus(currentWindow) ? $7264401512871bae$export$347a3a46df242257 : $7264401512871bae$export$6181eef8f2dfdf3c
        ].join(" ");
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
        tabindex: "0",
        ref: textBufferEl,
        className: classes(),
        children: messages.map((0, $0f82f0e8d6bc47f2$export$2e2bcd8739ae039))
    });
}






function $272a9a66be55229e$export$2e2bcd8739ae039({ inbox: inbox, currentWindow: currentWindow }) {
    const [prevMessages, setPrevMessages] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)([]);
    const [messages, setMessages] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)([]);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        const currentInboxObj = inbox.find(({ id: id })=>id === currentWindow.id);
        const currentInbox = currentInboxObj?.lines ?? [];
        const newOrPrev = (cur, prev)=>(i)=>{
                const byId = (list, i)=>list.find(({ line: line })=>line === i);
                return byId(cur, i) || byId(prev, i);
            };
        const rawMessages = Array(currentWindow.gridheight).fill(null).map((_, i)=>i).map(newOrPrev(currentInbox, prevMessages));
        /* */ const shouldUpdatePrev = (rawMessages, prevMessages)=>{
            const serialize = JSON.stringify;
            return serialize(rawMessages) !== serialize(prevMessages);
        };
        if (shouldUpdatePrev(rawMessages, prevMessages)) setPrevMessages(rawMessages);
        /* */ const rawMessagesContent = rawMessages.map((x)=>x.content).flat().map((message)=>({
                ...message,
                text: message.text.trim()
            }));
        const isEmpty = rawMessagesContent.map(({ text: text })=>text.length).every((l)=>l === 0);
        const getGridStyle = ({ style: style })=>{
            if ([
                "alert",
                "normal"
            ].includes(style)) return "grid";
            return style || "grid";
        };
        const messages = rawMessagesContent.map((message)=>({
                style: getGridStyle(message),
                text: message.text.replace("   ", " / ")
            }));
        setMessages(isEmpty ? [] : messages);
    }, [
        inbox,
        currentWindow,
        prevMessages
    ]);
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
        className: [
            $7264401512871bae$export$ab1029bcae9ddb4a,
            $7264401512871bae$export$347a3a46df242257
        ].join(" "),
        children: messages.map((0, $0f82f0e8d6bc47f2$export$2e2bcd8739ae039))
    });
}





var $fd5fe8e2ac9eacb0$export$2bacab2130704b28;
var $fd5fe8e2ac9eacb0$export$8439e0443b88eae;
$fd5fe8e2ac9eacb0$export$2bacab2130704b28 = `gUkI1a_menuButton`;
$fd5fe8e2ac9eacb0$export$8439e0443b88eae = `gUkI1a_menuIcon`;


function $1aca019851cc147a$export$2e2bcd8739ae039({ onClick: onClick }) {
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("button", {
        "aria-label": "Menu",
        className: $fd5fe8e2ac9eacb0$export$2bacab2130704b28,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("svg", {
            class: $fd5fe8e2ac9eacb0$export$8439e0443b88eae,
            viewBox: "0 0 28 32",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("rect", {
                    x: "12",
                    y: "4",
                    width: "4",
                    height: "4"
                }),
                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("rect", {
                    x: "12",
                    y: "14",
                    width: "4",
                    height: "4"
                }),
                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("rect", {
                    x: "12",
                    y: "24",
                    width: "4",
                    height: "4"
                })
            ]
        })
    });
}


var $3193ce97b05087f7$export$1d6e32fec5a4f082;
var $3193ce97b05087f7$export$4a36d31092c0d718;
$3193ce97b05087f7$export$1d6e32fec5a4f082 = `LdLucW_inputBox`;
$3193ce97b05087f7$export$4a36d31092c0d718 = `LdLucW_inputControls`;


/* eslint-disable */ const $6ceab6f7d9d9af03$var$keyCodes = {
    KEY_BACKSPACE: 8,
    KEY_TAB: 9,
    KEY_RETURN: 13,
    KEY_ESC: 27,
    KEY_PAGEUP: 33,
    KEY_PAGEDOWN: 34,
    KEY_END: 35,
    KEY_HOME: 36,
    KEY_LEFT: 37,
    KEY_UP: 38,
    KEY_RIGHT: 39,
    KEY_DOWN: 40
};
const $6ceab6f7d9d9af03$var$keyNames = {
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_BACKSPACE]: "delete",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_TAB]: "tab",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_RETURN]: "return",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_ESC]: "escape",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_PAGEUP]: "pageup",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_PAGEDOWN]: "pagedown",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_END]: "end",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_HOME]: "home",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_LEFT]: "left",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_UP]: "up",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_RIGHT]: "right",
    [$6ceab6f7d9d9af03$var$keyCodes.KEY_DOWN]: "down"
};
/* eslint-enable */ const $6ceab6f7d9d9af03$var$hasModifier = (event)=>{
    const modifiers = [
        event.altKey,
        event.ctrlKey,
        event.metaKey,
        event.shiftKey
    ];
    return modifiers.some((modifier)=>modifier === true);
};
function $6ceab6f7d9d9af03$export$2e2bcd8739ae039({ inputType: inputType, windows: windows, currentWindowId: currentWindowId, sendMessage: sendMessage, onFullscreenRequest: onFullscreenRequest, setMenuOpen: setMenuOpen }) {
    const [targetWindow, setTargetWindow] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(null);
    const [inputText, setInputText] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)("");
    const [lastInput, setLastInput] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)("");
    const inputEl = (0, $5c5fa90583e4b8e8$export$b8f5890fc79d6aca)(null);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        let setFocus = ()=>{
            inputEl.current && inputEl.current.focus();
        };
        setInputText("");
        setFocus();
        document.addEventListener("fullscreenchange", setFocus);
        return ()=>document.removeEventListener("fullscreenchange", setFocus);
    }, [
        inputType
    ]);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        setTargetWindow(windows.find(({ id: id })=>id === currentWindowId));
    }, [
        currentWindowId,
        windows
    ]);
    const send = (message)=>{
        sendMessage(message, inputType, targetWindow);
        setLastInput(message);
        setInputText("");
    };
    const charHandler = (event)=>(event.keyCode === 229 ? charHandlerMobile : charHandlerDefault)(event);
    const charHandlerDefault = (event)=>{
        if ($6ceab6f7d9d9af03$var$hasModifier(event)) return undefined;
        event.preventDefault();
        const key = $6ceab6f7d9d9af03$var$keyNames[event.keyCode] || event.key;
        send(key);
    };
    const charHandlerMobile = (event)=>setTimeout(()=>{
            send(event.target.value.slice(-1).toUpperCase());
            setInputText("");
        });
    const lineHandler = ({ keyCode: keyCode, target: { value: value } })=>{
        if (keyCode === $6ceab6f7d9d9af03$var$keyCodes.KEY_RETURN) send(value);
    };
    const lineArrowHandler = ({ keyCode: keyCode })=>{
        if (keyCode === $6ceab6f7d9d9af03$var$keyCodes.KEY_UP) {
            setInputText(lastInput);
            setTimeout(()=>{
                const end = lastInput.length;
                inputEl.current.setSelectionRange(end, end);
            }, 0);
        }
        if (keyCode === $6ceab6f7d9d9af03$var$keyCodes.KEY_DOWN) setInputText("");
    };
    const inputHandlers = {
        char: {
            maxlength: "1",
            placeholder: "Press any key here",
            onKeyDown: charHandler
        },
        line: {
            placeholder: " > ",
            onKeyDown: lineArrowHandler,
            onKeyPress: lineHandler
        },
        finished: {
            placeholder: "The program has finished",
            disabled: true
        }
    };
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
        className: $3193ce97b05087f7$export$4a36d31092c0d718,
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("input", {
                ...inputHandlers[inputType],
                className: $3193ce97b05087f7$export$1d6e32fec5a4f082,
                ref: inputEl,
                value: inputText,
                autofocus: true,
                autocomplete: "off",
                spellCheck: "false",
                autocapitalize: "off",
                autocorrect: "off",
                onDblClick: onFullscreenRequest,
                onInput: ({ target: { value: value } })=>setInputText(value),
                type: "search"
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $1aca019851cc147a$export$2e2bcd8739ae039), {
                onClick: ()=>setMenuOpen(true)
            })
        ]
    });
}




var $d7f5f88be915a221$export$cef8ff1a2814f0d7;
var $d7f5f88be915a221$export$46c1c92549715335;
var $d7f5f88be915a221$export$471f7ae5c4103ae1;
$d7f5f88be915a221$export$cef8ff1a2814f0d7 = `zi213q_dots0123`;
$d7f5f88be915a221$export$cef8ff1a2814f0d7;
$d7f5f88be915a221$export$46c1c92549715335 = `zi213q_loading`;
$d7f5f88be915a221$export$471f7ae5c4103ae1 = `zi213q_status`;


const $1068788a6b5bd866$var$fail = (details)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
        className: [
            $d7f5f88be915a221$export$471f7ae5c4103ae1
        ].join(" "),
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("h1", {
                children: "Error"
            }),
            details.map((x)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("p", {
                    children: x
                }, x)),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("hr", {}),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                href: "/",
                children: "Home"
            }),
            "|",
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                href: "https://github.com/He4eT/elseifplayer/issues",
                children: "Report bug"
            })
        ]
    });
const $1068788a6b5bd866$var$loading = (details)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
        className: [
            $d7f5f88be915a221$export$471f7ae5c4103ae1,
            $d7f5f88be915a221$export$46c1c92549715335
        ].join(" "),
        children: details.map((x)=>/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                children: x
            }, x))
    });
var $1068788a6b5bd866$export$2e2bcd8739ae039 = ({ stage: stage, details: details })=>({
        fail: $1068788a6b5bd866$var$fail,
        loading: $1068788a6b5bd866$var$loading
    })[stage](details);


/**
  Base32768 is a binary-to-text encoding optimised for UTF-16-encoded text.
  (e.g. Windows, Java, JavaScript)
*/ // Z is a number, usually a uint15 but sometimes a uint7
const $a3e838a981d9102e$var$BITS_PER_CHAR = 15 // Base32768 is a 15-bit encoding
;
const $a3e838a981d9102e$var$BITS_PER_BYTE = 8;
const $a3e838a981d9102e$var$pairStrings = [
    "ҠҿԀԟڀڿݠޟ߀ߟကဟႠႿᄀᅟᆀᆟᇠሿበቿዠዿጠጿᎠᏟᐠᙟᚠᛟកសᠠᡟᣀᣟᦀᦟ᧠᧿ᨠᨿᯀᯟᰀᰟᴀᴟ⇠⇿⋀⋟⍀⏟␀␟─❟➀➿⠀⥿⦠⦿⨠⩟⪀⪿⫠⭟ⰀⰟⲀⳟⴀⴟⵀⵟ⺠⻟㇀㇟㐀䶟䷀龿ꀀꑿ꒠꒿ꔀꗿꙀꙟꚠꛟ꜀ꝟꞀꞟꡀꡟ",
    "ƀƟɀʟ"
];
const $a3e838a981d9102e$var$lookupE = {};
const $a3e838a981d9102e$var$lookupD = {};
$a3e838a981d9102e$var$pairStrings.forEach((pairString, r)=>{
    // Decompression
    const encodeRepertoire = [];
    pairString.match(/../gu).forEach((pair)=>{
        const first = pair.codePointAt(0);
        const last = pair.codePointAt(1);
        for(let codePoint = first; codePoint <= last; codePoint++)encodeRepertoire.push(String.fromCodePoint(codePoint));
    });
    const numZBits = $a3e838a981d9102e$var$BITS_PER_CHAR - $a3e838a981d9102e$var$BITS_PER_BYTE * r // 0 -> 15, 1 -> 7
    ;
    $a3e838a981d9102e$var$lookupE[numZBits] = encodeRepertoire;
    encodeRepertoire.forEach((chr, z)=>{
        $a3e838a981d9102e$var$lookupD[chr] = [
            numZBits,
            z
        ];
    });
});
const $a3e838a981d9102e$export$c564cdbbe6da493 = (uint8Array)=>{
    const length = uint8Array.length;
    let str = "";
    let z = 0;
    let numZBits = 0;
    for(let i = 0; i < length; i++){
        const uint8 = uint8Array[i];
        // Take most significant bit first
        for(let j = $a3e838a981d9102e$var$BITS_PER_BYTE - 1; j >= 0; j--){
            const bit = uint8 >> j & 1;
            z = (z << 1) + bit;
            numZBits++;
            if (numZBits === $a3e838a981d9102e$var$BITS_PER_CHAR) {
                str += $a3e838a981d9102e$var$lookupE[numZBits][z];
                z = 0;
                numZBits = 0;
            }
        }
    }
    if (numZBits !== 0) {
        // Final bits require special treatment.
        // z = bbbbbbcccccccc, numZBits = 14, padBits = 1
        // z = bbbbbcccccccc, numZBits = 13, padBits = 2
        // z = bbbbcccccccc, numZBits = 12, padBits = 3
        // z = bbbcccccccc, numZBits = 11, padBits = 4
        // z = bbcccccccc, numZBits = 10, padBits = 5
        // z = bcccccccc, numZBits = 9, padBits = 6
        // z = cccccccc, numZBits = 8, padBits = 7
        // => Pad `z` out to 15 bits using 1s, then encode as normal (r = 0)
        // z = ccccccc, numZBits = 7, padBits = 0
        // z = cccccc, numZBits = 6, padBits = 1
        // z = ccccc, numZBits = 5, padBits = 2
        // z = cccc, numZBits = 4, padBits = 3
        // z = ccc, numZBits = 3, padBits = 4
        // z = cc, numZBits = 2, padBits = 5
        // z = c, numZBits = 1, padBits = 6
        // => Pad `z` out to 7 bits using 1s, then encode specially (r = 1)
        while(!(numZBits in $a3e838a981d9102e$var$lookupE)){
            z = (z << 1) + 1;
            numZBits++;
        }
        str += $a3e838a981d9102e$var$lookupE[numZBits][z];
    }
    return str;
};
const $a3e838a981d9102e$export$2f872c0f2117be69 = (str)=>{
    const length = str.length;
    // This length is a guess. There's a chance we allocate one more byte here
    // than we actually need. But we can count and slice it off later
    const uint8Array = new Uint8Array(Math.floor(length * $a3e838a981d9102e$var$BITS_PER_CHAR / $a3e838a981d9102e$var$BITS_PER_BYTE));
    let numUint8s = 0;
    let uint8 = 0;
    let numUint8Bits = 0;
    for(let i = 0; i < length; i++){
        const chr = str.charAt(i);
        if (!(chr in $a3e838a981d9102e$var$lookupD)) throw new Error(`Unrecognised Base32768 character: ${chr}`);
        const [numZBits, z] = $a3e838a981d9102e$var$lookupD[chr];
        if (numZBits !== $a3e838a981d9102e$var$BITS_PER_CHAR && i !== length - 1) throw new Error("Secondary character found before end of input at position " + String(i));
        // Take most significant bit first
        for(let j = numZBits - 1; j >= 0; j--){
            const bit = z >> j & 1;
            uint8 = (uint8 << 1) + bit;
            numUint8Bits++;
            if (numUint8Bits === $a3e838a981d9102e$var$BITS_PER_BYTE) {
                uint8Array[numUint8s] = uint8;
                numUint8s++;
                uint8 = 0;
                numUint8Bits = 0;
            }
        }
    }
    // Final padding bits! Requires special consideration!
    // Remember how we always pad with 1s?
    // Note: there could be 0 such bits, check still works though
    if (uint8 !== (1 << numUint8Bits) - 1) throw new Error("Padding mismatch");
    return new Uint8Array(uint8Array.buffer, 0, numUint8s);
};


const $55fe02cc0e361ca1$export$fe1040197752eb59 = ({ setStatus: setStatus, setWindows: setWindows, setCurrentWindowId: setCurrentWindowId, setInputType: setInputType, setInbox: setInbox })=>({
        onInit: ()=>{
            setStatus({
                stage: "ready"
            });
        },
        /* */ onUpdateWindows: (windows)=>{
            setWindows(windows);
        },
        onUpdateInputs: (data)=>{
            if (data.length === 0) return null;
            const { type: type, id: id } = data[0];
            setCurrentWindowId(id);
            setInputType(type);
        },
        onUpdateContent: (inbox)=>{
            setInbox(inbox);
        },
        onDisable: ()=>{
            setInputType(null);
        },
        /* */ onFileNameRequest: (_tosave, usage, _gameId, setFileName)=>{
            setFileName({
                usage: usage,
                filename: prompt("Enter the filename")
            });
        },
        onFileRead: ({ filename: filename })=>{
            const content = localStorage.getItem(`fake-fs/${filename}`);
            return (0, $a3e838a981d9102e$export$2f872c0f2117be69)(content);
        },
        onFileWrite: ({ filename: filename }, content)=>{
            localStorage.setItem(`fake-fs/${filename}`, (0, $a3e838a981d9102e$export$c564cdbbe6da493)(content));
        },
        /* */ onExit: ()=>{
            setInputType("finished");
        }
    });
const $55fe02cc0e361ca1$export$877ebb39146e6928 = (onExit)=>(event)=>{
        if (event.reason.name === "ExitStatus" || event.reason.message === "Program terminated with exit(0)") onExit();
        else console.error("Unhandled rejection (promise: ", event.promise, ", reason: ", event.reason, ").");
        event.preventDefault();
    };



const $d1e73e56b58e412e$var$INITIAL_STATUS = {
    stage: "loading",
    details: [
        "Preparing"
    ]
};
const $d1e73e56b58e412e$var$runMachine = ({ engine: Engine, wasmBinary: wasmBinary, storyfile: storyfile, handlers: handlers })=>{
    const { Dialog: Dialog, GlkOte: GlkOte, send: send } = (0, $db6ac6276ae4f3e4$export$2e2bcd8739ae039)(handlers);
    const instance = new Engine();
    instance.init(storyfile, {
        Dialog: Dialog,
        GlkOte: GlkOte,
        Glk: {},
        wasmBinary: wasmBinary,
        arguments: [
            "storyfile"
        ]
    });
    instance.start();
    return {
        send: send,
        instance: instance
    };
};
function $d1e73e56b58e412e$export$2e2bcd8739ae039({ vmParts: { storyfile: storyfile, engine: engine, wasmBinary: wasmBinary }, onFullscreenRequest: onFullscreenRequest, setMenuOpen: setMenuOpen, singleWindow: singleWindow }) {
    const [status, setStatus] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)($d1e73e56b58e412e$var$INITIAL_STATUS);
    const [windows, setWindows] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)([]);
    const [currentWindowId, setCurrentWindowId] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(null);
    const [inputType, setInputType] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(null);
    const [inbox, setInbox] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)([]);
    const [vm, setVm] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(null);
    const [sendMessage, setSendMessage] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(null);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        const handlers = (0, $55fe02cc0e361ca1$export$fe1040197752eb59)({
            setStatus: setStatus,
            setWindows: setWindows,
            setCurrentWindowId: setCurrentWindowId,
            setInputType: setInputType,
            setInbox: setInbox
        });
        setVm($d1e73e56b58e412e$var$runMachine({
            engine: engine,
            wasmBinary: wasmBinary,
            storyfile: storyfile,
            handlers: handlers
        }));
        const rejectionHandler = (0, $55fe02cc0e361ca1$export$877ebb39146e6928)(handlers.onExit);
        window.addEventListener("unhandledrejection", rejectionHandler);
        return ()=>{
            setVm(null);
            window.removeEventListener("unhandledrejection", rejectionHandler);
        };
    }, [
        storyfile,
        engine,
        wasmBinary
    ]);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        setSendMessage(()=>vm ? vm.send : null);
        return ()=>setSendMessage(null);
    }, [
        vm
    ]);
    const textWindow = (inbox)=>(currentWindow)=>{
            const props = {
                inbox: inbox,
                currentWindow: currentWindow
            };
            return ({
                buffer: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $c5dda773199830f0$export$2e2bcd8739ae039), {
                    ...props
                }),
                grid: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $272a9a66be55229e$export$2e2bcd8739ae039), {
                    ...props
                })
            })[currentWindow.type];
        };
    const byTop = (a, b)=>a.top - b.top;
    return status.stage !== "ready" ? /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $1068788a6b5bd866$export$2e2bcd8739ae039), {
        ...status
    }) : /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
        className: $7264401512871bae$export$d7f0ba9e5e132b36,
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
                className: $7264401512871bae$export$c789db2c85949867,
                children: windows.sort(byTop).filter(singleWindow ? ({ id: id })=>id === currentWindowId : ()=>true).map(textWindow(inbox))
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $6ceab6f7d9d9af03$export$2e2bcd8739ae039), {
                inputType: inputType,
                windows: windows,
                currentWindowId: currentWindowId,
                sendMessage: sendMessage,
                onFullscreenRequest: onFullscreenRequest,
                setMenuOpen: setMenuOpen
            })
        ]
    });
}



const $cc5481a01a7ff6bc$var$INITIAL_STATUS = {
    stage: "loading",
    details: [
        "Loading"
    ]
};
const $cc5481a01a7ff6bc$var$prepareVM = ({ url: url, setStatus: setStatus, setParts: setParts })=>{
    const st = (stage, details)=>(args)=>{
            setStatus({
                stage: stage,
                details: [
                    details
                ]
            });
            return args;
        };
    const cleanUrl = (url)=>url.startsWith("blob:") ? url.replace(/#(.*)$/g, "") : url;
    const fetchWasm = (wasmBinaryName)=>fetch(wasmBinaryName).then((response)=>response.arrayBuffer());
    const checkResponse = (response)=>{
        if (response.ok) return response;
        throw new Error(response.statusText);
    };
    return Promise.resolve(url).then(st("loading", "Downloading file")).then(cleanUrl).then(fetch).then(checkResponse).then(st("loading", "Processing file")).then((response)=>response.arrayBuffer()).then((arrayBuffer)=>new Uint8Array(arrayBuffer)).then(st("loading", "Downloading engine")).then((storyfile)=>{
        let parts = (0, $11084da5888c7d7e$export$1784a1ff765207b7)(url);
        return [
            storyfile,
            parts.engine,
            parts.wasmBinaryName
        ];
    }).then(([storyfile, engine, wasmBinaryName])=>Promise.all([
            storyfile,
            engine,
            fetchWasm(wasmBinaryName)
        ])).then(([storyfile, engine, wasmBinary])=>setParts({
            storyfile: storyfile,
            engine: engine,
            wasmBinary: wasmBinary
        })).then(st("loading", "Running")).catch((e)=>{
        console.error(e);
        setStatus({
            stage: "fail",
            details: [
                e.message,
                url
            ]
        });
    });
};
function $cc5481a01a7ff6bc$export$2e2bcd8739ae039({ url: url, singleWindow: singleWindow, onFullscreenRequest: onFullscreenRequest, setMenuOpen: setMenuOpen }) {
    const [status, setStatus] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)($cc5481a01a7ff6bc$var$INITIAL_STATUS);
    const [vmParts, setParts] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(null);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        setStatus($cc5481a01a7ff6bc$var$INITIAL_STATUS);
        setParts(null);
        $cc5481a01a7ff6bc$var$prepareVM({
            url: url,
            setStatus: setStatus,
            setParts: setParts
        });
        return ()=>setParts(null);
    }, [
        url
    ]);
    return vmParts ? /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $d1e73e56b58e412e$export$2e2bcd8739ae039), {
        vmParts: vmParts,
        onFullscreenRequest: onFullscreenRequest,
        setMenuOpen: setMenuOpen,
        singleWindow: singleWindow
    }) : /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $1068788a6b5bd866$export$2e2bcd8739ae039), {
        ...status
    });
}






var $0c7160f142d5c9c6$export$d90360df408c8ceb;
var $0c7160f142d5c9c6$export$b1e5508a851be14d;
var $0c7160f142d5c9c6$export$428e7c787d57587d;
$0c7160f142d5c9c6$export$d90360df408c8ceb = `J9zJZG_appearance`;
$0c7160f142d5c9c6$export$b1e5508a851be14d = `J9zJZG_menu`;
$0c7160f142d5c9c6$export$428e7c787d57587d = `J9zJZG_navigation`;


function $dcf9cc7c30fac7fa$export$2e2bcd8739ae039({ themeEngine: themeEngine, onFullscreenRequest: onFullscreenRequest, menuOpen: menuOpen, setMenuOpen: setMenuOpen }) {
    const dialog = (0, $5c5fa90583e4b8e8$export$b8f5890fc79d6aca)(null);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        const dialogOpen = dialog.current.open;
        if (menuOpen && !dialogOpen) dialog.current.showModal();
        if (!menuOpen && dialogOpen) dialog.current.close();
    }, [
        menuOpen
    ]);
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        const currentDialog = dialog.current;
        const closeHandler = ()=>{
            setMenuOpen(false);
        };
        currentDialog.addEventListener("close", closeHandler);
        return ()=>currentDialog.removeEventListener("close", closeHandler);
    }, [
        dialog,
        setMenuOpen
    ]);
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("dialog", {
        ref: dialog,
        className: $0c7160f142d5c9c6$export$b1e5508a851be14d,
        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("section", {
            children: [
                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                    children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("button", {
                        tabIndex: 0,
                        onClick: ()=>dialog.current.close(),
                        children: "Close this menu"
                    })
                }),
                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                    className: $0c7160f142d5c9c6$export$d90360df408c8ceb,
                    children: [
                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("button", {
                            onClick: ()=>{
                                dialog.current.close();
                                onFullscreenRequest();
                            },
                            children: "Full screen"
                        }),
                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("button", {
                            onClick: ()=>themeEngine.setRandomTheme(),
                            children: "Set a random theme"
                        }),
                        /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("label", {
                            children: [
                                "Current theme:",
                                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $7c39639b64b564e0$export$2e2bcd8739ae039), {
                                    themeEngine: themeEngine
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
                    className: $0c7160f142d5c9c6$export$428e7c787d57587d,
                    children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$a6c7ac8248d6e38a), {
                        href: "/",
                        tabIndex: 0,
                        children: "ElseIfPlayer"
                    })
                })
            ]
        })
    });
}


const $b5ee9fb5e8b4f417$var$decode = (encodedUrl)=>decodeURIComponent(encodedUrl);
function $b5ee9fb5e8b4f417$export$2e2bcd8739ae039({ theme: theme, themeEngine: themeEngine, encodedUrl: encodedUrl, singleWindow: singleWindow }) {
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        themeEngine.setTheme(theme);
    }, [
        theme,
        themeEngine
    ]);
    const [targetUrl, setTargetUrl] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)($b5ee9fb5e8b4f417$var$decode(encodedUrl));
    (0, $5c5fa90583e4b8e8$export$6d9c69b0de29b591)(()=>{
        setTargetUrl($b5ee9fb5e8b4f417$var$decode(encodedUrl));
    }, [
        encodedUrl
    ]);
    const [menuOpen, setMenuOpen] = (0, $5c5fa90583e4b8e8$export$60241385465d0a34)(false);
    const onFullscreenRequest = ()=>{
        document.documentElement.requestFullscreen();
    };
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("main", {
        children: [
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $dcf9cc7c30fac7fa$export$2e2bcd8739ae039), {
                themeEngine: themeEngine,
                onFullscreenRequest: onFullscreenRequest,
                menuOpen: menuOpen,
                setMenuOpen: setMenuOpen
            }),
            /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $cc5481a01a7ff6bc$export$2e2bcd8739ae039), {
                url: targetUrl,
                onFullscreenRequest: onFullscreenRequest,
                setMenuOpen: setMenuOpen,
                singleWindow: singleWindow
            })
        ]
    });
}




function $1425950ba2693d8f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("main", {
        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $1068788a6b5bd866$export$2e2bcd8739ae039), {
            stage: "fail",
            details: [
                "404",
                "Page Not Found"
            ]
        })
    });
}


var $6003de219045a58b$exports = {};

$parcel$export($6003de219045a58b$exports, "app", function () { return $6003de219045a58b$export$729c8b7179294ba; }, function (v) { return $6003de219045a58b$export$729c8b7179294ba = v; });
$parcel$export($6003de219045a58b$exports, "focus", function () { return $6003de219045a58b$export$d7ddd398f22d79ef; }, function (v) { return $6003de219045a58b$export$d7ddd398f22d79ef = v; });
$parcel$export($6003de219045a58b$exports, "games", function () { return $6003de219045a58b$export$79863f625c4e57; }, function (v) { return $6003de219045a58b$export$79863f625c4e57 = v; });
$parcel$export($6003de219045a58b$exports, "home", function () { return $6003de219045a58b$export$d12a05a2da93ee73; }, function (v) { return $6003de219045a58b$export$d12a05a2da93ee73 = v; });
$parcel$export($6003de219045a58b$exports, "play", function () { return $6003de219045a58b$export$899fbdb5fa08b653; }, function (v) { return $6003de219045a58b$export$899fbdb5fa08b653 = v; });
$parcel$export($6003de219045a58b$exports, "themes", function () { return $6003de219045a58b$export$d9a33280f07116d9; }, function (v) { return $6003de219045a58b$export$d9a33280f07116d9 = v; });
var $6003de219045a58b$export$729c8b7179294ba;
var $6003de219045a58b$export$d7ddd398f22d79ef;
var $6003de219045a58b$export$79863f625c4e57;
var $6003de219045a58b$export$d12a05a2da93ee73;
var $6003de219045a58b$export$899fbdb5fa08b653;
var $6003de219045a58b$export$d9a33280f07116d9;
$6003de219045a58b$export$729c8b7179294ba = `X8uEDW_app`;
$6003de219045a58b$export$d7ddd398f22d79ef = `X8uEDW_focus`;
$6003de219045a58b$export$79863f625c4e57 = `X8uEDW_games`;
$6003de219045a58b$export$d12a05a2da93ee73 = `X8uEDW_home`;
$6003de219045a58b$export$899fbdb5fa08b653 = `X8uEDW_play`;
$6003de219045a58b$export$d9a33280f07116d9 = `X8uEDW_themes`;


function $0cf2ca330b15cac0$export$2e2bcd8739ae039() {
    const themeEngine = (0, $1e789317f11755fe$export$818080cba8053148)();
    const [currentLocation] = (0, $66f2da609d6d9bfe$export$b37f3f4c9f6562f7)();
    const playerView = (themeEngine, singleWindow)=>function view(params) {
            return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $b5ee9fb5e8b4f417$export$2e2bcd8739ae039), {
                themeEngine: themeEngine,
                singleWindow: singleWindow,
                ...params
            });
        };
    return /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$55185c17a0fcbe46), {
        hook: (0, $66f2da609d6d9bfe$export$b37f3f4c9f6562f7),
        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)("div", {
            className: [
                $6003de219045a58b$exports.app,
                $6003de219045a58b$exports[(0, $66f2da609d6d9bfe$export$4fac2eeccfa4a8ca)(currentLocation)],
                themeEngine.currentTheme
            ].join(" "),
            children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/",
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $85078130a8d7a0de$export$2e2bcd8739ae039), {
                            themeEngine: themeEngine
                        })
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/games/",
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $a9795ef4044b2e22$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/themes/",
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $d21b3c63351f5932$export$2e2bcd8739ae039), {
                            themeEngine: themeEngine
                        })
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/play/:encodedUrl",
                        children: playerView(themeEngine, false)
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/play/:encodedUrl/:theme",
                        children: playerView(themeEngine, false)
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/focus/:encodedUrl",
                        children: playerView(themeEngine, true)
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        path: "/focus/:encodedUrl/:theme",
                        children: playerView(themeEngine, true)
                    }),
                    /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $bf49b3b08868bbb1$export$e7b0ac011bb776c6), {
                        children: /*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $1425950ba2693d8f$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
}


(0, $551174e99d8c5924$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $8161a3c5d316e860$export$34b9dba7ce09269b)((0, $0cf2ca330b15cac0$export$2e2bcd8739ae039), {}), document.getElementById("root"));

})();
//# sourceMappingURL=index.7852e909.js.map
